(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[186],{

/***/ 4046:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...page]]",
      function () {
        return __webpack_require__(3819);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23:
/***/ (function(module) {

"use strict";

module.exports = {
    locales: [
        "cs",
        "en",
        "fr"
    ],
    defaultLocale: "cs",
    localeDetection: false
};


/***/ }),

/***/ 3819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ CommonPage; }
});

// NAMESPACE OBJECT: ./app/icons/index.ts
var icons_namespaceObject = {};
__webpack_require__.r(icons_namespaceObject);
__webpack_require__.d(icons_namespaceObject, {
  "arrowBig": function() { return arrowBig; },
  "arrowDown": function() { return arrowDown; },
  "arte": function() { return arte; },
  "cross": function() { return cross; },
  "go": function() { return go; },
  "hamburger": function() { return hamburger; },
  "hamburgerMobile": function() { return hamburgerMobile; },
  "play": function() { return play; },
  "plus": function() { return plus; },
  "pro": function() { return pro; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@contember/react-client/dist/production/components/RichTextRenderer/RichTextRenderer.js + 9 modules
var RichTextRenderer = __webpack_require__(8865);
// EXTERNAL MODULE: ./node_modules/@mangoweb/react-fslightbox/dist/index.js
var dist = __webpack_require__(9276);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
;// CONCATENATED MODULE: ./app/utils/filterNonEmpty.ts
const filterNonEmpty = (item)=>Boolean(item);

// EXTERNAL MODULE: ./app/components/Artwork.module.sass
var Artwork_module = __webpack_require__(7172);
var Artwork_module_default = /*#__PURE__*/__webpack_require__.n(Artwork_module);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(7650);
// EXTERNAL MODULE: ./app/components/Anchor.module.sass
var Anchor_module = __webpack_require__(5579);
var Anchor_module_default = /*#__PURE__*/__webpack_require__.n(Anchor_module);
;// CONCATENATED MODULE: ./app/components/Anchor.tsx




function Anchor(props) {
    const { onAnchorInView , remainChanged =true  } = props;
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)();
    const [isAboveOrInViewport, setIsAboveOrInViewport] = (0,react.useState)(false);
    const contentRef = (0,react.useRef)(null);
    const onScroll = (0,react.useCallback)(()=>{
        if (contentRef.current) {
            const boundingBox = contentRef.current.getBoundingClientRect();
            const scrollTop = document.documentElement.scrollTop;
            const anchorY = scrollTop + boundingBox.top;
            setIsAboveOrInViewport(anchorY <= scrollTop + window.innerHeight);
        }
    }, []);
    (0,react.useEffect)(()=>{
        onScroll();
        window.addEventListener("scroll", ()=>{
            onScroll();
        });
    }, [
        onScroll
    ]);
    (0,react.useEffect)(()=>{
        if (!remainChanged || !isAboveOrInViewport || isAboveOrInViewport && inView) {
            onAnchorInView(inView);
        }
    }, [
        inView,
        isAboveOrInViewport,
        onAnchorInView,
        remainChanged
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Anchor_module_default()).wrapper,
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: contentRef
        })
    });
}

// EXTERNAL MODULE: ./app/components/Container.module.sass
var Container_module = __webpack_require__(8539);
var Container_module_default = /*#__PURE__*/__webpack_require__.n(Container_module);
;// CONCATENATED MODULE: ./app/components/Container.tsx





const Container = (param)=>{
    let { children , size ="normal" , disableGutters =false , disableInView  } = param;
    const [containerInView, setContainerInView] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((Container_module_default()).wrapper, (Container_module_default())["view_size_".concat(size)], disableGutters && (Container_module_default()).view_disableGutters, containerInView && (Container_module_default()).isInView, disableInView && (Container_module_default()).isInView),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Container_module_default()).Anchor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor, {
                    onAnchorInView: (inView)=>setContainerInView(inView)
                })
            }),
            children
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(9755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./app/components/ContemberImage.tsx



function ContemberImage(props) {
    const { image: { url , width , height  }  } = props;
    if (!url && !width && !height) {
        return null;
    }
    const baseProps = {
        sizes: props.sizes,
        loading: props.loading,
        objectFit: props.objectFit,
        objectPosition: props.objectPosition,
        onLoad: props.onLoad,
        unoptimized: "production" === "development"
    };
    if (props.layout === "fill") {
        var _alt;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            ...baseProps,
            src: url,
            alt: (_alt = props.image.alt) !== null && _alt !== void 0 ? _alt : "",
            layout: props.layout
        });
    }
    var _alt1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        ...baseProps,
        src: url,
        width: width,
        height: height,
        alt: (_alt1 = props.image.alt) !== null && _alt1 !== void 0 ? _alt1 : "",
        layout: props.layout
    });
}

;// CONCATENATED MODULE: ./app/utils/useContentRendererCopyPasteBugWorkaround.ts

const useContentRendererCopyPasteBugWorkaround = (blocks)=>(0,react.useMemo)(()=>{
        const allReferences = [];
        return blocks.map((block)=>{
            allReferences.push(...block.references);
            return {
                ...block,
                references: allReferences
            };
        });
    }, [
        blocks
    ]);

// EXTERNAL MODULE: ./app/components/BoxList.module.sass
var BoxList_module = __webpack_require__(3857);
var BoxList_module_default = /*#__PURE__*/__webpack_require__.n(BoxList_module);
// EXTERNAL MODULE: ./app/components/BoxTile.module.sass
var BoxTile_module = __webpack_require__(3714);
var BoxTile_module_default = /*#__PURE__*/__webpack_require__.n(BoxTile_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./generated/content.ts
/* eslint-disable */ 
const AllTypesProps = {
    Query: {
        getContactPage: {
            by: {
                type: "ContactPageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContactPage: {
            filter: {
                type: "ContactPageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactPageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContactPage: {
            filter: {
                type: "ContactPageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactPageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContactPage: {
            data: {
                type: "ContactPageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContactPage: {
            by: {
                type: "ContactPageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContactPageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContactPageLocale: {
            by: {
                type: "ContactPageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContactPageLocale: {
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactPageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContactPageLocale: {
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactPageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContactPageLocale: {
            data: {
                type: "ContactPageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContactPageLocale: {
            by: {
                type: "ContactPageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContactPageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContent: {
            by: {
                type: "ContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContent: {
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContent: {
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContent: {
            data: {
                type: "ContentCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContent: {
            by: {
                type: "ContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContentUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContentBlock: {
            by: {
                type: "ContentBlockUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContentBlock: {
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentBlockOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContentBlock: {
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentBlockOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContentBlock: {
            data: {
                type: "ContentBlockCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContentBlock: {
            by: {
                type: "ContentBlockUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContentBlockUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContentReference: {
            by: {
                type: "ContentReferenceUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContentReference: {
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentReferenceOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContentReference: {
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentReferenceOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContentReference: {
            data: {
                type: "ContentReferenceCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContentReference: {
            by: {
                type: "ContentReferenceUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContentReferenceUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getFooter: {
            by: {
                type: "FooterUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listFooter: {
            filter: {
                type: "FooterWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FooterOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateFooter: {
            filter: {
                type: "FooterWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FooterOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateFooter: {
            data: {
                type: "FooterCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateFooter: {
            by: {
                type: "FooterUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "FooterUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getFooterLocale: {
            by: {
                type: "FooterLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listFooterLocale: {
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FooterLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateFooterLocale: {
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FooterLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateFooterLocale: {
            data: {
                type: "FooterLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateFooterLocale: {
            by: {
                type: "FooterLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "FooterLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getHeader: {
            by: {
                type: "HeaderUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listHeader: {
            filter: {
                type: "HeaderWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateHeader: {
            filter: {
                type: "HeaderWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateHeader: {
            data: {
                type: "HeaderCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateHeader: {
            by: {
                type: "HeaderUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "HeaderUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getHeaderLink: {
            by: {
                type: "HeaderLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listHeaderLink: {
            filter: {
                type: "HeaderLinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderLinkOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateHeaderLink: {
            filter: {
                type: "HeaderLinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderLinkOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateHeaderLink: {
            data: {
                type: "HeaderLinkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateHeaderLink: {
            by: {
                type: "HeaderLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "HeaderLinkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getHeaderLocale: {
            by: {
                type: "HeaderLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listHeaderLocale: {
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateHeaderLocale: {
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateHeaderLocale: {
            data: {
                type: "HeaderLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateHeaderLocale: {
            by: {
                type: "HeaderLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "HeaderLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getHomePage: {
            by: {
                type: "HomePageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listHomePage: {
            filter: {
                type: "HomePageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HomePageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateHomePage: {
            filter: {
                type: "HomePageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HomePageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateHomePage: {
            data: {
                type: "HomePageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateHomePage: {
            by: {
                type: "HomePageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "HomePageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getHomePageLocale: {
            by: {
                type: "HomePageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listHomePageLocale: {
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HomePageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateHomePageLocale: {
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HomePageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateHomePageLocale: {
            data: {
                type: "HomePageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateHomePageLocale: {
            by: {
                type: "HomePageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "HomePageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getLink: {
            by: {
                type: "LinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listLink: {
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LinkOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLink: {
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LinkOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateLink: {
            data: {
                type: "LinkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateLink: {
            by: {
                type: "LinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "LinkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getLinkable: {
            by: {
                type: "LinkableUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listLinkable: {
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LinkableOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLinkable: {
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LinkableOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateLinkable: {
            data: {
                type: "LinkableCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateLinkable: {
            by: {
                type: "LinkableUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "LinkableUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getLocale: {
            by: {
                type: "LocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listLocale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLocale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateLocale: {
            data: {
                type: "LocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateLocale: {
            by: {
                type: "LocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "LocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getMedium: {
            by: {
                type: "MediumUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listMedium: {
            filter: {
                type: "MediumWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "MediumOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateMedium: {
            filter: {
                type: "MediumWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "MediumOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateMedium: {
            data: {
                type: "MediumCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateMedium: {
            by: {
                type: "MediumUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "MediumUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getMediumItem: {
            by: {
                type: "MediumItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listMediumItem: {
            filter: {
                type: "MediumItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "MediumItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateMediumItem: {
            filter: {
                type: "MediumItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "MediumItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateMediumItem: {
            data: {
                type: "MediumItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateMediumItem: {
            by: {
                type: "MediumItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "MediumItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getMediumList: {
            by: {
                type: "MediumListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listMediumList: {
            filter: {
                type: "MediumListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "MediumListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateMediumList: {
            filter: {
                type: "MediumListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "MediumListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateMediumList: {
            data: {
                type: "MediumListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateMediumList: {
            by: {
                type: "MediumListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "MediumListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getPage: {
            by: {
                type: "PageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listPage: {
            filter: {
                type: "PageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginatePage: {
            filter: {
                type: "PageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreatePage: {
            data: {
                type: "PageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdatePage: {
            by: {
                type: "PageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "PageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getPageLocale: {
            by: {
                type: "PageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listPageLocale: {
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginatePageLocale: {
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreatePageLocale: {
            data: {
                type: "PageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdatePageLocale: {
            by: {
                type: "PageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "PageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getSeoDefault: {
            by: {
                type: "SeoDefaultUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listSeoDefault: {
            filter: {
                type: "SeoDefaultWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoDefaultOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateSeoDefault: {
            filter: {
                type: "SeoDefaultWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoDefaultOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateSeoDefault: {
            data: {
                type: "SeoDefaultCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateSeoDefault: {
            by: {
                type: "SeoDefaultUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "SeoDefaultUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getSeoDefaultLocale: {
            by: {
                type: "SeoDefaultLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listSeoDefaultLocale: {
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoDefaultLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateSeoDefaultLocale: {
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoDefaultLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateSeoDefaultLocale: {
            data: {
                type: "SeoDefaultLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateSeoDefaultLocale: {
            by: {
                type: "SeoDefaultLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "SeoDefaultLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getVideo: {
            by: {
                type: "VideoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "VideoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listVideo: {
            filter: {
                type: "VideoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "VideoOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateVideo: {
            filter: {
                type: "VideoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "VideoOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateVideo: {
            data: {
                type: "VideoCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateVideo: {
            by: {
                type: "VideoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "VideoUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getImage: {
            by: {
                type: "ImageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listImage: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ImageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateImage: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ImageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateImage: {
            data: {
                type: "ImageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateImage: {
            by: {
                type: "ImageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ImageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getSeo: {
            by: {
                type: "SeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listSeo: {
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateSeo: {
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateSeo: {
            data: {
                type: "SeoCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateSeo: {
            by: {
                type: "SeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "SeoUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getTranslationDomain: {
            by: {
                type: "TranslationDomainUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationDomainWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listTranslationDomain: {
            filter: {
                type: "TranslationDomainWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationDomainOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateTranslationDomain: {
            filter: {
                type: "TranslationDomainWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationDomainOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateTranslationDomain: {
            data: {
                type: "TranslationDomainCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateTranslationDomain: {
            by: {
                type: "TranslationDomainUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "TranslationDomainUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getTranslationCatalogue: {
            by: {
                type: "TranslationCatalogueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listTranslationCatalogue: {
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationCatalogueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateTranslationCatalogue: {
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationCatalogueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateTranslationCatalogue: {
            data: {
                type: "TranslationCatalogueCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateTranslationCatalogue: {
            by: {
                type: "TranslationCatalogueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "TranslationCatalogueUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getTranslationCataloguesIdentifier: {
            by: {
                type: "TranslationCataloguesIdentifierUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCataloguesIdentifierWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listTranslationCataloguesIdentifier: {
            filter: {
                type: "TranslationCataloguesIdentifierWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationCataloguesIdentifierOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateTranslationCataloguesIdentifier: {
            filter: {
                type: "TranslationCataloguesIdentifierWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationCataloguesIdentifierOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateTranslationCataloguesIdentifier: {
            data: {
                type: "TranslationCataloguesIdentifierCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateTranslationCataloguesIdentifier: {
            by: {
                type: "TranslationCataloguesIdentifierUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "TranslationCataloguesIdentifierUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getTranslationKey: {
            by: {
                type: "TranslationKeyUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listTranslationKey: {
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationKeyOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateTranslationKey: {
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationKeyOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateTranslationKey: {
            data: {
                type: "TranslationKeyCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateTranslationKey: {
            by: {
                type: "TranslationKeyUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "TranslationKeyUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getTranslationValue: {
            by: {
                type: "TranslationValueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listTranslationValue: {
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationValueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateTranslationValue: {
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationValueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateTranslationValue: {
            data: {
                type: "TranslationValueCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateTranslationValue: {
            by: {
                type: "TranslationValueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "TranslationValueUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getBranches: {
            by: {
                type: "BranchesUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BranchesWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listBranches: {
            filter: {
                type: "BranchesWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BranchesOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateBranches: {
            filter: {
                type: "BranchesWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BranchesOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateBranches: {
            data: {
                type: "BranchesCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateBranches: {
            by: {
                type: "BranchesUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "BranchesUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getGraphicDesigner: {
            by: {
                type: "GraphicDesignerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GraphicDesignerWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listGraphicDesigner: {
            filter: {
                type: "GraphicDesignerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GraphicDesignerOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateGraphicDesigner: {
            filter: {
                type: "GraphicDesignerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GraphicDesignerOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateGraphicDesigner: {
            data: {
                type: "GraphicDesignerCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateGraphicDesigner: {
            by: {
                type: "GraphicDesignerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "GraphicDesignerUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEvent: {
            by: {
                type: "EventUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEvent: {
            filter: {
                type: "EventWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEvent: {
            filter: {
                type: "EventWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEvent: {
            data: {
                type: "EventCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEvent: {
            by: {
                type: "EventUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EventUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEventLocale: {
            by: {
                type: "EventLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEventLocale: {
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEventLocale: {
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEventLocale: {
            data: {
                type: "EventLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEventLocale: {
            by: {
                type: "EventLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EventLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtwork: {
            by: {
                type: "ArtworkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtwork: {
            filter: {
                type: "ArtworkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtwork: {
            filter: {
                type: "ArtworkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtwork: {
            data: {
                type: "ArtworkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtwork: {
            by: {
                type: "ArtworkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtworkLocale: {
            by: {
                type: "ArtworkLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtworkLocale: {
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworkLocale: {
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtworkLocale: {
            data: {
                type: "ArtworkLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtworkLocale: {
            by: {
                type: "ArtworkLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getDropDownItem: {
            by: {
                type: "DropDownItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listDropDownItem: {
            filter: {
                type: "DropDownItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DropDownItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateDropDownItem: {
            filter: {
                type: "DropDownItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DropDownItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateDropDownItem: {
            data: {
                type: "DropDownItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateDropDownItem: {
            by: {
                type: "DropDownItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "DropDownItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getDropDownList: {
            by: {
                type: "DropDownListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listDropDownList: {
            filter: {
                type: "DropDownListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DropDownListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateDropDownList: {
            filter: {
                type: "DropDownListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DropDownListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateDropDownList: {
            data: {
                type: "DropDownListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateDropDownList: {
            by: {
                type: "DropDownListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "DropDownListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtworkItem: {
            by: {
                type: "ArtworkItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtworkItem: {
            filter: {
                type: "ArtworkItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworkItem: {
            filter: {
                type: "ArtworkItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtworkItem: {
            data: {
                type: "ArtworkItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtworkItem: {
            by: {
                type: "ArtworkItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtworkList: {
            by: {
                type: "ArtworkListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtworkList: {
            filter: {
                type: "ArtworkListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworkList: {
            filter: {
                type: "ArtworkListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtworkList: {
            data: {
                type: "ArtworkListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtworkList: {
            by: {
                type: "ArtworkListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtworkSelection: {
            by: {
                type: "ArtworkSelectionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtworkSelection: {
            filter: {
                type: "ArtworkSelectionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworkSelection: {
            filter: {
                type: "ArtworkSelectionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtworkSelection: {
            data: {
                type: "ArtworkSelectionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtworkSelection: {
            by: {
                type: "ArtworkSelectionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkSelectionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtworkSelectionItem: {
            by: {
                type: "ArtworkSelectionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtworkSelectionItem: {
            filter: {
                type: "ArtworkSelectionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworkSelectionItem: {
            filter: {
                type: "ArtworkSelectionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtworkSelectionItem: {
            data: {
                type: "ArtworkSelectionItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtworkSelectionItem: {
            by: {
                type: "ArtworkSelectionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkSelectionItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtworkSelectionList: {
            by: {
                type: "ArtworkSelectionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtworkSelectionList: {
            filter: {
                type: "ArtworkSelectionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworkSelectionList: {
            filter: {
                type: "ArtworkSelectionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtworkSelectionList: {
            data: {
                type: "ArtworkSelectionListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtworkSelectionList: {
            by: {
                type: "ArtworkSelectionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkSelectionListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtworkSelectionLocale: {
            by: {
                type: "ArtworkSelectionLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtworkSelectionLocale: {
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworkSelectionLocale: {
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtworkSelectionLocale: {
            data: {
                type: "ArtworkSelectionLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtworkSelectionLocale: {
            by: {
                type: "ArtworkSelectionLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkSelectionLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEventItem: {
            by: {
                type: "EventItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEventItem: {
            filter: {
                type: "EventItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEventItem: {
            filter: {
                type: "EventItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEventItem: {
            data: {
                type: "EventItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEventItem: {
            by: {
                type: "EventItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EventItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEventList: {
            by: {
                type: "EventListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEventList: {
            filter: {
                type: "EventListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEventList: {
            filter: {
                type: "EventListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEventList: {
            data: {
                type: "EventListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEventList: {
            by: {
                type: "EventListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EventListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getBoxItem: {
            by: {
                type: "BoxItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listBoxItem: {
            filter: {
                type: "BoxItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BoxItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateBoxItem: {
            filter: {
                type: "BoxItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BoxItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateBoxItem: {
            data: {
                type: "BoxItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateBoxItem: {
            by: {
                type: "BoxItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "BoxItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getBoxList: {
            by: {
                type: "BoxListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listBoxList: {
            filter: {
                type: "BoxListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BoxListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateBoxList: {
            filter: {
                type: "BoxListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BoxListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateBoxList: {
            data: {
                type: "BoxListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateBoxList: {
            by: {
                type: "BoxListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "BoxListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getNewsletterForm: {
            by: {
                type: "NewsletterFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listNewsletterForm: {
            filter: {
                type: "NewsletterFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterFormOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateNewsletterForm: {
            filter: {
                type: "NewsletterFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterFormOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateNewsletterForm: {
            data: {
                type: "NewsletterFormCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateNewsletterForm: {
            by: {
                type: "NewsletterFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "NewsletterFormUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getNewsletterTypeItem: {
            by: {
                type: "NewsletterTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listNewsletterTypeItem: {
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterTypeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateNewsletterTypeItem: {
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterTypeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateNewsletterTypeItem: {
            data: {
                type: "NewsletterTypeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateNewsletterTypeItem: {
            by: {
                type: "NewsletterTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "NewsletterTypeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getNewsletterFormLocale: {
            by: {
                type: "NewsletterFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listNewsletterFormLocale: {
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateNewsletterFormLocale: {
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateNewsletterFormLocale: {
            data: {
                type: "NewsletterFormLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateNewsletterFormLocale: {
            by: {
                type: "NewsletterFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "NewsletterFormLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getNewsletterSubscription: {
            by: {
                type: "NewsletterSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listNewsletterSubscription: {
            filter: {
                type: "NewsletterSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterSubscriptionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateNewsletterSubscription: {
            filter: {
                type: "NewsletterSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterSubscriptionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateNewsletterSubscription: {
            data: {
                type: "NewsletterSubscriptionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateNewsletterSubscription: {
            by: {
                type: "NewsletterSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "NewsletterSubscriptionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getChart: {
            by: {
                type: "ChartUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listChart: {
            filter: {
                type: "ChartWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ChartOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateChart: {
            filter: {
                type: "ChartWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ChartOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateChart: {
            data: {
                type: "ChartCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateChart: {
            by: {
                type: "ChartUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ChartUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getChartData: {
            by: {
                type: "ChartDataUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartDataWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listChartData: {
            filter: {
                type: "ChartDataWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ChartDataOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateChartData: {
            filter: {
                type: "ChartDataWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ChartDataOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateChartData: {
            data: {
                type: "ChartDataCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateChartData: {
            by: {
                type: "ChartDataUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ChartDataUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEmployee: {
            by: {
                type: "EmployeeUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEmployee: {
            filter: {
                type: "EmployeeWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEmployee: {
            filter: {
                type: "EmployeeWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEmployee: {
            data: {
                type: "EmployeeCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEmployee: {
            by: {
                type: "EmployeeUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EmployeeUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEmployeeItem: {
            by: {
                type: "EmployeeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEmployeeItem: {
            filter: {
                type: "EmployeeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEmployeeItem: {
            filter: {
                type: "EmployeeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEmployeeItem: {
            data: {
                type: "EmployeeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEmployeeItem: {
            by: {
                type: "EmployeeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EmployeeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEmployeeList: {
            by: {
                type: "EmployeeListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEmployeeList: {
            filter: {
                type: "EmployeeListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEmployeeList: {
            filter: {
                type: "EmployeeListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEmployeeList: {
            data: {
                type: "EmployeeListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEmployeeList: {
            by: {
                type: "EmployeeListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EmployeeListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEmployeeLocale: {
            by: {
                type: "EmployeeLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEmployeeLocale: {
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEmployeeLocale: {
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEmployeeLocale: {
            data: {
                type: "EmployeeLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEmployeeLocale: {
            by: {
                type: "EmployeeLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EmployeeLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getPhotographer: {
            by: {
                type: "PhotographerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PhotographerWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listPhotographer: {
            filter: {
                type: "PhotographerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PhotographerOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginatePhotographer: {
            filter: {
                type: "PhotographerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PhotographerOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreatePhotographer: {
            data: {
                type: "PhotographerCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdatePhotographer: {
            by: {
                type: "PhotographerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "PhotographerUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getDefinitionItem: {
            by: {
                type: "DefinitionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listDefinitionItem: {
            filter: {
                type: "DefinitionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DefinitionItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateDefinitionItem: {
            filter: {
                type: "DefinitionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DefinitionItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateDefinitionItem: {
            data: {
                type: "DefinitionItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateDefinitionItem: {
            by: {
                type: "DefinitionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "DefinitionItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getDefinitionList: {
            by: {
                type: "DefinitionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listDefinitionList: {
            filter: {
                type: "DefinitionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DefinitionListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateDefinitionList: {
            filter: {
                type: "DefinitionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DefinitionListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateDefinitionList: {
            data: {
                type: "DefinitionListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateDefinitionList: {
            by: {
                type: "DefinitionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "DefinitionListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getLogoItem: {
            by: {
                type: "LogoItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listLogoItem: {
            filter: {
                type: "LogoItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LogoItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLogoItem: {
            filter: {
                type: "LogoItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LogoItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateLogoItem: {
            data: {
                type: "LogoItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateLogoItem: {
            by: {
                type: "LogoItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "LogoItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getLogoList: {
            by: {
                type: "LogoListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listLogoList: {
            filter: {
                type: "LogoListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LogoListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLogoList: {
            filter: {
                type: "LogoListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LogoListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateLogoList: {
            data: {
                type: "LogoListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateLogoList: {
            by: {
                type: "LogoListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "LogoListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getStrategySchema: {
            by: {
                type: "StrategySchemaUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listStrategySchema: {
            filter: {
                type: "StrategySchemaWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "StrategySchemaOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateStrategySchema: {
            filter: {
                type: "StrategySchemaWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "StrategySchemaOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateStrategySchema: {
            data: {
                type: "StrategySchemaCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateStrategySchema: {
            by: {
                type: "StrategySchemaUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "StrategySchemaUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getStrategySchemaGroup: {
            by: {
                type: "StrategySchemaGroupUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listStrategySchemaGroup: {
            filter: {
                type: "StrategySchemaGroupWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "StrategySchemaGroupOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateStrategySchemaGroup: {
            filter: {
                type: "StrategySchemaGroupWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "StrategySchemaGroupOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateStrategySchemaGroup: {
            data: {
                type: "StrategySchemaGroupCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateStrategySchemaGroup: {
            by: {
                type: "StrategySchemaGroupUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "StrategySchemaGroupUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getStrategySchemaGroupItem: {
            by: {
                type: "StrategySchemaGroupItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listStrategySchemaGroupItem: {
            filter: {
                type: "StrategySchemaGroupItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "StrategySchemaGroupItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateStrategySchemaGroupItem: {
            filter: {
                type: "StrategySchemaGroupItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "StrategySchemaGroupItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateStrategySchemaGroupItem: {
            data: {
                type: "StrategySchemaGroupItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateStrategySchemaGroupItem: {
            by: {
                type: "StrategySchemaGroupItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "StrategySchemaGroupItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getRedirect: {
            by: {
                type: "RedirectUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "RedirectWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listRedirect: {
            filter: {
                type: "RedirectWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "RedirectOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateRedirect: {
            filter: {
                type: "RedirectWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "RedirectOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateRedirect: {
            data: {
                type: "RedirectCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateRedirect: {
            by: {
                type: "RedirectUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "RedirectUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getGallery: {
            by: {
                type: "GalleryUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listGallery: {
            filter: {
                type: "GalleryWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GalleryOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateGallery: {
            filter: {
                type: "GalleryWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GalleryOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateGallery: {
            data: {
                type: "GalleryCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateGallery: {
            by: {
                type: "GalleryUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "GalleryUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getGalleryItem: {
            by: {
                type: "GalleryItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listGalleryItem: {
            filter: {
                type: "GalleryItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GalleryItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateGalleryItem: {
            filter: {
                type: "GalleryItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GalleryItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateGalleryItem: {
            data: {
                type: "GalleryItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateGalleryItem: {
            by: {
                type: "GalleryItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "GalleryItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContactForm: {
            by: {
                type: "ContactFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContactForm: {
            filter: {
                type: "ContactFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactFormOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContactForm: {
            filter: {
                type: "ContactFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactFormOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContactForm: {
            data: {
                type: "ContactFormCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContactForm: {
            by: {
                type: "ContactFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContactFormUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContactFormLocale: {
            by: {
                type: "ContactFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContactFormLocale: {
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContactFormLocale: {
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContactFormLocale: {
            data: {
                type: "ContactFormLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContactFormLocale: {
            by: {
                type: "ContactFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContactFormLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContactSubscription: {
            by: {
                type: "ContactSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContactSubscription: {
            filter: {
                type: "ContactSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactSubscriptionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContactSubscription: {
            filter: {
                type: "ContactSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactSubscriptionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContactSubscription: {
            data: {
                type: "ContactSubscriptionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContactSubscription: {
            by: {
                type: "ContactSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContactSubscriptionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContactTypeItem: {
            by: {
                type: "ContactTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContactTypeItem: {
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactTypeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContactTypeItem: {
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactTypeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContactTypeItem: {
            data: {
                type: "ContactTypeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContactTypeItem: {
            by: {
                type: "ContactTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContactTypeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getFile: {
            by: {
                type: "FileUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FileWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listFile: {
            filter: {
                type: "FileWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FileOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateFile: {
            filter: {
                type: "FileWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FileOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateFile: {
            data: {
                type: "FileCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateFile: {
            by: {
                type: "FileUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "FileUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        }
    },
    ContactPage: {
        locales: {
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactPageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLocale: {
            by: {
                type: "ContactPageLocalesByLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLink: {
            by: {
                type: "ContactPageLocalesByLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesBySeo: {
            by: {
                type: "ContactPageLocalesBySeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByAddressLink: {
            by: {
                type: "ContactPageLocalesByAddressLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLocales: {
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactPageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    UUID: "String",
    One: "enum",
    ContactPageLocale: {
        root: {
            filter: {
                type: "ContactPageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        locale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        link: {
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        seo: {
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        addressLink: {
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ContactPageWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "OneCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ContactPageLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ContactPageWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ContactPageWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ContactPageWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    UUIDCondition: {
        and: {
            type: "UUIDCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        or: {
            type: "UUIDCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        not: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        null: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        isNull: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        eq: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        notEq: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        in: {
            type: "UUID",
            array: true,
            arrayRequired: false,
            required: true
        },
        notIn: {
            type: "UUID",
            array: true,
            arrayRequired: false,
            required: true
        },
        lt: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        lte: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        gt: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        gte: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    OneCondition: {
        and: {
            type: "OneCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        or: {
            type: "OneCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        not: {
            type: "OneCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        null: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        isNull: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        eq: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        notEq: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        in: {
            type: "One",
            array: true,
            arrayRequired: false,
            required: true
        },
        notIn: {
            type: "One",
            array: true,
            arrayRequired: false,
            required: true
        },
        lt: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        lte: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        gt: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        gte: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactPageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        address: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        databox: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        databoxNumber: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        addressLink: {
            type: "LinkWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        socialsLabel: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        openingHours: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        identificationsLabel: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        ico: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        dic: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        phoneLabel: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailLabel: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        securities: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        securitiesNumber: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ContactPageLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ContactPageLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ContactPageLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StringCondition: {
        and: {
            type: "StringCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        or: {
            type: "StringCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        not: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        null: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        isNull: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        eq: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        notEq: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        in: {
            type: "String",
            array: true,
            arrayRequired: false,
            required: true
        },
        notIn: {
            type: "String",
            array: true,
            arrayRequired: false,
            required: true
        },
        lt: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        lte: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        gt: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        gte: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contains: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        startsWith: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        endsWith: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        containsCI: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        startsWithCI: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        endsWithCI: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "ContactPageLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        footers: {
            type: "FooterLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        headers: {
            type: "HeaderLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePages: {
            type: "HomePageLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        pages: {
            type: "PageLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seoDefaults: {
            type: "SeoDefaultLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        events: {
            type: "EventLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworks: {
            type: "ArtworkLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelections: {
            type: "ArtworkSelectionLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterForms: {
            type: "NewsletterFormLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        employees: {
            type: "EmployeeLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactForms: {
            type: "ContactFormLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "LocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "LocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "LocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        address: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        graphicDesign: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "FooterWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        graphicDesigners: {
            type: "GraphicDesignerWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        developerLink: {
            type: "LinkWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        development: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        photography: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        photographers: {
            type: "PhotographerWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "FooterLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "FooterLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "FooterLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "OneCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "ImageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "FooterLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "FooterWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "FooterWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "FooterWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ImageWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        width: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        height: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        size: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        alt: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ImageWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ImageWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ImageWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    IntCondition: {
        and: {
            type: "IntCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        or: {
            type: "IntCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        not: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        null: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        isNull: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        eq: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        notEq: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        in: {
            type: "Int",
            array: true,
            arrayRequired: false,
            required: true
        },
        notIn: {
            type: "Int",
            array: true,
            arrayRequired: false,
            required: true
        },
        lt: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        lte: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        gt: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        gte: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GraphicDesignerWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "GraphicDesignerWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "GraphicDesignerWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "GraphicDesignerWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "LinkTypeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        externalLink: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        internalLink: {
            type: "LinkableWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        anchorLink: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "LinkWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "LinkWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "LinkWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkTypeCondition: {
        and: {
            type: "LinkTypeCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        or: {
            type: "LinkTypeCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        not: {
            type: "LinkTypeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        null: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        isNull: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        eq: {
            type: "LinkType",
            array: false,
            arrayRequired: false,
            required: false
        },
        notEq: {
            type: "LinkType",
            array: false,
            arrayRequired: false,
            required: false
        },
        in: {
            type: "LinkType",
            array: true,
            arrayRequired: false,
            required: true
        },
        notIn: {
            type: "LinkType",
            array: true,
            arrayRequired: false,
            required: true
        },
        lt: {
            type: "LinkType",
            array: false,
            arrayRequired: false,
            required: false
        },
        lte: {
            type: "LinkType",
            array: false,
            arrayRequired: false,
            required: false
        },
        gt: {
            type: "LinkType",
            array: false,
            arrayRequired: false,
            required: false
        },
        gte: {
            type: "LinkType",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkType: "enum",
    LinkableWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "HomePageLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "ContactPageLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "PageLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "EventLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "ArtworkLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "ArtworkSelectionLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "RedirectWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "LinkableWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "LinkableWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "LinkableWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "HomePageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        branches: {
            type: "BranchesWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "HomePageLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "HomePageLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "HomePageLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "OneCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "HomePageLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        media: {
            type: "MediumListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "HomePageWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "HomePageWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "HomePageWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumListWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "MediumItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "MediumListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "MediumListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "MediumListWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumItemWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "MediumListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        medium: {
            type: "MediumWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "MediumItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "MediumItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "MediumItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "MediumTypeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        video: {
            type: "VideoWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtubeEmbed: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "MediumWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "MediumWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "MediumWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumTypeCondition: {
        and: {
            type: "MediumTypeCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        or: {
            type: "MediumTypeCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        not: {
            type: "MediumTypeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        null: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        isNull: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        eq: {
            type: "MediumType",
            array: false,
            arrayRequired: false,
            required: false
        },
        notEq: {
            type: "MediumType",
            array: false,
            arrayRequired: false,
            required: false
        },
        in: {
            type: "MediumType",
            array: true,
            arrayRequired: false,
            required: true
        },
        notIn: {
            type: "MediumType",
            array: true,
            arrayRequired: false,
            required: true
        },
        lt: {
            type: "MediumType",
            array: false,
            arrayRequired: false,
            required: false
        },
        lte: {
            type: "MediumType",
            array: false,
            arrayRequired: false,
            required: false
        },
        gt: {
            type: "MediumType",
            array: false,
            arrayRequired: false,
            required: false
        },
        gte: {
            type: "MediumType",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumType: "enum",
    VideoWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        src: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        width: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        height: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        size: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        duration: {
            type: "FloatCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        poster: {
            type: "ImageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "VideoWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "VideoWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "VideoWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FloatCondition: {
        and: {
            type: "FloatCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        or: {
            type: "FloatCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        not: {
            type: "FloatCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        null: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        isNull: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        eq: {
            type: "Float",
            array: false,
            arrayRequired: false,
            required: false
        },
        notEq: {
            type: "Float",
            array: false,
            arrayRequired: false,
            required: false
        },
        in: {
            type: "Float",
            array: true,
            arrayRequired: false,
            required: true
        },
        notIn: {
            type: "Float",
            array: true,
            arrayRequired: false,
            required: true
        },
        lt: {
            type: "Float",
            array: false,
            arrayRequired: false,
            required: false
        },
        lte: {
            type: "Float",
            array: false,
            arrayRequired: false,
            required: false
        },
        gt: {
            type: "Float",
            array: false,
            arrayRequired: false,
            required: false
        },
        gte: {
            type: "Float",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        blocks: {
            type: "ContentBlockWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ContentWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ContentWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ContentWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        json: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        references: {
            type: "ContentReferenceWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ContentBlockWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ContentBlockWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ContentBlockWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "ContentReferenceTypeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        primaryText: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        block: {
            type: "ContentBlockWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        media: {
            type: "MediumListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        secondaryText: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        dropDownList: {
            type: "DropDownListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "ArtworkSelectionWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        eventList: {
            type: "EventListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        boxList: {
            type: "BoxListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        isVisible: {
            type: "BooleanCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        chart: {
            type: "ChartWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        definitionList: {
            type: "DefinitionListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        logoList: {
            type: "LogoListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        strategySchema: {
            type: "StrategySchemaWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        employeeList: {
            type: "EmployeeListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        imageSecond: {
            type: "ImageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactForm: {
            type: "ContactFormWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterForm: {
            type: "NewsletterFormWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ContentReferenceWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ContentReferenceWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ContentReferenceWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceTypeCondition: {
        and: {
            type: "ContentReferenceTypeCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        or: {
            type: "ContentReferenceTypeCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        not: {
            type: "ContentReferenceTypeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        null: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        isNull: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        eq: {
            type: "ContentReferenceType",
            array: false,
            arrayRequired: false,
            required: false
        },
        notEq: {
            type: "ContentReferenceType",
            array: false,
            arrayRequired: false,
            required: false
        },
        in: {
            type: "ContentReferenceType",
            array: true,
            arrayRequired: false,
            required: true
        },
        notIn: {
            type: "ContentReferenceType",
            array: true,
            arrayRequired: false,
            required: true
        },
        lt: {
            type: "ContentReferenceType",
            array: false,
            arrayRequired: false,
            required: false
        },
        lte: {
            type: "ContentReferenceType",
            array: false,
            arrayRequired: false,
            required: false
        },
        gt: {
            type: "ContentReferenceType",
            array: false,
            arrayRequired: false,
            required: false
        },
        gte: {
            type: "ContentReferenceType",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceType: "enum",
    DropDownListWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "DropDownItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        dropDownType: {
            type: "DropDownTypeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        employees: {
            type: "EmployeeListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "DropDownListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "DropDownListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "DropDownListWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownItemWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "DropDownListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "DropDownItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "DropDownItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "DropDownItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownTypeCondition: {
        and: {
            type: "DropDownTypeCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        or: {
            type: "DropDownTypeCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        not: {
            type: "DropDownTypeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        null: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        isNull: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        eq: {
            type: "DropDownType",
            array: false,
            arrayRequired: false,
            required: false
        },
        notEq: {
            type: "DropDownType",
            array: false,
            arrayRequired: false,
            required: false
        },
        in: {
            type: "DropDownType",
            array: true,
            arrayRequired: false,
            required: true
        },
        notIn: {
            type: "DropDownType",
            array: true,
            arrayRequired: false,
            required: true
        },
        lt: {
            type: "DropDownType",
            array: false,
            arrayRequired: false,
            required: false
        },
        lte: {
            type: "DropDownType",
            array: false,
            arrayRequired: false,
            required: false
        },
        gt: {
            type: "DropDownType",
            array: false,
            arrayRequired: false,
            required: false
        },
        gte: {
            type: "DropDownType",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownType: "enum",
    EmployeeListWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "EmployeeItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "EmployeeListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "EmployeeListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "EmployeeListWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeItemWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "EmployeeListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        employee: {
            type: "EmployeeWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "EmployeeItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "EmployeeItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "EmployeeItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "EmployeeLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "EmployeeWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "EmployeeWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "EmployeeWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeLocaleWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        position: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EmployeeWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "EmployeeLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "EmployeeLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "EmployeeLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ArtworkSelectionLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworks: {
            type: "ArtworkSelectionListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ArtworkSelectionWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ArtworkSelectionWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ArtworkSelectionWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkSelectionWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ArtworkSelectionLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ArtworkSelectionLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ArtworkSelectionLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        description: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        ogTitle: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        ogDescription: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        noIndex: {
            type: "BooleanCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        noFollow: {
            type: "BooleanCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        ogImage: {
            type: "ImageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "SeoWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "SeoWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "SeoWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BooleanCondition: {
        and: {
            type: "BooleanCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        or: {
            type: "BooleanCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        not: {
            type: "BooleanCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        null: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        isNull: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        eq: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        notEq: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        in: {
            type: "Boolean",
            array: true,
            arrayRequired: false,
            required: true
        },
        notIn: {
            type: "Boolean",
            array: true,
            arrayRequired: false,
            required: true
        },
        lt: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        lte: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        gt: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        gte: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionListWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ArtworkSelectionItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ArtworkSelectionListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ArtworkSelectionListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ArtworkSelectionListWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionItemWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ArtworkSelectionListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "ArtworkWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ArtworkSelectionItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ArtworkSelectionItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ArtworkSelectionItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ArtworkLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        gallery: {
            type: "GalleryWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ArtworkWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ArtworkWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ArtworkWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artist: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ArtworkLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ArtworkLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ArtworkLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "GalleryItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "GalleryWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "GalleryWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "GalleryWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryItemWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "GalleryWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "GalleryItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "GalleryItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "GalleryItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventListWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "EventItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "EventListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "EventListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "EventListWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventItemWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "EventListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "EventWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "EventItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "EventItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "EventItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "EventLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        dateStart: {
            type: "DateTimeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        dateFinish: {
            type: "DateTimeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "EventWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "EventWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "EventWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EventWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        venue: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        venueNote: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        isDark: {
            type: "BooleanCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "EventLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "EventLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "EventLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DateTimeCondition: {
        and: {
            type: "DateTimeCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        or: {
            type: "DateTimeCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        not: {
            type: "DateTimeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        null: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        isNull: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        eq: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        notEq: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        in: {
            type: "DateTime",
            array: true,
            arrayRequired: false,
            required: true
        },
        notIn: {
            type: "DateTime",
            array: true,
            arrayRequired: false,
            required: true
        },
        lt: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        lte: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        gt: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        gte: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DateTime: "String",
    BoxListWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "BoxItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "BoxListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "BoxListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "BoxListWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxItemWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "BoxListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "BoxItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "BoxItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "BoxItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "ChartTypeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ChartDataWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ChartWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ChartWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ChartWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartTypeCondition: {
        and: {
            type: "ChartTypeCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        or: {
            type: "ChartTypeCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        not: {
            type: "ChartTypeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        null: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        isNull: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        eq: {
            type: "ChartType",
            array: false,
            arrayRequired: false,
            required: false
        },
        notEq: {
            type: "ChartType",
            array: false,
            arrayRequired: false,
            required: false
        },
        in: {
            type: "ChartType",
            array: true,
            arrayRequired: false,
            required: true
        },
        notIn: {
            type: "ChartType",
            array: true,
            arrayRequired: false,
            required: true
        },
        lt: {
            type: "ChartType",
            array: false,
            arrayRequired: false,
            required: false
        },
        lte: {
            type: "ChartType",
            array: false,
            arrayRequired: false,
            required: false
        },
        gt: {
            type: "ChartType",
            array: false,
            arrayRequired: false,
            required: false
        },
        gte: {
            type: "ChartType",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartType: "enum",
    ChartDataWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ChartWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "DateCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        number: {
            type: "FloatCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ChartDataWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ChartDataWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ChartDataWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DateCondition: {
        and: {
            type: "DateCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        or: {
            type: "DateCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        not: {
            type: "DateCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        null: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        isNull: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        eq: {
            type: "Date",
            array: false,
            arrayRequired: false,
            required: false
        },
        notEq: {
            type: "Date",
            array: false,
            arrayRequired: false,
            required: false
        },
        in: {
            type: "Date",
            array: true,
            arrayRequired: false,
            required: true
        },
        notIn: {
            type: "Date",
            array: true,
            arrayRequired: false,
            required: true
        },
        lt: {
            type: "Date",
            array: false,
            arrayRequired: false,
            required: false
        },
        lte: {
            type: "Date",
            array: false,
            arrayRequired: false,
            required: false
        },
        gt: {
            type: "Date",
            array: false,
            arrayRequired: false,
            required: false
        },
        gte: {
            type: "Date",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    Date: "String",
    DefinitionListWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "DefinitionItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "DefinitionListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "DefinitionListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "DefinitionListWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionItemWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        key: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        value: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "DefinitionListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "DefinitionItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "DefinitionItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "DefinitionItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoListWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "LogoItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "LogoListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "LogoListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "LogoListWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoItemWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "LogoListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "LogoItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "LogoItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "LogoItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        inputFirst: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        inputSecond: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        inputThird: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        outputFirst: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        outputSecond: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        outputThird: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        itemsFirst: {
            type: "StrategySchemaGroupWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "ImageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        itemsSecond: {
            type: "StrategySchemaGroupWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "StrategySchemaWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "StrategySchemaWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "StrategySchemaWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "StrategySchemaGroupItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "StrategySchemaGroupWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "StrategySchemaGroupWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "StrategySchemaGroupWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupItemWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        schema: {
            type: "StrategySchemaGroupWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "StrategySchemaGroupItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "StrategySchemaGroupItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "StrategySchemaGroupItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "OneCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ContactFormLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ContactFormWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ContactFormWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ContactFormWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactTypeErrorMessage: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactFormWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ContactTypeItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        file: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ContactFormLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ContactFormLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ContactFormLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        subscriptions: {
            type: "ContactSubscriptionWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ContactFormLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ContactTypeItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ContactTypeItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ContactTypeItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactSubscriptionWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        createdAt: {
            type: "DateTimeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        file: {
            type: "FileWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactType: {
            type: "ContactTypeItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ContactSubscriptionWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ContactSubscriptionWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ContactSubscriptionWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FileWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        size: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "FileWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "FileWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "FileWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "OneCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "NewsletterFormLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "NewsletterFormWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "NewsletterFormWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "NewsletterFormWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeNote: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailNote: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "NewsletterFormWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "NewsletterTypeItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeErrorMessage: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "NewsletterFormLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "NewsletterFormLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "NewsletterFormLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "NewsletterFormLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        subscriptions: {
            type: "NewsletterSubscriptionWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "NewsletterTypeItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "NewsletterTypeItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "NewsletterTypeItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterSubscriptionWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        createdAt: {
            type: "DateTimeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterType: {
            type: "NewsletterTypeItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "NewsletterSubscriptionWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "NewsletterSubscriptionWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "NewsletterSubscriptionWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BranchesWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        more: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "BranchesWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "BranchesWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "BranchesWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "PageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "PageLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "PageLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "PageLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "PageLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "PageWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "PageWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "PageWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    RedirectWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        target: {
            type: "LinkableWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "RedirectWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "RedirectWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "RedirectWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PhotographerWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "PhotographerWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "PhotographerWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "PhotographerWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "HeaderWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        links: {
            type: "HeaderLinkWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkBreadcrumbParentLink: {
            type: "LinkableWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "HeaderLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "HeaderLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "HeaderLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "OneCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "HeaderLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "ImageWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "HeaderWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "HeaderWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "HeaderWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLinkWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "HeaderLinkWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "HeaderLinkWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "HeaderLinkWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "SeoDefaultWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "SeoDefaultLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "SeoDefaultLocaleWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "SeoDefaultLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "OneCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "SeoDefaultLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "SeoDefaultWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "SeoDefaultWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "SeoDefaultWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    Locale: {
        contactPages: {
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactPageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        footers: {
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FooterLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        headers: {
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        homePages: {
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HomePageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        pages: {
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        seoDefaults: {
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoDefaultLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        events: {
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artworks: {
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artworkSelections: {
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        newsletterForms: {
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        employees: {
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        contactForms: {
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        contactPagesByRoot: {
            by: {
                type: "LocaleContactPagesByRootUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        contactPagesByLink: {
            by: {
                type: "LocaleContactPagesByLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        contactPagesBySeo: {
            by: {
                type: "LocaleContactPagesBySeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        contactPagesByAddressLink: {
            by: {
                type: "LocaleContactPagesByAddressLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        footersByRoot: {
            by: {
                type: "LocaleFootersByRootUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        footersByDeveloperLink: {
            by: {
                type: "LocaleFootersByDeveloperLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        headersByRoot: {
            by: {
                type: "LocaleHeadersByRootUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        headersByArtworkBreadcrumbParentLink: {
            by: {
                type: "LocaleHeadersByArtworkBreadcrumbParentLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        homePagesByRoot: {
            by: {
                type: "LocaleHomePagesByRootUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        homePagesByContent: {
            by: {
                type: "LocaleHomePagesByContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        homePagesByLink: {
            by: {
                type: "LocaleHomePagesByLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        homePagesBySeo: {
            by: {
                type: "LocaleHomePagesBySeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        pagesByRoot: {
            by: {
                type: "LocalePagesByRootUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        pagesByLink: {
            by: {
                type: "LocalePagesByLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        pagesByContent: {
            by: {
                type: "LocalePagesByContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        pagesBySeo: {
            by: {
                type: "LocalePagesBySeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        seoDefaultsByRoot: {
            by: {
                type: "LocaleSeoDefaultsByRootUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        seoDefaultsBySeo: {
            by: {
                type: "LocaleSeoDefaultsBySeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        eventsByRoot: {
            by: {
                type: "LocaleEventsByRootUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        eventsByImage: {
            by: {
                type: "LocaleEventsByImageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        eventsBySeo: {
            by: {
                type: "LocaleEventsBySeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        eventsByLink: {
            by: {
                type: "LocaleEventsByLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        eventsByContent: {
            by: {
                type: "LocaleEventsByContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artworksByRoot: {
            by: {
                type: "LocaleArtworksByRootUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artworksByContent: {
            by: {
                type: "LocaleArtworksByContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artworksBySeo: {
            by: {
                type: "LocaleArtworksBySeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artworksByLink: {
            by: {
                type: "LocaleArtworksByLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artworkSelectionsByRoot: {
            by: {
                type: "LocaleArtworkSelectionsByRootUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artworkSelectionsBySeo: {
            by: {
                type: "LocaleArtworkSelectionsBySeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artworkSelectionsByLink: {
            by: {
                type: "LocaleArtworkSelectionsByLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        newsletterFormsByRoot: {
            by: {
                type: "LocaleNewsletterFormsByRootUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        newsletterFormsByItems: {
            by: {
                type: "LocaleNewsletterFormsByItemsUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        employeesByRoot: {
            by: {
                type: "LocaleEmployeesByRootUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        contactFormsByRoot: {
            by: {
                type: "LocaleContactFormsByRootUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        contactFormsByItems: {
            by: {
                type: "LocaleContactFormsByItemsUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContactPages: {
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactPageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateFooters: {
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FooterLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateHeaders: {
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateHomePages: {
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HomePageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginatePages: {
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateSeoDefaults: {
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoDefaultLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEvents: {
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworks: {
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworkSelections: {
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateNewsletterForms: {
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEmployees: {
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContactForms: {
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ContactPageLocaleOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactPageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        address: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        databox: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        databoxNumber: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        addressLink: {
            type: "LinkOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        socialsLabel: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        openingHours: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        identificationsLabel: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        ico: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        dic: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        phoneLabel: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailLabel: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        securities: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        securitiesNumber: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    OrderDirection: "enum",
    ContactPageOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "HomePageLocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "ContactPageLocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "PageLocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "EventLocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "ArtworkLocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "ArtworkSelectionLocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "RedirectOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "HomePageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        media: {
            type: "MediumListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumListOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        description: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        ogTitle: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        ogDescription: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        noIndex: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        noFollow: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        ogImage: {
            type: "ImageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ImageOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        width: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        height: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        size: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        alt: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "PageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EventOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        venue: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        venueNote: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        isDark: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        dateStart: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        dateFinish: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        artist: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        gallery: {
            type: "GalleryOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkSelectionOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworks: {
            type: "ArtworkSelectionListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionListOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    RedirectOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        target: {
            type: "LinkableOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        externalLink: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        internalLink: {
            type: "LinkableOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        anchorLink: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocale: {
        root: {
            filter: {
                type: "FooterWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        locale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        graphicDesigners: {
            filter: {
                type: "GraphicDesignerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GraphicDesignerOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        developerLink: {
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        photographers: {
            filter: {
                type: "PhotographerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PhotographerOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateGraphicDesigners: {
            filter: {
                type: "GraphicDesignerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GraphicDesignerOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginatePhotographers: {
            filter: {
                type: "PhotographerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PhotographerOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    Footer: {
        logo: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        locales: {
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FooterLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLocale: {
            by: {
                type: "FooterLocalesByLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByDeveloperLink: {
            by: {
                type: "FooterLocalesByDeveloperLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLocales: {
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FooterLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    FooterLocaleOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        address: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        graphicDesign: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "FooterOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        developerLink: {
            type: "LinkOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        development: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        photography: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "ImageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocalesByLocaleUniqueWhere: {
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        footers: {
            type: "FooterLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        headers: {
            type: "HeaderLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePages: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        pages: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seoDefaults: {
            type: "SeoDefaultLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        events: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworks: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelections: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterForms: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        employees: {
            type: "EmployeeLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactForms: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactPageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        addressLink: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "RedirectUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "HomePageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        media: {
            type: "MediumListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumListUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "MediumItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumItemUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        blocks: {
            type: "ContentBlockUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        references: {
            type: "ContentReferenceUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        media: {
            type: "MediumListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        dropDownList: {
            type: "DropDownListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        eventList: {
            type: "EventListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        boxList: {
            type: "BoxListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        chart: {
            type: "ChartUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        definitionList: {
            type: "DefinitionListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        logoList: {
            type: "LogoListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        strategySchema: {
            type: "StrategySchemaUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        employeeList: {
            type: "EmployeeListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownListUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "DropDownItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        employees: {
            type: "EmployeeListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownItemUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeListUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "EmployeeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeItemUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventListUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "EventItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventItemUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxListUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "BoxItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxItemUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ChartDataUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartDataUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionListUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "DefinitionItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionItemUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoListUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "LogoItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoItemUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        itemsFirst: {
            type: "StrategySchemaGroupUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        itemsSecond: {
            type: "StrategySchemaGroupUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "StrategySchemaGroupItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupItemUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ImageUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        ogImage: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "PageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EventUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        gallery: {
            type: "GalleryUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "GalleryItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryItemUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkSelectionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworks: {
            type: "ArtworkSelectionListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionListUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ArtworkSelectionItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionItemUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    RedirectUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "FooterUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        developerLink: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "FooterLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "HeaderUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkBreadcrumbParentLink: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "HeaderLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "SeoDefaultUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "SeoDefaultLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "NewsletterFormUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "NewsletterTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        subscriptions: {
            type: "NewsletterSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterSubscriptionUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeLocaleUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EmployeeUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "EmployeeLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactFormUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ContactTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        subscriptions: {
            type: "ContactSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactSubscriptionUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        file: {
            type: "FileUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FileUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocalesByDeveloperLinkUniqueWhere: {
        developerLink: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GraphicDesigner: {
        link: {
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    Link: {
        internalLink: {
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    Linkable: {
        homePage: {
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        contactPage: {
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        page: {
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        event: {
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artwork: {
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artworkSelection: {
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        redirect: {
            filter: {
                type: "RedirectWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    HomePageLocale: {
        root: {
            filter: {
                type: "HomePageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        locale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        content: {
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        link: {
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        seo: {
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        branches: {
            filter: {
                type: "BranchesWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BranchesOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateBranches: {
            filter: {
                type: "BranchesWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BranchesOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    HomePage: {
        locales: {
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HomePageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        media: {
            filter: {
                type: "MediumListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLocale: {
            by: {
                type: "HomePageLocalesByLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByContent: {
            by: {
                type: "HomePageLocalesByContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLink: {
            by: {
                type: "HomePageLocalesByLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesBySeo: {
            by: {
                type: "HomePageLocalesBySeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLocales: {
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HomePageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    MediumList: {
        items: {
            filter: {
                type: "MediumItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "MediumItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateItems: {
            filter: {
                type: "MediumItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "MediumItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    MediumItem: {
        list: {
            filter: {
                type: "MediumListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        medium: {
            filter: {
                type: "MediumWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    Medium: {
        image: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        video: {
            filter: {
                type: "VideoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    Video: {
        poster: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    MediumItemOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "MediumListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        medium: {
            type: "MediumOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        video: {
            type: "VideoOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtubeEmbed: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    VideoOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        src: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        width: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        height: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        size: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        duration: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        poster: {
            type: "ImageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocalesByLocaleUniqueWhere: {
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocalesByContentUniqueWhere: {
        content: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocalesByLinkUniqueWhere: {
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocalesBySeoUniqueWhere: {
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    Content: {
        blocks: {
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentBlockOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        blocksByReferences: {
            by: {
                type: "ContentBlocksByReferencesUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateBlocks: {
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentBlockOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ContentBlock: {
        content: {
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        references: {
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentReferenceOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        referencesByMedia: {
            by: {
                type: "ContentBlockReferencesByMediaUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        referencesByLink: {
            by: {
                type: "ContentBlockReferencesByLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        referencesByDropDownList: {
            by: {
                type: "ContentBlockReferencesByDropDownListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        referencesByEventList: {
            by: {
                type: "ContentBlockReferencesByEventListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        referencesByBoxList: {
            by: {
                type: "ContentBlockReferencesByBoxListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        referencesByChart: {
            by: {
                type: "ContentBlockReferencesByChartUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        referencesByDefinitionList: {
            by: {
                type: "ContentBlockReferencesByDefinitionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        referencesByLogoList: {
            by: {
                type: "ContentBlockReferencesByLogoListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        referencesByStrategySchema: {
            by: {
                type: "ContentBlockReferencesByStrategySchemaUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        referencesByEmployeeList: {
            by: {
                type: "ContentBlockReferencesByEmployeeListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateReferences: {
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentReferenceOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ContentReference: {
        block: {
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        media: {
            filter: {
                type: "MediumListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        link: {
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        dropDownList: {
            filter: {
                type: "DropDownListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artworkSelection: {
            filter: {
                type: "ArtworkSelectionWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        eventList: {
            filter: {
                type: "EventListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        boxList: {
            filter: {
                type: "BoxListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        chart: {
            filter: {
                type: "ChartWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        definitionList: {
            filter: {
                type: "DefinitionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        logoList: {
            filter: {
                type: "LogoListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        strategySchema: {
            filter: {
                type: "StrategySchemaWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        image: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        employeeList: {
            filter: {
                type: "EmployeeListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        imageSecond: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        contactForm: {
            filter: {
                type: "ContactFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        newsletterForm: {
            filter: {
                type: "NewsletterFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    DropDownList: {
        items: {
            filter: {
                type: "DropDownItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DropDownItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        employees: {
            filter: {
                type: "EmployeeListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        itemsByLink: {
            by: {
                type: "DropDownListItemsByLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateItems: {
            filter: {
                type: "DropDownItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DropDownItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    DropDownItem: {
        list: {
            filter: {
                type: "DropDownListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        link: {
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    DropDownItemOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "DropDownListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownListOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        dropDownType: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        employees: {
            type: "EmployeeListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeListOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeList: {
        items: {
            filter: {
                type: "EmployeeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateItems: {
            filter: {
                type: "EmployeeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    EmployeeItem: {
        list: {
            filter: {
                type: "EmployeeListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        employee: {
            filter: {
                type: "EmployeeWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    Employee: {
        image: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        locales: {
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLocale: {
            by: {
                type: "EmployeeLocalesByLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLocales: {
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    EmployeeLocale: {
        root: {
            filter: {
                type: "EmployeeWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        locale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    EmployeeLocaleOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        position: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EmployeeOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeLocalesByLocaleUniqueWhere: {
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeItemOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "EmployeeListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        employee: {
            type: "EmployeeOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownListItemsByLinkUniqueWhere: {
        link: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelection: {
        locales: {
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artworks: {
            filter: {
                type: "ArtworkSelectionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLocale: {
            by: {
                type: "ArtworkSelectionLocalesByLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesBySeo: {
            by: {
                type: "ArtworkSelectionLocalesBySeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLink: {
            by: {
                type: "ArtworkSelectionLocalesByLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLocales: {
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ArtworkSelectionLocale: {
        root: {
            filter: {
                type: "ArtworkSelectionWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        locale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        seo: {
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        link: {
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    Seo: {
        ogImage: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ArtworkSelectionList: {
        items: {
            filter: {
                type: "ArtworkSelectionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateItems: {
            filter: {
                type: "ArtworkSelectionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ArtworkSelectionItem: {
        list: {
            filter: {
                type: "ArtworkSelectionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artwork: {
            filter: {
                type: "ArtworkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    Artwork: {
        locales: {
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        image: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        gallery: {
            filter: {
                type: "GalleryWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLocale: {
            by: {
                type: "ArtworkLocalesByLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByContent: {
            by: {
                type: "ArtworkLocalesByContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesBySeo: {
            by: {
                type: "ArtworkLocalesBySeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLink: {
            by: {
                type: "ArtworkLocalesByLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLocales: {
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ArtworkLocale: {
        root: {
            filter: {
                type: "ArtworkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        locale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        content: {
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        seo: {
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        link: {
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    Gallery: {
        items: {
            filter: {
                type: "GalleryItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GalleryItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateItems: {
            filter: {
                type: "GalleryItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GalleryItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    GalleryItem: {
        list: {
            filter: {
                type: "GalleryWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        image: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    GalleryItemOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "GalleryOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocalesByLocaleUniqueWhere: {
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocalesByContentUniqueWhere: {
        content: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocalesBySeoUniqueWhere: {
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocalesByLinkUniqueWhere: {
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionItemOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ArtworkSelectionListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "ArtworkOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocalesByLocaleUniqueWhere: {
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocalesBySeoUniqueWhere: {
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocalesByLinkUniqueWhere: {
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventList: {
        items: {
            filter: {
                type: "EventItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateItems: {
            filter: {
                type: "EventItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    EventItem: {
        list: {
            filter: {
                type: "EventListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        event: {
            filter: {
                type: "EventWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    Event: {
        locales: {
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLocale: {
            by: {
                type: "EventLocalesByLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByImage: {
            by: {
                type: "EventLocalesByImageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesBySeo: {
            by: {
                type: "EventLocalesBySeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLink: {
            by: {
                type: "EventLocalesByLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByContent: {
            by: {
                type: "EventLocalesByContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLocales: {
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    EventLocale: {
        root: {
            filter: {
                type: "EventWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        locale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        image: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        seo: {
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        link: {
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        content: {
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    EventLocalesByLocaleUniqueWhere: {
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocalesByImageUniqueWhere: {
        image: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocalesBySeoUniqueWhere: {
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocalesByLinkUniqueWhere: {
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocalesByContentUniqueWhere: {
        content: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventItemOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "EventListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "EventOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventListOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxList: {
        items: {
            filter: {
                type: "BoxItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BoxItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateItems: {
            filter: {
                type: "BoxItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BoxItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    BoxItem: {
        list: {
            filter: {
                type: "BoxListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    BoxItemOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "BoxListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxListOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    Chart: {
        items: {
            filter: {
                type: "ChartDataWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ChartDataOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateItems: {
            filter: {
                type: "ChartDataWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ChartDataOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ChartData: {
        list: {
            filter: {
                type: "ChartWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        image: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ChartDataOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ChartOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        number: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionList: {
        items: {
            filter: {
                type: "DefinitionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DefinitionItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateItems: {
            filter: {
                type: "DefinitionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DefinitionItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    DefinitionItem: {
        list: {
            filter: {
                type: "DefinitionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    DefinitionItemOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        key: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        value: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "DefinitionListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionListOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoList: {
        items: {
            filter: {
                type: "LogoItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LogoItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateItems: {
            filter: {
                type: "LogoItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LogoItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    LogoItem: {
        list: {
            filter: {
                type: "LogoListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        image: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    LogoItemOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "LogoListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoListOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchema: {
        itemsFirst: {
            filter: {
                type: "StrategySchemaGroupWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        logo: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        itemsSecond: {
            filter: {
                type: "StrategySchemaGroupWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    StrategySchemaGroup: {
        items: {
            filter: {
                type: "StrategySchemaGroupItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "StrategySchemaGroupItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateItems: {
            filter: {
                type: "StrategySchemaGroupItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "StrategySchemaGroupItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    StrategySchemaGroupItem: {
        schema: {
            filter: {
                type: "StrategySchemaGroupWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    StrategySchemaGroupItemOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        schema: {
            type: "StrategySchemaGroupOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactForm: {
        locales: {
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLocale: {
            by: {
                type: "ContactFormLocalesByLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByItems: {
            by: {
                type: "ContactFormLocalesByItemsUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLocales: {
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ContactFormLocale: {
        root: {
            filter: {
                type: "ContactFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        locale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        items: {
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactTypeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        itemsBySubscriptions: {
            by: {
                type: "ContactFormLocaleItemsBySubscriptionsUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateItems: {
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactTypeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ContactTypeItem: {
        subscriptions: {
            filter: {
                type: "ContactSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactSubscriptionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        list: {
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        subscriptionsByFile: {
            by: {
                type: "ContactTypeItemSubscriptionsByFileUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateSubscriptions: {
            filter: {
                type: "ContactSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactSubscriptionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ContactSubscription: {
        file: {
            filter: {
                type: "FileWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        contactType: {
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ContactSubscriptionOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        createdAt: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        file: {
            type: "FileOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactType: {
            type: "ContactTypeItemOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FileOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        size: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ContactFormLocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactTypeErrorMessage: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactFormOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        file: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemSubscriptionsByFileUniqueWhere: {
        file: {
            type: "FileUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleItemsBySubscriptionsUniqueWhere: {
        subscriptions: {
            type: "ContactSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocalesByLocaleUniqueWhere: {
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocalesByItemsUniqueWhere: {
        items: {
            type: "ContactTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterForm: {
        locales: {
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLocale: {
            by: {
                type: "NewsletterFormLocalesByLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByItems: {
            by: {
                type: "NewsletterFormLocalesByItemsUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLocales: {
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    NewsletterFormLocale: {
        root: {
            filter: {
                type: "NewsletterFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        locale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        items: {
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterTypeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        itemsBySubscriptions: {
            by: {
                type: "NewsletterFormLocaleItemsBySubscriptionsUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateItems: {
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterTypeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    NewsletterTypeItem: {
        list: {
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        subscriptions: {
            filter: {
                type: "NewsletterSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterSubscriptionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateSubscriptions: {
            filter: {
                type: "NewsletterSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterSubscriptionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    NewsletterSubscription: {
        newsletterType: {
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    NewsletterSubscriptionOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        createdAt: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterType: {
            type: "NewsletterTypeItemOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "NewsletterFormLocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeNote: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailNote: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "NewsletterFormOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeErrorMessage: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleItemsBySubscriptionsUniqueWhere: {
        subscriptions: {
            type: "NewsletterSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocalesByLocaleUniqueWhere: {
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocalesByItemsUniqueWhere: {
        items: {
            type: "NewsletterTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        primaryText: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        block: {
            type: "ContentBlockOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        media: {
            type: "MediumListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        secondaryText: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        dropDownList: {
            type: "DropDownListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "ArtworkSelectionOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        eventList: {
            type: "EventListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        boxList: {
            type: "BoxListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        isVisible: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        chart: {
            type: "ChartOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        definitionList: {
            type: "DefinitionListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        logoList: {
            type: "LogoListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        strategySchema: {
            type: "StrategySchemaOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ImageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        employeeList: {
            type: "EmployeeListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        imageSecond: {
            type: "ImageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactForm: {
            type: "ContactFormOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterForm: {
            type: "NewsletterFormOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        json: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        inputFirst: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        inputSecond: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        inputThird: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        outputFirst: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        outputSecond: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        outputThird: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        itemsFirst: {
            type: "StrategySchemaGroupOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "ImageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        itemsSecond: {
            type: "StrategySchemaGroupOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockReferencesByMediaUniqueWhere: {
        media: {
            type: "MediumListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockReferencesByLinkUniqueWhere: {
        link: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockReferencesByDropDownListUniqueWhere: {
        dropDownList: {
            type: "DropDownListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockReferencesByEventListUniqueWhere: {
        eventList: {
            type: "EventListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockReferencesByBoxListUniqueWhere: {
        boxList: {
            type: "BoxListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockReferencesByChartUniqueWhere: {
        chart: {
            type: "ChartUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockReferencesByDefinitionListUniqueWhere: {
        definitionList: {
            type: "DefinitionListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockReferencesByLogoListUniqueWhere: {
        logoList: {
            type: "LogoListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockReferencesByStrategySchemaUniqueWhere: {
        strategySchema: {
            type: "StrategySchemaUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockReferencesByEmployeeListUniqueWhere: {
        employeeList: {
            type: "EmployeeListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlocksByReferencesUniqueWhere: {
        references: {
            type: "ContentReferenceUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    Branches: {
        link: {
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    BranchesOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        more: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocale: {
        link: {
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        root: {
            filter: {
                type: "PageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        locale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        content: {
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        seo: {
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    Page: {
        locales: {
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLocale: {
            by: {
                type: "PageLocalesByLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLink: {
            by: {
                type: "PageLocalesByLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByContent: {
            by: {
                type: "PageLocalesByContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesBySeo: {
            by: {
                type: "PageLocalesBySeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLocales: {
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    PageLocalesByLocaleUniqueWhere: {
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocalesByLinkUniqueWhere: {
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocalesByContentUniqueWhere: {
        content: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocalesBySeoUniqueWhere: {
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    Redirect: {
        link: {
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        target: {
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    GraphicDesignerOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    Photographer: {
        link: {
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    PhotographerOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocale: {
        root: {
            filter: {
                type: "HeaderWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        locale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        links: {
            filter: {
                type: "HeaderLinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderLinkOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artworkBreadcrumbParentLink: {
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLinks: {
            filter: {
                type: "HeaderLinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderLinkOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    Header: {
        locales: {
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        logo: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLocale: {
            by: {
                type: "HeaderLocalesByLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByArtworkBreadcrumbParentLink: {
            by: {
                type: "HeaderLocalesByArtworkBreadcrumbParentLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLocales: {
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    HeaderLocaleOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "HeaderOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkBreadcrumbParentLink: {
            type: "LinkableOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "ImageOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocalesByLocaleUniqueWhere: {
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocalesByArtworkBreadcrumbParentLinkUniqueWhere: {
        artworkBreadcrumbParentLink: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLink: {
        link: {
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    HeaderLinkOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocale: {
        root: {
            filter: {
                type: "SeoDefaultWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        locale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        seo: {
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    SeoDefault: {
        locales: {
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoDefaultLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesByLocale: {
            by: {
                type: "SeoDefaultLocalesByLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        localesBySeo: {
            by: {
                type: "SeoDefaultLocalesBySeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLocales: {
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoDefaultLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    SeoDefaultLocaleOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "SeoDefaultOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "LocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocalesByLocaleUniqueWhere: {
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocalesBySeoUniqueWhere: {
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleContactPagesByRootUniqueWhere: {
        root: {
            type: "ContactPageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleContactPagesByLinkUniqueWhere: {
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleContactPagesBySeoUniqueWhere: {
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleContactPagesByAddressLinkUniqueWhere: {
        addressLink: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleFootersByRootUniqueWhere: {
        root: {
            type: "FooterUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleFootersByDeveloperLinkUniqueWhere: {
        developerLink: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleHeadersByRootUniqueWhere: {
        root: {
            type: "HeaderUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleHeadersByArtworkBreadcrumbParentLinkUniqueWhere: {
        artworkBreadcrumbParentLink: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleHomePagesByRootUniqueWhere: {
        root: {
            type: "HomePageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleHomePagesByContentUniqueWhere: {
        content: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleHomePagesByLinkUniqueWhere: {
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleHomePagesBySeoUniqueWhere: {
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocalePagesByRootUniqueWhere: {
        root: {
            type: "PageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocalePagesByLinkUniqueWhere: {
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocalePagesByContentUniqueWhere: {
        content: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocalePagesBySeoUniqueWhere: {
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleSeoDefaultsByRootUniqueWhere: {
        root: {
            type: "SeoDefaultUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleSeoDefaultsBySeoUniqueWhere: {
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleEventsByRootUniqueWhere: {
        root: {
            type: "EventUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleEventsByImageUniqueWhere: {
        image: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleEventsBySeoUniqueWhere: {
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleEventsByLinkUniqueWhere: {
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleEventsByContentUniqueWhere: {
        content: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleArtworksByRootUniqueWhere: {
        root: {
            type: "ArtworkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleArtworksByContentUniqueWhere: {
        content: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleArtworksBySeoUniqueWhere: {
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleArtworksByLinkUniqueWhere: {
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleArtworkSelectionsByRootUniqueWhere: {
        root: {
            type: "ArtworkSelectionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleArtworkSelectionsBySeoUniqueWhere: {
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleArtworkSelectionsByLinkUniqueWhere: {
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleNewsletterFormsByRootUniqueWhere: {
        root: {
            type: "NewsletterFormUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleNewsletterFormsByItemsUniqueWhere: {
        items: {
            type: "NewsletterTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleEmployeesByRootUniqueWhere: {
        root: {
            type: "EmployeeUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleContactFormsByRootUniqueWhere: {
        root: {
            type: "ContactFormUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleContactFormsByItemsUniqueWhere: {
        items: {
            type: "ContactTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocalesByLocaleUniqueWhere: {
        locale: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocalesByLinkUniqueWhere: {
        link: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocalesBySeoUniqueWhere: {
        seo: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocalesByAddressLinkUniqueWhere: {
        addressLink: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ContactPageCreateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageCreateLocalesEntityRelationInput: {
        connect: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactPageLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleWithoutRootCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ContactPageLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ContactPageLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ContactPageLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        address: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databox: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databoxNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        addressLink: {
            type: "ContactPageLocaleCreateAddressLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        socialsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        openingHours: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        identificationsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        ico: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        dic: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phoneLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securities: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securitiesNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleCreateLocaleEntityRelationInput: {
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutContactPagesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutContactPagesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        footers: {
            type: "LocaleCreateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleCreateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleCreateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleCreatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleCreateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleCreateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleCreateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleCreateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleCreateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleCreateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleCreateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleCreateFootersEntityRelationInput: {
        connect: {
            type: "FooterLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "FooterLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleWithoutLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        address: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        graphicDesign: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "FooterLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        graphicDesigners: {
            type: "FooterLocaleCreateGraphicDesignersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        developerLink: {
            type: "FooterLocaleCreateDeveloperLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        development: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        photography: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        photographers: {
            type: "FooterLocaleCreatePhotographersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleCreateRootEntityRelationInput: {
        connect: {
            type: "FooterUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "FooterWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterWithoutLocalesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "FooterCreateLogoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterCreateLogoEntityRelationInput: {
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ImageCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        width: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        height: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        size: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        alt: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleCreateGraphicDesignersEntityRelationInput: {
        connect: {
            type: "GraphicDesignerUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "GraphicDesignerCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GraphicDesignerUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GraphicDesignerCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "GraphicDesignerCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GraphicDesignerCreateLinkEntityRelationInput: {
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "LinkType",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        externalLink: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        internalLink: {
            type: "LinkCreateInternalLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        anchorLink: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkCreateInternalLinkEntityRelationInput: {
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "LinkableCreateHomePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "LinkableCreateContactPageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "LinkableCreatePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "LinkableCreateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "LinkableCreateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "LinkableCreateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "LinkableCreateRedirectEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableCreateHomePageEntityRelationInput: {
        connect: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HomePageLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleWithoutLinkCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "HomePageLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "HomePageLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "HomePageLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "HomePageLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        branches: {
            type: "HomePageLocaleCreateBranchesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleCreateRootEntityRelationInput: {
        connect: {
            type: "HomePageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HomePageWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageWithoutLocalesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        media: {
            type: "HomePageCreateMediaEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageCreateMediaEntityRelationInput: {
        connect: {
            type: "MediumListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "MediumListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "MediumListCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumListCreateItemsEntityRelationInput: {
        connect: {
            type: "MediumItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "MediumItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumItemWithoutListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        medium: {
            type: "MediumItemCreateMediumEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumItemCreateMediumEntityRelationInput: {
        connect: {
            type: "MediumUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "MediumCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "MediumType",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "MediumCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        video: {
            type: "MediumCreateVideoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtubeEmbed: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumCreateImageEntityRelationInput: {
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumCreateVideoEntityRelationInput: {
        connect: {
            type: "VideoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "VideoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    VideoUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    VideoCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        src: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        width: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        height: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        size: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        duration: {
            type: "Float",
            array: false,
            arrayRequired: false,
            required: false
        },
        poster: {
            type: "VideoCreatePosterEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    VideoCreatePosterEntityRelationInput: {
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleCreateLocaleEntityRelationInput: {
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutHomePagesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutHomePagesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleCreateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleCreateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleCreateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleCreatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleCreateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleCreateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleCreateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleCreateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleCreateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleCreateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleCreateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleCreateContactPagesEntityRelationInput: {
        connect: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactPageLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleWithoutLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactPageLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ContactPageLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ContactPageLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        address: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databox: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databoxNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        addressLink: {
            type: "ContactPageLocaleCreateAddressLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        socialsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        openingHours: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        identificationsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        ico: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        dic: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phoneLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securities: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securitiesNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleCreateRootEntityRelationInput: {
        connect: {
            type: "ContactPageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactPageWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageWithoutLocalesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleCreateLinkEntityRelationInput: {
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableWithoutContactPageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableWithoutContactPageCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "LinkableCreateHomePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "LinkableCreatePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "LinkableCreateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "LinkableCreateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "LinkableCreateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "LinkableCreateRedirectEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableCreatePageEntityRelationInput: {
        connect: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "PageLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleWithoutLinkCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "PageLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "PageLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "PageLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "PageLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleCreateRootEntityRelationInput: {
        connect: {
            type: "PageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "PageWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageWithoutLocalesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleCreateLocaleEntityRelationInput: {
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutPagesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutPagesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleCreateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleCreateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleCreateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleCreateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleCreateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleCreateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleCreateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleCreateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleCreateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleCreateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleCreateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleCreateHeadersEntityRelationInput: {
        connect: {
            type: "HeaderLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HeaderLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleWithoutLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "HeaderLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        links: {
            type: "HeaderLocaleCreateLinksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkBreadcrumbParentLink: {
            type: "HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleCreateRootEntityRelationInput: {
        connect: {
            type: "HeaderUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HeaderWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderWithoutLocalesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "HeaderCreateLogoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderCreateLogoEntityRelationInput: {
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleCreateLinksEntityRelationInput: {
        connect: {
            type: "HeaderLinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HeaderLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLinkUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLinkCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "HeaderLinkCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLinkCreateLinkEntityRelationInput: {
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput: {
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleCreateHomePagesEntityRelationInput: {
        connect: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HomePageLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleWithoutLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "HomePageLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "HomePageLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "HomePageLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "HomePageLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        branches: {
            type: "HomePageLocaleCreateBranchesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleCreateContentEntityRelationInput: {
        connect: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        blocks: {
            type: "ContentCreateBlocksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentCreateBlocksEntityRelationInput: {
        connect: {
            type: "ContentBlockUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentBlockWithoutContentCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockWithoutContentCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        json: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        references: {
            type: "ContentBlockCreateReferencesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockCreateReferencesEntityRelationInput: {
        connect: {
            type: "ContentReferenceUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentReferenceWithoutBlockCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceWithoutBlockCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "ContentReferenceType",
            array: false,
            arrayRequired: false,
            required: false
        },
        primaryText: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        media: {
            type: "ContentReferenceCreateMediaEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ContentReferenceCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        secondaryText: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        dropDownList: {
            type: "ContentReferenceCreateDropDownListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "ContentReferenceCreateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        eventList: {
            type: "ContentReferenceCreateEventListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        boxList: {
            type: "ContentReferenceCreateBoxListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        isVisible: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        chart: {
            type: "ContentReferenceCreateChartEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        definitionList: {
            type: "ContentReferenceCreateDefinitionListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        logoList: {
            type: "ContentReferenceCreateLogoListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        strategySchema: {
            type: "ContentReferenceCreateStrategySchemaEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ContentReferenceCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        employeeList: {
            type: "ContentReferenceCreateEmployeeListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        imageSecond: {
            type: "ContentReferenceCreateImageSecondEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactForm: {
            type: "ContentReferenceCreateContactFormEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterForm: {
            type: "ContentReferenceCreateNewsletterFormEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateMediaEntityRelationInput: {
        connect: {
            type: "MediumListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "MediumListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateLinkEntityRelationInput: {
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateDropDownListEntityRelationInput: {
        connect: {
            type: "DropDownListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "DropDownListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "DropDownListCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        dropDownType: {
            type: "DropDownType",
            array: false,
            arrayRequired: false,
            required: false
        },
        employees: {
            type: "DropDownListCreateEmployeesEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownListCreateItemsEntityRelationInput: {
        connect: {
            type: "DropDownItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "DropDownItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownItemWithoutListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "DropDownItemCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownItemCreateLinkEntityRelationInput: {
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownListCreateEmployeesEntityRelationInput: {
        connect: {
            type: "EmployeeListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "EmployeeListCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeListCreateItemsEntityRelationInput: {
        connect: {
            type: "EmployeeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeItemWithoutListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        employee: {
            type: "EmployeeItemCreateEmployeeEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeItemCreateEmployeeEntityRelationInput: {
        connect: {
            type: "EmployeeUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "EmployeeCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "EmployeeCreateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeCreateImageEntityRelationInput: {
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeCreateLocalesEntityRelationInput: {
        connect: {
            type: "EmployeeLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeLocaleWithoutRootCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        position: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "EmployeeLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeLocaleCreateLocaleEntityRelationInput: {
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutEmployeesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutEmployeesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleCreateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleCreateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleCreateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleCreateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleCreatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleCreateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleCreateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleCreateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleCreateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleCreateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleCreateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleCreatePagesEntityRelationInput: {
        connect: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "PageLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleWithoutLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "PageLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "PageLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "PageLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "PageLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleCreateLinkEntityRelationInput: {
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableWithoutPageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableWithoutPageCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "LinkableCreateHomePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "LinkableCreateContactPageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "LinkableCreateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "LinkableCreateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "LinkableCreateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "LinkableCreateRedirectEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableCreateContactPageEntityRelationInput: {
        connect: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactPageLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleWithoutLinkCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactPageLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ContactPageLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ContactPageLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        address: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databox: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databoxNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        addressLink: {
            type: "ContactPageLocaleCreateAddressLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        socialsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        openingHours: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        identificationsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        ico: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        dic: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phoneLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securities: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securitiesNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleCreateSeoEntityRelationInput: {
        connect: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        description: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        ogTitle: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        ogDescription: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        noIndex: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        noFollow: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        ogImage: {
            type: "SeoCreateOgImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoCreateOgImageEntityRelationInput: {
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleCreateAddressLinkEntityRelationInput: {
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableCreateEventEntityRelationInput: {
        connect: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleWithoutLinkCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EventLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "EventLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "EventLocaleCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "EventLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        venue: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        venueNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "EventLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        isDark: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleCreateRootEntityRelationInput: {
        connect: {
            type: "EventUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventWithoutLocalesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        dateStart: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        dateFinish: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleCreateLocaleEntityRelationInput: {
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutEventsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutEventsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleCreateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleCreateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleCreateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleCreateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleCreatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleCreateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleCreateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleCreateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleCreateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleCreateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleCreateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleCreateSeoDefaultsEntityRelationInput: {
        connect: {
            type: "SeoDefaultLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoDefaultLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleWithoutLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "SeoDefaultLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoDefaultLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleCreateRootEntityRelationInput: {
        connect: {
            type: "SeoDefaultUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoDefaultWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultWithoutLocalesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleCreateSeoEntityRelationInput: {
        connect: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleCreateArtworksEntityRelationInput: {
        connect: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleWithoutLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ArtworkLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ArtworkLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artist: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleCreateRootEntityRelationInput: {
        connect: {
            type: "ArtworkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkWithoutLocalesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ArtworkCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        gallery: {
            type: "ArtworkCreateGalleryEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkCreateImageEntityRelationInput: {
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkCreateGalleryEntityRelationInput: {
        connect: {
            type: "GalleryUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "GalleryCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "GalleryCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryCreateItemsEntityRelationInput: {
        connect: {
            type: "GalleryItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "GalleryItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryItemWithoutListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "GalleryItemCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryItemCreateImageEntityRelationInput: {
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleCreateContentEntityRelationInput: {
        connect: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleCreateSeoEntityRelationInput: {
        connect: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleCreateLinkEntityRelationInput: {
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableWithoutArtworkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableWithoutArtworkCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "LinkableCreateHomePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "LinkableCreateContactPageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "LinkableCreatePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "LinkableCreateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "LinkableCreateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "LinkableCreateRedirectEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableCreateArtworkSelectionEntityRelationInput: {
        connect: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleWithoutLinkCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkSelectionLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ArtworkSelectionLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkSelectionLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleCreateRootEntityRelationInput: {
        connect: {
            type: "ArtworkSelectionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionWithoutLocalesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworks: {
            type: "ArtworkSelectionCreateArtworksEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionCreateArtworksEntityRelationInput: {
        connect: {
            type: "ArtworkSelectionListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ArtworkSelectionListCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionListCreateItemsEntityRelationInput: {
        connect: {
            type: "ArtworkSelectionItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionItemWithoutListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "ArtworkSelectionItemCreateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionItemCreateArtworkEntityRelationInput: {
        connect: {
            type: "ArtworkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ArtworkCreateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        image: {
            type: "ArtworkCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        gallery: {
            type: "ArtworkCreateGalleryEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkCreateLocalesEntityRelationInput: {
        connect: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleWithoutRootCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ArtworkLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ArtworkLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ArtworkLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artist: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleCreateLocaleEntityRelationInput: {
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutArtworksCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutArtworksCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleCreateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleCreateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleCreateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleCreateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleCreatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleCreateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleCreateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleCreateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleCreateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleCreateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleCreateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleCreateEventsEntityRelationInput: {
        connect: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleWithoutLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EventLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "EventLocaleCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "EventLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "EventLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        venue: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        venueNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "EventLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        isDark: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleCreateImageEntityRelationInput: {
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleCreateSeoEntityRelationInput: {
        connect: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleCreateLinkEntityRelationInput: {
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableWithoutEventCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableWithoutEventCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "LinkableCreateHomePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "LinkableCreateContactPageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "LinkableCreatePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "LinkableCreateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "LinkableCreateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "LinkableCreateRedirectEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableCreateArtworkEntityRelationInput: {
        connect: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleWithoutLinkCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ArtworkLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ArtworkLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artist: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableCreateRedirectEntityRelationInput: {
        connect: {
            type: "RedirectUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "RedirectWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    RedirectWithoutLinkCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        target: {
            type: "RedirectCreateTargetEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    RedirectCreateTargetEntityRelationInput: {
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleCreateContentEntityRelationInput: {
        connect: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleCreateArtworkSelectionsEntityRelationInput: {
        connect: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleWithoutLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkSelectionLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkSelectionLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ArtworkSelectionLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleCreateSeoEntityRelationInput: {
        connect: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleCreateLinkEntityRelationInput: {
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableWithoutArtworkSelectionCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableWithoutArtworkSelectionCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "LinkableCreateHomePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "LinkableCreateContactPageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "LinkableCreatePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "LinkableCreateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "LinkableCreateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "LinkableCreateRedirectEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleCreateNewsletterFormsEntityRelationInput: {
        connect: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterFormLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleWithoutLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "NewsletterFormLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "NewsletterFormLocaleCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleCreateRootEntityRelationInput: {
        connect: {
            type: "NewsletterFormUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterFormWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormWithoutLocalesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleCreateItemsEntityRelationInput: {
        connect: {
            type: "NewsletterTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterTypeItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemWithoutListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        subscriptions: {
            type: "NewsletterTypeItemCreateSubscriptionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemCreateSubscriptionsEntityRelationInput: {
        connect: {
            type: "NewsletterSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterSubscriptionWithoutNewsletterTypeCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterSubscriptionWithoutNewsletterTypeCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        createdAt: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleCreateEmployeesEntityRelationInput: {
        connect: {
            type: "EmployeeLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeLocaleWithoutLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        position: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EmployeeLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeLocaleCreateRootEntityRelationInput: {
        connect: {
            type: "EmployeeUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeWithoutLocalesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "EmployeeCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleCreateContactFormsEntityRelationInput: {
        connect: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactFormLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleWithoutLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactFormLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ContactFormLocaleCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        file: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleCreateRootEntityRelationInput: {
        connect: {
            type: "ContactFormUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactFormWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormWithoutLocalesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleCreateItemsEntityRelationInput: {
        connect: {
            type: "ContactTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactTypeItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemWithoutListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        subscriptions: {
            type: "ContactTypeItemCreateSubscriptionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemCreateSubscriptionsEntityRelationInput: {
        connect: {
            type: "ContactSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactSubscriptionWithoutContactTypeCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactSubscriptionWithoutContactTypeCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        createdAt: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        file: {
            type: "ContactSubscriptionCreateFileEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactSubscriptionCreateFileEntityRelationInput: {
        connect: {
            type: "FileUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "FileCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FileCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        size: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleCreateLocaleEntityRelationInput: {
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutArtworkSelectionsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutArtworkSelectionsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleCreateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleCreateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleCreateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleCreateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleCreatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleCreateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleCreateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleCreateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleCreateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleCreateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleCreateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleCreateContentEntityRelationInput: {
        connect: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleCreateSeoEntityRelationInput: {
        connect: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateArtworkSelectionEntityRelationInput: {
        connect: {
            type: "ArtworkSelectionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ArtworkSelectionCreateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "ArtworkSelectionCreateArtworksEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionCreateLocalesEntityRelationInput: {
        connect: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleWithoutRootCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ArtworkSelectionLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkSelectionLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ArtworkSelectionLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateEventListEntityRelationInput: {
        connect: {
            type: "EventListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "EventListCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventListCreateItemsEntityRelationInput: {
        connect: {
            type: "EventItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventItemWithoutListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "EventItemCreateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventItemCreateEventEntityRelationInput: {
        connect: {
            type: "EventUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "EventCreateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        dateStart: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        dateFinish: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventCreateLocalesEntityRelationInput: {
        connect: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleWithoutRootCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "EventLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "EventLocaleCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "EventLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "EventLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        venue: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        venueNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "EventLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        isDark: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateBoxListEntityRelationInput: {
        connect: {
            type: "BoxListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "BoxListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "BoxListCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxListCreateItemsEntityRelationInput: {
        connect: {
            type: "BoxItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "BoxItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxItemWithoutListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateChartEntityRelationInput: {
        connect: {
            type: "ChartUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ChartCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "ChartType",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ChartCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartCreateItemsEntityRelationInput: {
        connect: {
            type: "ChartDataUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ChartDataWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartDataWithoutListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "Date",
            array: false,
            arrayRequired: false,
            required: false
        },
        number: {
            type: "Float",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ChartDataCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartDataCreateImageEntityRelationInput: {
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateDefinitionListEntityRelationInput: {
        connect: {
            type: "DefinitionListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "DefinitionListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "DefinitionListCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionListCreateItemsEntityRelationInput: {
        connect: {
            type: "DefinitionItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "DefinitionItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionItemWithoutListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        key: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        value: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateLogoListEntityRelationInput: {
        connect: {
            type: "LogoListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LogoListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "LogoListCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoListCreateItemsEntityRelationInput: {
        connect: {
            type: "LogoItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LogoItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoItemWithoutListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "LogoItemCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoItemCreateImageEntityRelationInput: {
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateStrategySchemaEntityRelationInput: {
        connect: {
            type: "StrategySchemaUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "StrategySchemaCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        inputFirst: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        inputSecond: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        inputThird: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        outputFirst: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        outputSecond: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        outputThird: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        itemsFirst: {
            type: "StrategySchemaCreateItemsFirstEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "StrategySchemaCreateLogoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        itemsSecond: {
            type: "StrategySchemaCreateItemsSecondEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaCreateItemsFirstEntityRelationInput: {
        connect: {
            type: "StrategySchemaGroupUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "StrategySchemaGroupCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "StrategySchemaGroupCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupCreateItemsEntityRelationInput: {
        connect: {
            type: "StrategySchemaGroupItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "StrategySchemaGroupItemWithoutSchemaCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupItemWithoutSchemaCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaCreateLogoEntityRelationInput: {
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaCreateItemsSecondEntityRelationInput: {
        connect: {
            type: "StrategySchemaGroupUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "StrategySchemaGroupCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateImageEntityRelationInput: {
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateEmployeeListEntityRelationInput: {
        connect: {
            type: "EmployeeListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateImageSecondEntityRelationInput: {
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateContactFormEntityRelationInput: {
        connect: {
            type: "ContactFormUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactFormCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ContactFormCreateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormCreateLocalesEntityRelationInput: {
        connect: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactFormLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleWithoutRootCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ContactFormLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ContactFormLocaleCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        file: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleCreateLocaleEntityRelationInput: {
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutContactFormsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutContactFormsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleCreateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleCreateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleCreateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleCreateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleCreatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleCreateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleCreateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleCreateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleCreateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleCreateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleCreateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateNewsletterFormEntityRelationInput: {
        connect: {
            type: "NewsletterFormUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterFormCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "NewsletterFormCreateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormCreateLocalesEntityRelationInput: {
        connect: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterFormLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleWithoutRootCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "NewsletterFormLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "NewsletterFormLocaleCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleCreateLocaleEntityRelationInput: {
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutNewsletterFormsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutNewsletterFormsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleCreateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleCreateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleCreateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleCreateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleCreatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleCreateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleCreateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleCreateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleCreateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleCreateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleCreateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleCreateLinkEntityRelationInput: {
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableWithoutHomePageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableWithoutHomePageCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "LinkableCreateContactPageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "LinkableCreatePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "LinkableCreateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "LinkableCreateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "LinkableCreateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "LinkableCreateRedirectEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleCreateSeoEntityRelationInput: {
        connect: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleCreateBranchesEntityRelationInput: {
        connect: {
            type: "BranchesUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "BranchesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BranchesUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BranchesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        more: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "BranchesCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BranchesCreateLinkEntityRelationInput: {
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleCreateDeveloperLinkEntityRelationInput: {
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleCreatePhotographersEntityRelationInput: {
        connect: {
            type: "PhotographerUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "PhotographerCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PhotographerUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PhotographerCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "PhotographerCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PhotographerCreateLinkEntityRelationInput: {
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageUpdateInput: {
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ContactPageUpdateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageUpdateLocalesEntityRelationInput: {
        create: {
            type: "ContactPageLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactPageUpdateLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContactPageUpsertLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageUpdateLocalesRelationInput: {
        by: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "ContactPageLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleWithoutRootUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ContactPageLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ContactPageLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ContactPageLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        address: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databox: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databoxNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        addressLink: {
            type: "ContactPageLocaleUpdateAddressLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        socialsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        openingHours: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        identificationsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        ico: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        dic: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phoneLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securities: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securitiesNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleUpdateLocaleEntityRelationInput: {
        create: {
            type: "LocaleWithoutContactPagesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleWithoutContactPagesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContactPageLocaleUpsertLocaleRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutContactPagesUpdateInput: {
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        footers: {
            type: "LocaleUpdateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleUpdateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleUpdateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleUpdatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleUpdateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleUpdateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleUpdateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleUpdateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleUpdateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleUpdateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleUpdateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateFootersEntityRelationInput: {
        create: {
            type: "FooterLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleUpdateFootersRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LocaleUpsertFootersRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "FooterLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "FooterLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "FooterLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateFootersRelationInput: {
        by: {
            type: "FooterLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "FooterLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleWithoutLocaleUpdateInput: {
        address: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        graphicDesign: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "FooterLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        graphicDesigners: {
            type: "FooterLocaleUpdateGraphicDesignersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        developerLink: {
            type: "FooterLocaleUpdateDeveloperLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        development: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        photography: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        photographers: {
            type: "FooterLocaleUpdatePhotographersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleUpdateRootEntityRelationInput: {
        create: {
            type: "FooterWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "FooterWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "FooterLocaleUpsertRootRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "FooterUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterWithoutLocalesUpdateInput: {
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "FooterUpdateLogoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterUpdateLogoEntityRelationInput: {
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "FooterUpsertLogoRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ImageUpdateInput: {
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        width: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        height: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        size: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        alt: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterUpsertLogoRelationInput: {
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleUpsertRootRelationInput: {
        update: {
            type: "FooterWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "FooterWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleUpdateGraphicDesignersEntityRelationInput: {
        create: {
            type: "GraphicDesignerCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "FooterLocaleUpdateGraphicDesignersRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "FooterLocaleUpsertGraphicDesignersRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "GraphicDesignerUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "GraphicDesignerUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "GraphicDesignerUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleUpdateGraphicDesignersRelationInput: {
        by: {
            type: "GraphicDesignerUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "GraphicDesignerUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GraphicDesignerUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "GraphicDesignerUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GraphicDesignerUpdateLinkEntityRelationInput: {
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "GraphicDesignerUpsertLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkUpdateInput: {
        type: {
            type: "LinkType",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        externalLink: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        internalLink: {
            type: "LinkUpdateInternalLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        anchorLink: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkUpdateInternalLinkEntityRelationInput: {
        create: {
            type: "LinkableCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkableUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LinkUpsertInternalLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUpdateInput: {
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "LinkableUpdateHomePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "LinkableUpdateContactPageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "LinkableUpdatePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "LinkableUpdateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "LinkableUpdateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "LinkableUpdateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "LinkableUpdateRedirectEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUpdateHomePageEntityRelationInput: {
        create: {
            type: "HomePageLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "HomePageLocaleWithoutLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LinkableUpsertHomePageRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleWithoutLinkUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "HomePageLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "HomePageLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "HomePageLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "HomePageLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        branches: {
            type: "HomePageLocaleUpdateBranchesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleUpdateRootEntityRelationInput: {
        create: {
            type: "HomePageWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "HomePageWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "HomePageLocaleUpsertRootRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "HomePageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageWithoutLocalesUpdateInput: {
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        media: {
            type: "HomePageUpdateMediaEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageUpdateMediaEntityRelationInput: {
        create: {
            type: "MediumListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "MediumListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "HomePageUpsertMediaRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "MediumListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumListUpdateInput: {
        items: {
            type: "MediumListUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumListUpdateItemsEntityRelationInput: {
        create: {
            type: "MediumItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "MediumListUpdateItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "MediumListUpsertItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "MediumItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "MediumItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "MediumItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumListUpdateItemsRelationInput: {
        by: {
            type: "MediumItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "MediumItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumItemWithoutListUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        medium: {
            type: "MediumItemUpdateMediumEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumItemUpdateMediumEntityRelationInput: {
        create: {
            type: "MediumCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "MediumUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "MediumItemUpsertMediumRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "MediumUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumUpdateInput: {
        type: {
            type: "MediumType",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "MediumUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        video: {
            type: "MediumUpdateVideoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtubeEmbed: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumUpdateImageEntityRelationInput: {
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "MediumUpsertImageRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumUpsertImageRelationInput: {
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumUpdateVideoEntityRelationInput: {
        create: {
            type: "VideoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "VideoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "MediumUpsertVideoRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "VideoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    VideoUpdateInput: {
        src: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        width: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        height: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        size: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        duration: {
            type: "Float",
            array: false,
            arrayRequired: false,
            required: false
        },
        poster: {
            type: "VideoUpdatePosterEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    VideoUpdatePosterEntityRelationInput: {
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "VideoUpsertPosterRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    VideoUpsertPosterRelationInput: {
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumUpsertVideoRelationInput: {
        update: {
            type: "VideoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "VideoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumItemUpsertMediumRelationInput: {
        update: {
            type: "MediumUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "MediumCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumListUpsertItemsRelationInput: {
        by: {
            type: "MediumItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "MediumItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "MediumItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageUpsertMediaRelationInput: {
        update: {
            type: "MediumListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "MediumListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleUpsertRootRelationInput: {
        update: {
            type: "HomePageWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HomePageWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleUpdateLocaleEntityRelationInput: {
        create: {
            type: "LocaleWithoutHomePagesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleWithoutHomePagesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "HomePageLocaleUpsertLocaleRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutHomePagesUpdateInput: {
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleUpdateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleUpdateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleUpdateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleUpdatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleUpdateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleUpdateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleUpdateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleUpdateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleUpdateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleUpdateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleUpdateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateContactPagesEntityRelationInput: {
        create: {
            type: "ContactPageLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleUpdateContactPagesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LocaleUpsertContactPagesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateContactPagesRelationInput: {
        by: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "ContactPageLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleWithoutLocaleUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactPageLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ContactPageLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ContactPageLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        address: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databox: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databoxNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        addressLink: {
            type: "ContactPageLocaleUpdateAddressLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        socialsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        openingHours: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        identificationsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        ico: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        dic: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phoneLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securities: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securitiesNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleUpdateRootEntityRelationInput: {
        create: {
            type: "ContactPageWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactPageWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContactPageLocaleUpsertRootRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContactPageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageWithoutLocalesUpdateInput: {
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleUpsertRootRelationInput: {
        update: {
            type: "ContactPageWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactPageWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleUpdateLinkEntityRelationInput: {
        create: {
            type: "LinkableWithoutContactPageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkableWithoutContactPageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContactPageLocaleUpsertLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableWithoutContactPageUpdateInput: {
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "LinkableUpdateHomePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "LinkableUpdatePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "LinkableUpdateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "LinkableUpdateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "LinkableUpdateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "LinkableUpdateRedirectEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUpdatePageEntityRelationInput: {
        create: {
            type: "PageLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "PageLocaleWithoutLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LinkableUpsertPageRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleWithoutLinkUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "PageLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "PageLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "PageLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "PageLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleUpdateRootEntityRelationInput: {
        create: {
            type: "PageWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "PageWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "PageLocaleUpsertRootRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "PageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageWithoutLocalesUpdateInput: {
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleUpsertRootRelationInput: {
        update: {
            type: "PageWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "PageWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleUpdateLocaleEntityRelationInput: {
        create: {
            type: "LocaleWithoutPagesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleWithoutPagesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "PageLocaleUpsertLocaleRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutPagesUpdateInput: {
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleUpdateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleUpdateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleUpdateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleUpdateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleUpdateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleUpdateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleUpdateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleUpdateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleUpdateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleUpdateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleUpdateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateHeadersEntityRelationInput: {
        create: {
            type: "HeaderLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleUpdateHeadersRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LocaleUpsertHeadersRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "HeaderLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "HeaderLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "HeaderLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateHeadersRelationInput: {
        by: {
            type: "HeaderLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "HeaderLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleWithoutLocaleUpdateInput: {
        root: {
            type: "HeaderLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        links: {
            type: "HeaderLocaleUpdateLinksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkBreadcrumbParentLink: {
            type: "HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleUpdateRootEntityRelationInput: {
        create: {
            type: "HeaderWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "HeaderWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "HeaderLocaleUpsertRootRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "HeaderUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderWithoutLocalesUpdateInput: {
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "HeaderUpdateLogoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderUpdateLogoEntityRelationInput: {
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "HeaderUpsertLogoRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderUpsertLogoRelationInput: {
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleUpsertRootRelationInput: {
        update: {
            type: "HeaderWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HeaderWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleUpdateLinksEntityRelationInput: {
        create: {
            type: "HeaderLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "HeaderLocaleUpdateLinksRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "HeaderLocaleUpsertLinksRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "HeaderLinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "HeaderLinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "HeaderLinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleUpdateLinksRelationInput: {
        by: {
            type: "HeaderLinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "HeaderLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLinkUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "HeaderLinkUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLinkUpdateLinkEntityRelationInput: {
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "HeaderLinkUpsertLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLinkUpsertLinkRelationInput: {
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleUpsertLinksRelationInput: {
        by: {
            type: "HeaderLinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "HeaderLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HeaderLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput: {
        create: {
            type: "LinkableCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkableUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "HeaderLocaleUpsertArtworkBreadcrumbParentLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleUpsertArtworkBreadcrumbParentLinkRelationInput: {
        update: {
            type: "LinkableUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpsertHeadersRelationInput: {
        by: {
            type: "HeaderLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "HeaderLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HeaderLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateHomePagesEntityRelationInput: {
        create: {
            type: "HomePageLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleUpdateHomePagesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LocaleUpsertHomePagesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateHomePagesRelationInput: {
        by: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "HomePageLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleWithoutLocaleUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "HomePageLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "HomePageLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "HomePageLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "HomePageLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        branches: {
            type: "HomePageLocaleUpdateBranchesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleUpdateContentEntityRelationInput: {
        create: {
            type: "ContentCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContentUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "HomePageLocaleUpsertContentRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentUpdateInput: {
        blocks: {
            type: "ContentUpdateBlocksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentUpdateBlocksEntityRelationInput: {
        create: {
            type: "ContentBlockWithoutContentCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContentUpdateBlocksRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentUpsertBlocksRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContentBlockUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "ContentBlockUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "ContentBlockUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentUpdateBlocksRelationInput: {
        by: {
            type: "ContentBlockUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "ContentBlockWithoutContentUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockWithoutContentUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        json: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        references: {
            type: "ContentBlockUpdateReferencesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockUpdateReferencesEntityRelationInput: {
        create: {
            type: "ContentReferenceWithoutBlockCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContentBlockUpdateReferencesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentBlockUpsertReferencesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContentReferenceUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "ContentReferenceUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "ContentReferenceUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockUpdateReferencesRelationInput: {
        by: {
            type: "ContentReferenceUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "ContentReferenceWithoutBlockUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceWithoutBlockUpdateInput: {
        type: {
            type: "ContentReferenceType",
            array: false,
            arrayRequired: false,
            required: false
        },
        primaryText: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        media: {
            type: "ContentReferenceUpdateMediaEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ContentReferenceUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        secondaryText: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        dropDownList: {
            type: "ContentReferenceUpdateDropDownListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "ContentReferenceUpdateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        eventList: {
            type: "ContentReferenceUpdateEventListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        boxList: {
            type: "ContentReferenceUpdateBoxListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        isVisible: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        chart: {
            type: "ContentReferenceUpdateChartEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        definitionList: {
            type: "ContentReferenceUpdateDefinitionListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        logoList: {
            type: "ContentReferenceUpdateLogoListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        strategySchema: {
            type: "ContentReferenceUpdateStrategySchemaEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ContentReferenceUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        employeeList: {
            type: "ContentReferenceUpdateEmployeeListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        imageSecond: {
            type: "ContentReferenceUpdateImageSecondEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactForm: {
            type: "ContentReferenceUpdateContactFormEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterForm: {
            type: "ContentReferenceUpdateNewsletterFormEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateMediaEntityRelationInput: {
        create: {
            type: "MediumListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "MediumListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertMediaRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "MediumListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertMediaRelationInput: {
        update: {
            type: "MediumListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "MediumListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateLinkEntityRelationInput: {
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertLinkRelationInput: {
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateDropDownListEntityRelationInput: {
        create: {
            type: "DropDownListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "DropDownListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertDropDownListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "DropDownListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownListUpdateInput: {
        items: {
            type: "DropDownListUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        dropDownType: {
            type: "DropDownType",
            array: false,
            arrayRequired: false,
            required: false
        },
        employees: {
            type: "DropDownListUpdateEmployeesEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownListUpdateItemsEntityRelationInput: {
        create: {
            type: "DropDownItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "DropDownListUpdateItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "DropDownListUpsertItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "DropDownItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "DropDownItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "DropDownItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownListUpdateItemsRelationInput: {
        by: {
            type: "DropDownItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "DropDownItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownItemWithoutListUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "DropDownItemUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownItemUpdateLinkEntityRelationInput: {
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "DropDownItemUpsertLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownItemUpsertLinkRelationInput: {
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownListUpsertItemsRelationInput: {
        by: {
            type: "DropDownItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "DropDownItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "DropDownItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownListUpdateEmployeesEntityRelationInput: {
        create: {
            type: "EmployeeListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EmployeeListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "DropDownListUpsertEmployeesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EmployeeListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeListUpdateInput: {
        items: {
            type: "EmployeeListUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeListUpdateItemsEntityRelationInput: {
        create: {
            type: "EmployeeItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EmployeeListUpdateItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EmployeeListUpsertItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EmployeeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "EmployeeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "EmployeeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeListUpdateItemsRelationInput: {
        by: {
            type: "EmployeeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "EmployeeItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeItemWithoutListUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        employee: {
            type: "EmployeeItemUpdateEmployeeEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeItemUpdateEmployeeEntityRelationInput: {
        create: {
            type: "EmployeeCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EmployeeUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EmployeeItemUpsertEmployeeRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EmployeeUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "EmployeeUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "EmployeeUpdateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeUpdateImageEntityRelationInput: {
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EmployeeUpsertImageRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeUpsertImageRelationInput: {
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeUpdateLocalesEntityRelationInput: {
        create: {
            type: "EmployeeLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EmployeeUpdateLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EmployeeUpsertLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EmployeeLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "EmployeeLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "EmployeeLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeUpdateLocalesRelationInput: {
        by: {
            type: "EmployeeLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "EmployeeLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeLocaleWithoutRootUpdateInput: {
        position: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "EmployeeLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeLocaleUpdateLocaleEntityRelationInput: {
        create: {
            type: "LocaleWithoutEmployeesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleWithoutEmployeesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EmployeeLocaleUpsertLocaleRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutEmployeesUpdateInput: {
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleUpdateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleUpdateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleUpdateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleUpdateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleUpdatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleUpdateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleUpdateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleUpdateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleUpdateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleUpdateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleUpdateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdatePagesEntityRelationInput: {
        create: {
            type: "PageLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleUpdatePagesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LocaleUpsertPagesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdatePagesRelationInput: {
        by: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "PageLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleWithoutLocaleUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "PageLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "PageLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "PageLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "PageLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleUpdateLinkEntityRelationInput: {
        create: {
            type: "LinkableWithoutPageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkableWithoutPageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "PageLocaleUpsertLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableWithoutPageUpdateInput: {
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "LinkableUpdateHomePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "LinkableUpdateContactPageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "LinkableUpdateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "LinkableUpdateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "LinkableUpdateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "LinkableUpdateRedirectEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUpdateContactPageEntityRelationInput: {
        create: {
            type: "ContactPageLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactPageLocaleWithoutLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LinkableUpsertContactPageRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleWithoutLinkUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactPageLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ContactPageLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ContactPageLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        address: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databox: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databoxNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        addressLink: {
            type: "ContactPageLocaleUpdateAddressLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        socialsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        openingHours: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        identificationsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        ico: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        dic: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phoneLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securities: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securitiesNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleUpdateSeoEntityRelationInput: {
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "SeoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContactPageLocaleUpsertSeoRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        description: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        ogTitle: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        ogDescription: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        noIndex: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        noFollow: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        ogImage: {
            type: "SeoUpdateOgImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoUpdateOgImageEntityRelationInput: {
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "SeoUpsertOgImageRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoUpsertOgImageRelationInput: {
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleUpsertSeoRelationInput: {
        update: {
            type: "SeoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleUpdateAddressLinkEntityRelationInput: {
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContactPageLocaleUpsertAddressLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleUpsertAddressLinkRelationInput: {
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUpsertContactPageRelationInput: {
        update: {
            type: "ContactPageLocaleWithoutLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactPageLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUpdateEventEntityRelationInput: {
        create: {
            type: "EventLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EventLocaleWithoutLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LinkableUpsertEventRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleWithoutLinkUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EventLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "EventLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "EventLocaleUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "EventLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        venue: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        venueNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "EventLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        isDark: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleUpdateRootEntityRelationInput: {
        create: {
            type: "EventWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EventWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EventLocaleUpsertRootRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EventUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventWithoutLocalesUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        dateStart: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        dateFinish: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleUpsertRootRelationInput: {
        update: {
            type: "EventWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleUpdateLocaleEntityRelationInput: {
        create: {
            type: "LocaleWithoutEventsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleWithoutEventsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EventLocaleUpsertLocaleRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutEventsUpdateInput: {
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleUpdateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleUpdateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleUpdateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleUpdateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleUpdatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleUpdateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleUpdateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleUpdateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleUpdateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleUpdateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleUpdateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateSeoDefaultsEntityRelationInput: {
        create: {
            type: "SeoDefaultLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleUpdateSeoDefaultsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LocaleUpsertSeoDefaultsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "SeoDefaultLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "SeoDefaultLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "SeoDefaultLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateSeoDefaultsRelationInput: {
        by: {
            type: "SeoDefaultLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "SeoDefaultLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleWithoutLocaleUpdateInput: {
        root: {
            type: "SeoDefaultLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoDefaultLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleUpdateRootEntityRelationInput: {
        create: {
            type: "SeoDefaultWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "SeoDefaultWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "SeoDefaultLocaleUpsertRootRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "SeoDefaultUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultWithoutLocalesUpdateInput: {
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleUpsertRootRelationInput: {
        update: {
            type: "SeoDefaultWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoDefaultWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleUpdateSeoEntityRelationInput: {
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "SeoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "SeoDefaultLocaleUpsertSeoRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleUpsertSeoRelationInput: {
        update: {
            type: "SeoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpsertSeoDefaultsRelationInput: {
        by: {
            type: "SeoDefaultLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "SeoDefaultLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoDefaultLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateArtworksEntityRelationInput: {
        create: {
            type: "ArtworkLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleUpdateArtworksRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LocaleUpsertArtworksRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateArtworksRelationInput: {
        by: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "ArtworkLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleWithoutLocaleUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ArtworkLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ArtworkLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artist: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleUpdateRootEntityRelationInput: {
        create: {
            type: "ArtworkWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkLocaleUpsertRootRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkWithoutLocalesUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ArtworkUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        gallery: {
            type: "ArtworkUpdateGalleryEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkUpdateImageEntityRelationInput: {
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkUpsertImageRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkUpsertImageRelationInput: {
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkUpdateGalleryEntityRelationInput: {
        create: {
            type: "GalleryCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "GalleryUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkUpsertGalleryRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "GalleryUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryUpdateInput: {
        items: {
            type: "GalleryUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryUpdateItemsEntityRelationInput: {
        create: {
            type: "GalleryItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "GalleryUpdateItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "GalleryUpsertItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "GalleryItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "GalleryItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "GalleryItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryUpdateItemsRelationInput: {
        by: {
            type: "GalleryItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "GalleryItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryItemWithoutListUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "GalleryItemUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryItemUpdateImageEntityRelationInput: {
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "GalleryItemUpsertImageRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryItemUpsertImageRelationInput: {
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryUpsertItemsRelationInput: {
        by: {
            type: "GalleryItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "GalleryItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "GalleryItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkUpsertGalleryRelationInput: {
        update: {
            type: "GalleryUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "GalleryCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleUpsertRootRelationInput: {
        update: {
            type: "ArtworkWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleUpdateContentEntityRelationInput: {
        create: {
            type: "ContentCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContentUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkLocaleUpsertContentRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleUpsertContentRelationInput: {
        update: {
            type: "ContentUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleUpdateSeoEntityRelationInput: {
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "SeoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkLocaleUpsertSeoRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleUpsertSeoRelationInput: {
        update: {
            type: "SeoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleUpdateLinkEntityRelationInput: {
        create: {
            type: "LinkableWithoutArtworkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkableWithoutArtworkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkLocaleUpsertLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableWithoutArtworkUpdateInput: {
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "LinkableUpdateHomePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "LinkableUpdateContactPageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "LinkableUpdatePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "LinkableUpdateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "LinkableUpdateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "LinkableUpdateRedirectEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUpdateArtworkSelectionEntityRelationInput: {
        create: {
            type: "ArtworkSelectionLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkSelectionLocaleWithoutLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LinkableUpsertArtworkSelectionRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleWithoutLinkUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkSelectionLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ArtworkSelectionLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkSelectionLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleUpdateRootEntityRelationInput: {
        create: {
            type: "ArtworkSelectionWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkSelectionWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkSelectionLocaleUpsertRootRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkSelectionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionWithoutLocalesUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworks: {
            type: "ArtworkSelectionUpdateArtworksEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionUpdateArtworksEntityRelationInput: {
        create: {
            type: "ArtworkSelectionListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkSelectionListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkSelectionUpsertArtworksRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkSelectionListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionListUpdateInput: {
        items: {
            type: "ArtworkSelectionListUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionListUpdateItemsEntityRelationInput: {
        create: {
            type: "ArtworkSelectionItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkSelectionListUpdateItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkSelectionListUpsertItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkSelectionItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "ArtworkSelectionItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "ArtworkSelectionItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionListUpdateItemsRelationInput: {
        by: {
            type: "ArtworkSelectionItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "ArtworkSelectionItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionItemWithoutListUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "ArtworkSelectionItemUpdateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionItemUpdateArtworkEntityRelationInput: {
        create: {
            type: "ArtworkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkSelectionItemUpsertArtworkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ArtworkUpdateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        image: {
            type: "ArtworkUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        gallery: {
            type: "ArtworkUpdateGalleryEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkUpdateLocalesEntityRelationInput: {
        create: {
            type: "ArtworkLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkUpdateLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkUpsertLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkUpdateLocalesRelationInput: {
        by: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "ArtworkLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleWithoutRootUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ArtworkLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ArtworkLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ArtworkLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artist: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleUpdateLocaleEntityRelationInput: {
        create: {
            type: "LocaleWithoutArtworksCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleWithoutArtworksUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkLocaleUpsertLocaleRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutArtworksUpdateInput: {
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleUpdateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleUpdateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleUpdateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleUpdateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleUpdatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleUpdateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleUpdateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleUpdateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleUpdateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleUpdateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleUpdateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateEventsEntityRelationInput: {
        create: {
            type: "EventLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleUpdateEventsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LocaleUpsertEventsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateEventsRelationInput: {
        by: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "EventLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleWithoutLocaleUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EventLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "EventLocaleUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "EventLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "EventLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        venue: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        venueNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "EventLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        isDark: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleUpdateImageEntityRelationInput: {
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EventLocaleUpsertImageRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleUpsertImageRelationInput: {
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleUpdateSeoEntityRelationInput: {
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "SeoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EventLocaleUpsertSeoRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleUpsertSeoRelationInput: {
        update: {
            type: "SeoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleUpdateLinkEntityRelationInput: {
        create: {
            type: "LinkableWithoutEventCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkableWithoutEventUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EventLocaleUpsertLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableWithoutEventUpdateInput: {
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "LinkableUpdateHomePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "LinkableUpdateContactPageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "LinkableUpdatePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "LinkableUpdateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "LinkableUpdateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "LinkableUpdateRedirectEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUpdateArtworkEntityRelationInput: {
        create: {
            type: "ArtworkLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkLocaleWithoutLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LinkableUpsertArtworkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleWithoutLinkUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ArtworkLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ArtworkLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artist: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUpsertArtworkRelationInput: {
        update: {
            type: "ArtworkLocaleWithoutLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUpdateRedirectEntityRelationInput: {
        create: {
            type: "RedirectWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "RedirectWithoutLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LinkableUpsertRedirectRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "RedirectUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    RedirectWithoutLinkUpdateInput: {
        target: {
            type: "RedirectUpdateTargetEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    RedirectUpdateTargetEntityRelationInput: {
        create: {
            type: "LinkableCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkableUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "RedirectUpsertTargetRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    RedirectUpsertTargetRelationInput: {
        update: {
            type: "LinkableUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUpsertRedirectRelationInput: {
        update: {
            type: "RedirectWithoutLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "RedirectWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleUpsertLinkRelationInput: {
        update: {
            type: "LinkableWithoutEventUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableWithoutEventCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleUpdateContentEntityRelationInput: {
        create: {
            type: "ContentCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContentUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EventLocaleUpsertContentRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleUpsertContentRelationInput: {
        update: {
            type: "ContentUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpsertEventsRelationInput: {
        by: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EventLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateArtworkSelectionsEntityRelationInput: {
        create: {
            type: "ArtworkSelectionLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleUpdateArtworkSelectionsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LocaleUpsertArtworkSelectionsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateArtworkSelectionsRelationInput: {
        by: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "ArtworkSelectionLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleWithoutLocaleUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkSelectionLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkSelectionLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ArtworkSelectionLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleUpdateSeoEntityRelationInput: {
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "SeoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkSelectionLocaleUpsertSeoRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleUpsertSeoRelationInput: {
        update: {
            type: "SeoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleUpdateLinkEntityRelationInput: {
        create: {
            type: "LinkableWithoutArtworkSelectionCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkableWithoutArtworkSelectionUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkSelectionLocaleUpsertLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableWithoutArtworkSelectionUpdateInput: {
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "LinkableUpdateHomePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "LinkableUpdateContactPageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "LinkableUpdatePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "LinkableUpdateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "LinkableUpdateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "LinkableUpdateRedirectEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleUpsertLinkRelationInput: {
        update: {
            type: "LinkableWithoutArtworkSelectionUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableWithoutArtworkSelectionCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpsertArtworkSelectionsRelationInput: {
        by: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkSelectionLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateNewsletterFormsEntityRelationInput: {
        create: {
            type: "NewsletterFormLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleUpdateNewsletterFormsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LocaleUpsertNewsletterFormsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateNewsletterFormsRelationInput: {
        by: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "NewsletterFormLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleWithoutLocaleUpdateInput: {
        newsletterTypeNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "NewsletterFormLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "NewsletterFormLocaleUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleUpdateRootEntityRelationInput: {
        create: {
            type: "NewsletterFormWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "NewsletterFormWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "NewsletterFormLocaleUpsertRootRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "NewsletterFormUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormWithoutLocalesUpdateInput: {
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleUpsertRootRelationInput: {
        update: {
            type: "NewsletterFormWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterFormWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleUpdateItemsEntityRelationInput: {
        create: {
            type: "NewsletterTypeItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "NewsletterFormLocaleUpdateItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "NewsletterFormLocaleUpsertItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "NewsletterTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "NewsletterTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "NewsletterTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleUpdateItemsRelationInput: {
        by: {
            type: "NewsletterTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "NewsletterTypeItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemWithoutListUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        subscriptions: {
            type: "NewsletterTypeItemUpdateSubscriptionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemUpdateSubscriptionsEntityRelationInput: {
        create: {
            type: "NewsletterSubscriptionWithoutNewsletterTypeCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "NewsletterTypeItemUpdateSubscriptionsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "NewsletterTypeItemUpsertSubscriptionsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "NewsletterSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "NewsletterSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "NewsletterSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemUpdateSubscriptionsRelationInput: {
        by: {
            type: "NewsletterSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "NewsletterSubscriptionWithoutNewsletterTypeUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterSubscriptionWithoutNewsletterTypeUpdateInput: {
        createdAt: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemUpsertSubscriptionsRelationInput: {
        by: {
            type: "NewsletterSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "NewsletterSubscriptionWithoutNewsletterTypeUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterSubscriptionWithoutNewsletterTypeCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleUpsertItemsRelationInput: {
        by: {
            type: "NewsletterTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "NewsletterTypeItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterTypeItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpsertNewsletterFormsRelationInput: {
        by: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "NewsletterFormLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterFormLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateEmployeesEntityRelationInput: {
        create: {
            type: "EmployeeLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleUpdateEmployeesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LocaleUpsertEmployeesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EmployeeLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "EmployeeLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "EmployeeLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateEmployeesRelationInput: {
        by: {
            type: "EmployeeLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "EmployeeLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeLocaleWithoutLocaleUpdateInput: {
        position: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EmployeeLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeLocaleUpdateRootEntityRelationInput: {
        create: {
            type: "EmployeeWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EmployeeWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EmployeeLocaleUpsertRootRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EmployeeUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeWithoutLocalesUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "EmployeeUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeLocaleUpsertRootRelationInput: {
        update: {
            type: "EmployeeWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpsertEmployeesRelationInput: {
        by: {
            type: "EmployeeLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EmployeeLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateContactFormsEntityRelationInput: {
        create: {
            type: "ContactFormLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleUpdateContactFormsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LocaleUpsertContactFormsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateContactFormsRelationInput: {
        by: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "ContactFormLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleWithoutLocaleUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactFormLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ContactFormLocaleUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        file: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleUpdateRootEntityRelationInput: {
        create: {
            type: "ContactFormWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactFormWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContactFormLocaleUpsertRootRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContactFormUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormWithoutLocalesUpdateInput: {
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleUpsertRootRelationInput: {
        update: {
            type: "ContactFormWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactFormWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleUpdateItemsEntityRelationInput: {
        create: {
            type: "ContactTypeItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactFormLocaleUpdateItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContactFormLocaleUpsertItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContactTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "ContactTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "ContactTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleUpdateItemsRelationInput: {
        by: {
            type: "ContactTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "ContactTypeItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemWithoutListUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        subscriptions: {
            type: "ContactTypeItemUpdateSubscriptionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemUpdateSubscriptionsEntityRelationInput: {
        create: {
            type: "ContactSubscriptionWithoutContactTypeCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactTypeItemUpdateSubscriptionsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContactTypeItemUpsertSubscriptionsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContactSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "ContactSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "ContactSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemUpdateSubscriptionsRelationInput: {
        by: {
            type: "ContactSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "ContactSubscriptionWithoutContactTypeUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactSubscriptionWithoutContactTypeUpdateInput: {
        createdAt: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        file: {
            type: "ContactSubscriptionUpdateFileEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactSubscriptionUpdateFileEntityRelationInput: {
        create: {
            type: "FileCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "FileUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContactSubscriptionUpsertFileRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "FileUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FileUpdateInput: {
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        size: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactSubscriptionUpsertFileRelationInput: {
        update: {
            type: "FileUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "FileCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemUpsertSubscriptionsRelationInput: {
        by: {
            type: "ContactSubscriptionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactSubscriptionWithoutContactTypeUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactSubscriptionWithoutContactTypeCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleUpsertItemsRelationInput: {
        by: {
            type: "ContactTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactTypeItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactTypeItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpsertContactFormsRelationInput: {
        by: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactFormLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactFormLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleUpsertLocaleRelationInput: {
        update: {
            type: "LocaleWithoutArtworksUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutArtworksCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkUpsertLocalesRelationInput: {
        by: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionItemUpsertArtworkRelationInput: {
        update: {
            type: "ArtworkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionListUpsertItemsRelationInput: {
        by: {
            type: "ArtworkSelectionItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkSelectionItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionUpsertArtworksRelationInput: {
        update: {
            type: "ArtworkSelectionListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleUpsertRootRelationInput: {
        update: {
            type: "ArtworkSelectionWithoutLocalesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionWithoutLocalesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleUpdateLocaleEntityRelationInput: {
        create: {
            type: "LocaleWithoutArtworkSelectionsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleWithoutArtworkSelectionsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkSelectionLocaleUpsertLocaleRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutArtworkSelectionsUpdateInput: {
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleUpdateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleUpdateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleUpdateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleUpdateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleUpdatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleUpdateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleUpdateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleUpdateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleUpdateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleUpdateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleUpdateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleUpsertLocaleRelationInput: {
        update: {
            type: "LocaleWithoutArtworkSelectionsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutArtworkSelectionsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUpsertArtworkSelectionRelationInput: {
        update: {
            type: "ArtworkSelectionLocaleWithoutLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleUpsertLinkRelationInput: {
        update: {
            type: "LinkableWithoutArtworkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableWithoutArtworkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpsertArtworksRelationInput: {
        by: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleUpsertLocaleRelationInput: {
        update: {
            type: "LocaleWithoutEventsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutEventsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUpsertEventRelationInput: {
        update: {
            type: "EventLocaleWithoutLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleUpsertLinkRelationInput: {
        update: {
            type: "LinkableWithoutPageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableWithoutPageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleUpdateContentEntityRelationInput: {
        create: {
            type: "ContentCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContentUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "PageLocaleUpsertContentRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleUpsertContentRelationInput: {
        update: {
            type: "ContentUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleUpdateSeoEntityRelationInput: {
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "SeoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "PageLocaleUpsertSeoRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleUpsertSeoRelationInput: {
        update: {
            type: "SeoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpsertPagesRelationInput: {
        by: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "PageLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "PageLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeLocaleUpsertLocaleRelationInput: {
        update: {
            type: "LocaleWithoutEmployeesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutEmployeesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeUpsertLocalesRelationInput: {
        by: {
            type: "EmployeeLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EmployeeLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeItemUpsertEmployeeRelationInput: {
        update: {
            type: "EmployeeUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeListUpsertItemsRelationInput: {
        by: {
            type: "EmployeeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EmployeeItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownListUpsertEmployeesRelationInput: {
        update: {
            type: "EmployeeListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertDropDownListRelationInput: {
        update: {
            type: "DropDownListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "DropDownListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateArtworkSelectionEntityRelationInput: {
        create: {
            type: "ArtworkSelectionCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkSelectionUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertArtworkSelectionRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkSelectionUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ArtworkSelectionUpdateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "ArtworkSelectionUpdateArtworksEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionUpdateLocalesEntityRelationInput: {
        create: {
            type: "ArtworkSelectionLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkSelectionUpdateLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkSelectionUpsertLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionUpdateLocalesRelationInput: {
        by: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "ArtworkSelectionLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleWithoutRootUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ArtworkSelectionLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkSelectionLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ArtworkSelectionLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionUpsertLocalesRelationInput: {
        by: {
            type: "ArtworkSelectionLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkSelectionLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertArtworkSelectionRelationInput: {
        update: {
            type: "ArtworkSelectionUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateEventListEntityRelationInput: {
        create: {
            type: "EventListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EventListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertEventListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EventListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventListUpdateInput: {
        items: {
            type: "EventListUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventListUpdateItemsEntityRelationInput: {
        create: {
            type: "EventItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EventListUpdateItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EventListUpsertItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EventItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "EventItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "EventItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventListUpdateItemsRelationInput: {
        by: {
            type: "EventItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "EventItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventItemWithoutListUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "EventItemUpdateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventItemUpdateEventEntityRelationInput: {
        create: {
            type: "EventCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EventUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EventItemUpsertEventRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EventUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventUpdateInput: {
        locales: {
            type: "EventUpdateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        dateStart: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        dateFinish: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventUpdateLocalesEntityRelationInput: {
        create: {
            type: "EventLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EventUpdateLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EventUpsertLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventUpdateLocalesRelationInput: {
        by: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "EventLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleWithoutRootUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "EventLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "EventLocaleUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "EventLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "EventLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        venue: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        venueNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "EventLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        isDark: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventUpsertLocalesRelationInput: {
        by: {
            type: "EventLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EventLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventItemUpsertEventRelationInput: {
        update: {
            type: "EventUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventListUpsertItemsRelationInput: {
        by: {
            type: "EventItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EventItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertEventListRelationInput: {
        update: {
            type: "EventListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateBoxListEntityRelationInput: {
        create: {
            type: "BoxListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "BoxListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertBoxListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "BoxListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxListUpdateInput: {
        items: {
            type: "BoxListUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxListUpdateItemsEntityRelationInput: {
        create: {
            type: "BoxItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "BoxListUpdateItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "BoxListUpsertItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "BoxItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "BoxItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "BoxItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxListUpdateItemsRelationInput: {
        by: {
            type: "BoxItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "BoxItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxItemWithoutListUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxListUpsertItemsRelationInput: {
        by: {
            type: "BoxItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "BoxItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "BoxItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertBoxListRelationInput: {
        update: {
            type: "BoxListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "BoxListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateChartEntityRelationInput: {
        create: {
            type: "ChartCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ChartUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertChartRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ChartUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartUpdateInput: {
        type: {
            type: "ChartType",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ChartUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartUpdateItemsEntityRelationInput: {
        create: {
            type: "ChartDataWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ChartUpdateItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ChartUpsertItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ChartDataUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "ChartDataUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "ChartDataUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartUpdateItemsRelationInput: {
        by: {
            type: "ChartDataUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "ChartDataWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartDataWithoutListUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "Date",
            array: false,
            arrayRequired: false,
            required: false
        },
        number: {
            type: "Float",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ChartDataUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartDataUpdateImageEntityRelationInput: {
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ChartDataUpsertImageRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartDataUpsertImageRelationInput: {
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartUpsertItemsRelationInput: {
        by: {
            type: "ChartDataUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ChartDataWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ChartDataWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertChartRelationInput: {
        update: {
            type: "ChartUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ChartCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateDefinitionListEntityRelationInput: {
        create: {
            type: "DefinitionListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "DefinitionListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertDefinitionListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "DefinitionListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionListUpdateInput: {
        items: {
            type: "DefinitionListUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionListUpdateItemsEntityRelationInput: {
        create: {
            type: "DefinitionItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "DefinitionListUpdateItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "DefinitionListUpsertItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "DefinitionItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "DefinitionItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "DefinitionItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionListUpdateItemsRelationInput: {
        by: {
            type: "DefinitionItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "DefinitionItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionItemWithoutListUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        key: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        value: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionListUpsertItemsRelationInput: {
        by: {
            type: "DefinitionItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "DefinitionItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "DefinitionItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertDefinitionListRelationInput: {
        update: {
            type: "DefinitionListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "DefinitionListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateLogoListEntityRelationInput: {
        create: {
            type: "LogoListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LogoListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertLogoListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LogoListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoListUpdateInput: {
        items: {
            type: "LogoListUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoListUpdateItemsEntityRelationInput: {
        create: {
            type: "LogoItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LogoListUpdateItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LogoListUpsertItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LogoItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "LogoItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "LogoItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoListUpdateItemsRelationInput: {
        by: {
            type: "LogoItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "LogoItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoItemWithoutListUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "LogoItemUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoItemUpdateImageEntityRelationInput: {
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LogoItemUpsertImageRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoItemUpsertImageRelationInput: {
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoListUpsertItemsRelationInput: {
        by: {
            type: "LogoItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LogoItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LogoItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertLogoListRelationInput: {
        update: {
            type: "LogoListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LogoListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateStrategySchemaEntityRelationInput: {
        create: {
            type: "StrategySchemaCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "StrategySchemaUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertStrategySchemaRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "StrategySchemaUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaUpdateInput: {
        inputFirst: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        inputSecond: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        inputThird: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        outputFirst: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        outputSecond: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        outputThird: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        itemsFirst: {
            type: "StrategySchemaUpdateItemsFirstEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "StrategySchemaUpdateLogoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        itemsSecond: {
            type: "StrategySchemaUpdateItemsSecondEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaUpdateItemsFirstEntityRelationInput: {
        create: {
            type: "StrategySchemaGroupCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "StrategySchemaGroupUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "StrategySchemaUpsertItemsFirstRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "StrategySchemaGroupUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupUpdateInput: {
        items: {
            type: "StrategySchemaGroupUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupUpdateItemsEntityRelationInput: {
        create: {
            type: "StrategySchemaGroupItemWithoutSchemaCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "StrategySchemaGroupUpdateItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "StrategySchemaGroupUpsertItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "StrategySchemaGroupItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "StrategySchemaGroupItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "StrategySchemaGroupItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupUpdateItemsRelationInput: {
        by: {
            type: "StrategySchemaGroupItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "StrategySchemaGroupItemWithoutSchemaUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupItemWithoutSchemaUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupUpsertItemsRelationInput: {
        by: {
            type: "StrategySchemaGroupItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "StrategySchemaGroupItemWithoutSchemaUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "StrategySchemaGroupItemWithoutSchemaCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaUpsertItemsFirstRelationInput: {
        update: {
            type: "StrategySchemaGroupUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "StrategySchemaGroupCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaUpdateLogoEntityRelationInput: {
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "StrategySchemaUpsertLogoRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaUpsertLogoRelationInput: {
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaUpdateItemsSecondEntityRelationInput: {
        create: {
            type: "StrategySchemaGroupCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "StrategySchemaGroupUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "StrategySchemaUpsertItemsSecondRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "StrategySchemaGroupUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaUpsertItemsSecondRelationInput: {
        update: {
            type: "StrategySchemaGroupUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "StrategySchemaGroupCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertStrategySchemaRelationInput: {
        update: {
            type: "StrategySchemaUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "StrategySchemaCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateImageEntityRelationInput: {
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertImageRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertImageRelationInput: {
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateEmployeeListEntityRelationInput: {
        create: {
            type: "EmployeeListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EmployeeListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertEmployeeListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EmployeeListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertEmployeeListRelationInput: {
        update: {
            type: "EmployeeListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateImageSecondEntityRelationInput: {
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertImageSecondRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ImageUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertImageSecondRelationInput: {
        update: {
            type: "ImageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ImageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateContactFormEntityRelationInput: {
        create: {
            type: "ContactFormCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactFormUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertContactFormRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContactFormUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormUpdateInput: {
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "ContactFormUpdateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormUpdateLocalesEntityRelationInput: {
        create: {
            type: "ContactFormLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactFormUpdateLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContactFormUpsertLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormUpdateLocalesRelationInput: {
        by: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "ContactFormLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleWithoutRootUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ContactFormLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ContactFormLocaleUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        file: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleUpdateLocaleEntityRelationInput: {
        create: {
            type: "LocaleWithoutContactFormsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleWithoutContactFormsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContactFormLocaleUpsertLocaleRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutContactFormsUpdateInput: {
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleUpdateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleUpdateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleUpdateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleUpdateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleUpdatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleUpdateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleUpdateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleUpdateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleUpdateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleUpdateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleUpdateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleUpsertLocaleRelationInput: {
        update: {
            type: "LocaleWithoutContactFormsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutContactFormsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormUpsertLocalesRelationInput: {
        by: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactFormLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactFormLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertContactFormRelationInput: {
        update: {
            type: "ContactFormUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactFormCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateNewsletterFormEntityRelationInput: {
        create: {
            type: "NewsletterFormCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "NewsletterFormUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertNewsletterFormRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "NewsletterFormUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormUpdateInput: {
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "NewsletterFormUpdateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormUpdateLocalesEntityRelationInput: {
        create: {
            type: "NewsletterFormLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "NewsletterFormUpdateLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "NewsletterFormUpsertLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormUpdateLocalesRelationInput: {
        by: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "NewsletterFormLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleWithoutRootUpdateInput: {
        newsletterTypeNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "NewsletterFormLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "NewsletterFormLocaleUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleUpdateLocaleEntityRelationInput: {
        create: {
            type: "LocaleWithoutNewsletterFormsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleWithoutNewsletterFormsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "NewsletterFormLocaleUpsertLocaleRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutNewsletterFormsUpdateInput: {
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleUpdateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleUpdateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleUpdateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleUpdateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleUpdatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleUpdateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleUpdateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleUpdateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleUpdateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleUpdateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleUpdateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleUpsertLocaleRelationInput: {
        update: {
            type: "LocaleWithoutNewsletterFormsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutNewsletterFormsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormUpsertLocalesRelationInput: {
        by: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "NewsletterFormLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterFormLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertNewsletterFormRelationInput: {
        update: {
            type: "NewsletterFormUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterFormCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockUpsertReferencesRelationInput: {
        by: {
            type: "ContentReferenceUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContentReferenceWithoutBlockUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentReferenceWithoutBlockCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentUpsertBlocksRelationInput: {
        by: {
            type: "ContentBlockUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContentBlockWithoutContentUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentBlockWithoutContentCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleUpsertContentRelationInput: {
        update: {
            type: "ContentUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleUpdateLinkEntityRelationInput: {
        create: {
            type: "LinkableWithoutHomePageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkableWithoutHomePageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "HomePageLocaleUpsertLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableWithoutHomePageUpdateInput: {
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "LinkableUpdateContactPageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "LinkableUpdatePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "LinkableUpdateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "LinkableUpdateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "LinkableUpdateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        redirect: {
            type: "LinkableUpdateRedirectEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleUpsertLinkRelationInput: {
        update: {
            type: "LinkableWithoutHomePageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableWithoutHomePageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleUpdateSeoEntityRelationInput: {
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "SeoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "HomePageLocaleUpsertSeoRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "SeoUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleUpsertSeoRelationInput: {
        update: {
            type: "SeoUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleUpdateBranchesEntityRelationInput: {
        create: {
            type: "BranchesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "HomePageLocaleUpdateBranchesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "HomePageLocaleUpsertBranchesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "BranchesUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "BranchesUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "BranchesUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleUpdateBranchesRelationInput: {
        by: {
            type: "BranchesUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "BranchesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BranchesUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        more: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "BranchesUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BranchesUpdateLinkEntityRelationInput: {
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "BranchesUpsertLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BranchesUpsertLinkRelationInput: {
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleUpsertBranchesRelationInput: {
        by: {
            type: "BranchesUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "BranchesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "BranchesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpsertHomePagesRelationInput: {
        by: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "HomePageLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HomePageLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleUpsertLocaleRelationInput: {
        update: {
            type: "LocaleWithoutPagesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutPagesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUpsertPageRelationInput: {
        update: {
            type: "PageLocaleWithoutLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "PageLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleUpsertLinkRelationInput: {
        update: {
            type: "LinkableWithoutContactPageUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableWithoutContactPageCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpsertContactPagesRelationInput: {
        by: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactPageLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactPageLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleUpsertLocaleRelationInput: {
        update: {
            type: "LocaleWithoutHomePagesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutHomePagesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableUpsertHomePageRelationInput: {
        update: {
            type: "HomePageLocaleWithoutLinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HomePageLocaleWithoutLinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkUpsertInternalLinkRelationInput: {
        update: {
            type: "LinkableUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GraphicDesignerUpsertLinkRelationInput: {
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleUpsertGraphicDesignersRelationInput: {
        by: {
            type: "GraphicDesignerUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "GraphicDesignerUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "GraphicDesignerCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleUpdateDeveloperLinkEntityRelationInput: {
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "FooterLocaleUpsertDeveloperLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleUpsertDeveloperLinkRelationInput: {
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleUpdatePhotographersEntityRelationInput: {
        create: {
            type: "PhotographerCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "FooterLocaleUpdatePhotographersRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "FooterLocaleUpsertPhotographersRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "PhotographerUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "PhotographerUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "PhotographerUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleUpdatePhotographersRelationInput: {
        by: {
            type: "PhotographerUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "PhotographerUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PhotographerUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "PhotographerUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PhotographerUpdateLinkEntityRelationInput: {
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "PhotographerUpsertLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PhotographerUpsertLinkRelationInput: {
        update: {
            type: "LinkUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleUpsertPhotographersRelationInput: {
        by: {
            type: "PhotographerUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "PhotographerUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "PhotographerCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpsertFootersRelationInput: {
        by: {
            type: "FooterLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "FooterLocaleWithoutLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "FooterLocaleWithoutLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleUpsertLocaleRelationInput: {
        update: {
            type: "LocaleWithoutContactPagesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutContactPagesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageUpsertLocalesRelationInput: {
        by: {
            type: "ContactPageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactPageLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactPageLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactPageLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ContactPageLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ContactPageLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ContactPageLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        address: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databox: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databoxNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        addressLink: {
            type: "ContactPageLocaleCreateAddressLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        socialsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        openingHours: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        identificationsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        ico: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        dic: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phoneLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securities: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securitiesNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactPageLocaleUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactPageLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ContactPageLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ContactPageLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ContactPageLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        address: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databox: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        databoxNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        addressLink: {
            type: "ContactPageLocaleUpdateAddressLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        socialsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        openingHours: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        identificationsLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        ico: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        dic: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phoneLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailLabel: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securities: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        securitiesNumber: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        json: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentBlockCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        references: {
            type: "ContentBlockCreateReferencesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockCreateContentEntityRelationInput: {
        connect: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentWithoutBlocksCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentWithoutBlocksCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        json: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentBlockUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        references: {
            type: "ContentBlockUpdateReferencesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockUpdateContentEntityRelationInput: {
        create: {
            type: "ContentWithoutBlocksCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContentWithoutBlocksUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentBlockUpsertContentRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContentUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentWithoutBlocksUpdateInput: {
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockUpsertContentRelationInput: {
        update: {
            type: "ContentWithoutBlocksUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentWithoutBlocksCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "ContentReferenceType",
            array: false,
            arrayRequired: false,
            required: false
        },
        primaryText: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        block: {
            type: "ContentReferenceCreateBlockEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        media: {
            type: "ContentReferenceCreateMediaEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ContentReferenceCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        secondaryText: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        dropDownList: {
            type: "ContentReferenceCreateDropDownListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "ContentReferenceCreateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        eventList: {
            type: "ContentReferenceCreateEventListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        boxList: {
            type: "ContentReferenceCreateBoxListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        isVisible: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        chart: {
            type: "ContentReferenceCreateChartEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        definitionList: {
            type: "ContentReferenceCreateDefinitionListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        logoList: {
            type: "ContentReferenceCreateLogoListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        strategySchema: {
            type: "ContentReferenceCreateStrategySchemaEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ContentReferenceCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        employeeList: {
            type: "ContentReferenceCreateEmployeeListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        imageSecond: {
            type: "ContentReferenceCreateImageSecondEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactForm: {
            type: "ContentReferenceCreateContactFormEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterForm: {
            type: "ContentReferenceCreateNewsletterFormEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceCreateBlockEntityRelationInput: {
        connect: {
            type: "ContentBlockUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentBlockWithoutReferencesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockWithoutReferencesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        json: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentBlockCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateInput: {
        type: {
            type: "ContentReferenceType",
            array: false,
            arrayRequired: false,
            required: false
        },
        primaryText: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        block: {
            type: "ContentReferenceUpdateBlockEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        media: {
            type: "ContentReferenceUpdateMediaEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ContentReferenceUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        secondaryText: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        dropDownList: {
            type: "ContentReferenceUpdateDropDownListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "ContentReferenceUpdateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        eventList: {
            type: "ContentReferenceUpdateEventListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        boxList: {
            type: "ContentReferenceUpdateBoxListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        isVisible: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        chart: {
            type: "ContentReferenceUpdateChartEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        definitionList: {
            type: "ContentReferenceUpdateDefinitionListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        logoList: {
            type: "ContentReferenceUpdateLogoListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        strategySchema: {
            type: "ContentReferenceUpdateStrategySchemaEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ContentReferenceUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        employeeList: {
            type: "ContentReferenceUpdateEmployeeListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        imageSecond: {
            type: "ContentReferenceUpdateImageSecondEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactForm: {
            type: "ContentReferenceUpdateContactFormEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterForm: {
            type: "ContentReferenceUpdateNewsletterFormEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpdateBlockEntityRelationInput: {
        create: {
            type: "ContentBlockWithoutReferencesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContentBlockWithoutReferencesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContentReferenceUpsertBlockRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContentBlockUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentBlockWithoutReferencesUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        json: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ContentBlockUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContentReferenceUpsertBlockRelationInput: {
        update: {
            type: "ContentBlockWithoutReferencesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContentBlockWithoutReferencesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "FooterCreateLogoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "FooterCreateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterCreateLocalesEntityRelationInput: {
        connect: {
            type: "FooterLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "FooterLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleWithoutRootCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        address: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        graphicDesign: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "FooterLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        graphicDesigners: {
            type: "FooterLocaleCreateGraphicDesignersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        developerLink: {
            type: "FooterLocaleCreateDeveloperLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        development: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        photography: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        photographers: {
            type: "FooterLocaleCreatePhotographersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleCreateLocaleEntityRelationInput: {
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutFootersCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutFootersCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleCreateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleCreateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleCreateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleCreatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleCreateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleCreateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleCreateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleCreateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleCreateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleCreateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleCreateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterUpdateInput: {
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        logo: {
            type: "FooterUpdateLogoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "FooterUpdateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterUpdateLocalesEntityRelationInput: {
        create: {
            type: "FooterLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "FooterUpdateLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "FooterUpsertLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "FooterLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "FooterLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "FooterLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterUpdateLocalesRelationInput: {
        by: {
            type: "FooterLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "FooterLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleWithoutRootUpdateInput: {
        address: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        graphicDesign: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "FooterLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        graphicDesigners: {
            type: "FooterLocaleUpdateGraphicDesignersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        developerLink: {
            type: "FooterLocaleUpdateDeveloperLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        development: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        photography: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        photographers: {
            type: "FooterLocaleUpdatePhotographersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleUpdateLocaleEntityRelationInput: {
        create: {
            type: "LocaleWithoutFootersCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleWithoutFootersUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "FooterLocaleUpsertLocaleRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutFootersUpdateInput: {
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleUpdateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleUpdateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleUpdateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleUpdatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleUpdateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleUpdateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleUpdateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleUpdateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleUpdateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleUpdateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleUpdateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleUpsertLocaleRelationInput: {
        update: {
            type: "LocaleWithoutFootersUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutFootersCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterUpsertLocalesRelationInput: {
        by: {
            type: "FooterLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "FooterLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "FooterLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        address: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        graphicDesign: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "FooterLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "FooterLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        graphicDesigners: {
            type: "FooterLocaleCreateGraphicDesignersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        developerLink: {
            type: "FooterLocaleCreateDeveloperLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        development: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        photography: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        photographers: {
            type: "FooterLocaleCreatePhotographersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    FooterLocaleUpdateInput: {
        address: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        youtube: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        instagram: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        facebook: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        graphicDesign: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "FooterLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "FooterLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        graphicDesigners: {
            type: "FooterLocaleUpdateGraphicDesignersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        developerLink: {
            type: "FooterLocaleUpdateDeveloperLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        development: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        linkedIn: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        photography: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        photographers: {
            type: "FooterLocaleUpdatePhotographersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "HeaderCreateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        logo: {
            type: "HeaderCreateLogoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderCreateLocalesEntityRelationInput: {
        connect: {
            type: "HeaderLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HeaderLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleWithoutRootCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "HeaderLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        links: {
            type: "HeaderLocaleCreateLinksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkBreadcrumbParentLink: {
            type: "HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleCreateLocaleEntityRelationInput: {
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutHeadersCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutHeadersCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleCreateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleCreateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleCreateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleCreatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleCreateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleCreateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleCreateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleCreateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleCreateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleCreateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleCreateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderUpdateInput: {
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "HeaderUpdateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        logo: {
            type: "HeaderUpdateLogoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderUpdateLocalesEntityRelationInput: {
        create: {
            type: "HeaderLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "HeaderUpdateLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "HeaderUpsertLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "HeaderLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "HeaderLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "HeaderLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderUpdateLocalesRelationInput: {
        by: {
            type: "HeaderLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "HeaderLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleWithoutRootUpdateInput: {
        locale: {
            type: "HeaderLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        links: {
            type: "HeaderLocaleUpdateLinksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkBreadcrumbParentLink: {
            type: "HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleUpdateLocaleEntityRelationInput: {
        create: {
            type: "LocaleWithoutHeadersCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleWithoutHeadersUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "HeaderLocaleUpsertLocaleRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutHeadersUpdateInput: {
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleUpdateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleUpdateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleUpdateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleUpdatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleUpdateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleUpdateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleUpdateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleUpdateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleUpdateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleUpdateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleUpdateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleUpsertLocaleRelationInput: {
        update: {
            type: "LocaleWithoutHeadersUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutHeadersCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderUpsertLocalesRelationInput: {
        by: {
            type: "HeaderLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "HeaderLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HeaderLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "HeaderLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "HeaderLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        links: {
            type: "HeaderLocaleCreateLinksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkBreadcrumbParentLink: {
            type: "HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HeaderLocaleUpdateInput: {
        root: {
            type: "HeaderLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "HeaderLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        links: {
            type: "HeaderLocaleUpdateLinksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkBreadcrumbParentLink: {
            type: "HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "HomePageCreateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        media: {
            type: "HomePageCreateMediaEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageCreateLocalesEntityRelationInput: {
        connect: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HomePageLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleWithoutRootCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "HomePageLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "HomePageLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "HomePageLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "HomePageLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        branches: {
            type: "HomePageLocaleCreateBranchesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageUpdateInput: {
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "HomePageUpdateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        media: {
            type: "HomePageUpdateMediaEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageUpdateLocalesEntityRelationInput: {
        create: {
            type: "HomePageLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "HomePageUpdateLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "HomePageUpsertLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageUpdateLocalesRelationInput: {
        by: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "HomePageLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleWithoutRootUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "HomePageLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "HomePageLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "HomePageLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "HomePageLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        branches: {
            type: "HomePageLocaleUpdateBranchesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageUpsertLocalesRelationInput: {
        by: {
            type: "HomePageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "HomePageLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "HomePageLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "HomePageLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "HomePageLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "HomePageLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "HomePageLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "HomePageLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        branches: {
            type: "HomePageLocaleCreateBranchesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    HomePageLocaleUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "HomePageLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "HomePageLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "HomePageLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "HomePageLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "HomePageLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        branches: {
            type: "HomePageLocaleUpdateBranchesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleCreateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleCreateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleCreateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleCreateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleCreatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleCreateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleCreateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleCreateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleCreateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleCreateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleCreateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleCreateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleUpdateInput: {
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleUpdateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleUpdateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleUpdateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleUpdateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleUpdatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        seoDefaults: {
            type: "LocaleUpdateSeoDefaultsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleUpdateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleUpdateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleUpdateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleUpdateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleUpdateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleUpdateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumItemCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "MediumItemCreateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        medium: {
            type: "MediumItemCreateMediumEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumItemCreateListEntityRelationInput: {
        connect: {
            type: "MediumListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "MediumListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumListWithoutItemsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumItemUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "MediumItemUpdateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        medium: {
            type: "MediumItemUpdateMediumEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumItemUpdateListEntityRelationInput: {
        create: {
            type: "MediumListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "MediumListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "MediumItemUpsertListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "MediumListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumListWithoutItemsUpdateInput: {
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    MediumItemUpsertListRelationInput: {
        update: {
            type: "MediumListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "MediumListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "PageCreateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageCreateLocalesEntityRelationInput: {
        connect: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "PageLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleWithoutRootCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "PageLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "PageLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "PageLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "PageLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageUpdateInput: {
        locales: {
            type: "PageUpdateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageUpdateLocalesEntityRelationInput: {
        create: {
            type: "PageLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "PageUpdateLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "PageUpsertLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageUpdateLocalesRelationInput: {
        by: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "PageLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleWithoutRootUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "PageLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "PageLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "PageLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "PageLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageUpsertLocalesRelationInput: {
        by: {
            type: "PageLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "PageLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "PageLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "PageLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "PageLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "PageLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "PageLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "PageLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    PageLocaleUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "PageLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "PageLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "PageLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "PageLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "PageLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "SeoDefaultCreateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultCreateLocalesEntityRelationInput: {
        connect: {
            type: "SeoDefaultLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoDefaultLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleWithoutRootCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "SeoDefaultLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoDefaultLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleCreateLocaleEntityRelationInput: {
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutSeoDefaultsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutSeoDefaultsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleCreateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleCreateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleCreateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleCreateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleCreatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleCreateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleCreateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleCreateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleCreateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleCreateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleCreateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultUpdateInput: {
        unique: {
            type: "One",
            array: false,
            arrayRequired: false,
            required: false
        },
        locales: {
            type: "SeoDefaultUpdateLocalesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultUpdateLocalesEntityRelationInput: {
        create: {
            type: "SeoDefaultLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "SeoDefaultUpdateLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "SeoDefaultUpsertLocalesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "SeoDefaultLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "SeoDefaultLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "SeoDefaultLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultUpdateLocalesRelationInput: {
        by: {
            type: "SeoDefaultLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "SeoDefaultLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleWithoutRootUpdateInput: {
        locale: {
            type: "SeoDefaultLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoDefaultLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleUpdateLocaleEntityRelationInput: {
        create: {
            type: "LocaleWithoutSeoDefaultsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LocaleWithoutSeoDefaultsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "SeoDefaultLocaleUpsertLocaleRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LocaleWithoutSeoDefaultsUpdateInput: {
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPages: {
            type: "LocaleUpdateContactPagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        footers: {
            type: "LocaleUpdateFootersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        headers: {
            type: "LocaleUpdateHeadersEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        homePages: {
            type: "LocaleUpdateHomePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        pages: {
            type: "LocaleUpdatePagesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        events: {
            type: "LocaleUpdateEventsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworks: {
            type: "LocaleUpdateArtworksEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        artworkSelections: {
            type: "LocaleUpdateArtworkSelectionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        newsletterForms: {
            type: "LocaleUpdateNewsletterFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        employees: {
            type: "LocaleUpdateEmployeesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        contactForms: {
            type: "LocaleUpdateContactFormsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleUpsertLocaleRelationInput: {
        update: {
            type: "LocaleWithoutSeoDefaultsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LocaleWithoutSeoDefaultsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultUpsertLocalesRelationInput: {
        by: {
            type: "SeoDefaultLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "SeoDefaultLocaleWithoutRootUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "SeoDefaultLocaleWithoutRootCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "SeoDefaultLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "SeoDefaultLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoDefaultLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    SeoDefaultLocaleUpdateInput: {
        root: {
            type: "SeoDefaultLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "SeoDefaultLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "SeoDefaultLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomain: {
        catalogues: {
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationCatalogueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        keys: {
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationKeyOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        cataloguesByIdentifier: {
            by: {
                type: "TranslationDomainCataloguesByIdentifierUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        cataloguesByValues: {
            by: {
                type: "TranslationDomainCataloguesByValuesUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        keysByIdentifier: {
            by: {
                type: "TranslationDomainKeysByIdentifierUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        keysByValues: {
            by: {
                type: "TranslationDomainKeysByValuesUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateCatalogues: {
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationCatalogueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateKeys: {
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationKeyOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    TranslationCatalogue: {
        domain: {
            filter: {
                type: "TranslationDomainWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        identifier: {
            filter: {
                type: "TranslationCataloguesIdentifierWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        fallback: {
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        values: {
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationValueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        valuesByKey: {
            by: {
                type: "TranslationCatalogueValuesByKeyUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateValues: {
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationValueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    TranslationDomainWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogues: {
            type: "TranslationCatalogueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        keys: {
            type: "TranslationKeyWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "TranslationDomainWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "TranslationDomainWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "TranslationDomainWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        domain: {
            type: "TranslationDomainWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "TranslationCataloguesIdentifierWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        fallback: {
            type: "TranslationCatalogueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        values: {
            type: "TranslationValueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "TranslationCatalogueWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "TranslationCatalogueWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "TranslationCatalogueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCataloguesIdentifierWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogue: {
            type: "TranslationCatalogueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "TranslationCataloguesIdentifierWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "TranslationCataloguesIdentifierWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "TranslationCataloguesIdentifierWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationValueWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        value: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogue: {
            type: "TranslationCatalogueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        key: {
            type: "TranslationKeyWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "TranslationValueWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "TranslationValueWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "TranslationValueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        contentType: {
            type: "TranslationContentTypeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        note: {
            type: "StringCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        domain: {
            type: "TranslationDomainWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        values: {
            type: "TranslationValueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "TranslationKeyWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "TranslationKeyWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "TranslationKeyWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationContentTypeCondition: {
        and: {
            type: "TranslationContentTypeCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        or: {
            type: "TranslationContentTypeCondition",
            array: true,
            arrayRequired: false,
            required: true
        },
        not: {
            type: "TranslationContentTypeCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        null: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        isNull: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        eq: {
            type: "TranslationContentType",
            array: false,
            arrayRequired: false,
            required: false
        },
        notEq: {
            type: "TranslationContentType",
            array: false,
            arrayRequired: false,
            required: false
        },
        in: {
            type: "TranslationContentType",
            array: true,
            arrayRequired: false,
            required: true
        },
        notIn: {
            type: "TranslationContentType",
            array: true,
            arrayRequired: false,
            required: true
        },
        lt: {
            type: "TranslationContentType",
            array: false,
            arrayRequired: false,
            required: false
        },
        lte: {
            type: "TranslationContentType",
            array: false,
            arrayRequired: false,
            required: false
        },
        gt: {
            type: "TranslationContentType",
            array: false,
            arrayRequired: false,
            required: false
        },
        gte: {
            type: "TranslationContentType",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationContentType: "enum",
    TranslationCataloguesIdentifier: {
        catalogue: {
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationCatalogueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        catalogueByDomain: {
            by: {
                type: "TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        catalogueByValues: {
            by: {
                type: "TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateCatalogue: {
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationCatalogueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    TranslationCatalogueOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        domain: {
            type: "TranslationDomainOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "TranslationCataloguesIdentifierOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        fallback: {
            type: "TranslationCatalogueOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCataloguesIdentifierOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere: {
        domain: {
            type: "TranslationDomainUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogues: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        keys: {
            type: "TranslationKeyUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        domain: {
            type: "TranslationDomainUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "TranslationCataloguesIdentifierUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        values: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCataloguesIdentifierUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogue: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationValueUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogue: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        key: {
            type: "TranslationKeyUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        domain: {
            type: "TranslationDomainUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        values: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere: {
        values: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationValue: {
        catalogue: {
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        key: {
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    TranslationKey: {
        domain: {
            filter: {
                type: "TranslationDomainWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        values: {
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationValueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        valuesByCatalogue: {
            by: {
                type: "TranslationKeyValuesByCatalogueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateValues: {
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationValueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    TranslationValueOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        value: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogue: {
            type: "TranslationCatalogueOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        key: {
            type: "TranslationKeyOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        contentType: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        note: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        domain: {
            type: "TranslationDomainOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyValuesByCatalogueUniqueWhere: {
        catalogue: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueValuesByKeyUniqueWhere: {
        key: {
            type: "TranslationKeyUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainCataloguesByIdentifierUniqueWhere: {
        identifier: {
            type: "TranslationCataloguesIdentifierUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainCataloguesByValuesUniqueWhere: {
        values: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainKeysByIdentifierUniqueWhere: {
        identifier: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainKeysByValuesUniqueWhere: {
        values: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogues: {
            type: "TranslationDomainCreateCataloguesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        keys: {
            type: "TranslationDomainCreateKeysEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainCreateCataloguesEntityRelationInput: {
        connect: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationCatalogueWithoutDomainCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueWithoutDomainCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "TranslationCatalogueCreateIdentifierEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        fallback: {
            type: "TranslationCatalogueCreateFallbackEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        values: {
            type: "TranslationCatalogueCreateValuesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueCreateIdentifierEntityRelationInput: {
        connect: {
            type: "TranslationCataloguesIdentifierUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationCataloguesIdentifierWithoutCatalogueCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCataloguesIdentifierWithoutCatalogueCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueCreateFallbackEntityRelationInput: {
        connect: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationCatalogueCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        domain: {
            type: "TranslationCatalogueCreateDomainEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "TranslationCatalogueCreateIdentifierEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        fallback: {
            type: "TranslationCatalogueCreateFallbackEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        values: {
            type: "TranslationCatalogueCreateValuesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueCreateDomainEntityRelationInput: {
        connect: {
            type: "TranslationDomainUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationDomainWithoutCataloguesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainWithoutCataloguesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        keys: {
            type: "TranslationDomainCreateKeysEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainCreateKeysEntityRelationInput: {
        connect: {
            type: "TranslationKeyUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationKeyWithoutDomainCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyWithoutDomainCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contentType: {
            type: "TranslationContentType",
            array: false,
            arrayRequired: false,
            required: false
        },
        note: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        values: {
            type: "TranslationKeyCreateValuesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyCreateValuesEntityRelationInput: {
        connect: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationValueWithoutKeyCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationValueWithoutKeyCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        value: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogue: {
            type: "TranslationValueCreateCatalogueEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationValueCreateCatalogueEntityRelationInput: {
        connect: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationCatalogueWithoutValuesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueWithoutValuesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        domain: {
            type: "TranslationCatalogueCreateDomainEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "TranslationCatalogueCreateIdentifierEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        fallback: {
            type: "TranslationCatalogueCreateFallbackEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueCreateValuesEntityRelationInput: {
        connect: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationValueWithoutCatalogueCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationValueWithoutCatalogueCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        value: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        key: {
            type: "TranslationValueCreateKeyEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationValueCreateKeyEntityRelationInput: {
        connect: {
            type: "TranslationKeyUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationKeyWithoutValuesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyWithoutValuesCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contentType: {
            type: "TranslationContentType",
            array: false,
            arrayRequired: false,
            required: false
        },
        note: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        domain: {
            type: "TranslationKeyCreateDomainEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyCreateDomainEntityRelationInput: {
        connect: {
            type: "TranslationDomainUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationDomainWithoutKeysCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainWithoutKeysCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogues: {
            type: "TranslationDomainCreateCataloguesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainUpdateInput: {
        identifier: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogues: {
            type: "TranslationDomainUpdateCataloguesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        keys: {
            type: "TranslationDomainUpdateKeysEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainUpdateCataloguesEntityRelationInput: {
        create: {
            type: "TranslationCatalogueWithoutDomainCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationDomainUpdateCataloguesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "TranslationDomainUpsertCataloguesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainUpdateCataloguesRelationInput: {
        by: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "TranslationCatalogueWithoutDomainUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueWithoutDomainUpdateInput: {
        identifier: {
            type: "TranslationCatalogueUpdateIdentifierEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        fallback: {
            type: "TranslationCatalogueUpdateFallbackEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        values: {
            type: "TranslationCatalogueUpdateValuesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueUpdateIdentifierEntityRelationInput: {
        create: {
            type: "TranslationCataloguesIdentifierWithoutCatalogueCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationCataloguesIdentifierWithoutCatalogueUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "TranslationCatalogueUpsertIdentifierRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "TranslationCataloguesIdentifierUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCataloguesIdentifierWithoutCatalogueUpdateInput: {
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueUpsertIdentifierRelationInput: {
        update: {
            type: "TranslationCataloguesIdentifierWithoutCatalogueUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationCataloguesIdentifierWithoutCatalogueCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueUpdateFallbackEntityRelationInput: {
        create: {
            type: "TranslationCatalogueCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationCatalogueUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "TranslationCatalogueUpsertFallbackRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueUpdateInput: {
        domain: {
            type: "TranslationCatalogueUpdateDomainEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "TranslationCatalogueUpdateIdentifierEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        fallback: {
            type: "TranslationCatalogueUpdateFallbackEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        values: {
            type: "TranslationCatalogueUpdateValuesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueUpdateDomainEntityRelationInput: {
        create: {
            type: "TranslationDomainWithoutCataloguesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationDomainWithoutCataloguesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "TranslationCatalogueUpsertDomainRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "TranslationDomainUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainWithoutCataloguesUpdateInput: {
        identifier: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        keys: {
            type: "TranslationDomainUpdateKeysEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainUpdateKeysEntityRelationInput: {
        create: {
            type: "TranslationKeyWithoutDomainCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationDomainUpdateKeysRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "TranslationDomainUpsertKeysRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "TranslationKeyUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "TranslationKeyUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "TranslationKeyUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainUpdateKeysRelationInput: {
        by: {
            type: "TranslationKeyUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "TranslationKeyWithoutDomainUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyWithoutDomainUpdateInput: {
        identifier: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contentType: {
            type: "TranslationContentType",
            array: false,
            arrayRequired: false,
            required: false
        },
        note: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        values: {
            type: "TranslationKeyUpdateValuesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyUpdateValuesEntityRelationInput: {
        create: {
            type: "TranslationValueWithoutKeyCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationKeyUpdateValuesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "TranslationKeyUpsertValuesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyUpdateValuesRelationInput: {
        by: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "TranslationValueWithoutKeyUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationValueWithoutKeyUpdateInput: {
        value: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogue: {
            type: "TranslationValueUpdateCatalogueEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationValueUpdateCatalogueEntityRelationInput: {
        create: {
            type: "TranslationCatalogueWithoutValuesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationCatalogueWithoutValuesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "TranslationValueUpsertCatalogueRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueWithoutValuesUpdateInput: {
        domain: {
            type: "TranslationCatalogueUpdateDomainEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "TranslationCatalogueUpdateIdentifierEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        fallback: {
            type: "TranslationCatalogueUpdateFallbackEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationValueUpsertCatalogueRelationInput: {
        update: {
            type: "TranslationCatalogueWithoutValuesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationCatalogueWithoutValuesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyUpsertValuesRelationInput: {
        by: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationValueWithoutKeyUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationValueWithoutKeyCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainUpsertKeysRelationInput: {
        by: {
            type: "TranslationKeyUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationKeyWithoutDomainUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationKeyWithoutDomainCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueUpsertDomainRelationInput: {
        update: {
            type: "TranslationDomainWithoutCataloguesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationDomainWithoutCataloguesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueUpdateValuesEntityRelationInput: {
        create: {
            type: "TranslationValueWithoutCatalogueCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationCatalogueUpdateValuesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "TranslationCatalogueUpsertValuesRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueUpdateValuesRelationInput: {
        by: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "TranslationValueWithoutCatalogueUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationValueWithoutCatalogueUpdateInput: {
        value: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        key: {
            type: "TranslationValueUpdateKeyEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationValueUpdateKeyEntityRelationInput: {
        create: {
            type: "TranslationKeyWithoutValuesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationKeyWithoutValuesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "TranslationValueUpsertKeyRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "TranslationKeyUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyWithoutValuesUpdateInput: {
        identifier: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contentType: {
            type: "TranslationContentType",
            array: false,
            arrayRequired: false,
            required: false
        },
        note: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        domain: {
            type: "TranslationKeyUpdateDomainEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyUpdateDomainEntityRelationInput: {
        create: {
            type: "TranslationDomainWithoutKeysCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationDomainWithoutKeysUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "TranslationKeyUpsertDomainRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "TranslationDomainUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainWithoutKeysUpdateInput: {
        identifier: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogues: {
            type: "TranslationDomainUpdateCataloguesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyUpsertDomainRelationInput: {
        update: {
            type: "TranslationDomainWithoutKeysUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationDomainWithoutKeysCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationValueUpsertKeyRelationInput: {
        update: {
            type: "TranslationKeyWithoutValuesUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationKeyWithoutValuesCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueUpsertValuesRelationInput: {
        by: {
            type: "TranslationValueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationValueWithoutCatalogueUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationValueWithoutCatalogueCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueUpsertFallbackRelationInput: {
        update: {
            type: "TranslationCatalogueUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationCatalogueCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationDomainUpsertCataloguesRelationInput: {
        by: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationCatalogueWithoutDomainUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationCatalogueWithoutDomainCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCataloguesIdentifierCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogue: {
            type: "TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput: {
        connect: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationCatalogueWithoutIdentifierCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueWithoutIdentifierCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        domain: {
            type: "TranslationCatalogueCreateDomainEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        fallback: {
            type: "TranslationCatalogueCreateFallbackEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        values: {
            type: "TranslationCatalogueCreateValuesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCataloguesIdentifierUpdateInput: {
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        code: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogue: {
            type: "TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput: {
        create: {
            type: "TranslationCatalogueWithoutIdentifierCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationCataloguesIdentifierUpdateCatalogueRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "TranslationCataloguesIdentifierUpsertCatalogueRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCataloguesIdentifierUpdateCatalogueRelationInput: {
        by: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "TranslationCatalogueWithoutIdentifierUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCatalogueWithoutIdentifierUpdateInput: {
        domain: {
            type: "TranslationCatalogueUpdateDomainEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        fallback: {
            type: "TranslationCatalogueUpdateFallbackEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        values: {
            type: "TranslationCatalogueUpdateValuesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationCataloguesIdentifierUpsertCatalogueRelationInput: {
        by: {
            type: "TranslationCatalogueUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "TranslationCatalogueWithoutIdentifierUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "TranslationCatalogueWithoutIdentifierCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        identifier: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contentType: {
            type: "TranslationContentType",
            array: false,
            arrayRequired: false,
            required: false
        },
        note: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        domain: {
            type: "TranslationKeyCreateDomainEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        values: {
            type: "TranslationKeyCreateValuesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationKeyUpdateInput: {
        identifier: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contentType: {
            type: "TranslationContentType",
            array: false,
            arrayRequired: false,
            required: false
        },
        note: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        domain: {
            type: "TranslationKeyUpdateDomainEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        values: {
            type: "TranslationKeyUpdateValuesEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationValueCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        value: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogue: {
            type: "TranslationValueCreateCatalogueEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        key: {
            type: "TranslationValueCreateKeyEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    TranslationValueUpdateInput: {
        value: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        catalogue: {
            type: "TranslationValueUpdateCatalogueEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        key: {
            type: "TranslationValueUpdateKeyEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EventLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "EventLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "EventLocaleCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "EventLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "EventLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        venue: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        venueNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "EventLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        isDark: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventLocaleUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EventLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "EventLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "EventLocaleUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "EventLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "EventLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        venue: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        venueNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "EventLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        isDark: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ArtworkLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ArtworkLocaleCreateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ArtworkLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artist: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkLocaleUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        label: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        leadParagraph: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ArtworkLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        content: {
            type: "ArtworkLocaleUpdateContentEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ArtworkLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artist: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownItemCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "DropDownItemCreateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "DropDownItemCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownItemCreateListEntityRelationInput: {
        connect: {
            type: "DropDownListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "DropDownListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownListWithoutItemsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        dropDownType: {
            type: "DropDownType",
            array: false,
            arrayRequired: false,
            required: false
        },
        employees: {
            type: "DropDownListCreateEmployeesEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownItemUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "DropDownItemUpdateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "DropDownItemUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownItemUpdateListEntityRelationInput: {
        create: {
            type: "DropDownListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "DropDownListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "DropDownItemUpsertListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "DropDownListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownListWithoutItemsUpdateInput: {
        dropDownType: {
            type: "DropDownType",
            array: false,
            arrayRequired: false,
            required: false
        },
        employees: {
            type: "DropDownListUpdateEmployeesEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DropDownItemUpsertListRelationInput: {
        update: {
            type: "DropDownListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "DropDownListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkItem: {
        list: {
            filter: {
                type: "ArtworkListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        artwork: {
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ArtworkList: {
        items: {
            filter: {
                type: "ArtworkItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateItems: {
            filter: {
                type: "ArtworkItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    ArtworkItemWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "IntCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ArtworkListWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "ArtworkLocaleWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ArtworkItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ArtworkItemWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ArtworkItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkListWhere: {
        id: {
            type: "UUIDCondition",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ArtworkItemWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        and: {
            type: "ArtworkListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        or: {
            type: "ArtworkListWhere",
            array: true,
            arrayRequired: false,
            required: false
        },
        not: {
            type: "ArtworkListWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkItemOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ArtworkListOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "ArtworkLocaleOrderBy",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkListOrderBy: {
        _random: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        _randomSeeded: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        id: {
            type: "OrderDirection",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkItemUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkItemCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ArtworkItemCreateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "ArtworkItemCreateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkItemCreateListEntityRelationInput: {
        connect: {
            type: "ArtworkListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkListUniqueWhere: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ArtworkItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkListWithoutItemsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkItemCreateArtworkEntityRelationInput: {
        connect: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkItemUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ArtworkItemUpdateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "ArtworkItemUpdateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkItemUpdateListEntityRelationInput: {
        create: {
            type: "ArtworkListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkItemUpsertListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkListWithoutItemsUpdateInput: {
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkItemUpsertListRelationInput: {
        update: {
            type: "ArtworkListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkItemUpdateArtworkEntityRelationInput: {
        create: {
            type: "ArtworkLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkItemUpsertArtworkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkItemUpsertArtworkRelationInput: {
        update: {
            type: "ArtworkLocaleUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkLocaleCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ArtworkListCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkListCreateItemsEntityRelationInput: {
        connect: {
            type: "ArtworkItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkItemWithoutListCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "ArtworkItemCreateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkListUpdateInput: {
        items: {
            type: "ArtworkListUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkListUpdateItemsEntityRelationInput: {
        create: {
            type: "ArtworkItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkListUpdateItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkListUpsertItemsRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "ArtworkItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "ArtworkItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        alias: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkListUpdateItemsRelationInput: {
        by: {
            type: "ArtworkItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        data: {
            type: "ArtworkItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkItemWithoutListUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "ArtworkItemUpdateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkListUpsertItemsRelationInput: {
        by: {
            type: "ArtworkItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkItemWithoutListUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkItemWithoutListCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionItemCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ArtworkSelectionItemCreateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "ArtworkSelectionItemCreateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionItemCreateListEntityRelationInput: {
        connect: {
            type: "ArtworkSelectionListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionListWithoutItemsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionItemUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ArtworkSelectionItemUpdateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "ArtworkSelectionItemUpdateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionItemUpdateListEntityRelationInput: {
        create: {
            type: "ArtworkSelectionListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ArtworkSelectionListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ArtworkSelectionItemUpsertListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ArtworkSelectionListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionListWithoutItemsUpdateInput: {
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionItemUpsertListRelationInput: {
        update: {
            type: "ArtworkSelectionListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ArtworkSelectionListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkSelectionLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ArtworkSelectionLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkSelectionLocaleCreateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ArtworkSelectionLocaleCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ArtworkSelectionLocaleUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ArtworkSelectionLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ArtworkSelectionLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        seo: {
            type: "ArtworkSelectionLocaleUpdateSeoEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "ArtworkSelectionLocaleUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventItemCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "EventItemCreateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "EventItemCreateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventItemCreateListEntityRelationInput: {
        connect: {
            type: "EventListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventListWithoutItemsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventItemUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "EventItemUpdateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "EventItemUpdateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventItemUpdateListEntityRelationInput: {
        create: {
            type: "EventListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EventListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EventItemUpsertListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EventListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventListWithoutItemsUpdateInput: {
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EventItemUpsertListRelationInput: {
        update: {
            type: "EventListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EventListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxItemCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "BoxItemCreateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxItemCreateListEntityRelationInput: {
        connect: {
            type: "BoxListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "BoxListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxListWithoutItemsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxItemUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "BoxItemUpdateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxItemUpdateListEntityRelationInput: {
        create: {
            type: "BoxListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "BoxListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "BoxItemUpsertListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "BoxListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxListWithoutItemsUpdateInput: {
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    BoxItemUpsertListRelationInput: {
        update: {
            type: "BoxListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "BoxListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "NewsletterTypeItemCreateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        subscriptions: {
            type: "NewsletterTypeItemCreateSubscriptionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemCreateListEntityRelationInput: {
        connect: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterFormLocaleWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleWithoutItemsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "NewsletterFormLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "NewsletterFormLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "NewsletterTypeItemUpdateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        subscriptions: {
            type: "NewsletterTypeItemUpdateSubscriptionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemUpdateListEntityRelationInput: {
        create: {
            type: "NewsletterFormLocaleWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "NewsletterFormLocaleWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "NewsletterTypeItemUpsertListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "NewsletterFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleWithoutItemsUpdateInput: {
        newsletterTypeNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "NewsletterFormLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "NewsletterFormLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemUpsertListRelationInput: {
        update: {
            type: "NewsletterFormLocaleWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterFormLocaleWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "NewsletterFormLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "NewsletterFormLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "NewsletterFormLocaleCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterFormLocaleUpdateInput: {
        newsletterTypeNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        emailNote: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "NewsletterFormLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "NewsletterFormLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "NewsletterFormLocaleUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterSubscriptionCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        createdAt: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterType: {
            type: "NewsletterSubscriptionCreateNewsletterTypeEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterSubscriptionCreateNewsletterTypeEntityRelationInput: {
        connect: {
            type: "NewsletterTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterTypeItemWithoutSubscriptionsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemWithoutSubscriptionsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "NewsletterTypeItemCreateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterSubscriptionUpdateInput: {
        createdAt: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        newsletterType: {
            type: "NewsletterSubscriptionUpdateNewsletterTypeEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterSubscriptionUpdateNewsletterTypeEntityRelationInput: {
        create: {
            type: "NewsletterTypeItemWithoutSubscriptionsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "NewsletterTypeItemWithoutSubscriptionsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "NewsletterSubscriptionUpsertNewsletterTypeRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "NewsletterTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterTypeItemWithoutSubscriptionsUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "NewsletterTypeItemUpdateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    NewsletterSubscriptionUpsertNewsletterTypeRelationInput: {
        update: {
            type: "NewsletterTypeItemWithoutSubscriptionsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "NewsletterTypeItemWithoutSubscriptionsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartDataCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ChartDataCreateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "Date",
            array: false,
            arrayRequired: false,
            required: false
        },
        number: {
            type: "Float",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ChartDataCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartDataCreateListEntityRelationInput: {
        connect: {
            type: "ChartUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ChartWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartWithoutItemsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        type: {
            type: "ChartType",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartDataUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ChartDataUpdateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        date: {
            type: "Date",
            array: false,
            arrayRequired: false,
            required: false
        },
        number: {
            type: "Float",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "ChartDataUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartDataUpdateListEntityRelationInput: {
        create: {
            type: "ChartWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ChartWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ChartDataUpsertListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ChartUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartWithoutItemsUpdateInput: {
        type: {
            type: "ChartType",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ChartDataUpsertListRelationInput: {
        update: {
            type: "ChartWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ChartWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeItemCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "EmployeeItemCreateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        employee: {
            type: "EmployeeItemCreateEmployeeEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeItemCreateListEntityRelationInput: {
        connect: {
            type: "EmployeeListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeListWithoutItemsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeItemUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "EmployeeItemUpdateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        employee: {
            type: "EmployeeItemUpdateEmployeeEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeItemUpdateListEntityRelationInput: {
        create: {
            type: "EmployeeListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "EmployeeListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "EmployeeItemUpsertListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "EmployeeListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeListWithoutItemsUpdateInput: {
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeItemUpsertListRelationInput: {
        update: {
            type: "EmployeeListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "EmployeeListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        position: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EmployeeLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "EmployeeLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    EmployeeLocaleUpdateInput: {
        position: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "EmployeeLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "EmployeeLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionItemCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        key: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        value: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "DefinitionItemCreateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionItemCreateListEntityRelationInput: {
        connect: {
            type: "DefinitionListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "DefinitionListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionListWithoutItemsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionItemUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        key: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        value: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "DefinitionItemUpdateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionItemUpdateListEntityRelationInput: {
        create: {
            type: "DefinitionListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "DefinitionListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "DefinitionItemUpsertListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "DefinitionListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionListWithoutItemsUpdateInput: {
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    DefinitionItemUpsertListRelationInput: {
        update: {
            type: "DefinitionListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "DefinitionListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoItemCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "LogoItemCreateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "LogoItemCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoItemCreateListEntityRelationInput: {
        connect: {
            type: "LogoListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LogoListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoListWithoutItemsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoItemUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "LogoItemUpdateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "LogoItemUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoItemUpdateListEntityRelationInput: {
        create: {
            type: "LogoListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LogoListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "LogoItemUpsertListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LogoListUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoListWithoutItemsUpdateInput: {
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LogoItemUpsertListRelationInput: {
        update: {
            type: "LogoListWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LogoListWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupItemCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        schema: {
            type: "StrategySchemaGroupItemCreateSchemaEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupItemCreateSchemaEntityRelationInput: {
        connect: {
            type: "StrategySchemaGroupUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "StrategySchemaGroupWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupWithoutItemsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupItemUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        text: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        schema: {
            type: "StrategySchemaGroupItemUpdateSchemaEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupItemUpdateSchemaEntityRelationInput: {
        create: {
            type: "StrategySchemaGroupWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "StrategySchemaGroupWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "StrategySchemaGroupItemUpsertSchemaRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "StrategySchemaGroupUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupWithoutItemsUpdateInput: {
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    StrategySchemaGroupItemUpsertSchemaRelationInput: {
        update: {
            type: "StrategySchemaGroupWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "StrategySchemaGroupWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    RedirectCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        link: {
            type: "RedirectCreateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        target: {
            type: "RedirectCreateTargetEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    RedirectCreateLinkEntityRelationInput: {
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableWithoutRedirectCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableWithoutRedirectCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "LinkableCreateHomePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "LinkableCreateContactPageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "LinkableCreatePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "LinkableCreateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "LinkableCreateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "LinkableCreateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    RedirectUpdateInput: {
        link: {
            type: "RedirectUpdateLinkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        target: {
            type: "RedirectUpdateTargetEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    RedirectUpdateLinkEntityRelationInput: {
        create: {
            type: "LinkableWithoutRedirectCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "LinkableWithoutRedirectUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "RedirectUpsertLinkRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "LinkableUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    LinkableWithoutRedirectUpdateInput: {
        url: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        homePage: {
            type: "LinkableUpdateHomePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactPage: {
            type: "LinkableUpdateContactPageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        page: {
            type: "LinkableUpdatePageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        event: {
            type: "LinkableUpdateEventEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artwork: {
            type: "LinkableUpdateArtworkEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        artworkSelection: {
            type: "LinkableUpdateArtworkSelectionEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    RedirectUpsertLinkRelationInput: {
        update: {
            type: "LinkableWithoutRedirectUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "LinkableWithoutRedirectCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryItemCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "GalleryItemCreateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "GalleryItemCreateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryItemCreateListEntityRelationInput: {
        connect: {
            type: "GalleryUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "GalleryWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryWithoutItemsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryItemUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "GalleryItemUpdateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        image: {
            type: "GalleryItemUpdateImageEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryItemUpdateListEntityRelationInput: {
        create: {
            type: "GalleryWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "GalleryWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "GalleryItemUpsertListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "GalleryUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryWithoutItemsUpdateInput: {
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    GalleryItemUpsertListRelationInput: {
        update: {
            type: "GalleryWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "GalleryWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactFormLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ContactFormLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ContactFormLocaleCreateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        file: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactFormLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ContactFormLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        items: {
            type: "ContactFormLocaleUpdateItemsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        file: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactSubscriptionCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        createdAt: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        file: {
            type: "ContactSubscriptionCreateFileEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactType: {
            type: "ContactSubscriptionCreateContactTypeEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactSubscriptionCreateContactTypeEntityRelationInput: {
        connect: {
            type: "ContactTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactTypeItemWithoutSubscriptionsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemWithoutSubscriptionsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ContactTypeItemCreateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemCreateListEntityRelationInput: {
        connect: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactFormLocaleWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleWithoutItemsCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactFormLocaleCreateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ContactFormLocaleCreateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        file: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactSubscriptionUpdateInput: {
        createdAt: {
            type: "DateTime",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        file: {
            type: "ContactSubscriptionUpdateFileEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactType: {
            type: "ContactSubscriptionUpdateContactTypeEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactSubscriptionUpdateContactTypeEntityRelationInput: {
        create: {
            type: "ContactTypeItemWithoutSubscriptionsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactTypeItemWithoutSubscriptionsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContactSubscriptionUpsertContactTypeRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContactTypeItemUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        disconnect: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemWithoutSubscriptionsUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        list: {
            type: "ContactTypeItemUpdateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemUpdateListEntityRelationInput: {
        create: {
            type: "ContactFormLocaleWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        update: {
            type: "ContactFormLocaleWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        upsert: {
            type: "ContactTypeItemUpsertListRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        connect: {
            type: "ContactFormLocaleUniqueWhere",
            array: false,
            arrayRequired: false,
            required: false
        },
        delete: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactFormLocaleWithoutItemsUpdateInput: {
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        name: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        phone: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        email: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        message: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        submit: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        successMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        genericErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        contactTypeErrorMessage: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        root: {
            type: "ContactFormLocaleUpdateRootEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        locale: {
            type: "ContactFormLocaleUpdateLocaleEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        file: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemUpsertListRelationInput: {
        update: {
            type: "ContactFormLocaleWithoutItemsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactFormLocaleWithoutItemsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactSubscriptionUpsertContactTypeRelationInput: {
        update: {
            type: "ContactTypeItemWithoutSubscriptionsUpdateInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        create: {
            type: "ContactTypeItemWithoutSubscriptionsCreateInput",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemCreateInput: {
        id: {
            type: "UUID",
            array: false,
            arrayRequired: false,
            required: false
        },
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        subscriptions: {
            type: "ContactTypeItemCreateSubscriptionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        list: {
            type: "ContactTypeItemCreateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    ContactTypeItemUpdateInput: {
        order: {
            type: "Int",
            array: false,
            arrayRequired: false,
            required: false
        },
        title: {
            type: "String",
            array: false,
            arrayRequired: false,
            required: false
        },
        subscriptions: {
            type: "ContactTypeItemUpdateSubscriptionsEntityRelationInput",
            array: true,
            arrayRequired: false,
            required: true
        },
        list: {
            type: "ContactTypeItemUpdateListEntityRelationInput",
            array: false,
            arrayRequired: false,
            required: false
        },
        _dummy_field_: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    QueryTransaction: {
        getContactPage: {
            by: {
                type: "ContactPageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContactPage: {
            filter: {
                type: "ContactPageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactPageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContactPage: {
            filter: {
                type: "ContactPageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactPageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContactPage: {
            data: {
                type: "ContactPageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContactPage: {
            by: {
                type: "ContactPageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContactPageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContactPageLocale: {
            by: {
                type: "ContactPageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContactPageLocale: {
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactPageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContactPageLocale: {
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactPageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContactPageLocale: {
            data: {
                type: "ContactPageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContactPageLocale: {
            by: {
                type: "ContactPageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContactPageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContent: {
            by: {
                type: "ContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContent: {
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContent: {
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContent: {
            data: {
                type: "ContentCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContent: {
            by: {
                type: "ContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContentUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContentBlock: {
            by: {
                type: "ContentBlockUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContentBlock: {
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentBlockOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContentBlock: {
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentBlockOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContentBlock: {
            data: {
                type: "ContentBlockCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContentBlock: {
            by: {
                type: "ContentBlockUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContentBlockUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContentReference: {
            by: {
                type: "ContentReferenceUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContentReference: {
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentReferenceOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContentReference: {
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContentReferenceOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContentReference: {
            data: {
                type: "ContentReferenceCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContentReference: {
            by: {
                type: "ContentReferenceUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContentReferenceUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getFooter: {
            by: {
                type: "FooterUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listFooter: {
            filter: {
                type: "FooterWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FooterOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateFooter: {
            filter: {
                type: "FooterWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FooterOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateFooter: {
            data: {
                type: "FooterCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateFooter: {
            by: {
                type: "FooterUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "FooterUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getFooterLocale: {
            by: {
                type: "FooterLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listFooterLocale: {
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FooterLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateFooterLocale: {
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FooterLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateFooterLocale: {
            data: {
                type: "FooterLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateFooterLocale: {
            by: {
                type: "FooterLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "FooterLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getHeader: {
            by: {
                type: "HeaderUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listHeader: {
            filter: {
                type: "HeaderWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateHeader: {
            filter: {
                type: "HeaderWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateHeader: {
            data: {
                type: "HeaderCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateHeader: {
            by: {
                type: "HeaderUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "HeaderUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getHeaderLink: {
            by: {
                type: "HeaderLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listHeaderLink: {
            filter: {
                type: "HeaderLinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderLinkOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateHeaderLink: {
            filter: {
                type: "HeaderLinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderLinkOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateHeaderLink: {
            data: {
                type: "HeaderLinkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateHeaderLink: {
            by: {
                type: "HeaderLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "HeaderLinkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getHeaderLocale: {
            by: {
                type: "HeaderLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listHeaderLocale: {
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateHeaderLocale: {
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HeaderLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateHeaderLocale: {
            data: {
                type: "HeaderLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateHeaderLocale: {
            by: {
                type: "HeaderLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "HeaderLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getHomePage: {
            by: {
                type: "HomePageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listHomePage: {
            filter: {
                type: "HomePageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HomePageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateHomePage: {
            filter: {
                type: "HomePageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HomePageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateHomePage: {
            data: {
                type: "HomePageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateHomePage: {
            by: {
                type: "HomePageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "HomePageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getHomePageLocale: {
            by: {
                type: "HomePageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listHomePageLocale: {
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HomePageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateHomePageLocale: {
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "HomePageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateHomePageLocale: {
            data: {
                type: "HomePageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateHomePageLocale: {
            by: {
                type: "HomePageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "HomePageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getLink: {
            by: {
                type: "LinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listLink: {
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LinkOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLink: {
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LinkOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateLink: {
            data: {
                type: "LinkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateLink: {
            by: {
                type: "LinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "LinkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getLinkable: {
            by: {
                type: "LinkableUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listLinkable: {
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LinkableOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLinkable: {
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LinkableOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateLinkable: {
            data: {
                type: "LinkableCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateLinkable: {
            by: {
                type: "LinkableUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "LinkableUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getLocale: {
            by: {
                type: "LocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listLocale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLocale: {
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateLocale: {
            data: {
                type: "LocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateLocale: {
            by: {
                type: "LocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "LocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getMedium: {
            by: {
                type: "MediumUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listMedium: {
            filter: {
                type: "MediumWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "MediumOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateMedium: {
            filter: {
                type: "MediumWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "MediumOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateMedium: {
            data: {
                type: "MediumCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateMedium: {
            by: {
                type: "MediumUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "MediumUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getMediumItem: {
            by: {
                type: "MediumItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listMediumItem: {
            filter: {
                type: "MediumItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "MediumItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateMediumItem: {
            filter: {
                type: "MediumItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "MediumItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateMediumItem: {
            data: {
                type: "MediumItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateMediumItem: {
            by: {
                type: "MediumItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "MediumItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getMediumList: {
            by: {
                type: "MediumListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listMediumList: {
            filter: {
                type: "MediumListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "MediumListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateMediumList: {
            filter: {
                type: "MediumListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "MediumListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateMediumList: {
            data: {
                type: "MediumListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateMediumList: {
            by: {
                type: "MediumListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "MediumListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getPage: {
            by: {
                type: "PageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listPage: {
            filter: {
                type: "PageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginatePage: {
            filter: {
                type: "PageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreatePage: {
            data: {
                type: "PageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdatePage: {
            by: {
                type: "PageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "PageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getPageLocale: {
            by: {
                type: "PageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listPageLocale: {
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginatePageLocale: {
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PageLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreatePageLocale: {
            data: {
                type: "PageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdatePageLocale: {
            by: {
                type: "PageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "PageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getSeoDefault: {
            by: {
                type: "SeoDefaultUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listSeoDefault: {
            filter: {
                type: "SeoDefaultWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoDefaultOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateSeoDefault: {
            filter: {
                type: "SeoDefaultWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoDefaultOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateSeoDefault: {
            data: {
                type: "SeoDefaultCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateSeoDefault: {
            by: {
                type: "SeoDefaultUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "SeoDefaultUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getSeoDefaultLocale: {
            by: {
                type: "SeoDefaultLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listSeoDefaultLocale: {
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoDefaultLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateSeoDefaultLocale: {
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoDefaultLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateSeoDefaultLocale: {
            data: {
                type: "SeoDefaultLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateSeoDefaultLocale: {
            by: {
                type: "SeoDefaultLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "SeoDefaultLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getVideo: {
            by: {
                type: "VideoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "VideoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listVideo: {
            filter: {
                type: "VideoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "VideoOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateVideo: {
            filter: {
                type: "VideoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "VideoOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateVideo: {
            data: {
                type: "VideoCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateVideo: {
            by: {
                type: "VideoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "VideoUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getImage: {
            by: {
                type: "ImageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listImage: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ImageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateImage: {
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ImageOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateImage: {
            data: {
                type: "ImageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateImage: {
            by: {
                type: "ImageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ImageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getSeo: {
            by: {
                type: "SeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listSeo: {
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateSeo: {
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "SeoOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateSeo: {
            data: {
                type: "SeoCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateSeo: {
            by: {
                type: "SeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "SeoUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getTranslationDomain: {
            by: {
                type: "TranslationDomainUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationDomainWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listTranslationDomain: {
            filter: {
                type: "TranslationDomainWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationDomainOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateTranslationDomain: {
            filter: {
                type: "TranslationDomainWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationDomainOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateTranslationDomain: {
            data: {
                type: "TranslationDomainCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateTranslationDomain: {
            by: {
                type: "TranslationDomainUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "TranslationDomainUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getTranslationCatalogue: {
            by: {
                type: "TranslationCatalogueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listTranslationCatalogue: {
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationCatalogueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateTranslationCatalogue: {
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationCatalogueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateTranslationCatalogue: {
            data: {
                type: "TranslationCatalogueCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateTranslationCatalogue: {
            by: {
                type: "TranslationCatalogueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "TranslationCatalogueUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getTranslationCataloguesIdentifier: {
            by: {
                type: "TranslationCataloguesIdentifierUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCataloguesIdentifierWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listTranslationCataloguesIdentifier: {
            filter: {
                type: "TranslationCataloguesIdentifierWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationCataloguesIdentifierOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateTranslationCataloguesIdentifier: {
            filter: {
                type: "TranslationCataloguesIdentifierWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationCataloguesIdentifierOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateTranslationCataloguesIdentifier: {
            data: {
                type: "TranslationCataloguesIdentifierCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateTranslationCataloguesIdentifier: {
            by: {
                type: "TranslationCataloguesIdentifierUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "TranslationCataloguesIdentifierUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getTranslationKey: {
            by: {
                type: "TranslationKeyUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listTranslationKey: {
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationKeyOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateTranslationKey: {
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationKeyOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateTranslationKey: {
            data: {
                type: "TranslationKeyCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateTranslationKey: {
            by: {
                type: "TranslationKeyUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "TranslationKeyUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getTranslationValue: {
            by: {
                type: "TranslationValueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listTranslationValue: {
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationValueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateTranslationValue: {
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "TranslationValueOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateTranslationValue: {
            data: {
                type: "TranslationValueCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateTranslationValue: {
            by: {
                type: "TranslationValueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "TranslationValueUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getBranches: {
            by: {
                type: "BranchesUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BranchesWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listBranches: {
            filter: {
                type: "BranchesWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BranchesOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateBranches: {
            filter: {
                type: "BranchesWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BranchesOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateBranches: {
            data: {
                type: "BranchesCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateBranches: {
            by: {
                type: "BranchesUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "BranchesUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getGraphicDesigner: {
            by: {
                type: "GraphicDesignerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GraphicDesignerWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listGraphicDesigner: {
            filter: {
                type: "GraphicDesignerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GraphicDesignerOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateGraphicDesigner: {
            filter: {
                type: "GraphicDesignerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GraphicDesignerOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateGraphicDesigner: {
            data: {
                type: "GraphicDesignerCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateGraphicDesigner: {
            by: {
                type: "GraphicDesignerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "GraphicDesignerUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEvent: {
            by: {
                type: "EventUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEvent: {
            filter: {
                type: "EventWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEvent: {
            filter: {
                type: "EventWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEvent: {
            data: {
                type: "EventCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEvent: {
            by: {
                type: "EventUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EventUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEventLocale: {
            by: {
                type: "EventLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEventLocale: {
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEventLocale: {
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEventLocale: {
            data: {
                type: "EventLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEventLocale: {
            by: {
                type: "EventLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EventLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtwork: {
            by: {
                type: "ArtworkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtwork: {
            filter: {
                type: "ArtworkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtwork: {
            filter: {
                type: "ArtworkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtwork: {
            data: {
                type: "ArtworkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtwork: {
            by: {
                type: "ArtworkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtworkLocale: {
            by: {
                type: "ArtworkLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtworkLocale: {
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworkLocale: {
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtworkLocale: {
            data: {
                type: "ArtworkLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtworkLocale: {
            by: {
                type: "ArtworkLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getDropDownItem: {
            by: {
                type: "DropDownItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listDropDownItem: {
            filter: {
                type: "DropDownItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DropDownItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateDropDownItem: {
            filter: {
                type: "DropDownItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DropDownItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateDropDownItem: {
            data: {
                type: "DropDownItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateDropDownItem: {
            by: {
                type: "DropDownItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "DropDownItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getDropDownList: {
            by: {
                type: "DropDownListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listDropDownList: {
            filter: {
                type: "DropDownListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DropDownListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateDropDownList: {
            filter: {
                type: "DropDownListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DropDownListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateDropDownList: {
            data: {
                type: "DropDownListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateDropDownList: {
            by: {
                type: "DropDownListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "DropDownListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtworkItem: {
            by: {
                type: "ArtworkItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtworkItem: {
            filter: {
                type: "ArtworkItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworkItem: {
            filter: {
                type: "ArtworkItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtworkItem: {
            data: {
                type: "ArtworkItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtworkItem: {
            by: {
                type: "ArtworkItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtworkList: {
            by: {
                type: "ArtworkListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtworkList: {
            filter: {
                type: "ArtworkListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworkList: {
            filter: {
                type: "ArtworkListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtworkList: {
            data: {
                type: "ArtworkListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtworkList: {
            by: {
                type: "ArtworkListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtworkSelection: {
            by: {
                type: "ArtworkSelectionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtworkSelection: {
            filter: {
                type: "ArtworkSelectionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworkSelection: {
            filter: {
                type: "ArtworkSelectionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtworkSelection: {
            data: {
                type: "ArtworkSelectionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtworkSelection: {
            by: {
                type: "ArtworkSelectionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkSelectionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtworkSelectionItem: {
            by: {
                type: "ArtworkSelectionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtworkSelectionItem: {
            filter: {
                type: "ArtworkSelectionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworkSelectionItem: {
            filter: {
                type: "ArtworkSelectionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtworkSelectionItem: {
            data: {
                type: "ArtworkSelectionItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtworkSelectionItem: {
            by: {
                type: "ArtworkSelectionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkSelectionItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtworkSelectionList: {
            by: {
                type: "ArtworkSelectionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtworkSelectionList: {
            filter: {
                type: "ArtworkSelectionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworkSelectionList: {
            filter: {
                type: "ArtworkSelectionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtworkSelectionList: {
            data: {
                type: "ArtworkSelectionListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtworkSelectionList: {
            by: {
                type: "ArtworkSelectionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkSelectionListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getArtworkSelectionLocale: {
            by: {
                type: "ArtworkSelectionLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listArtworkSelectionLocale: {
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateArtworkSelectionLocale: {
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ArtworkSelectionLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateArtworkSelectionLocale: {
            data: {
                type: "ArtworkSelectionLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateArtworkSelectionLocale: {
            by: {
                type: "ArtworkSelectionLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ArtworkSelectionLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEventItem: {
            by: {
                type: "EventItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEventItem: {
            filter: {
                type: "EventItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEventItem: {
            filter: {
                type: "EventItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEventItem: {
            data: {
                type: "EventItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEventItem: {
            by: {
                type: "EventItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EventItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEventList: {
            by: {
                type: "EventListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEventList: {
            filter: {
                type: "EventListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEventList: {
            filter: {
                type: "EventListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EventListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEventList: {
            data: {
                type: "EventListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEventList: {
            by: {
                type: "EventListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EventListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getBoxItem: {
            by: {
                type: "BoxItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listBoxItem: {
            filter: {
                type: "BoxItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BoxItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateBoxItem: {
            filter: {
                type: "BoxItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BoxItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateBoxItem: {
            data: {
                type: "BoxItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateBoxItem: {
            by: {
                type: "BoxItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "BoxItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getBoxList: {
            by: {
                type: "BoxListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listBoxList: {
            filter: {
                type: "BoxListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BoxListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateBoxList: {
            filter: {
                type: "BoxListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "BoxListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateBoxList: {
            data: {
                type: "BoxListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateBoxList: {
            by: {
                type: "BoxListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "BoxListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getNewsletterForm: {
            by: {
                type: "NewsletterFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listNewsletterForm: {
            filter: {
                type: "NewsletterFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterFormOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateNewsletterForm: {
            filter: {
                type: "NewsletterFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterFormOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateNewsletterForm: {
            data: {
                type: "NewsletterFormCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateNewsletterForm: {
            by: {
                type: "NewsletterFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "NewsletterFormUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getNewsletterTypeItem: {
            by: {
                type: "NewsletterTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listNewsletterTypeItem: {
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterTypeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateNewsletterTypeItem: {
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterTypeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateNewsletterTypeItem: {
            data: {
                type: "NewsletterTypeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateNewsletterTypeItem: {
            by: {
                type: "NewsletterTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "NewsletterTypeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getNewsletterFormLocale: {
            by: {
                type: "NewsletterFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listNewsletterFormLocale: {
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateNewsletterFormLocale: {
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateNewsletterFormLocale: {
            data: {
                type: "NewsletterFormLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateNewsletterFormLocale: {
            by: {
                type: "NewsletterFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "NewsletterFormLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getNewsletterSubscription: {
            by: {
                type: "NewsletterSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listNewsletterSubscription: {
            filter: {
                type: "NewsletterSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterSubscriptionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateNewsletterSubscription: {
            filter: {
                type: "NewsletterSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "NewsletterSubscriptionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateNewsletterSubscription: {
            data: {
                type: "NewsletterSubscriptionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateNewsletterSubscription: {
            by: {
                type: "NewsletterSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "NewsletterSubscriptionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getChart: {
            by: {
                type: "ChartUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listChart: {
            filter: {
                type: "ChartWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ChartOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateChart: {
            filter: {
                type: "ChartWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ChartOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateChart: {
            data: {
                type: "ChartCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateChart: {
            by: {
                type: "ChartUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ChartUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getChartData: {
            by: {
                type: "ChartDataUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartDataWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listChartData: {
            filter: {
                type: "ChartDataWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ChartDataOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateChartData: {
            filter: {
                type: "ChartDataWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ChartDataOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateChartData: {
            data: {
                type: "ChartDataCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateChartData: {
            by: {
                type: "ChartDataUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ChartDataUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEmployee: {
            by: {
                type: "EmployeeUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEmployee: {
            filter: {
                type: "EmployeeWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEmployee: {
            filter: {
                type: "EmployeeWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEmployee: {
            data: {
                type: "EmployeeCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEmployee: {
            by: {
                type: "EmployeeUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EmployeeUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEmployeeItem: {
            by: {
                type: "EmployeeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEmployeeItem: {
            filter: {
                type: "EmployeeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEmployeeItem: {
            filter: {
                type: "EmployeeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEmployeeItem: {
            data: {
                type: "EmployeeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEmployeeItem: {
            by: {
                type: "EmployeeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EmployeeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEmployeeList: {
            by: {
                type: "EmployeeListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEmployeeList: {
            filter: {
                type: "EmployeeListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEmployeeList: {
            filter: {
                type: "EmployeeListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEmployeeList: {
            data: {
                type: "EmployeeListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEmployeeList: {
            by: {
                type: "EmployeeListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EmployeeListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getEmployeeLocale: {
            by: {
                type: "EmployeeLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listEmployeeLocale: {
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateEmployeeLocale: {
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "EmployeeLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateEmployeeLocale: {
            data: {
                type: "EmployeeLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateEmployeeLocale: {
            by: {
                type: "EmployeeLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "EmployeeLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getPhotographer: {
            by: {
                type: "PhotographerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PhotographerWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listPhotographer: {
            filter: {
                type: "PhotographerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PhotographerOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginatePhotographer: {
            filter: {
                type: "PhotographerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "PhotographerOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreatePhotographer: {
            data: {
                type: "PhotographerCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdatePhotographer: {
            by: {
                type: "PhotographerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "PhotographerUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getDefinitionItem: {
            by: {
                type: "DefinitionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listDefinitionItem: {
            filter: {
                type: "DefinitionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DefinitionItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateDefinitionItem: {
            filter: {
                type: "DefinitionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DefinitionItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateDefinitionItem: {
            data: {
                type: "DefinitionItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateDefinitionItem: {
            by: {
                type: "DefinitionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "DefinitionItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getDefinitionList: {
            by: {
                type: "DefinitionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listDefinitionList: {
            filter: {
                type: "DefinitionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DefinitionListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateDefinitionList: {
            filter: {
                type: "DefinitionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "DefinitionListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateDefinitionList: {
            data: {
                type: "DefinitionListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateDefinitionList: {
            by: {
                type: "DefinitionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "DefinitionListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getLogoItem: {
            by: {
                type: "LogoItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listLogoItem: {
            filter: {
                type: "LogoItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LogoItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLogoItem: {
            filter: {
                type: "LogoItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LogoItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateLogoItem: {
            data: {
                type: "LogoItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateLogoItem: {
            by: {
                type: "LogoItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "LogoItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getLogoList: {
            by: {
                type: "LogoListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listLogoList: {
            filter: {
                type: "LogoListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LogoListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateLogoList: {
            filter: {
                type: "LogoListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "LogoListOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateLogoList: {
            data: {
                type: "LogoListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateLogoList: {
            by: {
                type: "LogoListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "LogoListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getStrategySchema: {
            by: {
                type: "StrategySchemaUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listStrategySchema: {
            filter: {
                type: "StrategySchemaWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "StrategySchemaOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateStrategySchema: {
            filter: {
                type: "StrategySchemaWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "StrategySchemaOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateStrategySchema: {
            data: {
                type: "StrategySchemaCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateStrategySchema: {
            by: {
                type: "StrategySchemaUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "StrategySchemaUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getStrategySchemaGroup: {
            by: {
                type: "StrategySchemaGroupUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listStrategySchemaGroup: {
            filter: {
                type: "StrategySchemaGroupWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "StrategySchemaGroupOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateStrategySchemaGroup: {
            filter: {
                type: "StrategySchemaGroupWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "StrategySchemaGroupOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateStrategySchemaGroup: {
            data: {
                type: "StrategySchemaGroupCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateStrategySchemaGroup: {
            by: {
                type: "StrategySchemaGroupUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "StrategySchemaGroupUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getStrategySchemaGroupItem: {
            by: {
                type: "StrategySchemaGroupItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listStrategySchemaGroupItem: {
            filter: {
                type: "StrategySchemaGroupItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "StrategySchemaGroupItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateStrategySchemaGroupItem: {
            filter: {
                type: "StrategySchemaGroupItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "StrategySchemaGroupItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateStrategySchemaGroupItem: {
            data: {
                type: "StrategySchemaGroupItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateStrategySchemaGroupItem: {
            by: {
                type: "StrategySchemaGroupItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "StrategySchemaGroupItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getRedirect: {
            by: {
                type: "RedirectUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "RedirectWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listRedirect: {
            filter: {
                type: "RedirectWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "RedirectOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateRedirect: {
            filter: {
                type: "RedirectWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "RedirectOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateRedirect: {
            data: {
                type: "RedirectCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateRedirect: {
            by: {
                type: "RedirectUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "RedirectUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getGallery: {
            by: {
                type: "GalleryUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listGallery: {
            filter: {
                type: "GalleryWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GalleryOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateGallery: {
            filter: {
                type: "GalleryWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GalleryOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateGallery: {
            data: {
                type: "GalleryCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateGallery: {
            by: {
                type: "GalleryUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "GalleryUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getGalleryItem: {
            by: {
                type: "GalleryItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listGalleryItem: {
            filter: {
                type: "GalleryItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GalleryItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateGalleryItem: {
            filter: {
                type: "GalleryItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "GalleryItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateGalleryItem: {
            data: {
                type: "GalleryItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateGalleryItem: {
            by: {
                type: "GalleryItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "GalleryItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContactForm: {
            by: {
                type: "ContactFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContactForm: {
            filter: {
                type: "ContactFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactFormOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContactForm: {
            filter: {
                type: "ContactFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactFormOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContactForm: {
            data: {
                type: "ContactFormCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContactForm: {
            by: {
                type: "ContactFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContactFormUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContactFormLocale: {
            by: {
                type: "ContactFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContactFormLocale: {
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContactFormLocale: {
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactFormLocaleOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContactFormLocale: {
            data: {
                type: "ContactFormLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContactFormLocale: {
            by: {
                type: "ContactFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContactFormLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContactSubscription: {
            by: {
                type: "ContactSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContactSubscription: {
            filter: {
                type: "ContactSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactSubscriptionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContactSubscription: {
            filter: {
                type: "ContactSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactSubscriptionOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContactSubscription: {
            data: {
                type: "ContactSubscriptionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContactSubscription: {
            by: {
                type: "ContactSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContactSubscriptionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getContactTypeItem: {
            by: {
                type: "ContactTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listContactTypeItem: {
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactTypeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateContactTypeItem: {
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "ContactTypeItemOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateContactTypeItem: {
            data: {
                type: "ContactTypeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateContactTypeItem: {
            by: {
                type: "ContactTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "ContactTypeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        getFile: {
            by: {
                type: "FileUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FileWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        listFile: {
            filter: {
                type: "FileWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FileOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            offset: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            limit: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        paginateFile: {
            filter: {
                type: "FileWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            orderBy: {
                type: "FileOrderBy",
                array: true,
                arrayRequired: false,
                required: true
            },
            skip: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            first: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        validateCreateFile: {
            data: {
                type: "FileCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        validateUpdateFile: {
            by: {
                type: "FileUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            data: {
                type: "FileUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        }
    },
    Mutation: {
        createContactPage: {
            data: {
                type: "ContactPageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContactPage: {
            by: {
                type: "ContactPageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContactPage: {
            by: {
                type: "ContactPageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContactPageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContactPage: {
            by: {
                type: "ContactPageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContactPageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContactPageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContactPageLocale: {
            data: {
                type: "ContactPageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContactPageLocale: {
            by: {
                type: "ContactPageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContactPageLocale: {
            by: {
                type: "ContactPageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContactPageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContactPageLocale: {
            by: {
                type: "ContactPageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContactPageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContactPageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContent: {
            data: {
                type: "ContentCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContent: {
            by: {
                type: "ContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContent: {
            by: {
                type: "ContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContentUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContent: {
            by: {
                type: "ContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContentUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContentCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContentBlock: {
            data: {
                type: "ContentBlockCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContentBlock: {
            by: {
                type: "ContentBlockUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContentBlock: {
            by: {
                type: "ContentBlockUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContentBlockUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContentBlock: {
            by: {
                type: "ContentBlockUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContentBlockUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContentBlockCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContentReference: {
            data: {
                type: "ContentReferenceCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContentReference: {
            by: {
                type: "ContentReferenceUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContentReference: {
            by: {
                type: "ContentReferenceUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContentReferenceUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContentReference: {
            by: {
                type: "ContentReferenceUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContentReferenceUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContentReferenceCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createFooter: {
            data: {
                type: "FooterCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteFooter: {
            by: {
                type: "FooterUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateFooter: {
            by: {
                type: "FooterUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "FooterUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertFooter: {
            by: {
                type: "FooterUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "FooterUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "FooterCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createFooterLocale: {
            data: {
                type: "FooterLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteFooterLocale: {
            by: {
                type: "FooterLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateFooterLocale: {
            by: {
                type: "FooterLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "FooterLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertFooterLocale: {
            by: {
                type: "FooterLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "FooterLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "FooterLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createHeader: {
            data: {
                type: "HeaderCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteHeader: {
            by: {
                type: "HeaderUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateHeader: {
            by: {
                type: "HeaderUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "HeaderUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertHeader: {
            by: {
                type: "HeaderUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "HeaderUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "HeaderCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createHeaderLink: {
            data: {
                type: "HeaderLinkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteHeaderLink: {
            by: {
                type: "HeaderLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateHeaderLink: {
            by: {
                type: "HeaderLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "HeaderLinkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertHeaderLink: {
            by: {
                type: "HeaderLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "HeaderLinkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "HeaderLinkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createHeaderLocale: {
            data: {
                type: "HeaderLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteHeaderLocale: {
            by: {
                type: "HeaderLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateHeaderLocale: {
            by: {
                type: "HeaderLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "HeaderLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertHeaderLocale: {
            by: {
                type: "HeaderLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "HeaderLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "HeaderLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createHomePage: {
            data: {
                type: "HomePageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteHomePage: {
            by: {
                type: "HomePageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateHomePage: {
            by: {
                type: "HomePageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "HomePageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertHomePage: {
            by: {
                type: "HomePageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "HomePageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "HomePageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createHomePageLocale: {
            data: {
                type: "HomePageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteHomePageLocale: {
            by: {
                type: "HomePageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateHomePageLocale: {
            by: {
                type: "HomePageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "HomePageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertHomePageLocale: {
            by: {
                type: "HomePageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "HomePageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "HomePageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createLink: {
            data: {
                type: "LinkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteLink: {
            by: {
                type: "LinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateLink: {
            by: {
                type: "LinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "LinkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertLink: {
            by: {
                type: "LinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "LinkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "LinkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createLinkable: {
            data: {
                type: "LinkableCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteLinkable: {
            by: {
                type: "LinkableUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateLinkable: {
            by: {
                type: "LinkableUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "LinkableUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertLinkable: {
            by: {
                type: "LinkableUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "LinkableUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "LinkableCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createLocale: {
            data: {
                type: "LocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteLocale: {
            by: {
                type: "LocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateLocale: {
            by: {
                type: "LocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "LocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertLocale: {
            by: {
                type: "LocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "LocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "LocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createMedium: {
            data: {
                type: "MediumCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteMedium: {
            by: {
                type: "MediumUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateMedium: {
            by: {
                type: "MediumUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "MediumUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertMedium: {
            by: {
                type: "MediumUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "MediumUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "MediumCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createMediumItem: {
            data: {
                type: "MediumItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteMediumItem: {
            by: {
                type: "MediumItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateMediumItem: {
            by: {
                type: "MediumItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "MediumItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertMediumItem: {
            by: {
                type: "MediumItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "MediumItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "MediumItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createMediumList: {
            data: {
                type: "MediumListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteMediumList: {
            by: {
                type: "MediumListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateMediumList: {
            by: {
                type: "MediumListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "MediumListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertMediumList: {
            by: {
                type: "MediumListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "MediumListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "MediumListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createPage: {
            data: {
                type: "PageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deletePage: {
            by: {
                type: "PageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updatePage: {
            by: {
                type: "PageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "PageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertPage: {
            by: {
                type: "PageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "PageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "PageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createPageLocale: {
            data: {
                type: "PageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deletePageLocale: {
            by: {
                type: "PageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updatePageLocale: {
            by: {
                type: "PageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "PageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertPageLocale: {
            by: {
                type: "PageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "PageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "PageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createSeoDefault: {
            data: {
                type: "SeoDefaultCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteSeoDefault: {
            by: {
                type: "SeoDefaultUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateSeoDefault: {
            by: {
                type: "SeoDefaultUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "SeoDefaultUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertSeoDefault: {
            by: {
                type: "SeoDefaultUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "SeoDefaultUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "SeoDefaultCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createSeoDefaultLocale: {
            data: {
                type: "SeoDefaultLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteSeoDefaultLocale: {
            by: {
                type: "SeoDefaultLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateSeoDefaultLocale: {
            by: {
                type: "SeoDefaultLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "SeoDefaultLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertSeoDefaultLocale: {
            by: {
                type: "SeoDefaultLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "SeoDefaultLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "SeoDefaultLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createVideo: {
            data: {
                type: "VideoCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteVideo: {
            by: {
                type: "VideoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "VideoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateVideo: {
            by: {
                type: "VideoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "VideoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "VideoUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertVideo: {
            by: {
                type: "VideoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "VideoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "VideoUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "VideoCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createImage: {
            data: {
                type: "ImageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteImage: {
            by: {
                type: "ImageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateImage: {
            by: {
                type: "ImageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ImageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertImage: {
            by: {
                type: "ImageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ImageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ImageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createSeo: {
            data: {
                type: "SeoCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteSeo: {
            by: {
                type: "SeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateSeo: {
            by: {
                type: "SeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "SeoUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertSeo: {
            by: {
                type: "SeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "SeoUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "SeoCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createTranslationDomain: {
            data: {
                type: "TranslationDomainCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteTranslationDomain: {
            by: {
                type: "TranslationDomainUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationDomainWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateTranslationDomain: {
            by: {
                type: "TranslationDomainUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationDomainWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "TranslationDomainUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertTranslationDomain: {
            by: {
                type: "TranslationDomainUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationDomainWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "TranslationDomainUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "TranslationDomainCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createTranslationCatalogue: {
            data: {
                type: "TranslationCatalogueCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteTranslationCatalogue: {
            by: {
                type: "TranslationCatalogueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateTranslationCatalogue: {
            by: {
                type: "TranslationCatalogueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "TranslationCatalogueUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertTranslationCatalogue: {
            by: {
                type: "TranslationCatalogueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "TranslationCatalogueUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "TranslationCatalogueCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createTranslationCataloguesIdentifier: {
            data: {
                type: "TranslationCataloguesIdentifierCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteTranslationCataloguesIdentifier: {
            by: {
                type: "TranslationCataloguesIdentifierUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCataloguesIdentifierWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateTranslationCataloguesIdentifier: {
            by: {
                type: "TranslationCataloguesIdentifierUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCataloguesIdentifierWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "TranslationCataloguesIdentifierUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertTranslationCataloguesIdentifier: {
            by: {
                type: "TranslationCataloguesIdentifierUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCataloguesIdentifierWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "TranslationCataloguesIdentifierUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "TranslationCataloguesIdentifierCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createTranslationKey: {
            data: {
                type: "TranslationKeyCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteTranslationKey: {
            by: {
                type: "TranslationKeyUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateTranslationKey: {
            by: {
                type: "TranslationKeyUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "TranslationKeyUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertTranslationKey: {
            by: {
                type: "TranslationKeyUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "TranslationKeyUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "TranslationKeyCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createTranslationValue: {
            data: {
                type: "TranslationValueCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteTranslationValue: {
            by: {
                type: "TranslationValueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateTranslationValue: {
            by: {
                type: "TranslationValueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "TranslationValueUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertTranslationValue: {
            by: {
                type: "TranslationValueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "TranslationValueUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "TranslationValueCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createBranches: {
            data: {
                type: "BranchesCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteBranches: {
            by: {
                type: "BranchesUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BranchesWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateBranches: {
            by: {
                type: "BranchesUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BranchesWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "BranchesUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertBranches: {
            by: {
                type: "BranchesUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BranchesWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "BranchesUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "BranchesCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createGraphicDesigner: {
            data: {
                type: "GraphicDesignerCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteGraphicDesigner: {
            by: {
                type: "GraphicDesignerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GraphicDesignerWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateGraphicDesigner: {
            by: {
                type: "GraphicDesignerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GraphicDesignerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "GraphicDesignerUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertGraphicDesigner: {
            by: {
                type: "GraphicDesignerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GraphicDesignerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "GraphicDesignerUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "GraphicDesignerCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEvent: {
            data: {
                type: "EventCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEvent: {
            by: {
                type: "EventUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEvent: {
            by: {
                type: "EventUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EventUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEvent: {
            by: {
                type: "EventUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EventUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EventCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEventLocale: {
            data: {
                type: "EventLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEventLocale: {
            by: {
                type: "EventLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEventLocale: {
            by: {
                type: "EventLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EventLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEventLocale: {
            by: {
                type: "EventLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EventLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EventLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtwork: {
            data: {
                type: "ArtworkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtwork: {
            by: {
                type: "ArtworkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtwork: {
            by: {
                type: "ArtworkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtwork: {
            by: {
                type: "ArtworkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtworkLocale: {
            data: {
                type: "ArtworkLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtworkLocale: {
            by: {
                type: "ArtworkLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtworkLocale: {
            by: {
                type: "ArtworkLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtworkLocale: {
            by: {
                type: "ArtworkLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createDropDownItem: {
            data: {
                type: "DropDownItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteDropDownItem: {
            by: {
                type: "DropDownItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateDropDownItem: {
            by: {
                type: "DropDownItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "DropDownItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertDropDownItem: {
            by: {
                type: "DropDownItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "DropDownItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "DropDownItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createDropDownList: {
            data: {
                type: "DropDownListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteDropDownList: {
            by: {
                type: "DropDownListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateDropDownList: {
            by: {
                type: "DropDownListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "DropDownListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertDropDownList: {
            by: {
                type: "DropDownListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "DropDownListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "DropDownListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtworkItem: {
            data: {
                type: "ArtworkItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtworkItem: {
            by: {
                type: "ArtworkItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtworkItem: {
            by: {
                type: "ArtworkItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtworkItem: {
            by: {
                type: "ArtworkItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtworkList: {
            data: {
                type: "ArtworkListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtworkList: {
            by: {
                type: "ArtworkListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtworkList: {
            by: {
                type: "ArtworkListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtworkList: {
            by: {
                type: "ArtworkListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtworkSelection: {
            data: {
                type: "ArtworkSelectionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtworkSelection: {
            by: {
                type: "ArtworkSelectionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtworkSelection: {
            by: {
                type: "ArtworkSelectionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkSelectionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtworkSelection: {
            by: {
                type: "ArtworkSelectionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkSelectionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkSelectionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtworkSelectionItem: {
            data: {
                type: "ArtworkSelectionItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtworkSelectionItem: {
            by: {
                type: "ArtworkSelectionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtworkSelectionItem: {
            by: {
                type: "ArtworkSelectionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkSelectionItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtworkSelectionItem: {
            by: {
                type: "ArtworkSelectionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkSelectionItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkSelectionItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtworkSelectionList: {
            data: {
                type: "ArtworkSelectionListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtworkSelectionList: {
            by: {
                type: "ArtworkSelectionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtworkSelectionList: {
            by: {
                type: "ArtworkSelectionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkSelectionListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtworkSelectionList: {
            by: {
                type: "ArtworkSelectionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkSelectionListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkSelectionListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtworkSelectionLocale: {
            data: {
                type: "ArtworkSelectionLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtworkSelectionLocale: {
            by: {
                type: "ArtworkSelectionLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtworkSelectionLocale: {
            by: {
                type: "ArtworkSelectionLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkSelectionLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtworkSelectionLocale: {
            by: {
                type: "ArtworkSelectionLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkSelectionLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkSelectionLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEventItem: {
            data: {
                type: "EventItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEventItem: {
            by: {
                type: "EventItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEventItem: {
            by: {
                type: "EventItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EventItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEventItem: {
            by: {
                type: "EventItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EventItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EventItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEventList: {
            data: {
                type: "EventListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEventList: {
            by: {
                type: "EventListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEventList: {
            by: {
                type: "EventListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EventListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEventList: {
            by: {
                type: "EventListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EventListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EventListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createBoxItem: {
            data: {
                type: "BoxItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteBoxItem: {
            by: {
                type: "BoxItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateBoxItem: {
            by: {
                type: "BoxItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "BoxItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertBoxItem: {
            by: {
                type: "BoxItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "BoxItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "BoxItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createBoxList: {
            data: {
                type: "BoxListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteBoxList: {
            by: {
                type: "BoxListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateBoxList: {
            by: {
                type: "BoxListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "BoxListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertBoxList: {
            by: {
                type: "BoxListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "BoxListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "BoxListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createNewsletterForm: {
            data: {
                type: "NewsletterFormCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteNewsletterForm: {
            by: {
                type: "NewsletterFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateNewsletterForm: {
            by: {
                type: "NewsletterFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "NewsletterFormUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertNewsletterForm: {
            by: {
                type: "NewsletterFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "NewsletterFormUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "NewsletterFormCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createNewsletterTypeItem: {
            data: {
                type: "NewsletterTypeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteNewsletterTypeItem: {
            by: {
                type: "NewsletterTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateNewsletterTypeItem: {
            by: {
                type: "NewsletterTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "NewsletterTypeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertNewsletterTypeItem: {
            by: {
                type: "NewsletterTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "NewsletterTypeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "NewsletterTypeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createNewsletterFormLocale: {
            data: {
                type: "NewsletterFormLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteNewsletterFormLocale: {
            by: {
                type: "NewsletterFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateNewsletterFormLocale: {
            by: {
                type: "NewsletterFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "NewsletterFormLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertNewsletterFormLocale: {
            by: {
                type: "NewsletterFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "NewsletterFormLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "NewsletterFormLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createNewsletterSubscription: {
            data: {
                type: "NewsletterSubscriptionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteNewsletterSubscription: {
            by: {
                type: "NewsletterSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateNewsletterSubscription: {
            by: {
                type: "NewsletterSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "NewsletterSubscriptionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertNewsletterSubscription: {
            by: {
                type: "NewsletterSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "NewsletterSubscriptionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "NewsletterSubscriptionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createChart: {
            data: {
                type: "ChartCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteChart: {
            by: {
                type: "ChartUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateChart: {
            by: {
                type: "ChartUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ChartUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertChart: {
            by: {
                type: "ChartUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ChartUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ChartCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createChartData: {
            data: {
                type: "ChartDataCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteChartData: {
            by: {
                type: "ChartDataUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartDataWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateChartData: {
            by: {
                type: "ChartDataUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartDataWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ChartDataUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertChartData: {
            by: {
                type: "ChartDataUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartDataWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ChartDataUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ChartDataCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEmployee: {
            data: {
                type: "EmployeeCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEmployee: {
            by: {
                type: "EmployeeUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEmployee: {
            by: {
                type: "EmployeeUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EmployeeUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEmployee: {
            by: {
                type: "EmployeeUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EmployeeUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EmployeeCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEmployeeItem: {
            data: {
                type: "EmployeeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEmployeeItem: {
            by: {
                type: "EmployeeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEmployeeItem: {
            by: {
                type: "EmployeeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EmployeeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEmployeeItem: {
            by: {
                type: "EmployeeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EmployeeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EmployeeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEmployeeList: {
            data: {
                type: "EmployeeListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEmployeeList: {
            by: {
                type: "EmployeeListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEmployeeList: {
            by: {
                type: "EmployeeListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EmployeeListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEmployeeList: {
            by: {
                type: "EmployeeListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EmployeeListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EmployeeListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEmployeeLocale: {
            data: {
                type: "EmployeeLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEmployeeLocale: {
            by: {
                type: "EmployeeLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEmployeeLocale: {
            by: {
                type: "EmployeeLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EmployeeLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEmployeeLocale: {
            by: {
                type: "EmployeeLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EmployeeLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EmployeeLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createPhotographer: {
            data: {
                type: "PhotographerCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deletePhotographer: {
            by: {
                type: "PhotographerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PhotographerWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updatePhotographer: {
            by: {
                type: "PhotographerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PhotographerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "PhotographerUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertPhotographer: {
            by: {
                type: "PhotographerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PhotographerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "PhotographerUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "PhotographerCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createDefinitionItem: {
            data: {
                type: "DefinitionItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteDefinitionItem: {
            by: {
                type: "DefinitionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateDefinitionItem: {
            by: {
                type: "DefinitionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "DefinitionItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertDefinitionItem: {
            by: {
                type: "DefinitionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "DefinitionItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "DefinitionItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createDefinitionList: {
            data: {
                type: "DefinitionListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteDefinitionList: {
            by: {
                type: "DefinitionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateDefinitionList: {
            by: {
                type: "DefinitionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "DefinitionListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertDefinitionList: {
            by: {
                type: "DefinitionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "DefinitionListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "DefinitionListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createLogoItem: {
            data: {
                type: "LogoItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteLogoItem: {
            by: {
                type: "LogoItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateLogoItem: {
            by: {
                type: "LogoItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "LogoItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertLogoItem: {
            by: {
                type: "LogoItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "LogoItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "LogoItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createLogoList: {
            data: {
                type: "LogoListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteLogoList: {
            by: {
                type: "LogoListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateLogoList: {
            by: {
                type: "LogoListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "LogoListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertLogoList: {
            by: {
                type: "LogoListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "LogoListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "LogoListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createStrategySchema: {
            data: {
                type: "StrategySchemaCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteStrategySchema: {
            by: {
                type: "StrategySchemaUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateStrategySchema: {
            by: {
                type: "StrategySchemaUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "StrategySchemaUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertStrategySchema: {
            by: {
                type: "StrategySchemaUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "StrategySchemaUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "StrategySchemaCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createStrategySchemaGroup: {
            data: {
                type: "StrategySchemaGroupCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteStrategySchemaGroup: {
            by: {
                type: "StrategySchemaGroupUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateStrategySchemaGroup: {
            by: {
                type: "StrategySchemaGroupUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "StrategySchemaGroupUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertStrategySchemaGroup: {
            by: {
                type: "StrategySchemaGroupUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "StrategySchemaGroupUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "StrategySchemaGroupCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createStrategySchemaGroupItem: {
            data: {
                type: "StrategySchemaGroupItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteStrategySchemaGroupItem: {
            by: {
                type: "StrategySchemaGroupItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateStrategySchemaGroupItem: {
            by: {
                type: "StrategySchemaGroupItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "StrategySchemaGroupItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertStrategySchemaGroupItem: {
            by: {
                type: "StrategySchemaGroupItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "StrategySchemaGroupItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "StrategySchemaGroupItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createRedirect: {
            data: {
                type: "RedirectCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteRedirect: {
            by: {
                type: "RedirectUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "RedirectWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateRedirect: {
            by: {
                type: "RedirectUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "RedirectWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "RedirectUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertRedirect: {
            by: {
                type: "RedirectUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "RedirectWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "RedirectUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "RedirectCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createGallery: {
            data: {
                type: "GalleryCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteGallery: {
            by: {
                type: "GalleryUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateGallery: {
            by: {
                type: "GalleryUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "GalleryUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertGallery: {
            by: {
                type: "GalleryUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "GalleryUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "GalleryCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createGalleryItem: {
            data: {
                type: "GalleryItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteGalleryItem: {
            by: {
                type: "GalleryItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateGalleryItem: {
            by: {
                type: "GalleryItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "GalleryItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertGalleryItem: {
            by: {
                type: "GalleryItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "GalleryItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "GalleryItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContactForm: {
            data: {
                type: "ContactFormCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContactForm: {
            by: {
                type: "ContactFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContactForm: {
            by: {
                type: "ContactFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContactFormUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContactForm: {
            by: {
                type: "ContactFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContactFormUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContactFormCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContactFormLocale: {
            data: {
                type: "ContactFormLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContactFormLocale: {
            by: {
                type: "ContactFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContactFormLocale: {
            by: {
                type: "ContactFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContactFormLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContactFormLocale: {
            by: {
                type: "ContactFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContactFormLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContactFormLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContactSubscription: {
            data: {
                type: "ContactSubscriptionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContactSubscription: {
            by: {
                type: "ContactSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContactSubscription: {
            by: {
                type: "ContactSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContactSubscriptionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContactSubscription: {
            by: {
                type: "ContactSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContactSubscriptionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContactSubscriptionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContactTypeItem: {
            data: {
                type: "ContactTypeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContactTypeItem: {
            by: {
                type: "ContactTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContactTypeItem: {
            by: {
                type: "ContactTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContactTypeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContactTypeItem: {
            by: {
                type: "ContactTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContactTypeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContactTypeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createFile: {
            data: {
                type: "FileCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteFile: {
            by: {
                type: "FileUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FileWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateFile: {
            by: {
                type: "FileUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FileWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "FileUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertFile: {
            by: {
                type: "FileUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FileWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "FileUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "FileCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        transaction: {
            options: {
                type: "MutationTransactionOptions",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        generateUploadUrl: {
            contentType: {
                type: "String",
                array: false,
                arrayRequired: false,
                required: true
            },
            expiration: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            },
            prefix: {
                type: "String",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        generateReadUrl: {
            objectKey: {
                type: "String",
                array: false,
                arrayRequired: false,
                required: true
            },
            expiration: {
                type: "Int",
                array: false,
                arrayRequired: false,
                required: false
            }
        }
    },
    _MutationErrorType: "enum",
    MutationTransaction: {
        createContactPage: {
            data: {
                type: "ContactPageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContactPage: {
            by: {
                type: "ContactPageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContactPage: {
            by: {
                type: "ContactPageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContactPageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContactPage: {
            by: {
                type: "ContactPageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContactPageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContactPageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContactPageLocale: {
            data: {
                type: "ContactPageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContactPageLocale: {
            by: {
                type: "ContactPageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContactPageLocale: {
            by: {
                type: "ContactPageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContactPageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContactPageLocale: {
            by: {
                type: "ContactPageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactPageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContactPageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContactPageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContent: {
            data: {
                type: "ContentCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContent: {
            by: {
                type: "ContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContent: {
            by: {
                type: "ContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContentUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContent: {
            by: {
                type: "ContentUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContentUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContentCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContentBlock: {
            data: {
                type: "ContentBlockCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContentBlock: {
            by: {
                type: "ContentBlockUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContentBlock: {
            by: {
                type: "ContentBlockUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContentBlockUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContentBlock: {
            by: {
                type: "ContentBlockUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentBlockWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContentBlockUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContentBlockCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContentReference: {
            data: {
                type: "ContentReferenceCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContentReference: {
            by: {
                type: "ContentReferenceUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContentReference: {
            by: {
                type: "ContentReferenceUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContentReferenceUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContentReference: {
            by: {
                type: "ContentReferenceUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContentReferenceWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContentReferenceUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContentReferenceCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createFooter: {
            data: {
                type: "FooterCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteFooter: {
            by: {
                type: "FooterUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateFooter: {
            by: {
                type: "FooterUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "FooterUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertFooter: {
            by: {
                type: "FooterUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "FooterUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "FooterCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createFooterLocale: {
            data: {
                type: "FooterLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteFooterLocale: {
            by: {
                type: "FooterLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateFooterLocale: {
            by: {
                type: "FooterLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "FooterLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertFooterLocale: {
            by: {
                type: "FooterLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FooterLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "FooterLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "FooterLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createHeader: {
            data: {
                type: "HeaderCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteHeader: {
            by: {
                type: "HeaderUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateHeader: {
            by: {
                type: "HeaderUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "HeaderUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertHeader: {
            by: {
                type: "HeaderUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "HeaderUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "HeaderCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createHeaderLink: {
            data: {
                type: "HeaderLinkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteHeaderLink: {
            by: {
                type: "HeaderLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateHeaderLink: {
            by: {
                type: "HeaderLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "HeaderLinkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertHeaderLink: {
            by: {
                type: "HeaderLinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "HeaderLinkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "HeaderLinkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createHeaderLocale: {
            data: {
                type: "HeaderLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteHeaderLocale: {
            by: {
                type: "HeaderLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateHeaderLocale: {
            by: {
                type: "HeaderLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "HeaderLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertHeaderLocale: {
            by: {
                type: "HeaderLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HeaderLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "HeaderLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "HeaderLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createHomePage: {
            data: {
                type: "HomePageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteHomePage: {
            by: {
                type: "HomePageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateHomePage: {
            by: {
                type: "HomePageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "HomePageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertHomePage: {
            by: {
                type: "HomePageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "HomePageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "HomePageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createHomePageLocale: {
            data: {
                type: "HomePageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteHomePageLocale: {
            by: {
                type: "HomePageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateHomePageLocale: {
            by: {
                type: "HomePageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "HomePageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertHomePageLocale: {
            by: {
                type: "HomePageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "HomePageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "HomePageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "HomePageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createLink: {
            data: {
                type: "LinkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteLink: {
            by: {
                type: "LinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateLink: {
            by: {
                type: "LinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "LinkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertLink: {
            by: {
                type: "LinkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "LinkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "LinkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createLinkable: {
            data: {
                type: "LinkableCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteLinkable: {
            by: {
                type: "LinkableUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateLinkable: {
            by: {
                type: "LinkableUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "LinkableUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertLinkable: {
            by: {
                type: "LinkableUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LinkableWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "LinkableUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "LinkableCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createLocale: {
            data: {
                type: "LocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteLocale: {
            by: {
                type: "LocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateLocale: {
            by: {
                type: "LocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "LocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertLocale: {
            by: {
                type: "LocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "LocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "LocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createMedium: {
            data: {
                type: "MediumCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteMedium: {
            by: {
                type: "MediumUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateMedium: {
            by: {
                type: "MediumUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "MediumUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertMedium: {
            by: {
                type: "MediumUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "MediumUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "MediumCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createMediumItem: {
            data: {
                type: "MediumItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteMediumItem: {
            by: {
                type: "MediumItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateMediumItem: {
            by: {
                type: "MediumItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "MediumItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertMediumItem: {
            by: {
                type: "MediumItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "MediumItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "MediumItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createMediumList: {
            data: {
                type: "MediumListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteMediumList: {
            by: {
                type: "MediumListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateMediumList: {
            by: {
                type: "MediumListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "MediumListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertMediumList: {
            by: {
                type: "MediumListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "MediumListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "MediumListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "MediumListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createPage: {
            data: {
                type: "PageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deletePage: {
            by: {
                type: "PageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updatePage: {
            by: {
                type: "PageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "PageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertPage: {
            by: {
                type: "PageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "PageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "PageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createPageLocale: {
            data: {
                type: "PageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deletePageLocale: {
            by: {
                type: "PageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updatePageLocale: {
            by: {
                type: "PageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "PageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertPageLocale: {
            by: {
                type: "PageLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PageLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "PageLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "PageLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createSeoDefault: {
            data: {
                type: "SeoDefaultCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteSeoDefault: {
            by: {
                type: "SeoDefaultUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateSeoDefault: {
            by: {
                type: "SeoDefaultUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "SeoDefaultUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertSeoDefault: {
            by: {
                type: "SeoDefaultUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "SeoDefaultUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "SeoDefaultCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createSeoDefaultLocale: {
            data: {
                type: "SeoDefaultLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteSeoDefaultLocale: {
            by: {
                type: "SeoDefaultLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateSeoDefaultLocale: {
            by: {
                type: "SeoDefaultLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "SeoDefaultLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertSeoDefaultLocale: {
            by: {
                type: "SeoDefaultLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoDefaultLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "SeoDefaultLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "SeoDefaultLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createVideo: {
            data: {
                type: "VideoCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteVideo: {
            by: {
                type: "VideoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "VideoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateVideo: {
            by: {
                type: "VideoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "VideoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "VideoUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertVideo: {
            by: {
                type: "VideoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "VideoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "VideoUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "VideoCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createImage: {
            data: {
                type: "ImageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteImage: {
            by: {
                type: "ImageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateImage: {
            by: {
                type: "ImageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ImageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertImage: {
            by: {
                type: "ImageUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ImageWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ImageUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ImageCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createSeo: {
            data: {
                type: "SeoCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteSeo: {
            by: {
                type: "SeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateSeo: {
            by: {
                type: "SeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "SeoUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertSeo: {
            by: {
                type: "SeoUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "SeoWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "SeoUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "SeoCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createTranslationDomain: {
            data: {
                type: "TranslationDomainCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteTranslationDomain: {
            by: {
                type: "TranslationDomainUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationDomainWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateTranslationDomain: {
            by: {
                type: "TranslationDomainUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationDomainWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "TranslationDomainUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertTranslationDomain: {
            by: {
                type: "TranslationDomainUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationDomainWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "TranslationDomainUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "TranslationDomainCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createTranslationCatalogue: {
            data: {
                type: "TranslationCatalogueCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteTranslationCatalogue: {
            by: {
                type: "TranslationCatalogueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateTranslationCatalogue: {
            by: {
                type: "TranslationCatalogueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "TranslationCatalogueUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertTranslationCatalogue: {
            by: {
                type: "TranslationCatalogueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCatalogueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "TranslationCatalogueUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "TranslationCatalogueCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createTranslationCataloguesIdentifier: {
            data: {
                type: "TranslationCataloguesIdentifierCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteTranslationCataloguesIdentifier: {
            by: {
                type: "TranslationCataloguesIdentifierUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCataloguesIdentifierWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateTranslationCataloguesIdentifier: {
            by: {
                type: "TranslationCataloguesIdentifierUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCataloguesIdentifierWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "TranslationCataloguesIdentifierUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertTranslationCataloguesIdentifier: {
            by: {
                type: "TranslationCataloguesIdentifierUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationCataloguesIdentifierWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "TranslationCataloguesIdentifierUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "TranslationCataloguesIdentifierCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createTranslationKey: {
            data: {
                type: "TranslationKeyCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteTranslationKey: {
            by: {
                type: "TranslationKeyUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateTranslationKey: {
            by: {
                type: "TranslationKeyUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "TranslationKeyUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertTranslationKey: {
            by: {
                type: "TranslationKeyUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationKeyWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "TranslationKeyUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "TranslationKeyCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createTranslationValue: {
            data: {
                type: "TranslationValueCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteTranslationValue: {
            by: {
                type: "TranslationValueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateTranslationValue: {
            by: {
                type: "TranslationValueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "TranslationValueUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertTranslationValue: {
            by: {
                type: "TranslationValueUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "TranslationValueWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "TranslationValueUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "TranslationValueCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createBranches: {
            data: {
                type: "BranchesCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteBranches: {
            by: {
                type: "BranchesUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BranchesWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateBranches: {
            by: {
                type: "BranchesUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BranchesWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "BranchesUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertBranches: {
            by: {
                type: "BranchesUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BranchesWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "BranchesUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "BranchesCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createGraphicDesigner: {
            data: {
                type: "GraphicDesignerCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteGraphicDesigner: {
            by: {
                type: "GraphicDesignerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GraphicDesignerWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateGraphicDesigner: {
            by: {
                type: "GraphicDesignerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GraphicDesignerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "GraphicDesignerUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertGraphicDesigner: {
            by: {
                type: "GraphicDesignerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GraphicDesignerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "GraphicDesignerUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "GraphicDesignerCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEvent: {
            data: {
                type: "EventCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEvent: {
            by: {
                type: "EventUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEvent: {
            by: {
                type: "EventUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EventUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEvent: {
            by: {
                type: "EventUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EventUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EventCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEventLocale: {
            data: {
                type: "EventLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEventLocale: {
            by: {
                type: "EventLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEventLocale: {
            by: {
                type: "EventLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EventLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEventLocale: {
            by: {
                type: "EventLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EventLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EventLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtwork: {
            data: {
                type: "ArtworkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtwork: {
            by: {
                type: "ArtworkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtwork: {
            by: {
                type: "ArtworkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtwork: {
            by: {
                type: "ArtworkUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtworkLocale: {
            data: {
                type: "ArtworkLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtworkLocale: {
            by: {
                type: "ArtworkLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtworkLocale: {
            by: {
                type: "ArtworkLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtworkLocale: {
            by: {
                type: "ArtworkLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createDropDownItem: {
            data: {
                type: "DropDownItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteDropDownItem: {
            by: {
                type: "DropDownItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateDropDownItem: {
            by: {
                type: "DropDownItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "DropDownItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertDropDownItem: {
            by: {
                type: "DropDownItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "DropDownItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "DropDownItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createDropDownList: {
            data: {
                type: "DropDownListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteDropDownList: {
            by: {
                type: "DropDownListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateDropDownList: {
            by: {
                type: "DropDownListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "DropDownListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertDropDownList: {
            by: {
                type: "DropDownListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DropDownListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "DropDownListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "DropDownListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtworkItem: {
            data: {
                type: "ArtworkItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtworkItem: {
            by: {
                type: "ArtworkItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtworkItem: {
            by: {
                type: "ArtworkItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtworkItem: {
            by: {
                type: "ArtworkItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtworkList: {
            data: {
                type: "ArtworkListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtworkList: {
            by: {
                type: "ArtworkListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtworkList: {
            by: {
                type: "ArtworkListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtworkList: {
            by: {
                type: "ArtworkListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtworkSelection: {
            data: {
                type: "ArtworkSelectionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtworkSelection: {
            by: {
                type: "ArtworkSelectionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtworkSelection: {
            by: {
                type: "ArtworkSelectionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkSelectionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtworkSelection: {
            by: {
                type: "ArtworkSelectionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkSelectionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkSelectionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtworkSelectionItem: {
            data: {
                type: "ArtworkSelectionItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtworkSelectionItem: {
            by: {
                type: "ArtworkSelectionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtworkSelectionItem: {
            by: {
                type: "ArtworkSelectionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkSelectionItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtworkSelectionItem: {
            by: {
                type: "ArtworkSelectionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkSelectionItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkSelectionItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtworkSelectionList: {
            data: {
                type: "ArtworkSelectionListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtworkSelectionList: {
            by: {
                type: "ArtworkSelectionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtworkSelectionList: {
            by: {
                type: "ArtworkSelectionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkSelectionListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtworkSelectionList: {
            by: {
                type: "ArtworkSelectionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkSelectionListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkSelectionListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createArtworkSelectionLocale: {
            data: {
                type: "ArtworkSelectionLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteArtworkSelectionLocale: {
            by: {
                type: "ArtworkSelectionLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateArtworkSelectionLocale: {
            by: {
                type: "ArtworkSelectionLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ArtworkSelectionLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertArtworkSelectionLocale: {
            by: {
                type: "ArtworkSelectionLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ArtworkSelectionLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ArtworkSelectionLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ArtworkSelectionLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEventItem: {
            data: {
                type: "EventItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEventItem: {
            by: {
                type: "EventItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEventItem: {
            by: {
                type: "EventItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EventItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEventItem: {
            by: {
                type: "EventItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EventItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EventItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEventList: {
            data: {
                type: "EventListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEventList: {
            by: {
                type: "EventListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEventList: {
            by: {
                type: "EventListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EventListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEventList: {
            by: {
                type: "EventListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EventListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EventListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EventListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createBoxItem: {
            data: {
                type: "BoxItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteBoxItem: {
            by: {
                type: "BoxItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateBoxItem: {
            by: {
                type: "BoxItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "BoxItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertBoxItem: {
            by: {
                type: "BoxItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "BoxItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "BoxItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createBoxList: {
            data: {
                type: "BoxListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteBoxList: {
            by: {
                type: "BoxListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateBoxList: {
            by: {
                type: "BoxListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "BoxListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertBoxList: {
            by: {
                type: "BoxListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "BoxListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "BoxListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "BoxListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createNewsletterForm: {
            data: {
                type: "NewsletterFormCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteNewsletterForm: {
            by: {
                type: "NewsletterFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateNewsletterForm: {
            by: {
                type: "NewsletterFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "NewsletterFormUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertNewsletterForm: {
            by: {
                type: "NewsletterFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "NewsletterFormUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "NewsletterFormCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createNewsletterTypeItem: {
            data: {
                type: "NewsletterTypeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteNewsletterTypeItem: {
            by: {
                type: "NewsletterTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateNewsletterTypeItem: {
            by: {
                type: "NewsletterTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "NewsletterTypeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertNewsletterTypeItem: {
            by: {
                type: "NewsletterTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "NewsletterTypeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "NewsletterTypeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createNewsletterFormLocale: {
            data: {
                type: "NewsletterFormLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteNewsletterFormLocale: {
            by: {
                type: "NewsletterFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateNewsletterFormLocale: {
            by: {
                type: "NewsletterFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "NewsletterFormLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertNewsletterFormLocale: {
            by: {
                type: "NewsletterFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "NewsletterFormLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "NewsletterFormLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createNewsletterSubscription: {
            data: {
                type: "NewsletterSubscriptionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteNewsletterSubscription: {
            by: {
                type: "NewsletterSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateNewsletterSubscription: {
            by: {
                type: "NewsletterSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "NewsletterSubscriptionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertNewsletterSubscription: {
            by: {
                type: "NewsletterSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "NewsletterSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "NewsletterSubscriptionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "NewsletterSubscriptionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createChart: {
            data: {
                type: "ChartCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteChart: {
            by: {
                type: "ChartUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateChart: {
            by: {
                type: "ChartUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ChartUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertChart: {
            by: {
                type: "ChartUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ChartUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ChartCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createChartData: {
            data: {
                type: "ChartDataCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteChartData: {
            by: {
                type: "ChartDataUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartDataWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateChartData: {
            by: {
                type: "ChartDataUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartDataWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ChartDataUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertChartData: {
            by: {
                type: "ChartDataUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ChartDataWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ChartDataUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ChartDataCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEmployee: {
            data: {
                type: "EmployeeCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEmployee: {
            by: {
                type: "EmployeeUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEmployee: {
            by: {
                type: "EmployeeUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EmployeeUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEmployee: {
            by: {
                type: "EmployeeUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EmployeeUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EmployeeCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEmployeeItem: {
            data: {
                type: "EmployeeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEmployeeItem: {
            by: {
                type: "EmployeeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEmployeeItem: {
            by: {
                type: "EmployeeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EmployeeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEmployeeItem: {
            by: {
                type: "EmployeeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EmployeeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EmployeeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEmployeeList: {
            data: {
                type: "EmployeeListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEmployeeList: {
            by: {
                type: "EmployeeListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEmployeeList: {
            by: {
                type: "EmployeeListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EmployeeListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEmployeeList: {
            by: {
                type: "EmployeeListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EmployeeListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EmployeeListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createEmployeeLocale: {
            data: {
                type: "EmployeeLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteEmployeeLocale: {
            by: {
                type: "EmployeeLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateEmployeeLocale: {
            by: {
                type: "EmployeeLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "EmployeeLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertEmployeeLocale: {
            by: {
                type: "EmployeeLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "EmployeeLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "EmployeeLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "EmployeeLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createPhotographer: {
            data: {
                type: "PhotographerCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deletePhotographer: {
            by: {
                type: "PhotographerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PhotographerWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updatePhotographer: {
            by: {
                type: "PhotographerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PhotographerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "PhotographerUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertPhotographer: {
            by: {
                type: "PhotographerUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "PhotographerWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "PhotographerUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "PhotographerCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createDefinitionItem: {
            data: {
                type: "DefinitionItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteDefinitionItem: {
            by: {
                type: "DefinitionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateDefinitionItem: {
            by: {
                type: "DefinitionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "DefinitionItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertDefinitionItem: {
            by: {
                type: "DefinitionItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "DefinitionItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "DefinitionItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createDefinitionList: {
            data: {
                type: "DefinitionListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteDefinitionList: {
            by: {
                type: "DefinitionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateDefinitionList: {
            by: {
                type: "DefinitionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "DefinitionListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertDefinitionList: {
            by: {
                type: "DefinitionListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "DefinitionListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "DefinitionListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "DefinitionListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createLogoItem: {
            data: {
                type: "LogoItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteLogoItem: {
            by: {
                type: "LogoItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateLogoItem: {
            by: {
                type: "LogoItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "LogoItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertLogoItem: {
            by: {
                type: "LogoItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "LogoItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "LogoItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createLogoList: {
            data: {
                type: "LogoListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteLogoList: {
            by: {
                type: "LogoListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoListWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateLogoList: {
            by: {
                type: "LogoListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "LogoListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertLogoList: {
            by: {
                type: "LogoListUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "LogoListWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "LogoListUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "LogoListCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createStrategySchema: {
            data: {
                type: "StrategySchemaCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteStrategySchema: {
            by: {
                type: "StrategySchemaUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateStrategySchema: {
            by: {
                type: "StrategySchemaUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "StrategySchemaUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertStrategySchema: {
            by: {
                type: "StrategySchemaUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "StrategySchemaUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "StrategySchemaCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createStrategySchemaGroup: {
            data: {
                type: "StrategySchemaGroupCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteStrategySchemaGroup: {
            by: {
                type: "StrategySchemaGroupUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateStrategySchemaGroup: {
            by: {
                type: "StrategySchemaGroupUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "StrategySchemaGroupUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertStrategySchemaGroup: {
            by: {
                type: "StrategySchemaGroupUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "StrategySchemaGroupUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "StrategySchemaGroupCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createStrategySchemaGroupItem: {
            data: {
                type: "StrategySchemaGroupItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteStrategySchemaGroupItem: {
            by: {
                type: "StrategySchemaGroupItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateStrategySchemaGroupItem: {
            by: {
                type: "StrategySchemaGroupItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "StrategySchemaGroupItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertStrategySchemaGroupItem: {
            by: {
                type: "StrategySchemaGroupItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "StrategySchemaGroupItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "StrategySchemaGroupItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "StrategySchemaGroupItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createRedirect: {
            data: {
                type: "RedirectCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteRedirect: {
            by: {
                type: "RedirectUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "RedirectWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateRedirect: {
            by: {
                type: "RedirectUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "RedirectWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "RedirectUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertRedirect: {
            by: {
                type: "RedirectUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "RedirectWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "RedirectUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "RedirectCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createGallery: {
            data: {
                type: "GalleryCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteGallery: {
            by: {
                type: "GalleryUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateGallery: {
            by: {
                type: "GalleryUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "GalleryUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertGallery: {
            by: {
                type: "GalleryUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "GalleryUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "GalleryCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createGalleryItem: {
            data: {
                type: "GalleryItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteGalleryItem: {
            by: {
                type: "GalleryItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateGalleryItem: {
            by: {
                type: "GalleryItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "GalleryItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertGalleryItem: {
            by: {
                type: "GalleryItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "GalleryItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "GalleryItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "GalleryItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContactForm: {
            data: {
                type: "ContactFormCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContactForm: {
            by: {
                type: "ContactFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContactForm: {
            by: {
                type: "ContactFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContactFormUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContactForm: {
            by: {
                type: "ContactFormUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContactFormUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContactFormCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContactFormLocale: {
            data: {
                type: "ContactFormLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContactFormLocale: {
            by: {
                type: "ContactFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContactFormLocale: {
            by: {
                type: "ContactFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContactFormLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContactFormLocale: {
            by: {
                type: "ContactFormLocaleUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactFormLocaleWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContactFormLocaleUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContactFormLocaleCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContactSubscription: {
            data: {
                type: "ContactSubscriptionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContactSubscription: {
            by: {
                type: "ContactSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContactSubscription: {
            by: {
                type: "ContactSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContactSubscriptionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContactSubscription: {
            by: {
                type: "ContactSubscriptionUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactSubscriptionWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContactSubscriptionUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContactSubscriptionCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createContactTypeItem: {
            data: {
                type: "ContactTypeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteContactTypeItem: {
            by: {
                type: "ContactTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateContactTypeItem: {
            by: {
                type: "ContactTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "ContactTypeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertContactTypeItem: {
            by: {
                type: "ContactTypeItemUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "ContactTypeItemWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "ContactTypeItemUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "ContactTypeItemCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        createFile: {
            data: {
                type: "FileCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        deleteFile: {
            by: {
                type: "FileUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FileWhere",
                array: false,
                arrayRequired: false,
                required: false
            }
        },
        updateFile: {
            by: {
                type: "FileUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FileWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            data: {
                type: "FileUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        },
        upsertFile: {
            by: {
                type: "FileUniqueWhere",
                array: false,
                arrayRequired: false,
                required: true
            },
            filter: {
                type: "FileWhere",
                array: false,
                arrayRequired: false,
                required: false
            },
            update: {
                type: "FileUpdateInput",
                array: false,
                arrayRequired: false,
                required: true
            },
            create: {
                type: "FileCreateInput",
                array: false,
                arrayRequired: false,
                required: true
            }
        }
    },
    MutationTransactionOptions: {
        deferForeignKeyConstraints: {
            type: "Boolean",
            array: false,
            arrayRequired: false,
            required: false
        }
    },
    Json: "String",
    _OnDeleteBehaviour: "enum",
    _RelationSide: "enum",
    _OrderByDirection: "enum"
};
const ReturnTypes = {
    Query: {
        getContactPage: "ContactPage",
        listContactPage: "ContactPage",
        paginateContactPage: "ContactPageConnection",
        validateCreateContactPage: "_ValidationResult",
        validateUpdateContactPage: "_ValidationResult",
        getContactPageLocale: "ContactPageLocale",
        listContactPageLocale: "ContactPageLocale",
        paginateContactPageLocale: "ContactPageLocaleConnection",
        validateCreateContactPageLocale: "_ValidationResult",
        validateUpdateContactPageLocale: "_ValidationResult",
        getContent: "Content",
        listContent: "Content",
        paginateContent: "ContentConnection",
        validateCreateContent: "_ValidationResult",
        validateUpdateContent: "_ValidationResult",
        getContentBlock: "ContentBlock",
        listContentBlock: "ContentBlock",
        paginateContentBlock: "ContentBlockConnection",
        validateCreateContentBlock: "_ValidationResult",
        validateUpdateContentBlock: "_ValidationResult",
        getContentReference: "ContentReference",
        listContentReference: "ContentReference",
        paginateContentReference: "ContentReferenceConnection",
        validateCreateContentReference: "_ValidationResult",
        validateUpdateContentReference: "_ValidationResult",
        getFooter: "Footer",
        listFooter: "Footer",
        paginateFooter: "FooterConnection",
        validateCreateFooter: "_ValidationResult",
        validateUpdateFooter: "_ValidationResult",
        getFooterLocale: "FooterLocale",
        listFooterLocale: "FooterLocale",
        paginateFooterLocale: "FooterLocaleConnection",
        validateCreateFooterLocale: "_ValidationResult",
        validateUpdateFooterLocale: "_ValidationResult",
        getHeader: "Header",
        listHeader: "Header",
        paginateHeader: "HeaderConnection",
        validateCreateHeader: "_ValidationResult",
        validateUpdateHeader: "_ValidationResult",
        getHeaderLink: "HeaderLink",
        listHeaderLink: "HeaderLink",
        paginateHeaderLink: "HeaderLinkConnection",
        validateCreateHeaderLink: "_ValidationResult",
        validateUpdateHeaderLink: "_ValidationResult",
        getHeaderLocale: "HeaderLocale",
        listHeaderLocale: "HeaderLocale",
        paginateHeaderLocale: "HeaderLocaleConnection",
        validateCreateHeaderLocale: "_ValidationResult",
        validateUpdateHeaderLocale: "_ValidationResult",
        getHomePage: "HomePage",
        listHomePage: "HomePage",
        paginateHomePage: "HomePageConnection",
        validateCreateHomePage: "_ValidationResult",
        validateUpdateHomePage: "_ValidationResult",
        getHomePageLocale: "HomePageLocale",
        listHomePageLocale: "HomePageLocale",
        paginateHomePageLocale: "HomePageLocaleConnection",
        validateCreateHomePageLocale: "_ValidationResult",
        validateUpdateHomePageLocale: "_ValidationResult",
        getLink: "Link",
        listLink: "Link",
        paginateLink: "LinkConnection",
        validateCreateLink: "_ValidationResult",
        validateUpdateLink: "_ValidationResult",
        getLinkable: "Linkable",
        listLinkable: "Linkable",
        paginateLinkable: "LinkableConnection",
        validateCreateLinkable: "_ValidationResult",
        validateUpdateLinkable: "_ValidationResult",
        getLocale: "Locale",
        listLocale: "Locale",
        paginateLocale: "LocaleConnection",
        validateCreateLocale: "_ValidationResult",
        validateUpdateLocale: "_ValidationResult",
        getMedium: "Medium",
        listMedium: "Medium",
        paginateMedium: "MediumConnection",
        validateCreateMedium: "_ValidationResult",
        validateUpdateMedium: "_ValidationResult",
        getMediumItem: "MediumItem",
        listMediumItem: "MediumItem",
        paginateMediumItem: "MediumItemConnection",
        validateCreateMediumItem: "_ValidationResult",
        validateUpdateMediumItem: "_ValidationResult",
        getMediumList: "MediumList",
        listMediumList: "MediumList",
        paginateMediumList: "MediumListConnection",
        validateCreateMediumList: "_ValidationResult",
        validateUpdateMediumList: "_ValidationResult",
        getPage: "Page",
        listPage: "Page",
        paginatePage: "PageConnection",
        validateCreatePage: "_ValidationResult",
        validateUpdatePage: "_ValidationResult",
        getPageLocale: "PageLocale",
        listPageLocale: "PageLocale",
        paginatePageLocale: "PageLocaleConnection",
        validateCreatePageLocale: "_ValidationResult",
        validateUpdatePageLocale: "_ValidationResult",
        getSeoDefault: "SeoDefault",
        listSeoDefault: "SeoDefault",
        paginateSeoDefault: "SeoDefaultConnection",
        validateCreateSeoDefault: "_ValidationResult",
        validateUpdateSeoDefault: "_ValidationResult",
        getSeoDefaultLocale: "SeoDefaultLocale",
        listSeoDefaultLocale: "SeoDefaultLocale",
        paginateSeoDefaultLocale: "SeoDefaultLocaleConnection",
        validateCreateSeoDefaultLocale: "_ValidationResult",
        validateUpdateSeoDefaultLocale: "_ValidationResult",
        getVideo: "Video",
        listVideo: "Video",
        paginateVideo: "VideoConnection",
        validateCreateVideo: "_ValidationResult",
        validateUpdateVideo: "_ValidationResult",
        getImage: "Image",
        listImage: "Image",
        paginateImage: "ImageConnection",
        validateCreateImage: "_ValidationResult",
        validateUpdateImage: "_ValidationResult",
        getSeo: "Seo",
        listSeo: "Seo",
        paginateSeo: "SeoConnection",
        validateCreateSeo: "_ValidationResult",
        validateUpdateSeo: "_ValidationResult",
        getTranslationDomain: "TranslationDomain",
        listTranslationDomain: "TranslationDomain",
        paginateTranslationDomain: "TranslationDomainConnection",
        validateCreateTranslationDomain: "_ValidationResult",
        validateUpdateTranslationDomain: "_ValidationResult",
        getTranslationCatalogue: "TranslationCatalogue",
        listTranslationCatalogue: "TranslationCatalogue",
        paginateTranslationCatalogue: "TranslationCatalogueConnection",
        validateCreateTranslationCatalogue: "_ValidationResult",
        validateUpdateTranslationCatalogue: "_ValidationResult",
        getTranslationCataloguesIdentifier: "TranslationCataloguesIdentifier",
        listTranslationCataloguesIdentifier: "TranslationCataloguesIdentifier",
        paginateTranslationCataloguesIdentifier: "TranslationCataloguesIdentifierConnection",
        validateCreateTranslationCataloguesIdentifier: "_ValidationResult",
        validateUpdateTranslationCataloguesIdentifier: "_ValidationResult",
        getTranslationKey: "TranslationKey",
        listTranslationKey: "TranslationKey",
        paginateTranslationKey: "TranslationKeyConnection",
        validateCreateTranslationKey: "_ValidationResult",
        validateUpdateTranslationKey: "_ValidationResult",
        getTranslationValue: "TranslationValue",
        listTranslationValue: "TranslationValue",
        paginateTranslationValue: "TranslationValueConnection",
        validateCreateTranslationValue: "_ValidationResult",
        validateUpdateTranslationValue: "_ValidationResult",
        getBranches: "Branches",
        listBranches: "Branches",
        paginateBranches: "BranchesConnection",
        validateCreateBranches: "_ValidationResult",
        validateUpdateBranches: "_ValidationResult",
        getGraphicDesigner: "GraphicDesigner",
        listGraphicDesigner: "GraphicDesigner",
        paginateGraphicDesigner: "GraphicDesignerConnection",
        validateCreateGraphicDesigner: "_ValidationResult",
        validateUpdateGraphicDesigner: "_ValidationResult",
        getEvent: "Event",
        listEvent: "Event",
        paginateEvent: "EventConnection",
        validateCreateEvent: "_ValidationResult",
        validateUpdateEvent: "_ValidationResult",
        getEventLocale: "EventLocale",
        listEventLocale: "EventLocale",
        paginateEventLocale: "EventLocaleConnection",
        validateCreateEventLocale: "_ValidationResult",
        validateUpdateEventLocale: "_ValidationResult",
        getArtwork: "Artwork",
        listArtwork: "Artwork",
        paginateArtwork: "ArtworkConnection",
        validateCreateArtwork: "_ValidationResult",
        validateUpdateArtwork: "_ValidationResult",
        getArtworkLocale: "ArtworkLocale",
        listArtworkLocale: "ArtworkLocale",
        paginateArtworkLocale: "ArtworkLocaleConnection",
        validateCreateArtworkLocale: "_ValidationResult",
        validateUpdateArtworkLocale: "_ValidationResult",
        getDropDownItem: "DropDownItem",
        listDropDownItem: "DropDownItem",
        paginateDropDownItem: "DropDownItemConnection",
        validateCreateDropDownItem: "_ValidationResult",
        validateUpdateDropDownItem: "_ValidationResult",
        getDropDownList: "DropDownList",
        listDropDownList: "DropDownList",
        paginateDropDownList: "DropDownListConnection",
        validateCreateDropDownList: "_ValidationResult",
        validateUpdateDropDownList: "_ValidationResult",
        getArtworkItem: "ArtworkItem",
        listArtworkItem: "ArtworkItem",
        paginateArtworkItem: "ArtworkItemConnection",
        validateCreateArtworkItem: "_ValidationResult",
        validateUpdateArtworkItem: "_ValidationResult",
        getArtworkList: "ArtworkList",
        listArtworkList: "ArtworkList",
        paginateArtworkList: "ArtworkListConnection",
        validateCreateArtworkList: "_ValidationResult",
        validateUpdateArtworkList: "_ValidationResult",
        getArtworkSelection: "ArtworkSelection",
        listArtworkSelection: "ArtworkSelection",
        paginateArtworkSelection: "ArtworkSelectionConnection",
        validateCreateArtworkSelection: "_ValidationResult",
        validateUpdateArtworkSelection: "_ValidationResult",
        getArtworkSelectionItem: "ArtworkSelectionItem",
        listArtworkSelectionItem: "ArtworkSelectionItem",
        paginateArtworkSelectionItem: "ArtworkSelectionItemConnection",
        validateCreateArtworkSelectionItem: "_ValidationResult",
        validateUpdateArtworkSelectionItem: "_ValidationResult",
        getArtworkSelectionList: "ArtworkSelectionList",
        listArtworkSelectionList: "ArtworkSelectionList",
        paginateArtworkSelectionList: "ArtworkSelectionListConnection",
        validateCreateArtworkSelectionList: "_ValidationResult",
        validateUpdateArtworkSelectionList: "_ValidationResult",
        getArtworkSelectionLocale: "ArtworkSelectionLocale",
        listArtworkSelectionLocale: "ArtworkSelectionLocale",
        paginateArtworkSelectionLocale: "ArtworkSelectionLocaleConnection",
        validateCreateArtworkSelectionLocale: "_ValidationResult",
        validateUpdateArtworkSelectionLocale: "_ValidationResult",
        getEventItem: "EventItem",
        listEventItem: "EventItem",
        paginateEventItem: "EventItemConnection",
        validateCreateEventItem: "_ValidationResult",
        validateUpdateEventItem: "_ValidationResult",
        getEventList: "EventList",
        listEventList: "EventList",
        paginateEventList: "EventListConnection",
        validateCreateEventList: "_ValidationResult",
        validateUpdateEventList: "_ValidationResult",
        getBoxItem: "BoxItem",
        listBoxItem: "BoxItem",
        paginateBoxItem: "BoxItemConnection",
        validateCreateBoxItem: "_ValidationResult",
        validateUpdateBoxItem: "_ValidationResult",
        getBoxList: "BoxList",
        listBoxList: "BoxList",
        paginateBoxList: "BoxListConnection",
        validateCreateBoxList: "_ValidationResult",
        validateUpdateBoxList: "_ValidationResult",
        getNewsletterForm: "NewsletterForm",
        listNewsletterForm: "NewsletterForm",
        paginateNewsletterForm: "NewsletterFormConnection",
        validateCreateNewsletterForm: "_ValidationResult",
        validateUpdateNewsletterForm: "_ValidationResult",
        getNewsletterTypeItem: "NewsletterTypeItem",
        listNewsletterTypeItem: "NewsletterTypeItem",
        paginateNewsletterTypeItem: "NewsletterTypeItemConnection",
        validateCreateNewsletterTypeItem: "_ValidationResult",
        validateUpdateNewsletterTypeItem: "_ValidationResult",
        getNewsletterFormLocale: "NewsletterFormLocale",
        listNewsletterFormLocale: "NewsletterFormLocale",
        paginateNewsletterFormLocale: "NewsletterFormLocaleConnection",
        validateCreateNewsletterFormLocale: "_ValidationResult",
        validateUpdateNewsletterFormLocale: "_ValidationResult",
        getNewsletterSubscription: "NewsletterSubscription",
        listNewsletterSubscription: "NewsletterSubscription",
        paginateNewsletterSubscription: "NewsletterSubscriptionConnection",
        validateCreateNewsletterSubscription: "_ValidationResult",
        validateUpdateNewsletterSubscription: "_ValidationResult",
        getChart: "Chart",
        listChart: "Chart",
        paginateChart: "ChartConnection",
        validateCreateChart: "_ValidationResult",
        validateUpdateChart: "_ValidationResult",
        getChartData: "ChartData",
        listChartData: "ChartData",
        paginateChartData: "ChartDataConnection",
        validateCreateChartData: "_ValidationResult",
        validateUpdateChartData: "_ValidationResult",
        getEmployee: "Employee",
        listEmployee: "Employee",
        paginateEmployee: "EmployeeConnection",
        validateCreateEmployee: "_ValidationResult",
        validateUpdateEmployee: "_ValidationResult",
        getEmployeeItem: "EmployeeItem",
        listEmployeeItem: "EmployeeItem",
        paginateEmployeeItem: "EmployeeItemConnection",
        validateCreateEmployeeItem: "_ValidationResult",
        validateUpdateEmployeeItem: "_ValidationResult",
        getEmployeeList: "EmployeeList",
        listEmployeeList: "EmployeeList",
        paginateEmployeeList: "EmployeeListConnection",
        validateCreateEmployeeList: "_ValidationResult",
        validateUpdateEmployeeList: "_ValidationResult",
        getEmployeeLocale: "EmployeeLocale",
        listEmployeeLocale: "EmployeeLocale",
        paginateEmployeeLocale: "EmployeeLocaleConnection",
        validateCreateEmployeeLocale: "_ValidationResult",
        validateUpdateEmployeeLocale: "_ValidationResult",
        getPhotographer: "Photographer",
        listPhotographer: "Photographer",
        paginatePhotographer: "PhotographerConnection",
        validateCreatePhotographer: "_ValidationResult",
        validateUpdatePhotographer: "_ValidationResult",
        getDefinitionItem: "DefinitionItem",
        listDefinitionItem: "DefinitionItem",
        paginateDefinitionItem: "DefinitionItemConnection",
        validateCreateDefinitionItem: "_ValidationResult",
        validateUpdateDefinitionItem: "_ValidationResult",
        getDefinitionList: "DefinitionList",
        listDefinitionList: "DefinitionList",
        paginateDefinitionList: "DefinitionListConnection",
        validateCreateDefinitionList: "_ValidationResult",
        validateUpdateDefinitionList: "_ValidationResult",
        getLogoItem: "LogoItem",
        listLogoItem: "LogoItem",
        paginateLogoItem: "LogoItemConnection",
        validateCreateLogoItem: "_ValidationResult",
        validateUpdateLogoItem: "_ValidationResult",
        getLogoList: "LogoList",
        listLogoList: "LogoList",
        paginateLogoList: "LogoListConnection",
        validateCreateLogoList: "_ValidationResult",
        validateUpdateLogoList: "_ValidationResult",
        getStrategySchema: "StrategySchema",
        listStrategySchema: "StrategySchema",
        paginateStrategySchema: "StrategySchemaConnection",
        validateCreateStrategySchema: "_ValidationResult",
        validateUpdateStrategySchema: "_ValidationResult",
        getStrategySchemaGroup: "StrategySchemaGroup",
        listStrategySchemaGroup: "StrategySchemaGroup",
        paginateStrategySchemaGroup: "StrategySchemaGroupConnection",
        validateCreateStrategySchemaGroup: "_ValidationResult",
        validateUpdateStrategySchemaGroup: "_ValidationResult",
        getStrategySchemaGroupItem: "StrategySchemaGroupItem",
        listStrategySchemaGroupItem: "StrategySchemaGroupItem",
        paginateStrategySchemaGroupItem: "StrategySchemaGroupItemConnection",
        validateCreateStrategySchemaGroupItem: "_ValidationResult",
        validateUpdateStrategySchemaGroupItem: "_ValidationResult",
        getRedirect: "Redirect",
        listRedirect: "Redirect",
        paginateRedirect: "RedirectConnection",
        validateCreateRedirect: "_ValidationResult",
        validateUpdateRedirect: "_ValidationResult",
        getGallery: "Gallery",
        listGallery: "Gallery",
        paginateGallery: "GalleryConnection",
        validateCreateGallery: "_ValidationResult",
        validateUpdateGallery: "_ValidationResult",
        getGalleryItem: "GalleryItem",
        listGalleryItem: "GalleryItem",
        paginateGalleryItem: "GalleryItemConnection",
        validateCreateGalleryItem: "_ValidationResult",
        validateUpdateGalleryItem: "_ValidationResult",
        getContactForm: "ContactForm",
        listContactForm: "ContactForm",
        paginateContactForm: "ContactFormConnection",
        validateCreateContactForm: "_ValidationResult",
        validateUpdateContactForm: "_ValidationResult",
        getContactFormLocale: "ContactFormLocale",
        listContactFormLocale: "ContactFormLocale",
        paginateContactFormLocale: "ContactFormLocaleConnection",
        validateCreateContactFormLocale: "_ValidationResult",
        validateUpdateContactFormLocale: "_ValidationResult",
        getContactSubscription: "ContactSubscription",
        listContactSubscription: "ContactSubscription",
        paginateContactSubscription: "ContactSubscriptionConnection",
        validateCreateContactSubscription: "_ValidationResult",
        validateUpdateContactSubscription: "_ValidationResult",
        getContactTypeItem: "ContactTypeItem",
        listContactTypeItem: "ContactTypeItem",
        paginateContactTypeItem: "ContactTypeItemConnection",
        validateCreateContactTypeItem: "_ValidationResult",
        validateUpdateContactTypeItem: "_ValidationResult",
        getFile: "File",
        listFile: "File",
        paginateFile: "FileConnection",
        validateCreateFile: "_ValidationResult",
        validateUpdateFile: "_ValidationResult",
        transaction: "QueryTransaction",
        _info: "Info",
        schema: "_Schema",
        s3DummyQuery: "String"
    },
    ContactPage: {
        _meta: "ContactPageMeta",
        id: "UUID",
        unique: "One",
        locales: "ContactPageLocale",
        localesByLocale: "ContactPageLocale",
        localesByLink: "ContactPageLocale",
        localesBySeo: "ContactPageLocale",
        localesByAddressLink: "ContactPageLocale",
        paginateLocales: "ContactPageLocaleConnection"
    },
    ContactPageMeta: {
        id: "FieldMeta",
        unique: "FieldMeta",
        locales: "FieldMeta"
    },
    FieldMeta: {
        readable: "Boolean",
        updatable: "Boolean"
    },
    ContactPageLocale: {
        _meta: "ContactPageLocaleMeta",
        id: "UUID",
        title: "String",
        root: "ContactPage",
        locale: "Locale",
        link: "Linkable",
        seo: "Seo",
        address: "String",
        phone: "String",
        email: "String",
        youtube: "String",
        instagram: "String",
        facebook: "String",
        databox: "String",
        databoxNumber: "String",
        addressLink: "Link",
        socialsLabel: "String",
        openingHours: "String",
        identificationsLabel: "String",
        ico: "String",
        dic: "String",
        phoneLabel: "String",
        emailLabel: "String",
        linkedIn: "String",
        securities: "String",
        securitiesNumber: "String"
    },
    ContactPageLocaleMeta: {
        id: "FieldMeta",
        title: "FieldMeta",
        root: "FieldMeta",
        locale: "FieldMeta",
        link: "FieldMeta",
        seo: "FieldMeta",
        address: "FieldMeta",
        phone: "FieldMeta",
        email: "FieldMeta",
        youtube: "FieldMeta",
        instagram: "FieldMeta",
        facebook: "FieldMeta",
        databox: "FieldMeta",
        databoxNumber: "FieldMeta",
        addressLink: "FieldMeta",
        socialsLabel: "FieldMeta",
        openingHours: "FieldMeta",
        identificationsLabel: "FieldMeta",
        ico: "FieldMeta",
        dic: "FieldMeta",
        phoneLabel: "FieldMeta",
        emailLabel: "FieldMeta",
        linkedIn: "FieldMeta",
        securities: "FieldMeta",
        securitiesNumber: "FieldMeta"
    },
    Locale: {
        _meta: "LocaleMeta",
        id: "UUID",
        code: "String",
        label: "String",
        contactPages: "ContactPageLocale",
        footers: "FooterLocale",
        headers: "HeaderLocale",
        homePages: "HomePageLocale",
        pages: "PageLocale",
        seoDefaults: "SeoDefaultLocale",
        events: "EventLocale",
        artworks: "ArtworkLocale",
        artworkSelections: "ArtworkSelectionLocale",
        newsletterForms: "NewsletterFormLocale",
        employees: "EmployeeLocale",
        contactForms: "ContactFormLocale",
        contactPagesByRoot: "ContactPageLocale",
        contactPagesByLink: "ContactPageLocale",
        contactPagesBySeo: "ContactPageLocale",
        contactPagesByAddressLink: "ContactPageLocale",
        footersByRoot: "FooterLocale",
        footersByDeveloperLink: "FooterLocale",
        headersByRoot: "HeaderLocale",
        headersByArtworkBreadcrumbParentLink: "HeaderLocale",
        homePagesByRoot: "HomePageLocale",
        homePagesByContent: "HomePageLocale",
        homePagesByLink: "HomePageLocale",
        homePagesBySeo: "HomePageLocale",
        pagesByRoot: "PageLocale",
        pagesByLink: "PageLocale",
        pagesByContent: "PageLocale",
        pagesBySeo: "PageLocale",
        seoDefaultsByRoot: "SeoDefaultLocale",
        seoDefaultsBySeo: "SeoDefaultLocale",
        eventsByRoot: "EventLocale",
        eventsByImage: "EventLocale",
        eventsBySeo: "EventLocale",
        eventsByLink: "EventLocale",
        eventsByContent: "EventLocale",
        artworksByRoot: "ArtworkLocale",
        artworksByContent: "ArtworkLocale",
        artworksBySeo: "ArtworkLocale",
        artworksByLink: "ArtworkLocale",
        artworkSelectionsByRoot: "ArtworkSelectionLocale",
        artworkSelectionsBySeo: "ArtworkSelectionLocale",
        artworkSelectionsByLink: "ArtworkSelectionLocale",
        newsletterFormsByRoot: "NewsletterFormLocale",
        newsletterFormsByItems: "NewsletterFormLocale",
        employeesByRoot: "EmployeeLocale",
        contactFormsByRoot: "ContactFormLocale",
        contactFormsByItems: "ContactFormLocale",
        paginateContactPages: "ContactPageLocaleConnection",
        paginateFooters: "FooterLocaleConnection",
        paginateHeaders: "HeaderLocaleConnection",
        paginateHomePages: "HomePageLocaleConnection",
        paginatePages: "PageLocaleConnection",
        paginateSeoDefaults: "SeoDefaultLocaleConnection",
        paginateEvents: "EventLocaleConnection",
        paginateArtworks: "ArtworkLocaleConnection",
        paginateArtworkSelections: "ArtworkSelectionLocaleConnection",
        paginateNewsletterForms: "NewsletterFormLocaleConnection",
        paginateEmployees: "EmployeeLocaleConnection",
        paginateContactForms: "ContactFormLocaleConnection"
    },
    LocaleMeta: {
        id: "FieldMeta",
        code: "FieldMeta",
        label: "FieldMeta",
        contactPages: "FieldMeta",
        footers: "FieldMeta",
        headers: "FieldMeta",
        homePages: "FieldMeta",
        pages: "FieldMeta",
        seoDefaults: "FieldMeta",
        events: "FieldMeta",
        artworks: "FieldMeta",
        artworkSelections: "FieldMeta",
        newsletterForms: "FieldMeta",
        employees: "FieldMeta",
        contactForms: "FieldMeta"
    },
    FooterLocale: {
        _meta: "FooterLocaleMeta",
        id: "UUID",
        address: "String",
        phone: "String",
        email: "String",
        youtube: "String",
        instagram: "String",
        facebook: "String",
        graphicDesign: "String",
        root: "Footer",
        locale: "Locale",
        graphicDesigners: "GraphicDesigner",
        developerLink: "Link",
        development: "String",
        linkedIn: "String",
        photography: "String",
        photographers: "Photographer",
        paginateGraphicDesigners: "GraphicDesignerConnection",
        paginatePhotographers: "PhotographerConnection"
    },
    FooterLocaleMeta: {
        id: "FieldMeta",
        address: "FieldMeta",
        phone: "FieldMeta",
        email: "FieldMeta",
        youtube: "FieldMeta",
        instagram: "FieldMeta",
        facebook: "FieldMeta",
        graphicDesign: "FieldMeta",
        root: "FieldMeta",
        locale: "FieldMeta",
        graphicDesigners: "FieldMeta",
        developerLink: "FieldMeta",
        development: "FieldMeta",
        linkedIn: "FieldMeta",
        photography: "FieldMeta",
        photographers: "FieldMeta"
    },
    Footer: {
        _meta: "FooterMeta",
        id: "UUID",
        unique: "One",
        logo: "Image",
        locales: "FooterLocale",
        localesByLocale: "FooterLocale",
        localesByDeveloperLink: "FooterLocale",
        paginateLocales: "FooterLocaleConnection"
    },
    FooterMeta: {
        id: "FieldMeta",
        unique: "FieldMeta",
        logo: "FieldMeta",
        locales: "FieldMeta"
    },
    Image: {
        _meta: "ImageMeta",
        id: "UUID",
        url: "String",
        width: "Int",
        height: "Int",
        size: "Int",
        type: "String",
        alt: "String"
    },
    ImageMeta: {
        id: "FieldMeta",
        url: "FieldMeta",
        width: "FieldMeta",
        height: "FieldMeta",
        size: "FieldMeta",
        type: "FieldMeta",
        alt: "FieldMeta"
    },
    FooterLocaleConnection: {
        pageInfo: "PageInfo",
        edges: "FooterLocaleEdge"
    },
    PageInfo: {
        totalCount: "Int"
    },
    FooterLocaleEdge: {
        node: "FooterLocale"
    },
    GraphicDesigner: {
        _meta: "GraphicDesignerMeta",
        id: "UUID",
        order: "Int",
        link: "Link"
    },
    GraphicDesignerMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        link: "FieldMeta"
    },
    Link: {
        _meta: "LinkMeta",
        id: "UUID",
        type: "LinkType",
        title: "String",
        externalLink: "String",
        internalLink: "Linkable",
        anchorLink: "String"
    },
    LinkMeta: {
        id: "FieldMeta",
        type: "FieldMeta",
        title: "FieldMeta",
        externalLink: "FieldMeta",
        internalLink: "FieldMeta",
        anchorLink: "FieldMeta"
    },
    Linkable: {
        _meta: "LinkableMeta",
        id: "UUID",
        url: "String",
        homePage: "HomePageLocale",
        contactPage: "ContactPageLocale",
        page: "PageLocale",
        event: "EventLocale",
        artwork: "ArtworkLocale",
        artworkSelection: "ArtworkSelectionLocale",
        redirect: "Redirect"
    },
    LinkableMeta: {
        id: "FieldMeta",
        url: "FieldMeta",
        homePage: "FieldMeta",
        contactPage: "FieldMeta",
        page: "FieldMeta",
        event: "FieldMeta",
        artwork: "FieldMeta",
        artworkSelection: "FieldMeta",
        redirect: "FieldMeta"
    },
    HomePageLocale: {
        _meta: "HomePageLocaleMeta",
        id: "UUID",
        title: "String",
        root: "HomePage",
        locale: "Locale",
        content: "Content",
        link: "Linkable",
        seo: "Seo",
        branches: "Branches",
        leadParagraph: "String",
        paginateBranches: "BranchesConnection"
    },
    HomePageLocaleMeta: {
        id: "FieldMeta",
        title: "FieldMeta",
        root: "FieldMeta",
        locale: "FieldMeta",
        content: "FieldMeta",
        link: "FieldMeta",
        seo: "FieldMeta",
        branches: "FieldMeta",
        leadParagraph: "FieldMeta"
    },
    HomePage: {
        _meta: "HomePageMeta",
        id: "UUID",
        unique: "One",
        locales: "HomePageLocale",
        media: "MediumList",
        localesByLocale: "HomePageLocale",
        localesByContent: "HomePageLocale",
        localesByLink: "HomePageLocale",
        localesBySeo: "HomePageLocale",
        paginateLocales: "HomePageLocaleConnection"
    },
    HomePageMeta: {
        id: "FieldMeta",
        unique: "FieldMeta",
        locales: "FieldMeta",
        media: "FieldMeta"
    },
    MediumList: {
        _meta: "MediumListMeta",
        id: "UUID",
        items: "MediumItem",
        paginateItems: "MediumItemConnection"
    },
    MediumListMeta: {
        id: "FieldMeta",
        items: "FieldMeta"
    },
    MediumItem: {
        _meta: "MediumItemMeta",
        id: "UUID",
        order: "Int",
        list: "MediumList",
        medium: "Medium"
    },
    MediumItemMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        list: "FieldMeta",
        medium: "FieldMeta"
    },
    Medium: {
        _meta: "MediumMeta",
        id: "UUID",
        type: "MediumType",
        image: "Image",
        video: "Video",
        youtubeEmbed: "String"
    },
    MediumMeta: {
        id: "FieldMeta",
        type: "FieldMeta",
        image: "FieldMeta",
        video: "FieldMeta",
        youtubeEmbed: "FieldMeta"
    },
    Video: {
        _meta: "VideoMeta",
        id: "UUID",
        src: "String",
        width: "Int",
        height: "Int",
        size: "Int",
        type: "String",
        duration: "Float",
        poster: "Image"
    },
    VideoMeta: {
        id: "FieldMeta",
        src: "FieldMeta",
        width: "FieldMeta",
        height: "FieldMeta",
        size: "FieldMeta",
        type: "FieldMeta",
        duration: "FieldMeta",
        poster: "FieldMeta"
    },
    MediumItemConnection: {
        pageInfo: "PageInfo",
        edges: "MediumItemEdge"
    },
    MediumItemEdge: {
        node: "MediumItem"
    },
    HomePageLocaleConnection: {
        pageInfo: "PageInfo",
        edges: "HomePageLocaleEdge"
    },
    HomePageLocaleEdge: {
        node: "HomePageLocale"
    },
    Content: {
        _meta: "ContentMeta",
        id: "UUID",
        blocks: "ContentBlock",
        blocksByReferences: "ContentBlock",
        paginateBlocks: "ContentBlockConnection"
    },
    ContentMeta: {
        id: "FieldMeta",
        blocks: "FieldMeta"
    },
    ContentBlock: {
        _meta: "ContentBlockMeta",
        id: "UUID",
        order: "Int",
        json: "String",
        content: "Content",
        references: "ContentReference",
        referencesByMedia: "ContentReference",
        referencesByLink: "ContentReference",
        referencesByDropDownList: "ContentReference",
        referencesByEventList: "ContentReference",
        referencesByBoxList: "ContentReference",
        referencesByChart: "ContentReference",
        referencesByDefinitionList: "ContentReference",
        referencesByLogoList: "ContentReference",
        referencesByStrategySchema: "ContentReference",
        referencesByEmployeeList: "ContentReference",
        paginateReferences: "ContentReferenceConnection"
    },
    ContentBlockMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        json: "FieldMeta",
        content: "FieldMeta",
        references: "FieldMeta"
    },
    ContentReference: {
        _meta: "ContentReferenceMeta",
        id: "UUID",
        type: "ContentReferenceType",
        primaryText: "String",
        block: "ContentBlock",
        media: "MediumList",
        link: "Link",
        secondaryText: "String",
        dropDownList: "DropDownList",
        artworkSelection: "ArtworkSelection",
        eventList: "EventList",
        boxList: "BoxList",
        isVisible: "Boolean",
        chart: "Chart",
        definitionList: "DefinitionList",
        logoList: "LogoList",
        strategySchema: "StrategySchema",
        image: "Image",
        employeeList: "EmployeeList",
        imageSecond: "Image",
        contactForm: "ContactForm",
        newsletterForm: "NewsletterForm"
    },
    ContentReferenceMeta: {
        id: "FieldMeta",
        type: "FieldMeta",
        primaryText: "FieldMeta",
        block: "FieldMeta",
        media: "FieldMeta",
        link: "FieldMeta",
        secondaryText: "FieldMeta",
        dropDownList: "FieldMeta",
        artworkSelection: "FieldMeta",
        eventList: "FieldMeta",
        boxList: "FieldMeta",
        isVisible: "FieldMeta",
        chart: "FieldMeta",
        definitionList: "FieldMeta",
        logoList: "FieldMeta",
        strategySchema: "FieldMeta",
        image: "FieldMeta",
        employeeList: "FieldMeta",
        imageSecond: "FieldMeta",
        contactForm: "FieldMeta",
        newsletterForm: "FieldMeta"
    },
    DropDownList: {
        _meta: "DropDownListMeta",
        id: "UUID",
        items: "DropDownItem",
        dropDownType: "DropDownType",
        employees: "EmployeeList",
        itemsByLink: "DropDownItem",
        paginateItems: "DropDownItemConnection"
    },
    DropDownListMeta: {
        id: "FieldMeta",
        items: "FieldMeta",
        dropDownType: "FieldMeta",
        employees: "FieldMeta"
    },
    DropDownItem: {
        _meta: "DropDownItemMeta",
        id: "UUID",
        order: "Int",
        title: "String",
        text: "String",
        list: "DropDownList",
        link: "Link"
    },
    DropDownItemMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        title: "FieldMeta",
        text: "FieldMeta",
        list: "FieldMeta",
        link: "FieldMeta"
    },
    EmployeeList: {
        _meta: "EmployeeListMeta",
        id: "UUID",
        items: "EmployeeItem",
        paginateItems: "EmployeeItemConnection"
    },
    EmployeeListMeta: {
        id: "FieldMeta",
        items: "FieldMeta"
    },
    EmployeeItem: {
        _meta: "EmployeeItemMeta",
        id: "UUID",
        order: "Int",
        list: "EmployeeList",
        employee: "Employee"
    },
    EmployeeItemMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        list: "FieldMeta",
        employee: "FieldMeta"
    },
    Employee: {
        _meta: "EmployeeMeta",
        id: "UUID",
        order: "Int",
        name: "String",
        image: "Image",
        locales: "EmployeeLocale",
        localesByLocale: "EmployeeLocale",
        paginateLocales: "EmployeeLocaleConnection"
    },
    EmployeeMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        name: "FieldMeta",
        image: "FieldMeta",
        locales: "FieldMeta"
    },
    EmployeeLocale: {
        _meta: "EmployeeLocaleMeta",
        id: "UUID",
        position: "String",
        text: "String",
        email: "String",
        phone: "String",
        root: "Employee",
        locale: "Locale"
    },
    EmployeeLocaleMeta: {
        id: "FieldMeta",
        position: "FieldMeta",
        text: "FieldMeta",
        email: "FieldMeta",
        phone: "FieldMeta",
        root: "FieldMeta",
        locale: "FieldMeta"
    },
    EmployeeLocaleConnection: {
        pageInfo: "PageInfo",
        edges: "EmployeeLocaleEdge"
    },
    EmployeeLocaleEdge: {
        node: "EmployeeLocale"
    },
    EmployeeItemConnection: {
        pageInfo: "PageInfo",
        edges: "EmployeeItemEdge"
    },
    EmployeeItemEdge: {
        node: "EmployeeItem"
    },
    DropDownItemConnection: {
        pageInfo: "PageInfo",
        edges: "DropDownItemEdge"
    },
    DropDownItemEdge: {
        node: "DropDownItem"
    },
    ArtworkSelection: {
        _meta: "ArtworkSelectionMeta",
        id: "UUID",
        order: "Int",
        locales: "ArtworkSelectionLocale",
        artworks: "ArtworkSelectionList",
        localesByLocale: "ArtworkSelectionLocale",
        localesBySeo: "ArtworkSelectionLocale",
        localesByLink: "ArtworkSelectionLocale",
        paginateLocales: "ArtworkSelectionLocaleConnection"
    },
    ArtworkSelectionMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        locales: "FieldMeta",
        artworks: "FieldMeta"
    },
    ArtworkSelectionLocale: {
        _meta: "ArtworkSelectionLocaleMeta",
        id: "UUID",
        title: "String",
        root: "ArtworkSelection",
        locale: "Locale",
        seo: "Seo",
        link: "Linkable"
    },
    ArtworkSelectionLocaleMeta: {
        id: "FieldMeta",
        title: "FieldMeta",
        root: "FieldMeta",
        locale: "FieldMeta",
        seo: "FieldMeta",
        link: "FieldMeta"
    },
    Seo: {
        _meta: "SeoMeta",
        id: "UUID",
        title: "String",
        description: "String",
        ogTitle: "String",
        ogDescription: "String",
        noIndex: "Boolean",
        noFollow: "Boolean",
        ogImage: "Image"
    },
    SeoMeta: {
        id: "FieldMeta",
        title: "FieldMeta",
        description: "FieldMeta",
        ogTitle: "FieldMeta",
        ogDescription: "FieldMeta",
        noIndex: "FieldMeta",
        noFollow: "FieldMeta",
        ogImage: "FieldMeta"
    },
    ArtworkSelectionList: {
        _meta: "ArtworkSelectionListMeta",
        id: "UUID",
        items: "ArtworkSelectionItem",
        paginateItems: "ArtworkSelectionItemConnection"
    },
    ArtworkSelectionListMeta: {
        id: "FieldMeta",
        items: "FieldMeta"
    },
    ArtworkSelectionItem: {
        _meta: "ArtworkSelectionItemMeta",
        id: "UUID",
        order: "Int",
        list: "ArtworkSelectionList",
        artwork: "Artwork"
    },
    ArtworkSelectionItemMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        list: "FieldMeta",
        artwork: "FieldMeta"
    },
    Artwork: {
        _meta: "ArtworkMeta",
        id: "UUID",
        order: "Int",
        locales: "ArtworkLocale",
        image: "Image",
        gallery: "Gallery",
        localesByLocale: "ArtworkLocale",
        localesByContent: "ArtworkLocale",
        localesBySeo: "ArtworkLocale",
        localesByLink: "ArtworkLocale",
        paginateLocales: "ArtworkLocaleConnection"
    },
    ArtworkMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        locales: "FieldMeta",
        image: "FieldMeta",
        gallery: "FieldMeta"
    },
    ArtworkLocale: {
        _meta: "ArtworkLocaleMeta",
        id: "UUID",
        title: "String",
        label: "String",
        leadParagraph: "String",
        root: "Artwork",
        locale: "Locale",
        content: "Content",
        seo: "Seo",
        link: "Linkable",
        artist: "String"
    },
    ArtworkLocaleMeta: {
        id: "FieldMeta",
        title: "FieldMeta",
        label: "FieldMeta",
        leadParagraph: "FieldMeta",
        root: "FieldMeta",
        locale: "FieldMeta",
        content: "FieldMeta",
        seo: "FieldMeta",
        link: "FieldMeta",
        artist: "FieldMeta"
    },
    Gallery: {
        _meta: "GalleryMeta",
        id: "UUID",
        items: "GalleryItem",
        paginateItems: "GalleryItemConnection"
    },
    GalleryMeta: {
        id: "FieldMeta",
        items: "FieldMeta"
    },
    GalleryItem: {
        _meta: "GalleryItemMeta",
        id: "UUID",
        order: "Int",
        list: "Gallery",
        image: "Image"
    },
    GalleryItemMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        list: "FieldMeta",
        image: "FieldMeta"
    },
    GalleryItemConnection: {
        pageInfo: "PageInfo",
        edges: "GalleryItemEdge"
    },
    GalleryItemEdge: {
        node: "GalleryItem"
    },
    ArtworkLocaleConnection: {
        pageInfo: "PageInfo",
        edges: "ArtworkLocaleEdge"
    },
    ArtworkLocaleEdge: {
        node: "ArtworkLocale"
    },
    ArtworkSelectionItemConnection: {
        pageInfo: "PageInfo",
        edges: "ArtworkSelectionItemEdge"
    },
    ArtworkSelectionItemEdge: {
        node: "ArtworkSelectionItem"
    },
    ArtworkSelectionLocaleConnection: {
        pageInfo: "PageInfo",
        edges: "ArtworkSelectionLocaleEdge"
    },
    ArtworkSelectionLocaleEdge: {
        node: "ArtworkSelectionLocale"
    },
    EventList: {
        _meta: "EventListMeta",
        id: "UUID",
        items: "EventItem",
        paginateItems: "EventItemConnection"
    },
    EventListMeta: {
        id: "FieldMeta",
        items: "FieldMeta"
    },
    EventItem: {
        _meta: "EventItemMeta",
        id: "UUID",
        order: "Int",
        list: "EventList",
        event: "Event"
    },
    EventItemMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        list: "FieldMeta",
        event: "FieldMeta"
    },
    Event: {
        _meta: "EventMeta",
        id: "UUID",
        locales: "EventLocale",
        order: "Int",
        dateStart: "DateTime",
        dateFinish: "DateTime",
        localesByLocale: "EventLocale",
        localesByImage: "EventLocale",
        localesBySeo: "EventLocale",
        localesByLink: "EventLocale",
        localesByContent: "EventLocale",
        paginateLocales: "EventLocaleConnection"
    },
    EventMeta: {
        id: "FieldMeta",
        locales: "FieldMeta",
        order: "FieldMeta",
        dateStart: "FieldMeta",
        dateFinish: "FieldMeta"
    },
    EventLocale: {
        _meta: "EventLocaleMeta",
        id: "UUID",
        title: "String",
        root: "Event",
        locale: "Locale",
        image: "Image",
        seo: "Seo",
        link: "Linkable",
        venue: "String",
        venueNote: "String",
        content: "Content",
        date: "String",
        leadParagraph: "String",
        isDark: "Boolean"
    },
    EventLocaleMeta: {
        id: "FieldMeta",
        title: "FieldMeta",
        root: "FieldMeta",
        locale: "FieldMeta",
        image: "FieldMeta",
        seo: "FieldMeta",
        link: "FieldMeta",
        venue: "FieldMeta",
        venueNote: "FieldMeta",
        content: "FieldMeta",
        date: "FieldMeta",
        leadParagraph: "FieldMeta",
        isDark: "FieldMeta"
    },
    EventLocaleConnection: {
        pageInfo: "PageInfo",
        edges: "EventLocaleEdge"
    },
    EventLocaleEdge: {
        node: "EventLocale"
    },
    EventItemConnection: {
        pageInfo: "PageInfo",
        edges: "EventItemEdge"
    },
    EventItemEdge: {
        node: "EventItem"
    },
    BoxList: {
        _meta: "BoxListMeta",
        id: "UUID",
        items: "BoxItem",
        paginateItems: "BoxItemConnection"
    },
    BoxListMeta: {
        id: "FieldMeta",
        items: "FieldMeta"
    },
    BoxItem: {
        _meta: "BoxItemMeta",
        id: "UUID",
        order: "Int",
        link: "String",
        date: "String",
        type: "String",
        title: "String",
        text: "String",
        list: "BoxList"
    },
    BoxItemMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        link: "FieldMeta",
        date: "FieldMeta",
        type: "FieldMeta",
        title: "FieldMeta",
        text: "FieldMeta",
        list: "FieldMeta"
    },
    BoxItemConnection: {
        pageInfo: "PageInfo",
        edges: "BoxItemEdge"
    },
    BoxItemEdge: {
        node: "BoxItem"
    },
    Chart: {
        _meta: "ChartMeta",
        id: "UUID",
        type: "ChartType",
        items: "ChartData",
        paginateItems: "ChartDataConnection"
    },
    ChartMeta: {
        id: "FieldMeta",
        type: "FieldMeta",
        items: "FieldMeta"
    },
    ChartData: {
        _meta: "ChartDataMeta",
        id: "UUID",
        order: "Int",
        list: "Chart",
        date: "Date",
        number: "Float",
        text: "String",
        image: "Image"
    },
    ChartDataMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        list: "FieldMeta",
        date: "FieldMeta",
        number: "FieldMeta",
        text: "FieldMeta",
        image: "FieldMeta"
    },
    ChartDataConnection: {
        pageInfo: "PageInfo",
        edges: "ChartDataEdge"
    },
    ChartDataEdge: {
        node: "ChartData"
    },
    DefinitionList: {
        _meta: "DefinitionListMeta",
        id: "UUID",
        items: "DefinitionItem",
        paginateItems: "DefinitionItemConnection"
    },
    DefinitionListMeta: {
        id: "FieldMeta",
        items: "FieldMeta"
    },
    DefinitionItem: {
        _meta: "DefinitionItemMeta",
        id: "UUID",
        order: "Int",
        key: "String",
        value: "String",
        list: "DefinitionList"
    },
    DefinitionItemMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        key: "FieldMeta",
        value: "FieldMeta",
        list: "FieldMeta"
    },
    DefinitionItemConnection: {
        pageInfo: "PageInfo",
        edges: "DefinitionItemEdge"
    },
    DefinitionItemEdge: {
        node: "DefinitionItem"
    },
    LogoList: {
        _meta: "LogoListMeta",
        id: "UUID",
        items: "LogoItem",
        paginateItems: "LogoItemConnection"
    },
    LogoListMeta: {
        id: "FieldMeta",
        items: "FieldMeta"
    },
    LogoItem: {
        _meta: "LogoItemMeta",
        id: "UUID",
        order: "Int",
        list: "LogoList",
        image: "Image"
    },
    LogoItemMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        list: "FieldMeta",
        image: "FieldMeta"
    },
    LogoItemConnection: {
        pageInfo: "PageInfo",
        edges: "LogoItemEdge"
    },
    LogoItemEdge: {
        node: "LogoItem"
    },
    StrategySchema: {
        _meta: "StrategySchemaMeta",
        id: "UUID",
        inputFirst: "String",
        inputSecond: "String",
        inputThird: "String",
        outputFirst: "String",
        outputSecond: "String",
        outputThird: "String",
        itemsFirst: "StrategySchemaGroup",
        logo: "Image",
        itemsSecond: "StrategySchemaGroup"
    },
    StrategySchemaMeta: {
        id: "FieldMeta",
        inputFirst: "FieldMeta",
        inputSecond: "FieldMeta",
        inputThird: "FieldMeta",
        outputFirst: "FieldMeta",
        outputSecond: "FieldMeta",
        outputThird: "FieldMeta",
        itemsFirst: "FieldMeta",
        logo: "FieldMeta",
        itemsSecond: "FieldMeta"
    },
    StrategySchemaGroup: {
        _meta: "StrategySchemaGroupMeta",
        id: "UUID",
        items: "StrategySchemaGroupItem",
        paginateItems: "StrategySchemaGroupItemConnection"
    },
    StrategySchemaGroupMeta: {
        id: "FieldMeta",
        items: "FieldMeta"
    },
    StrategySchemaGroupItem: {
        _meta: "StrategySchemaGroupItemMeta",
        id: "UUID",
        order: "Int",
        text: "String",
        schema: "StrategySchemaGroup"
    },
    StrategySchemaGroupItemMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        text: "FieldMeta",
        schema: "FieldMeta"
    },
    StrategySchemaGroupItemConnection: {
        pageInfo: "PageInfo",
        edges: "StrategySchemaGroupItemEdge"
    },
    StrategySchemaGroupItemEdge: {
        node: "StrategySchemaGroupItem"
    },
    ContactForm: {
        _meta: "ContactFormMeta",
        id: "UUID",
        unique: "One",
        locales: "ContactFormLocale",
        localesByLocale: "ContactFormLocale",
        localesByItems: "ContactFormLocale",
        paginateLocales: "ContactFormLocaleConnection"
    },
    ContactFormMeta: {
        id: "FieldMeta",
        unique: "FieldMeta",
        locales: "FieldMeta"
    },
    ContactFormLocale: {
        _meta: "ContactFormLocaleMeta",
        id: "UUID",
        title: "String",
        name: "String",
        phone: "String",
        email: "String",
        message: "String",
        submit: "String",
        successMessage: "String",
        genericErrorMessage: "String",
        contactTypeErrorMessage: "String",
        root: "ContactForm",
        locale: "Locale",
        items: "ContactTypeItem",
        file: "String",
        itemsBySubscriptions: "ContactTypeItem",
        paginateItems: "ContactTypeItemConnection"
    },
    ContactFormLocaleMeta: {
        id: "FieldMeta",
        title: "FieldMeta",
        name: "FieldMeta",
        phone: "FieldMeta",
        email: "FieldMeta",
        message: "FieldMeta",
        submit: "FieldMeta",
        successMessage: "FieldMeta",
        genericErrorMessage: "FieldMeta",
        contactTypeErrorMessage: "FieldMeta",
        root: "FieldMeta",
        locale: "FieldMeta",
        items: "FieldMeta",
        file: "FieldMeta"
    },
    ContactTypeItem: {
        _meta: "ContactTypeItemMeta",
        id: "UUID",
        order: "Int",
        title: "String",
        subscriptions: "ContactSubscription",
        list: "ContactFormLocale",
        subscriptionsByFile: "ContactSubscription",
        paginateSubscriptions: "ContactSubscriptionConnection"
    },
    ContactTypeItemMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        title: "FieldMeta",
        subscriptions: "FieldMeta",
        list: "FieldMeta"
    },
    ContactSubscription: {
        _meta: "ContactSubscriptionMeta",
        id: "UUID",
        createdAt: "DateTime",
        email: "String",
        name: "String",
        phone: "String",
        message: "String",
        file: "File",
        contactType: "ContactTypeItem"
    },
    ContactSubscriptionMeta: {
        id: "FieldMeta",
        createdAt: "FieldMeta",
        email: "FieldMeta",
        name: "FieldMeta",
        phone: "FieldMeta",
        message: "FieldMeta",
        file: "FieldMeta",
        contactType: "FieldMeta"
    },
    File: {
        _meta: "FileMeta",
        id: "UUID",
        url: "String",
        size: "Int",
        type: "String"
    },
    FileMeta: {
        id: "FieldMeta",
        url: "FieldMeta",
        size: "FieldMeta",
        type: "FieldMeta"
    },
    ContactSubscriptionConnection: {
        pageInfo: "PageInfo",
        edges: "ContactSubscriptionEdge"
    },
    ContactSubscriptionEdge: {
        node: "ContactSubscription"
    },
    ContactTypeItemConnection: {
        pageInfo: "PageInfo",
        edges: "ContactTypeItemEdge"
    },
    ContactTypeItemEdge: {
        node: "ContactTypeItem"
    },
    ContactFormLocaleConnection: {
        pageInfo: "PageInfo",
        edges: "ContactFormLocaleEdge"
    },
    ContactFormLocaleEdge: {
        node: "ContactFormLocale"
    },
    NewsletterForm: {
        _meta: "NewsletterFormMeta",
        id: "UUID",
        unique: "One",
        locales: "NewsletterFormLocale",
        localesByLocale: "NewsletterFormLocale",
        localesByItems: "NewsletterFormLocale",
        paginateLocales: "NewsletterFormLocaleConnection"
    },
    NewsletterFormMeta: {
        id: "FieldMeta",
        unique: "FieldMeta",
        locales: "FieldMeta"
    },
    NewsletterFormLocale: {
        _meta: "NewsletterFormLocaleMeta",
        id: "UUID",
        newsletterTypeNote: "String",
        email: "String",
        emailNote: "String",
        submit: "String",
        root: "NewsletterForm",
        locale: "Locale",
        items: "NewsletterTypeItem",
        title: "String",
        successMessage: "String",
        genericErrorMessage: "String",
        newsletterTypeErrorMessage: "String",
        itemsBySubscriptions: "NewsletterTypeItem",
        paginateItems: "NewsletterTypeItemConnection"
    },
    NewsletterFormLocaleMeta: {
        id: "FieldMeta",
        newsletterTypeNote: "FieldMeta",
        email: "FieldMeta",
        emailNote: "FieldMeta",
        submit: "FieldMeta",
        root: "FieldMeta",
        locale: "FieldMeta",
        items: "FieldMeta",
        title: "FieldMeta",
        successMessage: "FieldMeta",
        genericErrorMessage: "FieldMeta",
        newsletterTypeErrorMessage: "FieldMeta"
    },
    NewsletterTypeItem: {
        _meta: "NewsletterTypeItemMeta",
        id: "UUID",
        order: "Int",
        title: "String",
        list: "NewsletterFormLocale",
        subscriptions: "NewsletterSubscription",
        paginateSubscriptions: "NewsletterSubscriptionConnection"
    },
    NewsletterTypeItemMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        title: "FieldMeta",
        list: "FieldMeta",
        subscriptions: "FieldMeta"
    },
    NewsletterSubscription: {
        _meta: "NewsletterSubscriptionMeta",
        id: "UUID",
        createdAt: "DateTime",
        email: "String",
        newsletterType: "NewsletterTypeItem"
    },
    NewsletterSubscriptionMeta: {
        id: "FieldMeta",
        createdAt: "FieldMeta",
        email: "FieldMeta",
        newsletterType: "FieldMeta"
    },
    NewsletterSubscriptionConnection: {
        pageInfo: "PageInfo",
        edges: "NewsletterSubscriptionEdge"
    },
    NewsletterSubscriptionEdge: {
        node: "NewsletterSubscription"
    },
    NewsletterTypeItemConnection: {
        pageInfo: "PageInfo",
        edges: "NewsletterTypeItemEdge"
    },
    NewsletterTypeItemEdge: {
        node: "NewsletterTypeItem"
    },
    NewsletterFormLocaleConnection: {
        pageInfo: "PageInfo",
        edges: "NewsletterFormLocaleEdge"
    },
    NewsletterFormLocaleEdge: {
        node: "NewsletterFormLocale"
    },
    ContentReferenceConnection: {
        pageInfo: "PageInfo",
        edges: "ContentReferenceEdge"
    },
    ContentReferenceEdge: {
        node: "ContentReference"
    },
    ContentBlockConnection: {
        pageInfo: "PageInfo",
        edges: "ContentBlockEdge"
    },
    ContentBlockEdge: {
        node: "ContentBlock"
    },
    Branches: {
        _meta: "BranchesMeta",
        id: "UUID",
        order: "Int",
        leadParagraph: "String",
        more: "String",
        link: "Link"
    },
    BranchesMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        leadParagraph: "FieldMeta",
        more: "FieldMeta",
        link: "FieldMeta"
    },
    BranchesConnection: {
        pageInfo: "PageInfo",
        edges: "BranchesEdge"
    },
    BranchesEdge: {
        node: "Branches"
    },
    PageLocale: {
        _meta: "PageLocaleMeta",
        id: "UUID",
        title: "String",
        link: "Linkable",
        root: "Page",
        locale: "Locale",
        content: "Content",
        seo: "Seo"
    },
    PageLocaleMeta: {
        id: "FieldMeta",
        title: "FieldMeta",
        link: "FieldMeta",
        root: "FieldMeta",
        locale: "FieldMeta",
        content: "FieldMeta",
        seo: "FieldMeta"
    },
    Page: {
        _meta: "PageMeta",
        id: "UUID",
        locales: "PageLocale",
        localesByLocale: "PageLocale",
        localesByLink: "PageLocale",
        localesByContent: "PageLocale",
        localesBySeo: "PageLocale",
        paginateLocales: "PageLocaleConnection"
    },
    PageMeta: {
        id: "FieldMeta",
        locales: "FieldMeta"
    },
    PageLocaleConnection: {
        pageInfo: "PageInfo",
        edges: "PageLocaleEdge"
    },
    PageLocaleEdge: {
        node: "PageLocale"
    },
    Redirect: {
        _meta: "RedirectMeta",
        id: "UUID",
        link: "Linkable",
        target: "Linkable"
    },
    RedirectMeta: {
        id: "FieldMeta",
        link: "FieldMeta",
        target: "FieldMeta"
    },
    Photographer: {
        _meta: "PhotographerMeta",
        id: "UUID",
        order: "Int",
        link: "Link"
    },
    PhotographerMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        link: "FieldMeta"
    },
    GraphicDesignerConnection: {
        pageInfo: "PageInfo",
        edges: "GraphicDesignerEdge"
    },
    GraphicDesignerEdge: {
        node: "GraphicDesigner"
    },
    PhotographerConnection: {
        pageInfo: "PageInfo",
        edges: "PhotographerEdge"
    },
    PhotographerEdge: {
        node: "Photographer"
    },
    HeaderLocale: {
        _meta: "HeaderLocaleMeta",
        id: "UUID",
        root: "Header",
        locale: "Locale",
        links: "HeaderLink",
        artworkBreadcrumbParentLink: "Linkable",
        paginateLinks: "HeaderLinkConnection"
    },
    HeaderLocaleMeta: {
        id: "FieldMeta",
        root: "FieldMeta",
        locale: "FieldMeta",
        links: "FieldMeta",
        artworkBreadcrumbParentLink: "FieldMeta"
    },
    Header: {
        _meta: "HeaderMeta",
        id: "UUID",
        unique: "One",
        locales: "HeaderLocale",
        logo: "Image",
        localesByLocale: "HeaderLocale",
        localesByArtworkBreadcrumbParentLink: "HeaderLocale",
        paginateLocales: "HeaderLocaleConnection"
    },
    HeaderMeta: {
        id: "FieldMeta",
        unique: "FieldMeta",
        locales: "FieldMeta",
        logo: "FieldMeta"
    },
    HeaderLocaleConnection: {
        pageInfo: "PageInfo",
        edges: "HeaderLocaleEdge"
    },
    HeaderLocaleEdge: {
        node: "HeaderLocale"
    },
    HeaderLink: {
        _meta: "HeaderLinkMeta",
        id: "UUID",
        order: "Int",
        link: "Link"
    },
    HeaderLinkMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        link: "FieldMeta"
    },
    HeaderLinkConnection: {
        pageInfo: "PageInfo",
        edges: "HeaderLinkEdge"
    },
    HeaderLinkEdge: {
        node: "HeaderLink"
    },
    SeoDefaultLocale: {
        _meta: "SeoDefaultLocaleMeta",
        id: "UUID",
        root: "SeoDefault",
        locale: "Locale",
        seo: "Seo"
    },
    SeoDefaultLocaleMeta: {
        id: "FieldMeta",
        root: "FieldMeta",
        locale: "FieldMeta",
        seo: "FieldMeta"
    },
    SeoDefault: {
        _meta: "SeoDefaultMeta",
        id: "UUID",
        unique: "One",
        locales: "SeoDefaultLocale",
        localesByLocale: "SeoDefaultLocale",
        localesBySeo: "SeoDefaultLocale",
        paginateLocales: "SeoDefaultLocaleConnection"
    },
    SeoDefaultMeta: {
        id: "FieldMeta",
        unique: "FieldMeta",
        locales: "FieldMeta"
    },
    SeoDefaultLocaleConnection: {
        pageInfo: "PageInfo",
        edges: "SeoDefaultLocaleEdge"
    },
    SeoDefaultLocaleEdge: {
        node: "SeoDefaultLocale"
    },
    ContactPageLocaleConnection: {
        pageInfo: "PageInfo",
        edges: "ContactPageLocaleEdge"
    },
    ContactPageLocaleEdge: {
        node: "ContactPageLocale"
    },
    ContactPageConnection: {
        pageInfo: "PageInfo",
        edges: "ContactPageEdge"
    },
    ContactPageEdge: {
        node: "ContactPage"
    },
    _ValidationResult: {
        valid: "Boolean",
        errors: "_ValidationError"
    },
    _ValidationError: {
        path: "_PathFragment",
        message: "_ValidationMessage"
    },
    _PathFragment: {
        "...on _FieldPathFragment": "_FieldPathFragment",
        "...on _IndexPathFragment": "_IndexPathFragment"
    },
    _FieldPathFragment: {
        field: "String"
    },
    _IndexPathFragment: {
        index: "Int",
        alias: "String"
    },
    _ValidationMessage: {
        text: "String"
    },
    ContentConnection: {
        pageInfo: "PageInfo",
        edges: "ContentEdge"
    },
    ContentEdge: {
        node: "Content"
    },
    FooterConnection: {
        pageInfo: "PageInfo",
        edges: "FooterEdge"
    },
    FooterEdge: {
        node: "Footer"
    },
    HeaderConnection: {
        pageInfo: "PageInfo",
        edges: "HeaderEdge"
    },
    HeaderEdge: {
        node: "Header"
    },
    HomePageConnection: {
        pageInfo: "PageInfo",
        edges: "HomePageEdge"
    },
    HomePageEdge: {
        node: "HomePage"
    },
    LinkConnection: {
        pageInfo: "PageInfo",
        edges: "LinkEdge"
    },
    LinkEdge: {
        node: "Link"
    },
    LinkableConnection: {
        pageInfo: "PageInfo",
        edges: "LinkableEdge"
    },
    LinkableEdge: {
        node: "Linkable"
    },
    LocaleConnection: {
        pageInfo: "PageInfo",
        edges: "LocaleEdge"
    },
    LocaleEdge: {
        node: "Locale"
    },
    MediumConnection: {
        pageInfo: "PageInfo",
        edges: "MediumEdge"
    },
    MediumEdge: {
        node: "Medium"
    },
    MediumListConnection: {
        pageInfo: "PageInfo",
        edges: "MediumListEdge"
    },
    MediumListEdge: {
        node: "MediumList"
    },
    PageConnection: {
        pageInfo: "PageInfo",
        edges: "PageEdge"
    },
    PageEdge: {
        node: "Page"
    },
    SeoDefaultConnection: {
        pageInfo: "PageInfo",
        edges: "SeoDefaultEdge"
    },
    SeoDefaultEdge: {
        node: "SeoDefault"
    },
    VideoConnection: {
        pageInfo: "PageInfo",
        edges: "VideoEdge"
    },
    VideoEdge: {
        node: "Video"
    },
    ImageConnection: {
        pageInfo: "PageInfo",
        edges: "ImageEdge"
    },
    ImageEdge: {
        node: "Image"
    },
    SeoConnection: {
        pageInfo: "PageInfo",
        edges: "SeoEdge"
    },
    SeoEdge: {
        node: "Seo"
    },
    TranslationDomain: {
        _meta: "TranslationDomainMeta",
        id: "UUID",
        identifier: "String",
        name: "String",
        catalogues: "TranslationCatalogue",
        keys: "TranslationKey",
        cataloguesByIdentifier: "TranslationCatalogue",
        cataloguesByValues: "TranslationCatalogue",
        keysByIdentifier: "TranslationKey",
        keysByValues: "TranslationKey",
        paginateCatalogues: "TranslationCatalogueConnection",
        paginateKeys: "TranslationKeyConnection"
    },
    TranslationDomainMeta: {
        id: "FieldMeta",
        identifier: "FieldMeta",
        name: "FieldMeta",
        catalogues: "FieldMeta",
        keys: "FieldMeta"
    },
    TranslationCatalogue: {
        _meta: "TranslationCatalogueMeta",
        id: "UUID",
        domain: "TranslationDomain",
        identifier: "TranslationCataloguesIdentifier",
        fallback: "TranslationCatalogue",
        values: "TranslationValue",
        valuesByKey: "TranslationValue",
        paginateValues: "TranslationValueConnection"
    },
    TranslationCatalogueMeta: {
        id: "FieldMeta",
        domain: "FieldMeta",
        identifier: "FieldMeta",
        fallback: "FieldMeta",
        values: "FieldMeta"
    },
    TranslationCataloguesIdentifier: {
        _meta: "TranslationCataloguesIdentifierMeta",
        id: "UUID",
        name: "String",
        code: "String",
        catalogue: "TranslationCatalogue",
        catalogueByDomain: "TranslationCatalogue",
        catalogueByValues: "TranslationCatalogue",
        paginateCatalogue: "TranslationCatalogueConnection"
    },
    TranslationCataloguesIdentifierMeta: {
        id: "FieldMeta",
        name: "FieldMeta",
        code: "FieldMeta",
        catalogue: "FieldMeta"
    },
    TranslationCatalogueConnection: {
        pageInfo: "PageInfo",
        edges: "TranslationCatalogueEdge"
    },
    TranslationCatalogueEdge: {
        node: "TranslationCatalogue"
    },
    TranslationValue: {
        _meta: "TranslationValueMeta",
        id: "UUID",
        value: "String",
        catalogue: "TranslationCatalogue",
        key: "TranslationKey"
    },
    TranslationValueMeta: {
        id: "FieldMeta",
        value: "FieldMeta",
        catalogue: "FieldMeta",
        key: "FieldMeta"
    },
    TranslationKey: {
        _meta: "TranslationKeyMeta",
        id: "UUID",
        identifier: "String",
        contentType: "TranslationContentType",
        note: "String",
        domain: "TranslationDomain",
        values: "TranslationValue",
        valuesByCatalogue: "TranslationValue",
        paginateValues: "TranslationValueConnection"
    },
    TranslationKeyMeta: {
        id: "FieldMeta",
        identifier: "FieldMeta",
        contentType: "FieldMeta",
        note: "FieldMeta",
        domain: "FieldMeta",
        values: "FieldMeta"
    },
    TranslationValueConnection: {
        pageInfo: "PageInfo",
        edges: "TranslationValueEdge"
    },
    TranslationValueEdge: {
        node: "TranslationValue"
    },
    TranslationKeyConnection: {
        pageInfo: "PageInfo",
        edges: "TranslationKeyEdge"
    },
    TranslationKeyEdge: {
        node: "TranslationKey"
    },
    TranslationDomainConnection: {
        pageInfo: "PageInfo",
        edges: "TranslationDomainEdge"
    },
    TranslationDomainEdge: {
        node: "TranslationDomain"
    },
    TranslationCataloguesIdentifierConnection: {
        pageInfo: "PageInfo",
        edges: "TranslationCataloguesIdentifierEdge"
    },
    TranslationCataloguesIdentifierEdge: {
        node: "TranslationCataloguesIdentifier"
    },
    EventConnection: {
        pageInfo: "PageInfo",
        edges: "EventEdge"
    },
    EventEdge: {
        node: "Event"
    },
    ArtworkConnection: {
        pageInfo: "PageInfo",
        edges: "ArtworkEdge"
    },
    ArtworkEdge: {
        node: "Artwork"
    },
    DropDownListConnection: {
        pageInfo: "PageInfo",
        edges: "DropDownListEdge"
    },
    DropDownListEdge: {
        node: "DropDownList"
    },
    ArtworkItem: {
        _meta: "ArtworkItemMeta",
        id: "UUID",
        order: "Int",
        list: "ArtworkList",
        artwork: "ArtworkLocale"
    },
    ArtworkItemMeta: {
        id: "FieldMeta",
        order: "FieldMeta",
        list: "FieldMeta",
        artwork: "FieldMeta"
    },
    ArtworkList: {
        _meta: "ArtworkListMeta",
        id: "UUID",
        items: "ArtworkItem",
        paginateItems: "ArtworkItemConnection"
    },
    ArtworkListMeta: {
        id: "FieldMeta",
        items: "FieldMeta"
    },
    ArtworkItemConnection: {
        pageInfo: "PageInfo",
        edges: "ArtworkItemEdge"
    },
    ArtworkItemEdge: {
        node: "ArtworkItem"
    },
    ArtworkListConnection: {
        pageInfo: "PageInfo",
        edges: "ArtworkListEdge"
    },
    ArtworkListEdge: {
        node: "ArtworkList"
    },
    ArtworkSelectionConnection: {
        pageInfo: "PageInfo",
        edges: "ArtworkSelectionEdge"
    },
    ArtworkSelectionEdge: {
        node: "ArtworkSelection"
    },
    ArtworkSelectionListConnection: {
        pageInfo: "PageInfo",
        edges: "ArtworkSelectionListEdge"
    },
    ArtworkSelectionListEdge: {
        node: "ArtworkSelectionList"
    },
    EventListConnection: {
        pageInfo: "PageInfo",
        edges: "EventListEdge"
    },
    EventListEdge: {
        node: "EventList"
    },
    BoxListConnection: {
        pageInfo: "PageInfo",
        edges: "BoxListEdge"
    },
    BoxListEdge: {
        node: "BoxList"
    },
    NewsletterFormConnection: {
        pageInfo: "PageInfo",
        edges: "NewsletterFormEdge"
    },
    NewsletterFormEdge: {
        node: "NewsletterForm"
    },
    ChartConnection: {
        pageInfo: "PageInfo",
        edges: "ChartEdge"
    },
    ChartEdge: {
        node: "Chart"
    },
    EmployeeConnection: {
        pageInfo: "PageInfo",
        edges: "EmployeeEdge"
    },
    EmployeeEdge: {
        node: "Employee"
    },
    EmployeeListConnection: {
        pageInfo: "PageInfo",
        edges: "EmployeeListEdge"
    },
    EmployeeListEdge: {
        node: "EmployeeList"
    },
    DefinitionListConnection: {
        pageInfo: "PageInfo",
        edges: "DefinitionListEdge"
    },
    DefinitionListEdge: {
        node: "DefinitionList"
    },
    LogoListConnection: {
        pageInfo: "PageInfo",
        edges: "LogoListEdge"
    },
    LogoListEdge: {
        node: "LogoList"
    },
    StrategySchemaConnection: {
        pageInfo: "PageInfo",
        edges: "StrategySchemaEdge"
    },
    StrategySchemaEdge: {
        node: "StrategySchema"
    },
    StrategySchemaGroupConnection: {
        pageInfo: "PageInfo",
        edges: "StrategySchemaGroupEdge"
    },
    StrategySchemaGroupEdge: {
        node: "StrategySchemaGroup"
    },
    RedirectConnection: {
        pageInfo: "PageInfo",
        edges: "RedirectEdge"
    },
    RedirectEdge: {
        node: "Redirect"
    },
    GalleryConnection: {
        pageInfo: "PageInfo",
        edges: "GalleryEdge"
    },
    GalleryEdge: {
        node: "Gallery"
    },
    ContactFormConnection: {
        pageInfo: "PageInfo",
        edges: "ContactFormEdge"
    },
    ContactFormEdge: {
        node: "ContactForm"
    },
    FileConnection: {
        pageInfo: "PageInfo",
        edges: "FileEdge"
    },
    FileEdge: {
        node: "File"
    },
    QueryTransaction: {
        getContactPage: "ContactPage",
        listContactPage: "ContactPage",
        paginateContactPage: "ContactPageConnection",
        validateCreateContactPage: "_ValidationResult",
        validateUpdateContactPage: "_ValidationResult",
        getContactPageLocale: "ContactPageLocale",
        listContactPageLocale: "ContactPageLocale",
        paginateContactPageLocale: "ContactPageLocaleConnection",
        validateCreateContactPageLocale: "_ValidationResult",
        validateUpdateContactPageLocale: "_ValidationResult",
        getContent: "Content",
        listContent: "Content",
        paginateContent: "ContentConnection",
        validateCreateContent: "_ValidationResult",
        validateUpdateContent: "_ValidationResult",
        getContentBlock: "ContentBlock",
        listContentBlock: "ContentBlock",
        paginateContentBlock: "ContentBlockConnection",
        validateCreateContentBlock: "_ValidationResult",
        validateUpdateContentBlock: "_ValidationResult",
        getContentReference: "ContentReference",
        listContentReference: "ContentReference",
        paginateContentReference: "ContentReferenceConnection",
        validateCreateContentReference: "_ValidationResult",
        validateUpdateContentReference: "_ValidationResult",
        getFooter: "Footer",
        listFooter: "Footer",
        paginateFooter: "FooterConnection",
        validateCreateFooter: "_ValidationResult",
        validateUpdateFooter: "_ValidationResult",
        getFooterLocale: "FooterLocale",
        listFooterLocale: "FooterLocale",
        paginateFooterLocale: "FooterLocaleConnection",
        validateCreateFooterLocale: "_ValidationResult",
        validateUpdateFooterLocale: "_ValidationResult",
        getHeader: "Header",
        listHeader: "Header",
        paginateHeader: "HeaderConnection",
        validateCreateHeader: "_ValidationResult",
        validateUpdateHeader: "_ValidationResult",
        getHeaderLink: "HeaderLink",
        listHeaderLink: "HeaderLink",
        paginateHeaderLink: "HeaderLinkConnection",
        validateCreateHeaderLink: "_ValidationResult",
        validateUpdateHeaderLink: "_ValidationResult",
        getHeaderLocale: "HeaderLocale",
        listHeaderLocale: "HeaderLocale",
        paginateHeaderLocale: "HeaderLocaleConnection",
        validateCreateHeaderLocale: "_ValidationResult",
        validateUpdateHeaderLocale: "_ValidationResult",
        getHomePage: "HomePage",
        listHomePage: "HomePage",
        paginateHomePage: "HomePageConnection",
        validateCreateHomePage: "_ValidationResult",
        validateUpdateHomePage: "_ValidationResult",
        getHomePageLocale: "HomePageLocale",
        listHomePageLocale: "HomePageLocale",
        paginateHomePageLocale: "HomePageLocaleConnection",
        validateCreateHomePageLocale: "_ValidationResult",
        validateUpdateHomePageLocale: "_ValidationResult",
        getLink: "Link",
        listLink: "Link",
        paginateLink: "LinkConnection",
        validateCreateLink: "_ValidationResult",
        validateUpdateLink: "_ValidationResult",
        getLinkable: "Linkable",
        listLinkable: "Linkable",
        paginateLinkable: "LinkableConnection",
        validateCreateLinkable: "_ValidationResult",
        validateUpdateLinkable: "_ValidationResult",
        getLocale: "Locale",
        listLocale: "Locale",
        paginateLocale: "LocaleConnection",
        validateCreateLocale: "_ValidationResult",
        validateUpdateLocale: "_ValidationResult",
        getMedium: "Medium",
        listMedium: "Medium",
        paginateMedium: "MediumConnection",
        validateCreateMedium: "_ValidationResult",
        validateUpdateMedium: "_ValidationResult",
        getMediumItem: "MediumItem",
        listMediumItem: "MediumItem",
        paginateMediumItem: "MediumItemConnection",
        validateCreateMediumItem: "_ValidationResult",
        validateUpdateMediumItem: "_ValidationResult",
        getMediumList: "MediumList",
        listMediumList: "MediumList",
        paginateMediumList: "MediumListConnection",
        validateCreateMediumList: "_ValidationResult",
        validateUpdateMediumList: "_ValidationResult",
        getPage: "Page",
        listPage: "Page",
        paginatePage: "PageConnection",
        validateCreatePage: "_ValidationResult",
        validateUpdatePage: "_ValidationResult",
        getPageLocale: "PageLocale",
        listPageLocale: "PageLocale",
        paginatePageLocale: "PageLocaleConnection",
        validateCreatePageLocale: "_ValidationResult",
        validateUpdatePageLocale: "_ValidationResult",
        getSeoDefault: "SeoDefault",
        listSeoDefault: "SeoDefault",
        paginateSeoDefault: "SeoDefaultConnection",
        validateCreateSeoDefault: "_ValidationResult",
        validateUpdateSeoDefault: "_ValidationResult",
        getSeoDefaultLocale: "SeoDefaultLocale",
        listSeoDefaultLocale: "SeoDefaultLocale",
        paginateSeoDefaultLocale: "SeoDefaultLocaleConnection",
        validateCreateSeoDefaultLocale: "_ValidationResult",
        validateUpdateSeoDefaultLocale: "_ValidationResult",
        getVideo: "Video",
        listVideo: "Video",
        paginateVideo: "VideoConnection",
        validateCreateVideo: "_ValidationResult",
        validateUpdateVideo: "_ValidationResult",
        getImage: "Image",
        listImage: "Image",
        paginateImage: "ImageConnection",
        validateCreateImage: "_ValidationResult",
        validateUpdateImage: "_ValidationResult",
        getSeo: "Seo",
        listSeo: "Seo",
        paginateSeo: "SeoConnection",
        validateCreateSeo: "_ValidationResult",
        validateUpdateSeo: "_ValidationResult",
        getTranslationDomain: "TranslationDomain",
        listTranslationDomain: "TranslationDomain",
        paginateTranslationDomain: "TranslationDomainConnection",
        validateCreateTranslationDomain: "_ValidationResult",
        validateUpdateTranslationDomain: "_ValidationResult",
        getTranslationCatalogue: "TranslationCatalogue",
        listTranslationCatalogue: "TranslationCatalogue",
        paginateTranslationCatalogue: "TranslationCatalogueConnection",
        validateCreateTranslationCatalogue: "_ValidationResult",
        validateUpdateTranslationCatalogue: "_ValidationResult",
        getTranslationCataloguesIdentifier: "TranslationCataloguesIdentifier",
        listTranslationCataloguesIdentifier: "TranslationCataloguesIdentifier",
        paginateTranslationCataloguesIdentifier: "TranslationCataloguesIdentifierConnection",
        validateCreateTranslationCataloguesIdentifier: "_ValidationResult",
        validateUpdateTranslationCataloguesIdentifier: "_ValidationResult",
        getTranslationKey: "TranslationKey",
        listTranslationKey: "TranslationKey",
        paginateTranslationKey: "TranslationKeyConnection",
        validateCreateTranslationKey: "_ValidationResult",
        validateUpdateTranslationKey: "_ValidationResult",
        getTranslationValue: "TranslationValue",
        listTranslationValue: "TranslationValue",
        paginateTranslationValue: "TranslationValueConnection",
        validateCreateTranslationValue: "_ValidationResult",
        validateUpdateTranslationValue: "_ValidationResult",
        getBranches: "Branches",
        listBranches: "Branches",
        paginateBranches: "BranchesConnection",
        validateCreateBranches: "_ValidationResult",
        validateUpdateBranches: "_ValidationResult",
        getGraphicDesigner: "GraphicDesigner",
        listGraphicDesigner: "GraphicDesigner",
        paginateGraphicDesigner: "GraphicDesignerConnection",
        validateCreateGraphicDesigner: "_ValidationResult",
        validateUpdateGraphicDesigner: "_ValidationResult",
        getEvent: "Event",
        listEvent: "Event",
        paginateEvent: "EventConnection",
        validateCreateEvent: "_ValidationResult",
        validateUpdateEvent: "_ValidationResult",
        getEventLocale: "EventLocale",
        listEventLocale: "EventLocale",
        paginateEventLocale: "EventLocaleConnection",
        validateCreateEventLocale: "_ValidationResult",
        validateUpdateEventLocale: "_ValidationResult",
        getArtwork: "Artwork",
        listArtwork: "Artwork",
        paginateArtwork: "ArtworkConnection",
        validateCreateArtwork: "_ValidationResult",
        validateUpdateArtwork: "_ValidationResult",
        getArtworkLocale: "ArtworkLocale",
        listArtworkLocale: "ArtworkLocale",
        paginateArtworkLocale: "ArtworkLocaleConnection",
        validateCreateArtworkLocale: "_ValidationResult",
        validateUpdateArtworkLocale: "_ValidationResult",
        getDropDownItem: "DropDownItem",
        listDropDownItem: "DropDownItem",
        paginateDropDownItem: "DropDownItemConnection",
        validateCreateDropDownItem: "_ValidationResult",
        validateUpdateDropDownItem: "_ValidationResult",
        getDropDownList: "DropDownList",
        listDropDownList: "DropDownList",
        paginateDropDownList: "DropDownListConnection",
        validateCreateDropDownList: "_ValidationResult",
        validateUpdateDropDownList: "_ValidationResult",
        getArtworkItem: "ArtworkItem",
        listArtworkItem: "ArtworkItem",
        paginateArtworkItem: "ArtworkItemConnection",
        validateCreateArtworkItem: "_ValidationResult",
        validateUpdateArtworkItem: "_ValidationResult",
        getArtworkList: "ArtworkList",
        listArtworkList: "ArtworkList",
        paginateArtworkList: "ArtworkListConnection",
        validateCreateArtworkList: "_ValidationResult",
        validateUpdateArtworkList: "_ValidationResult",
        getArtworkSelection: "ArtworkSelection",
        listArtworkSelection: "ArtworkSelection",
        paginateArtworkSelection: "ArtworkSelectionConnection",
        validateCreateArtworkSelection: "_ValidationResult",
        validateUpdateArtworkSelection: "_ValidationResult",
        getArtworkSelectionItem: "ArtworkSelectionItem",
        listArtworkSelectionItem: "ArtworkSelectionItem",
        paginateArtworkSelectionItem: "ArtworkSelectionItemConnection",
        validateCreateArtworkSelectionItem: "_ValidationResult",
        validateUpdateArtworkSelectionItem: "_ValidationResult",
        getArtworkSelectionList: "ArtworkSelectionList",
        listArtworkSelectionList: "ArtworkSelectionList",
        paginateArtworkSelectionList: "ArtworkSelectionListConnection",
        validateCreateArtworkSelectionList: "_ValidationResult",
        validateUpdateArtworkSelectionList: "_ValidationResult",
        getArtworkSelectionLocale: "ArtworkSelectionLocale",
        listArtworkSelectionLocale: "ArtworkSelectionLocale",
        paginateArtworkSelectionLocale: "ArtworkSelectionLocaleConnection",
        validateCreateArtworkSelectionLocale: "_ValidationResult",
        validateUpdateArtworkSelectionLocale: "_ValidationResult",
        getEventItem: "EventItem",
        listEventItem: "EventItem",
        paginateEventItem: "EventItemConnection",
        validateCreateEventItem: "_ValidationResult",
        validateUpdateEventItem: "_ValidationResult",
        getEventList: "EventList",
        listEventList: "EventList",
        paginateEventList: "EventListConnection",
        validateCreateEventList: "_ValidationResult",
        validateUpdateEventList: "_ValidationResult",
        getBoxItem: "BoxItem",
        listBoxItem: "BoxItem",
        paginateBoxItem: "BoxItemConnection",
        validateCreateBoxItem: "_ValidationResult",
        validateUpdateBoxItem: "_ValidationResult",
        getBoxList: "BoxList",
        listBoxList: "BoxList",
        paginateBoxList: "BoxListConnection",
        validateCreateBoxList: "_ValidationResult",
        validateUpdateBoxList: "_ValidationResult",
        getNewsletterForm: "NewsletterForm",
        listNewsletterForm: "NewsletterForm",
        paginateNewsletterForm: "NewsletterFormConnection",
        validateCreateNewsletterForm: "_ValidationResult",
        validateUpdateNewsletterForm: "_ValidationResult",
        getNewsletterTypeItem: "NewsletterTypeItem",
        listNewsletterTypeItem: "NewsletterTypeItem",
        paginateNewsletterTypeItem: "NewsletterTypeItemConnection",
        validateCreateNewsletterTypeItem: "_ValidationResult",
        validateUpdateNewsletterTypeItem: "_ValidationResult",
        getNewsletterFormLocale: "NewsletterFormLocale",
        listNewsletterFormLocale: "NewsletterFormLocale",
        paginateNewsletterFormLocale: "NewsletterFormLocaleConnection",
        validateCreateNewsletterFormLocale: "_ValidationResult",
        validateUpdateNewsletterFormLocale: "_ValidationResult",
        getNewsletterSubscription: "NewsletterSubscription",
        listNewsletterSubscription: "NewsletterSubscription",
        paginateNewsletterSubscription: "NewsletterSubscriptionConnection",
        validateCreateNewsletterSubscription: "_ValidationResult",
        validateUpdateNewsletterSubscription: "_ValidationResult",
        getChart: "Chart",
        listChart: "Chart",
        paginateChart: "ChartConnection",
        validateCreateChart: "_ValidationResult",
        validateUpdateChart: "_ValidationResult",
        getChartData: "ChartData",
        listChartData: "ChartData",
        paginateChartData: "ChartDataConnection",
        validateCreateChartData: "_ValidationResult",
        validateUpdateChartData: "_ValidationResult",
        getEmployee: "Employee",
        listEmployee: "Employee",
        paginateEmployee: "EmployeeConnection",
        validateCreateEmployee: "_ValidationResult",
        validateUpdateEmployee: "_ValidationResult",
        getEmployeeItem: "EmployeeItem",
        listEmployeeItem: "EmployeeItem",
        paginateEmployeeItem: "EmployeeItemConnection",
        validateCreateEmployeeItem: "_ValidationResult",
        validateUpdateEmployeeItem: "_ValidationResult",
        getEmployeeList: "EmployeeList",
        listEmployeeList: "EmployeeList",
        paginateEmployeeList: "EmployeeListConnection",
        validateCreateEmployeeList: "_ValidationResult",
        validateUpdateEmployeeList: "_ValidationResult",
        getEmployeeLocale: "EmployeeLocale",
        listEmployeeLocale: "EmployeeLocale",
        paginateEmployeeLocale: "EmployeeLocaleConnection",
        validateCreateEmployeeLocale: "_ValidationResult",
        validateUpdateEmployeeLocale: "_ValidationResult",
        getPhotographer: "Photographer",
        listPhotographer: "Photographer",
        paginatePhotographer: "PhotographerConnection",
        validateCreatePhotographer: "_ValidationResult",
        validateUpdatePhotographer: "_ValidationResult",
        getDefinitionItem: "DefinitionItem",
        listDefinitionItem: "DefinitionItem",
        paginateDefinitionItem: "DefinitionItemConnection",
        validateCreateDefinitionItem: "_ValidationResult",
        validateUpdateDefinitionItem: "_ValidationResult",
        getDefinitionList: "DefinitionList",
        listDefinitionList: "DefinitionList",
        paginateDefinitionList: "DefinitionListConnection",
        validateCreateDefinitionList: "_ValidationResult",
        validateUpdateDefinitionList: "_ValidationResult",
        getLogoItem: "LogoItem",
        listLogoItem: "LogoItem",
        paginateLogoItem: "LogoItemConnection",
        validateCreateLogoItem: "_ValidationResult",
        validateUpdateLogoItem: "_ValidationResult",
        getLogoList: "LogoList",
        listLogoList: "LogoList",
        paginateLogoList: "LogoListConnection",
        validateCreateLogoList: "_ValidationResult",
        validateUpdateLogoList: "_ValidationResult",
        getStrategySchema: "StrategySchema",
        listStrategySchema: "StrategySchema",
        paginateStrategySchema: "StrategySchemaConnection",
        validateCreateStrategySchema: "_ValidationResult",
        validateUpdateStrategySchema: "_ValidationResult",
        getStrategySchemaGroup: "StrategySchemaGroup",
        listStrategySchemaGroup: "StrategySchemaGroup",
        paginateStrategySchemaGroup: "StrategySchemaGroupConnection",
        validateCreateStrategySchemaGroup: "_ValidationResult",
        validateUpdateStrategySchemaGroup: "_ValidationResult",
        getStrategySchemaGroupItem: "StrategySchemaGroupItem",
        listStrategySchemaGroupItem: "StrategySchemaGroupItem",
        paginateStrategySchemaGroupItem: "StrategySchemaGroupItemConnection",
        validateCreateStrategySchemaGroupItem: "_ValidationResult",
        validateUpdateStrategySchemaGroupItem: "_ValidationResult",
        getRedirect: "Redirect",
        listRedirect: "Redirect",
        paginateRedirect: "RedirectConnection",
        validateCreateRedirect: "_ValidationResult",
        validateUpdateRedirect: "_ValidationResult",
        getGallery: "Gallery",
        listGallery: "Gallery",
        paginateGallery: "GalleryConnection",
        validateCreateGallery: "_ValidationResult",
        validateUpdateGallery: "_ValidationResult",
        getGalleryItem: "GalleryItem",
        listGalleryItem: "GalleryItem",
        paginateGalleryItem: "GalleryItemConnection",
        validateCreateGalleryItem: "_ValidationResult",
        validateUpdateGalleryItem: "_ValidationResult",
        getContactForm: "ContactForm",
        listContactForm: "ContactForm",
        paginateContactForm: "ContactFormConnection",
        validateCreateContactForm: "_ValidationResult",
        validateUpdateContactForm: "_ValidationResult",
        getContactFormLocale: "ContactFormLocale",
        listContactFormLocale: "ContactFormLocale",
        paginateContactFormLocale: "ContactFormLocaleConnection",
        validateCreateContactFormLocale: "_ValidationResult",
        validateUpdateContactFormLocale: "_ValidationResult",
        getContactSubscription: "ContactSubscription",
        listContactSubscription: "ContactSubscription",
        paginateContactSubscription: "ContactSubscriptionConnection",
        validateCreateContactSubscription: "_ValidationResult",
        validateUpdateContactSubscription: "_ValidationResult",
        getContactTypeItem: "ContactTypeItem",
        listContactTypeItem: "ContactTypeItem",
        paginateContactTypeItem: "ContactTypeItemConnection",
        validateCreateContactTypeItem: "_ValidationResult",
        validateUpdateContactTypeItem: "_ValidationResult",
        getFile: "File",
        listFile: "File",
        paginateFile: "FileConnection",
        validateCreateFile: "_ValidationResult",
        validateUpdateFile: "_ValidationResult"
    },
    Info: {
        description: "String"
    },
    Mutation: {
        createContactPage: "ContactPageCreateResult",
        deleteContactPage: "ContactPageDeleteResult",
        updateContactPage: "ContactPageUpdateResult",
        upsertContactPage: "ContactPageUpsertResult",
        createContactPageLocale: "ContactPageLocaleCreateResult",
        deleteContactPageLocale: "ContactPageLocaleDeleteResult",
        updateContactPageLocale: "ContactPageLocaleUpdateResult",
        upsertContactPageLocale: "ContactPageLocaleUpsertResult",
        createContent: "ContentCreateResult",
        deleteContent: "ContentDeleteResult",
        updateContent: "ContentUpdateResult",
        upsertContent: "ContentUpsertResult",
        createContentBlock: "ContentBlockCreateResult",
        deleteContentBlock: "ContentBlockDeleteResult",
        updateContentBlock: "ContentBlockUpdateResult",
        upsertContentBlock: "ContentBlockUpsertResult",
        createContentReference: "ContentReferenceCreateResult",
        deleteContentReference: "ContentReferenceDeleteResult",
        updateContentReference: "ContentReferenceUpdateResult",
        upsertContentReference: "ContentReferenceUpsertResult",
        createFooter: "FooterCreateResult",
        deleteFooter: "FooterDeleteResult",
        updateFooter: "FooterUpdateResult",
        upsertFooter: "FooterUpsertResult",
        createFooterLocale: "FooterLocaleCreateResult",
        deleteFooterLocale: "FooterLocaleDeleteResult",
        updateFooterLocale: "FooterLocaleUpdateResult",
        upsertFooterLocale: "FooterLocaleUpsertResult",
        createHeader: "HeaderCreateResult",
        deleteHeader: "HeaderDeleteResult",
        updateHeader: "HeaderUpdateResult",
        upsertHeader: "HeaderUpsertResult",
        createHeaderLink: "HeaderLinkCreateResult",
        deleteHeaderLink: "HeaderLinkDeleteResult",
        updateHeaderLink: "HeaderLinkUpdateResult",
        upsertHeaderLink: "HeaderLinkUpsertResult",
        createHeaderLocale: "HeaderLocaleCreateResult",
        deleteHeaderLocale: "HeaderLocaleDeleteResult",
        updateHeaderLocale: "HeaderLocaleUpdateResult",
        upsertHeaderLocale: "HeaderLocaleUpsertResult",
        createHomePage: "HomePageCreateResult",
        deleteHomePage: "HomePageDeleteResult",
        updateHomePage: "HomePageUpdateResult",
        upsertHomePage: "HomePageUpsertResult",
        createHomePageLocale: "HomePageLocaleCreateResult",
        deleteHomePageLocale: "HomePageLocaleDeleteResult",
        updateHomePageLocale: "HomePageLocaleUpdateResult",
        upsertHomePageLocale: "HomePageLocaleUpsertResult",
        createLink: "LinkCreateResult",
        deleteLink: "LinkDeleteResult",
        updateLink: "LinkUpdateResult",
        upsertLink: "LinkUpsertResult",
        createLinkable: "LinkableCreateResult",
        deleteLinkable: "LinkableDeleteResult",
        updateLinkable: "LinkableUpdateResult",
        upsertLinkable: "LinkableUpsertResult",
        createLocale: "LocaleCreateResult",
        deleteLocale: "LocaleDeleteResult",
        updateLocale: "LocaleUpdateResult",
        upsertLocale: "LocaleUpsertResult",
        createMedium: "MediumCreateResult",
        deleteMedium: "MediumDeleteResult",
        updateMedium: "MediumUpdateResult",
        upsertMedium: "MediumUpsertResult",
        createMediumItem: "MediumItemCreateResult",
        deleteMediumItem: "MediumItemDeleteResult",
        updateMediumItem: "MediumItemUpdateResult",
        upsertMediumItem: "MediumItemUpsertResult",
        createMediumList: "MediumListCreateResult",
        deleteMediumList: "MediumListDeleteResult",
        updateMediumList: "MediumListUpdateResult",
        upsertMediumList: "MediumListUpsertResult",
        createPage: "PageCreateResult",
        deletePage: "PageDeleteResult",
        updatePage: "PageUpdateResult",
        upsertPage: "PageUpsertResult",
        createPageLocale: "PageLocaleCreateResult",
        deletePageLocale: "PageLocaleDeleteResult",
        updatePageLocale: "PageLocaleUpdateResult",
        upsertPageLocale: "PageLocaleUpsertResult",
        createSeoDefault: "SeoDefaultCreateResult",
        deleteSeoDefault: "SeoDefaultDeleteResult",
        updateSeoDefault: "SeoDefaultUpdateResult",
        upsertSeoDefault: "SeoDefaultUpsertResult",
        createSeoDefaultLocale: "SeoDefaultLocaleCreateResult",
        deleteSeoDefaultLocale: "SeoDefaultLocaleDeleteResult",
        updateSeoDefaultLocale: "SeoDefaultLocaleUpdateResult",
        upsertSeoDefaultLocale: "SeoDefaultLocaleUpsertResult",
        createVideo: "VideoCreateResult",
        deleteVideo: "VideoDeleteResult",
        updateVideo: "VideoUpdateResult",
        upsertVideo: "VideoUpsertResult",
        createImage: "ImageCreateResult",
        deleteImage: "ImageDeleteResult",
        updateImage: "ImageUpdateResult",
        upsertImage: "ImageUpsertResult",
        createSeo: "SeoCreateResult",
        deleteSeo: "SeoDeleteResult",
        updateSeo: "SeoUpdateResult",
        upsertSeo: "SeoUpsertResult",
        createTranslationDomain: "TranslationDomainCreateResult",
        deleteTranslationDomain: "TranslationDomainDeleteResult",
        updateTranslationDomain: "TranslationDomainUpdateResult",
        upsertTranslationDomain: "TranslationDomainUpsertResult",
        createTranslationCatalogue: "TranslationCatalogueCreateResult",
        deleteTranslationCatalogue: "TranslationCatalogueDeleteResult",
        updateTranslationCatalogue: "TranslationCatalogueUpdateResult",
        upsertTranslationCatalogue: "TranslationCatalogueUpsertResult",
        createTranslationCataloguesIdentifier: "TranslationCataloguesIdentifierCreateResult",
        deleteTranslationCataloguesIdentifier: "TranslationCataloguesIdentifierDeleteResult",
        updateTranslationCataloguesIdentifier: "TranslationCataloguesIdentifierUpdateResult",
        upsertTranslationCataloguesIdentifier: "TranslationCataloguesIdentifierUpsertResult",
        createTranslationKey: "TranslationKeyCreateResult",
        deleteTranslationKey: "TranslationKeyDeleteResult",
        updateTranslationKey: "TranslationKeyUpdateResult",
        upsertTranslationKey: "TranslationKeyUpsertResult",
        createTranslationValue: "TranslationValueCreateResult",
        deleteTranslationValue: "TranslationValueDeleteResult",
        updateTranslationValue: "TranslationValueUpdateResult",
        upsertTranslationValue: "TranslationValueUpsertResult",
        createBranches: "BranchesCreateResult",
        deleteBranches: "BranchesDeleteResult",
        updateBranches: "BranchesUpdateResult",
        upsertBranches: "BranchesUpsertResult",
        createGraphicDesigner: "GraphicDesignerCreateResult",
        deleteGraphicDesigner: "GraphicDesignerDeleteResult",
        updateGraphicDesigner: "GraphicDesignerUpdateResult",
        upsertGraphicDesigner: "GraphicDesignerUpsertResult",
        createEvent: "EventCreateResult",
        deleteEvent: "EventDeleteResult",
        updateEvent: "EventUpdateResult",
        upsertEvent: "EventUpsertResult",
        createEventLocale: "EventLocaleCreateResult",
        deleteEventLocale: "EventLocaleDeleteResult",
        updateEventLocale: "EventLocaleUpdateResult",
        upsertEventLocale: "EventLocaleUpsertResult",
        createArtwork: "ArtworkCreateResult",
        deleteArtwork: "ArtworkDeleteResult",
        updateArtwork: "ArtworkUpdateResult",
        upsertArtwork: "ArtworkUpsertResult",
        createArtworkLocale: "ArtworkLocaleCreateResult",
        deleteArtworkLocale: "ArtworkLocaleDeleteResult",
        updateArtworkLocale: "ArtworkLocaleUpdateResult",
        upsertArtworkLocale: "ArtworkLocaleUpsertResult",
        createDropDownItem: "DropDownItemCreateResult",
        deleteDropDownItem: "DropDownItemDeleteResult",
        updateDropDownItem: "DropDownItemUpdateResult",
        upsertDropDownItem: "DropDownItemUpsertResult",
        createDropDownList: "DropDownListCreateResult",
        deleteDropDownList: "DropDownListDeleteResult",
        updateDropDownList: "DropDownListUpdateResult",
        upsertDropDownList: "DropDownListUpsertResult",
        createArtworkItem: "ArtworkItemCreateResult",
        deleteArtworkItem: "ArtworkItemDeleteResult",
        updateArtworkItem: "ArtworkItemUpdateResult",
        upsertArtworkItem: "ArtworkItemUpsertResult",
        createArtworkList: "ArtworkListCreateResult",
        deleteArtworkList: "ArtworkListDeleteResult",
        updateArtworkList: "ArtworkListUpdateResult",
        upsertArtworkList: "ArtworkListUpsertResult",
        createArtworkSelection: "ArtworkSelectionCreateResult",
        deleteArtworkSelection: "ArtworkSelectionDeleteResult",
        updateArtworkSelection: "ArtworkSelectionUpdateResult",
        upsertArtworkSelection: "ArtworkSelectionUpsertResult",
        createArtworkSelectionItem: "ArtworkSelectionItemCreateResult",
        deleteArtworkSelectionItem: "ArtworkSelectionItemDeleteResult",
        updateArtworkSelectionItem: "ArtworkSelectionItemUpdateResult",
        upsertArtworkSelectionItem: "ArtworkSelectionItemUpsertResult",
        createArtworkSelectionList: "ArtworkSelectionListCreateResult",
        deleteArtworkSelectionList: "ArtworkSelectionListDeleteResult",
        updateArtworkSelectionList: "ArtworkSelectionListUpdateResult",
        upsertArtworkSelectionList: "ArtworkSelectionListUpsertResult",
        createArtworkSelectionLocale: "ArtworkSelectionLocaleCreateResult",
        deleteArtworkSelectionLocale: "ArtworkSelectionLocaleDeleteResult",
        updateArtworkSelectionLocale: "ArtworkSelectionLocaleUpdateResult",
        upsertArtworkSelectionLocale: "ArtworkSelectionLocaleUpsertResult",
        createEventItem: "EventItemCreateResult",
        deleteEventItem: "EventItemDeleteResult",
        updateEventItem: "EventItemUpdateResult",
        upsertEventItem: "EventItemUpsertResult",
        createEventList: "EventListCreateResult",
        deleteEventList: "EventListDeleteResult",
        updateEventList: "EventListUpdateResult",
        upsertEventList: "EventListUpsertResult",
        createBoxItem: "BoxItemCreateResult",
        deleteBoxItem: "BoxItemDeleteResult",
        updateBoxItem: "BoxItemUpdateResult",
        upsertBoxItem: "BoxItemUpsertResult",
        createBoxList: "BoxListCreateResult",
        deleteBoxList: "BoxListDeleteResult",
        updateBoxList: "BoxListUpdateResult",
        upsertBoxList: "BoxListUpsertResult",
        createNewsletterForm: "NewsletterFormCreateResult",
        deleteNewsletterForm: "NewsletterFormDeleteResult",
        updateNewsletterForm: "NewsletterFormUpdateResult",
        upsertNewsletterForm: "NewsletterFormUpsertResult",
        createNewsletterTypeItem: "NewsletterTypeItemCreateResult",
        deleteNewsletterTypeItem: "NewsletterTypeItemDeleteResult",
        updateNewsletterTypeItem: "NewsletterTypeItemUpdateResult",
        upsertNewsletterTypeItem: "NewsletterTypeItemUpsertResult",
        createNewsletterFormLocale: "NewsletterFormLocaleCreateResult",
        deleteNewsletterFormLocale: "NewsletterFormLocaleDeleteResult",
        updateNewsletterFormLocale: "NewsletterFormLocaleUpdateResult",
        upsertNewsletterFormLocale: "NewsletterFormLocaleUpsertResult",
        createNewsletterSubscription: "NewsletterSubscriptionCreateResult",
        deleteNewsletterSubscription: "NewsletterSubscriptionDeleteResult",
        updateNewsletterSubscription: "NewsletterSubscriptionUpdateResult",
        upsertNewsletterSubscription: "NewsletterSubscriptionUpsertResult",
        createChart: "ChartCreateResult",
        deleteChart: "ChartDeleteResult",
        updateChart: "ChartUpdateResult",
        upsertChart: "ChartUpsertResult",
        createChartData: "ChartDataCreateResult",
        deleteChartData: "ChartDataDeleteResult",
        updateChartData: "ChartDataUpdateResult",
        upsertChartData: "ChartDataUpsertResult",
        createEmployee: "EmployeeCreateResult",
        deleteEmployee: "EmployeeDeleteResult",
        updateEmployee: "EmployeeUpdateResult",
        upsertEmployee: "EmployeeUpsertResult",
        createEmployeeItem: "EmployeeItemCreateResult",
        deleteEmployeeItem: "EmployeeItemDeleteResult",
        updateEmployeeItem: "EmployeeItemUpdateResult",
        upsertEmployeeItem: "EmployeeItemUpsertResult",
        createEmployeeList: "EmployeeListCreateResult",
        deleteEmployeeList: "EmployeeListDeleteResult",
        updateEmployeeList: "EmployeeListUpdateResult",
        upsertEmployeeList: "EmployeeListUpsertResult",
        createEmployeeLocale: "EmployeeLocaleCreateResult",
        deleteEmployeeLocale: "EmployeeLocaleDeleteResult",
        updateEmployeeLocale: "EmployeeLocaleUpdateResult",
        upsertEmployeeLocale: "EmployeeLocaleUpsertResult",
        createPhotographer: "PhotographerCreateResult",
        deletePhotographer: "PhotographerDeleteResult",
        updatePhotographer: "PhotographerUpdateResult",
        upsertPhotographer: "PhotographerUpsertResult",
        createDefinitionItem: "DefinitionItemCreateResult",
        deleteDefinitionItem: "DefinitionItemDeleteResult",
        updateDefinitionItem: "DefinitionItemUpdateResult",
        upsertDefinitionItem: "DefinitionItemUpsertResult",
        createDefinitionList: "DefinitionListCreateResult",
        deleteDefinitionList: "DefinitionListDeleteResult",
        updateDefinitionList: "DefinitionListUpdateResult",
        upsertDefinitionList: "DefinitionListUpsertResult",
        createLogoItem: "LogoItemCreateResult",
        deleteLogoItem: "LogoItemDeleteResult",
        updateLogoItem: "LogoItemUpdateResult",
        upsertLogoItem: "LogoItemUpsertResult",
        createLogoList: "LogoListCreateResult",
        deleteLogoList: "LogoListDeleteResult",
        updateLogoList: "LogoListUpdateResult",
        upsertLogoList: "LogoListUpsertResult",
        createStrategySchema: "StrategySchemaCreateResult",
        deleteStrategySchema: "StrategySchemaDeleteResult",
        updateStrategySchema: "StrategySchemaUpdateResult",
        upsertStrategySchema: "StrategySchemaUpsertResult",
        createStrategySchemaGroup: "StrategySchemaGroupCreateResult",
        deleteStrategySchemaGroup: "StrategySchemaGroupDeleteResult",
        updateStrategySchemaGroup: "StrategySchemaGroupUpdateResult",
        upsertStrategySchemaGroup: "StrategySchemaGroupUpsertResult",
        createStrategySchemaGroupItem: "StrategySchemaGroupItemCreateResult",
        deleteStrategySchemaGroupItem: "StrategySchemaGroupItemDeleteResult",
        updateStrategySchemaGroupItem: "StrategySchemaGroupItemUpdateResult",
        upsertStrategySchemaGroupItem: "StrategySchemaGroupItemUpsertResult",
        createRedirect: "RedirectCreateResult",
        deleteRedirect: "RedirectDeleteResult",
        updateRedirect: "RedirectUpdateResult",
        upsertRedirect: "RedirectUpsertResult",
        createGallery: "GalleryCreateResult",
        deleteGallery: "GalleryDeleteResult",
        updateGallery: "GalleryUpdateResult",
        upsertGallery: "GalleryUpsertResult",
        createGalleryItem: "GalleryItemCreateResult",
        deleteGalleryItem: "GalleryItemDeleteResult",
        updateGalleryItem: "GalleryItemUpdateResult",
        upsertGalleryItem: "GalleryItemUpsertResult",
        createContactForm: "ContactFormCreateResult",
        deleteContactForm: "ContactFormDeleteResult",
        updateContactForm: "ContactFormUpdateResult",
        upsertContactForm: "ContactFormUpsertResult",
        createContactFormLocale: "ContactFormLocaleCreateResult",
        deleteContactFormLocale: "ContactFormLocaleDeleteResult",
        updateContactFormLocale: "ContactFormLocaleUpdateResult",
        upsertContactFormLocale: "ContactFormLocaleUpsertResult",
        createContactSubscription: "ContactSubscriptionCreateResult",
        deleteContactSubscription: "ContactSubscriptionDeleteResult",
        updateContactSubscription: "ContactSubscriptionUpdateResult",
        upsertContactSubscription: "ContactSubscriptionUpsertResult",
        createContactTypeItem: "ContactTypeItemCreateResult",
        deleteContactTypeItem: "ContactTypeItemDeleteResult",
        updateContactTypeItem: "ContactTypeItemUpdateResult",
        upsertContactTypeItem: "ContactTypeItemUpsertResult",
        createFile: "FileCreateResult",
        deleteFile: "FileDeleteResult",
        updateFile: "FileUpdateResult",
        upsertFile: "FileUpsertResult",
        transaction: "MutationTransaction",
        query: "Query",
        generateUploadUrl: "S3SignedUpload",
        generateReadUrl: "S3SignedRead"
    },
    ContactPageCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactPage",
        validation: "_ValidationResult"
    },
    MutationResult: {
        "...on ContactPageCreateResult": "ContactPageCreateResult",
        "...on ContactPageDeleteResult": "ContactPageDeleteResult",
        "...on ContactPageUpdateResult": "ContactPageUpdateResult",
        "...on ContactPageUpsertResult": "ContactPageUpsertResult",
        "...on ContactPageLocaleCreateResult": "ContactPageLocaleCreateResult",
        "...on ContactPageLocaleDeleteResult": "ContactPageLocaleDeleteResult",
        "...on ContactPageLocaleUpdateResult": "ContactPageLocaleUpdateResult",
        "...on ContactPageLocaleUpsertResult": "ContactPageLocaleUpsertResult",
        "...on ContentCreateResult": "ContentCreateResult",
        "...on ContentDeleteResult": "ContentDeleteResult",
        "...on ContentUpdateResult": "ContentUpdateResult",
        "...on ContentUpsertResult": "ContentUpsertResult",
        "...on ContentBlockCreateResult": "ContentBlockCreateResult",
        "...on ContentBlockDeleteResult": "ContentBlockDeleteResult",
        "...on ContentBlockUpdateResult": "ContentBlockUpdateResult",
        "...on ContentBlockUpsertResult": "ContentBlockUpsertResult",
        "...on ContentReferenceCreateResult": "ContentReferenceCreateResult",
        "...on ContentReferenceDeleteResult": "ContentReferenceDeleteResult",
        "...on ContentReferenceUpdateResult": "ContentReferenceUpdateResult",
        "...on ContentReferenceUpsertResult": "ContentReferenceUpsertResult",
        "...on FooterCreateResult": "FooterCreateResult",
        "...on FooterDeleteResult": "FooterDeleteResult",
        "...on FooterUpdateResult": "FooterUpdateResult",
        "...on FooterUpsertResult": "FooterUpsertResult",
        "...on FooterLocaleCreateResult": "FooterLocaleCreateResult",
        "...on FooterLocaleDeleteResult": "FooterLocaleDeleteResult",
        "...on FooterLocaleUpdateResult": "FooterLocaleUpdateResult",
        "...on FooterLocaleUpsertResult": "FooterLocaleUpsertResult",
        "...on HeaderCreateResult": "HeaderCreateResult",
        "...on HeaderDeleteResult": "HeaderDeleteResult",
        "...on HeaderUpdateResult": "HeaderUpdateResult",
        "...on HeaderUpsertResult": "HeaderUpsertResult",
        "...on HeaderLinkCreateResult": "HeaderLinkCreateResult",
        "...on HeaderLinkDeleteResult": "HeaderLinkDeleteResult",
        "...on HeaderLinkUpdateResult": "HeaderLinkUpdateResult",
        "...on HeaderLinkUpsertResult": "HeaderLinkUpsertResult",
        "...on HeaderLocaleCreateResult": "HeaderLocaleCreateResult",
        "...on HeaderLocaleDeleteResult": "HeaderLocaleDeleteResult",
        "...on HeaderLocaleUpdateResult": "HeaderLocaleUpdateResult",
        "...on HeaderLocaleUpsertResult": "HeaderLocaleUpsertResult",
        "...on HomePageCreateResult": "HomePageCreateResult",
        "...on HomePageDeleteResult": "HomePageDeleteResult",
        "...on HomePageUpdateResult": "HomePageUpdateResult",
        "...on HomePageUpsertResult": "HomePageUpsertResult",
        "...on HomePageLocaleCreateResult": "HomePageLocaleCreateResult",
        "...on HomePageLocaleDeleteResult": "HomePageLocaleDeleteResult",
        "...on HomePageLocaleUpdateResult": "HomePageLocaleUpdateResult",
        "...on HomePageLocaleUpsertResult": "HomePageLocaleUpsertResult",
        "...on LinkCreateResult": "LinkCreateResult",
        "...on LinkDeleteResult": "LinkDeleteResult",
        "...on LinkUpdateResult": "LinkUpdateResult",
        "...on LinkUpsertResult": "LinkUpsertResult",
        "...on LinkableCreateResult": "LinkableCreateResult",
        "...on LinkableDeleteResult": "LinkableDeleteResult",
        "...on LinkableUpdateResult": "LinkableUpdateResult",
        "...on LinkableUpsertResult": "LinkableUpsertResult",
        "...on LocaleCreateResult": "LocaleCreateResult",
        "...on LocaleDeleteResult": "LocaleDeleteResult",
        "...on LocaleUpdateResult": "LocaleUpdateResult",
        "...on LocaleUpsertResult": "LocaleUpsertResult",
        "...on MediumCreateResult": "MediumCreateResult",
        "...on MediumDeleteResult": "MediumDeleteResult",
        "...on MediumUpdateResult": "MediumUpdateResult",
        "...on MediumUpsertResult": "MediumUpsertResult",
        "...on MediumItemCreateResult": "MediumItemCreateResult",
        "...on MediumItemDeleteResult": "MediumItemDeleteResult",
        "...on MediumItemUpdateResult": "MediumItemUpdateResult",
        "...on MediumItemUpsertResult": "MediumItemUpsertResult",
        "...on MediumListCreateResult": "MediumListCreateResult",
        "...on MediumListDeleteResult": "MediumListDeleteResult",
        "...on MediumListUpdateResult": "MediumListUpdateResult",
        "...on MediumListUpsertResult": "MediumListUpsertResult",
        "...on PageCreateResult": "PageCreateResult",
        "...on PageDeleteResult": "PageDeleteResult",
        "...on PageUpdateResult": "PageUpdateResult",
        "...on PageUpsertResult": "PageUpsertResult",
        "...on PageLocaleCreateResult": "PageLocaleCreateResult",
        "...on PageLocaleDeleteResult": "PageLocaleDeleteResult",
        "...on PageLocaleUpdateResult": "PageLocaleUpdateResult",
        "...on PageLocaleUpsertResult": "PageLocaleUpsertResult",
        "...on SeoDefaultCreateResult": "SeoDefaultCreateResult",
        "...on SeoDefaultDeleteResult": "SeoDefaultDeleteResult",
        "...on SeoDefaultUpdateResult": "SeoDefaultUpdateResult",
        "...on SeoDefaultUpsertResult": "SeoDefaultUpsertResult",
        "...on SeoDefaultLocaleCreateResult": "SeoDefaultLocaleCreateResult",
        "...on SeoDefaultLocaleDeleteResult": "SeoDefaultLocaleDeleteResult",
        "...on SeoDefaultLocaleUpdateResult": "SeoDefaultLocaleUpdateResult",
        "...on SeoDefaultLocaleUpsertResult": "SeoDefaultLocaleUpsertResult",
        "...on VideoCreateResult": "VideoCreateResult",
        "...on VideoDeleteResult": "VideoDeleteResult",
        "...on VideoUpdateResult": "VideoUpdateResult",
        "...on VideoUpsertResult": "VideoUpsertResult",
        "...on ImageCreateResult": "ImageCreateResult",
        "...on ImageDeleteResult": "ImageDeleteResult",
        "...on ImageUpdateResult": "ImageUpdateResult",
        "...on ImageUpsertResult": "ImageUpsertResult",
        "...on SeoCreateResult": "SeoCreateResult",
        "...on SeoDeleteResult": "SeoDeleteResult",
        "...on SeoUpdateResult": "SeoUpdateResult",
        "...on SeoUpsertResult": "SeoUpsertResult",
        "...on TranslationDomainCreateResult": "TranslationDomainCreateResult",
        "...on TranslationDomainDeleteResult": "TranslationDomainDeleteResult",
        "...on TranslationDomainUpdateResult": "TranslationDomainUpdateResult",
        "...on TranslationDomainUpsertResult": "TranslationDomainUpsertResult",
        "...on TranslationCatalogueCreateResult": "TranslationCatalogueCreateResult",
        "...on TranslationCatalogueDeleteResult": "TranslationCatalogueDeleteResult",
        "...on TranslationCatalogueUpdateResult": "TranslationCatalogueUpdateResult",
        "...on TranslationCatalogueUpsertResult": "TranslationCatalogueUpsertResult",
        "...on TranslationCataloguesIdentifierCreateResult": "TranslationCataloguesIdentifierCreateResult",
        "...on TranslationCataloguesIdentifierDeleteResult": "TranslationCataloguesIdentifierDeleteResult",
        "...on TranslationCataloguesIdentifierUpdateResult": "TranslationCataloguesIdentifierUpdateResult",
        "...on TranslationCataloguesIdentifierUpsertResult": "TranslationCataloguesIdentifierUpsertResult",
        "...on TranslationKeyCreateResult": "TranslationKeyCreateResult",
        "...on TranslationKeyDeleteResult": "TranslationKeyDeleteResult",
        "...on TranslationKeyUpdateResult": "TranslationKeyUpdateResult",
        "...on TranslationKeyUpsertResult": "TranslationKeyUpsertResult",
        "...on TranslationValueCreateResult": "TranslationValueCreateResult",
        "...on TranslationValueDeleteResult": "TranslationValueDeleteResult",
        "...on TranslationValueUpdateResult": "TranslationValueUpdateResult",
        "...on TranslationValueUpsertResult": "TranslationValueUpsertResult",
        "...on BranchesCreateResult": "BranchesCreateResult",
        "...on BranchesDeleteResult": "BranchesDeleteResult",
        "...on BranchesUpdateResult": "BranchesUpdateResult",
        "...on BranchesUpsertResult": "BranchesUpsertResult",
        "...on GraphicDesignerCreateResult": "GraphicDesignerCreateResult",
        "...on GraphicDesignerDeleteResult": "GraphicDesignerDeleteResult",
        "...on GraphicDesignerUpdateResult": "GraphicDesignerUpdateResult",
        "...on GraphicDesignerUpsertResult": "GraphicDesignerUpsertResult",
        "...on EventCreateResult": "EventCreateResult",
        "...on EventDeleteResult": "EventDeleteResult",
        "...on EventUpdateResult": "EventUpdateResult",
        "...on EventUpsertResult": "EventUpsertResult",
        "...on EventLocaleCreateResult": "EventLocaleCreateResult",
        "...on EventLocaleDeleteResult": "EventLocaleDeleteResult",
        "...on EventLocaleUpdateResult": "EventLocaleUpdateResult",
        "...on EventLocaleUpsertResult": "EventLocaleUpsertResult",
        "...on ArtworkCreateResult": "ArtworkCreateResult",
        "...on ArtworkDeleteResult": "ArtworkDeleteResult",
        "...on ArtworkUpdateResult": "ArtworkUpdateResult",
        "...on ArtworkUpsertResult": "ArtworkUpsertResult",
        "...on ArtworkLocaleCreateResult": "ArtworkLocaleCreateResult",
        "...on ArtworkLocaleDeleteResult": "ArtworkLocaleDeleteResult",
        "...on ArtworkLocaleUpdateResult": "ArtworkLocaleUpdateResult",
        "...on ArtworkLocaleUpsertResult": "ArtworkLocaleUpsertResult",
        "...on DropDownItemCreateResult": "DropDownItemCreateResult",
        "...on DropDownItemDeleteResult": "DropDownItemDeleteResult",
        "...on DropDownItemUpdateResult": "DropDownItemUpdateResult",
        "...on DropDownItemUpsertResult": "DropDownItemUpsertResult",
        "...on DropDownListCreateResult": "DropDownListCreateResult",
        "...on DropDownListDeleteResult": "DropDownListDeleteResult",
        "...on DropDownListUpdateResult": "DropDownListUpdateResult",
        "...on DropDownListUpsertResult": "DropDownListUpsertResult",
        "...on ArtworkItemCreateResult": "ArtworkItemCreateResult",
        "...on ArtworkItemDeleteResult": "ArtworkItemDeleteResult",
        "...on ArtworkItemUpdateResult": "ArtworkItemUpdateResult",
        "...on ArtworkItemUpsertResult": "ArtworkItemUpsertResult",
        "...on ArtworkListCreateResult": "ArtworkListCreateResult",
        "...on ArtworkListDeleteResult": "ArtworkListDeleteResult",
        "...on ArtworkListUpdateResult": "ArtworkListUpdateResult",
        "...on ArtworkListUpsertResult": "ArtworkListUpsertResult",
        "...on ArtworkSelectionCreateResult": "ArtworkSelectionCreateResult",
        "...on ArtworkSelectionDeleteResult": "ArtworkSelectionDeleteResult",
        "...on ArtworkSelectionUpdateResult": "ArtworkSelectionUpdateResult",
        "...on ArtworkSelectionUpsertResult": "ArtworkSelectionUpsertResult",
        "...on ArtworkSelectionItemCreateResult": "ArtworkSelectionItemCreateResult",
        "...on ArtworkSelectionItemDeleteResult": "ArtworkSelectionItemDeleteResult",
        "...on ArtworkSelectionItemUpdateResult": "ArtworkSelectionItemUpdateResult",
        "...on ArtworkSelectionItemUpsertResult": "ArtworkSelectionItemUpsertResult",
        "...on ArtworkSelectionListCreateResult": "ArtworkSelectionListCreateResult",
        "...on ArtworkSelectionListDeleteResult": "ArtworkSelectionListDeleteResult",
        "...on ArtworkSelectionListUpdateResult": "ArtworkSelectionListUpdateResult",
        "...on ArtworkSelectionListUpsertResult": "ArtworkSelectionListUpsertResult",
        "...on ArtworkSelectionLocaleCreateResult": "ArtworkSelectionLocaleCreateResult",
        "...on ArtworkSelectionLocaleDeleteResult": "ArtworkSelectionLocaleDeleteResult",
        "...on ArtworkSelectionLocaleUpdateResult": "ArtworkSelectionLocaleUpdateResult",
        "...on ArtworkSelectionLocaleUpsertResult": "ArtworkSelectionLocaleUpsertResult",
        "...on EventItemCreateResult": "EventItemCreateResult",
        "...on EventItemDeleteResult": "EventItemDeleteResult",
        "...on EventItemUpdateResult": "EventItemUpdateResult",
        "...on EventItemUpsertResult": "EventItemUpsertResult",
        "...on EventListCreateResult": "EventListCreateResult",
        "...on EventListDeleteResult": "EventListDeleteResult",
        "...on EventListUpdateResult": "EventListUpdateResult",
        "...on EventListUpsertResult": "EventListUpsertResult",
        "...on BoxItemCreateResult": "BoxItemCreateResult",
        "...on BoxItemDeleteResult": "BoxItemDeleteResult",
        "...on BoxItemUpdateResult": "BoxItemUpdateResult",
        "...on BoxItemUpsertResult": "BoxItemUpsertResult",
        "...on BoxListCreateResult": "BoxListCreateResult",
        "...on BoxListDeleteResult": "BoxListDeleteResult",
        "...on BoxListUpdateResult": "BoxListUpdateResult",
        "...on BoxListUpsertResult": "BoxListUpsertResult",
        "...on NewsletterFormCreateResult": "NewsletterFormCreateResult",
        "...on NewsletterFormDeleteResult": "NewsletterFormDeleteResult",
        "...on NewsletterFormUpdateResult": "NewsletterFormUpdateResult",
        "...on NewsletterFormUpsertResult": "NewsletterFormUpsertResult",
        "...on NewsletterTypeItemCreateResult": "NewsletterTypeItemCreateResult",
        "...on NewsletterTypeItemDeleteResult": "NewsletterTypeItemDeleteResult",
        "...on NewsletterTypeItemUpdateResult": "NewsletterTypeItemUpdateResult",
        "...on NewsletterTypeItemUpsertResult": "NewsletterTypeItemUpsertResult",
        "...on NewsletterFormLocaleCreateResult": "NewsletterFormLocaleCreateResult",
        "...on NewsletterFormLocaleDeleteResult": "NewsletterFormLocaleDeleteResult",
        "...on NewsletterFormLocaleUpdateResult": "NewsletterFormLocaleUpdateResult",
        "...on NewsletterFormLocaleUpsertResult": "NewsletterFormLocaleUpsertResult",
        "...on NewsletterSubscriptionCreateResult": "NewsletterSubscriptionCreateResult",
        "...on NewsletterSubscriptionDeleteResult": "NewsletterSubscriptionDeleteResult",
        "...on NewsletterSubscriptionUpdateResult": "NewsletterSubscriptionUpdateResult",
        "...on NewsletterSubscriptionUpsertResult": "NewsletterSubscriptionUpsertResult",
        "...on ChartCreateResult": "ChartCreateResult",
        "...on ChartDeleteResult": "ChartDeleteResult",
        "...on ChartUpdateResult": "ChartUpdateResult",
        "...on ChartUpsertResult": "ChartUpsertResult",
        "...on ChartDataCreateResult": "ChartDataCreateResult",
        "...on ChartDataDeleteResult": "ChartDataDeleteResult",
        "...on ChartDataUpdateResult": "ChartDataUpdateResult",
        "...on ChartDataUpsertResult": "ChartDataUpsertResult",
        "...on EmployeeCreateResult": "EmployeeCreateResult",
        "...on EmployeeDeleteResult": "EmployeeDeleteResult",
        "...on EmployeeUpdateResult": "EmployeeUpdateResult",
        "...on EmployeeUpsertResult": "EmployeeUpsertResult",
        "...on EmployeeItemCreateResult": "EmployeeItemCreateResult",
        "...on EmployeeItemDeleteResult": "EmployeeItemDeleteResult",
        "...on EmployeeItemUpdateResult": "EmployeeItemUpdateResult",
        "...on EmployeeItemUpsertResult": "EmployeeItemUpsertResult",
        "...on EmployeeListCreateResult": "EmployeeListCreateResult",
        "...on EmployeeListDeleteResult": "EmployeeListDeleteResult",
        "...on EmployeeListUpdateResult": "EmployeeListUpdateResult",
        "...on EmployeeListUpsertResult": "EmployeeListUpsertResult",
        "...on EmployeeLocaleCreateResult": "EmployeeLocaleCreateResult",
        "...on EmployeeLocaleDeleteResult": "EmployeeLocaleDeleteResult",
        "...on EmployeeLocaleUpdateResult": "EmployeeLocaleUpdateResult",
        "...on EmployeeLocaleUpsertResult": "EmployeeLocaleUpsertResult",
        "...on PhotographerCreateResult": "PhotographerCreateResult",
        "...on PhotographerDeleteResult": "PhotographerDeleteResult",
        "...on PhotographerUpdateResult": "PhotographerUpdateResult",
        "...on PhotographerUpsertResult": "PhotographerUpsertResult",
        "...on DefinitionItemCreateResult": "DefinitionItemCreateResult",
        "...on DefinitionItemDeleteResult": "DefinitionItemDeleteResult",
        "...on DefinitionItemUpdateResult": "DefinitionItemUpdateResult",
        "...on DefinitionItemUpsertResult": "DefinitionItemUpsertResult",
        "...on DefinitionListCreateResult": "DefinitionListCreateResult",
        "...on DefinitionListDeleteResult": "DefinitionListDeleteResult",
        "...on DefinitionListUpdateResult": "DefinitionListUpdateResult",
        "...on DefinitionListUpsertResult": "DefinitionListUpsertResult",
        "...on LogoItemCreateResult": "LogoItemCreateResult",
        "...on LogoItemDeleteResult": "LogoItemDeleteResult",
        "...on LogoItemUpdateResult": "LogoItemUpdateResult",
        "...on LogoItemUpsertResult": "LogoItemUpsertResult",
        "...on LogoListCreateResult": "LogoListCreateResult",
        "...on LogoListDeleteResult": "LogoListDeleteResult",
        "...on LogoListUpdateResult": "LogoListUpdateResult",
        "...on LogoListUpsertResult": "LogoListUpsertResult",
        "...on StrategySchemaCreateResult": "StrategySchemaCreateResult",
        "...on StrategySchemaDeleteResult": "StrategySchemaDeleteResult",
        "...on StrategySchemaUpdateResult": "StrategySchemaUpdateResult",
        "...on StrategySchemaUpsertResult": "StrategySchemaUpsertResult",
        "...on StrategySchemaGroupCreateResult": "StrategySchemaGroupCreateResult",
        "...on StrategySchemaGroupDeleteResult": "StrategySchemaGroupDeleteResult",
        "...on StrategySchemaGroupUpdateResult": "StrategySchemaGroupUpdateResult",
        "...on StrategySchemaGroupUpsertResult": "StrategySchemaGroupUpsertResult",
        "...on StrategySchemaGroupItemCreateResult": "StrategySchemaGroupItemCreateResult",
        "...on StrategySchemaGroupItemDeleteResult": "StrategySchemaGroupItemDeleteResult",
        "...on StrategySchemaGroupItemUpdateResult": "StrategySchemaGroupItemUpdateResult",
        "...on StrategySchemaGroupItemUpsertResult": "StrategySchemaGroupItemUpsertResult",
        "...on RedirectCreateResult": "RedirectCreateResult",
        "...on RedirectDeleteResult": "RedirectDeleteResult",
        "...on RedirectUpdateResult": "RedirectUpdateResult",
        "...on RedirectUpsertResult": "RedirectUpsertResult",
        "...on GalleryCreateResult": "GalleryCreateResult",
        "...on GalleryDeleteResult": "GalleryDeleteResult",
        "...on GalleryUpdateResult": "GalleryUpdateResult",
        "...on GalleryUpsertResult": "GalleryUpsertResult",
        "...on GalleryItemCreateResult": "GalleryItemCreateResult",
        "...on GalleryItemDeleteResult": "GalleryItemDeleteResult",
        "...on GalleryItemUpdateResult": "GalleryItemUpdateResult",
        "...on GalleryItemUpsertResult": "GalleryItemUpsertResult",
        "...on ContactFormCreateResult": "ContactFormCreateResult",
        "...on ContactFormDeleteResult": "ContactFormDeleteResult",
        "...on ContactFormUpdateResult": "ContactFormUpdateResult",
        "...on ContactFormUpsertResult": "ContactFormUpsertResult",
        "...on ContactFormLocaleCreateResult": "ContactFormLocaleCreateResult",
        "...on ContactFormLocaleDeleteResult": "ContactFormLocaleDeleteResult",
        "...on ContactFormLocaleUpdateResult": "ContactFormLocaleUpdateResult",
        "...on ContactFormLocaleUpsertResult": "ContactFormLocaleUpsertResult",
        "...on ContactSubscriptionCreateResult": "ContactSubscriptionCreateResult",
        "...on ContactSubscriptionDeleteResult": "ContactSubscriptionDeleteResult",
        "...on ContactSubscriptionUpdateResult": "ContactSubscriptionUpdateResult",
        "...on ContactSubscriptionUpsertResult": "ContactSubscriptionUpsertResult",
        "...on ContactTypeItemCreateResult": "ContactTypeItemCreateResult",
        "...on ContactTypeItemDeleteResult": "ContactTypeItemDeleteResult",
        "...on ContactTypeItemUpdateResult": "ContactTypeItemUpdateResult",
        "...on ContactTypeItemUpsertResult": "ContactTypeItemUpsertResult",
        "...on FileCreateResult": "FileCreateResult",
        "...on FileDeleteResult": "FileDeleteResult",
        "...on FileUpdateResult": "FileUpdateResult",
        "...on FileUpsertResult": "FileUpsertResult",
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError"
    },
    _MutationError: {
        path: "_PathFragment",
        paths: "_PathFragment",
        type: "_MutationErrorType",
        message: "String"
    },
    ContactPageDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactPage"
    },
    ContactPageUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactPage",
        validation: "_ValidationResult"
    },
    ContactPageUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactPage",
        validation: "_ValidationResult"
    },
    ContactPageLocaleCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactPageLocale",
        validation: "_ValidationResult"
    },
    ContactPageLocaleDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactPageLocale"
    },
    ContactPageLocaleUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactPageLocale",
        validation: "_ValidationResult"
    },
    ContactPageLocaleUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactPageLocale",
        validation: "_ValidationResult"
    },
    ContentCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Content",
        validation: "_ValidationResult"
    },
    ContentDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Content"
    },
    ContentUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Content",
        validation: "_ValidationResult"
    },
    ContentUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Content",
        validation: "_ValidationResult"
    },
    ContentBlockCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContentBlock",
        validation: "_ValidationResult"
    },
    ContentBlockDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContentBlock"
    },
    ContentBlockUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContentBlock",
        validation: "_ValidationResult"
    },
    ContentBlockUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContentBlock",
        validation: "_ValidationResult"
    },
    ContentReferenceCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContentReference",
        validation: "_ValidationResult"
    },
    ContentReferenceDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContentReference"
    },
    ContentReferenceUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContentReference",
        validation: "_ValidationResult"
    },
    ContentReferenceUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContentReference",
        validation: "_ValidationResult"
    },
    FooterCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Footer",
        validation: "_ValidationResult"
    },
    FooterDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Footer"
    },
    FooterUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Footer",
        validation: "_ValidationResult"
    },
    FooterUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Footer",
        validation: "_ValidationResult"
    },
    FooterLocaleCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "FooterLocale",
        validation: "_ValidationResult"
    },
    FooterLocaleDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "FooterLocale"
    },
    FooterLocaleUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "FooterLocale",
        validation: "_ValidationResult"
    },
    FooterLocaleUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "FooterLocale",
        validation: "_ValidationResult"
    },
    HeaderCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Header",
        validation: "_ValidationResult"
    },
    HeaderDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Header"
    },
    HeaderUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Header",
        validation: "_ValidationResult"
    },
    HeaderUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Header",
        validation: "_ValidationResult"
    },
    HeaderLinkCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HeaderLink",
        validation: "_ValidationResult"
    },
    HeaderLinkDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HeaderLink"
    },
    HeaderLinkUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HeaderLink",
        validation: "_ValidationResult"
    },
    HeaderLinkUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HeaderLink",
        validation: "_ValidationResult"
    },
    HeaderLocaleCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HeaderLocale",
        validation: "_ValidationResult"
    },
    HeaderLocaleDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HeaderLocale"
    },
    HeaderLocaleUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HeaderLocale",
        validation: "_ValidationResult"
    },
    HeaderLocaleUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HeaderLocale",
        validation: "_ValidationResult"
    },
    HomePageCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HomePage",
        validation: "_ValidationResult"
    },
    HomePageDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HomePage"
    },
    HomePageUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HomePage",
        validation: "_ValidationResult"
    },
    HomePageUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HomePage",
        validation: "_ValidationResult"
    },
    HomePageLocaleCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HomePageLocale",
        validation: "_ValidationResult"
    },
    HomePageLocaleDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HomePageLocale"
    },
    HomePageLocaleUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HomePageLocale",
        validation: "_ValidationResult"
    },
    HomePageLocaleUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "HomePageLocale",
        validation: "_ValidationResult"
    },
    LinkCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Link",
        validation: "_ValidationResult"
    },
    LinkDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Link"
    },
    LinkUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Link",
        validation: "_ValidationResult"
    },
    LinkUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Link",
        validation: "_ValidationResult"
    },
    LinkableCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Linkable",
        validation: "_ValidationResult"
    },
    LinkableDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Linkable"
    },
    LinkableUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Linkable",
        validation: "_ValidationResult"
    },
    LinkableUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Linkable",
        validation: "_ValidationResult"
    },
    LocaleCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Locale",
        validation: "_ValidationResult"
    },
    LocaleDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Locale"
    },
    LocaleUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Locale",
        validation: "_ValidationResult"
    },
    LocaleUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Locale",
        validation: "_ValidationResult"
    },
    MediumCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Medium",
        validation: "_ValidationResult"
    },
    MediumDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Medium"
    },
    MediumUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Medium",
        validation: "_ValidationResult"
    },
    MediumUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Medium",
        validation: "_ValidationResult"
    },
    MediumItemCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "MediumItem",
        validation: "_ValidationResult"
    },
    MediumItemDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "MediumItem"
    },
    MediumItemUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "MediumItem",
        validation: "_ValidationResult"
    },
    MediumItemUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "MediumItem",
        validation: "_ValidationResult"
    },
    MediumListCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "MediumList",
        validation: "_ValidationResult"
    },
    MediumListDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "MediumList"
    },
    MediumListUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "MediumList",
        validation: "_ValidationResult"
    },
    MediumListUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "MediumList",
        validation: "_ValidationResult"
    },
    PageCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Page",
        validation: "_ValidationResult"
    },
    PageDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Page"
    },
    PageUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Page",
        validation: "_ValidationResult"
    },
    PageUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Page",
        validation: "_ValidationResult"
    },
    PageLocaleCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "PageLocale",
        validation: "_ValidationResult"
    },
    PageLocaleDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "PageLocale"
    },
    PageLocaleUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "PageLocale",
        validation: "_ValidationResult"
    },
    PageLocaleUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "PageLocale",
        validation: "_ValidationResult"
    },
    SeoDefaultCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "SeoDefault",
        validation: "_ValidationResult"
    },
    SeoDefaultDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "SeoDefault"
    },
    SeoDefaultUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "SeoDefault",
        validation: "_ValidationResult"
    },
    SeoDefaultUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "SeoDefault",
        validation: "_ValidationResult"
    },
    SeoDefaultLocaleCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "SeoDefaultLocale",
        validation: "_ValidationResult"
    },
    SeoDefaultLocaleDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "SeoDefaultLocale"
    },
    SeoDefaultLocaleUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "SeoDefaultLocale",
        validation: "_ValidationResult"
    },
    SeoDefaultLocaleUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "SeoDefaultLocale",
        validation: "_ValidationResult"
    },
    VideoCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Video",
        validation: "_ValidationResult"
    },
    VideoDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Video"
    },
    VideoUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Video",
        validation: "_ValidationResult"
    },
    VideoUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Video",
        validation: "_ValidationResult"
    },
    ImageCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Image",
        validation: "_ValidationResult"
    },
    ImageDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Image"
    },
    ImageUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Image",
        validation: "_ValidationResult"
    },
    ImageUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Image",
        validation: "_ValidationResult"
    },
    SeoCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Seo",
        validation: "_ValidationResult"
    },
    SeoDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Seo"
    },
    SeoUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Seo",
        validation: "_ValidationResult"
    },
    SeoUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Seo",
        validation: "_ValidationResult"
    },
    TranslationDomainCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationDomain",
        validation: "_ValidationResult"
    },
    TranslationDomainDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationDomain"
    },
    TranslationDomainUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationDomain",
        validation: "_ValidationResult"
    },
    TranslationDomainUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationDomain",
        validation: "_ValidationResult"
    },
    TranslationCatalogueCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationCatalogue",
        validation: "_ValidationResult"
    },
    TranslationCatalogueDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationCatalogue"
    },
    TranslationCatalogueUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationCatalogue",
        validation: "_ValidationResult"
    },
    TranslationCatalogueUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationCatalogue",
        validation: "_ValidationResult"
    },
    TranslationCataloguesIdentifierCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationCataloguesIdentifier",
        validation: "_ValidationResult"
    },
    TranslationCataloguesIdentifierDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationCataloguesIdentifier"
    },
    TranslationCataloguesIdentifierUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationCataloguesIdentifier",
        validation: "_ValidationResult"
    },
    TranslationCataloguesIdentifierUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationCataloguesIdentifier",
        validation: "_ValidationResult"
    },
    TranslationKeyCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationKey",
        validation: "_ValidationResult"
    },
    TranslationKeyDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationKey"
    },
    TranslationKeyUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationKey",
        validation: "_ValidationResult"
    },
    TranslationKeyUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationKey",
        validation: "_ValidationResult"
    },
    TranslationValueCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationValue",
        validation: "_ValidationResult"
    },
    TranslationValueDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationValue"
    },
    TranslationValueUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationValue",
        validation: "_ValidationResult"
    },
    TranslationValueUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "TranslationValue",
        validation: "_ValidationResult"
    },
    BranchesCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Branches",
        validation: "_ValidationResult"
    },
    BranchesDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Branches"
    },
    BranchesUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Branches",
        validation: "_ValidationResult"
    },
    BranchesUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Branches",
        validation: "_ValidationResult"
    },
    GraphicDesignerCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "GraphicDesigner",
        validation: "_ValidationResult"
    },
    GraphicDesignerDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "GraphicDesigner"
    },
    GraphicDesignerUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "GraphicDesigner",
        validation: "_ValidationResult"
    },
    GraphicDesignerUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "GraphicDesigner",
        validation: "_ValidationResult"
    },
    EventCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Event",
        validation: "_ValidationResult"
    },
    EventDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Event"
    },
    EventUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Event",
        validation: "_ValidationResult"
    },
    EventUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Event",
        validation: "_ValidationResult"
    },
    EventLocaleCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EventLocale",
        validation: "_ValidationResult"
    },
    EventLocaleDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EventLocale"
    },
    EventLocaleUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EventLocale",
        validation: "_ValidationResult"
    },
    EventLocaleUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EventLocale",
        validation: "_ValidationResult"
    },
    ArtworkCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Artwork",
        validation: "_ValidationResult"
    },
    ArtworkDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Artwork"
    },
    ArtworkUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Artwork",
        validation: "_ValidationResult"
    },
    ArtworkUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Artwork",
        validation: "_ValidationResult"
    },
    ArtworkLocaleCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkLocale",
        validation: "_ValidationResult"
    },
    ArtworkLocaleDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkLocale"
    },
    ArtworkLocaleUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkLocale",
        validation: "_ValidationResult"
    },
    ArtworkLocaleUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkLocale",
        validation: "_ValidationResult"
    },
    DropDownItemCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DropDownItem",
        validation: "_ValidationResult"
    },
    DropDownItemDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DropDownItem"
    },
    DropDownItemUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DropDownItem",
        validation: "_ValidationResult"
    },
    DropDownItemUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DropDownItem",
        validation: "_ValidationResult"
    },
    DropDownListCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DropDownList",
        validation: "_ValidationResult"
    },
    DropDownListDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DropDownList"
    },
    DropDownListUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DropDownList",
        validation: "_ValidationResult"
    },
    DropDownListUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DropDownList",
        validation: "_ValidationResult"
    },
    ArtworkItemCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkItem",
        validation: "_ValidationResult"
    },
    ArtworkItemDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkItem"
    },
    ArtworkItemUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkItem",
        validation: "_ValidationResult"
    },
    ArtworkItemUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkItem",
        validation: "_ValidationResult"
    },
    ArtworkListCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkList",
        validation: "_ValidationResult"
    },
    ArtworkListDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkList"
    },
    ArtworkListUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkList",
        validation: "_ValidationResult"
    },
    ArtworkListUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkList",
        validation: "_ValidationResult"
    },
    ArtworkSelectionCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelection",
        validation: "_ValidationResult"
    },
    ArtworkSelectionDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelection"
    },
    ArtworkSelectionUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelection",
        validation: "_ValidationResult"
    },
    ArtworkSelectionUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelection",
        validation: "_ValidationResult"
    },
    ArtworkSelectionItemCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelectionItem",
        validation: "_ValidationResult"
    },
    ArtworkSelectionItemDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelectionItem"
    },
    ArtworkSelectionItemUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelectionItem",
        validation: "_ValidationResult"
    },
    ArtworkSelectionItemUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelectionItem",
        validation: "_ValidationResult"
    },
    ArtworkSelectionListCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelectionList",
        validation: "_ValidationResult"
    },
    ArtworkSelectionListDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelectionList"
    },
    ArtworkSelectionListUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelectionList",
        validation: "_ValidationResult"
    },
    ArtworkSelectionListUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelectionList",
        validation: "_ValidationResult"
    },
    ArtworkSelectionLocaleCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelectionLocale",
        validation: "_ValidationResult"
    },
    ArtworkSelectionLocaleDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelectionLocale"
    },
    ArtworkSelectionLocaleUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelectionLocale",
        validation: "_ValidationResult"
    },
    ArtworkSelectionLocaleUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ArtworkSelectionLocale",
        validation: "_ValidationResult"
    },
    EventItemCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EventItem",
        validation: "_ValidationResult"
    },
    EventItemDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EventItem"
    },
    EventItemUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EventItem",
        validation: "_ValidationResult"
    },
    EventItemUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EventItem",
        validation: "_ValidationResult"
    },
    EventListCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EventList",
        validation: "_ValidationResult"
    },
    EventListDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EventList"
    },
    EventListUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EventList",
        validation: "_ValidationResult"
    },
    EventListUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EventList",
        validation: "_ValidationResult"
    },
    BoxItemCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "BoxItem",
        validation: "_ValidationResult"
    },
    BoxItemDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "BoxItem"
    },
    BoxItemUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "BoxItem",
        validation: "_ValidationResult"
    },
    BoxItemUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "BoxItem",
        validation: "_ValidationResult"
    },
    BoxListCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "BoxList",
        validation: "_ValidationResult"
    },
    BoxListDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "BoxList"
    },
    BoxListUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "BoxList",
        validation: "_ValidationResult"
    },
    BoxListUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "BoxList",
        validation: "_ValidationResult"
    },
    NewsletterFormCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterForm",
        validation: "_ValidationResult"
    },
    NewsletterFormDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterForm"
    },
    NewsletterFormUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterForm",
        validation: "_ValidationResult"
    },
    NewsletterFormUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterForm",
        validation: "_ValidationResult"
    },
    NewsletterTypeItemCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterTypeItem",
        validation: "_ValidationResult"
    },
    NewsletterTypeItemDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterTypeItem"
    },
    NewsletterTypeItemUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterTypeItem",
        validation: "_ValidationResult"
    },
    NewsletterTypeItemUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterTypeItem",
        validation: "_ValidationResult"
    },
    NewsletterFormLocaleCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterFormLocale",
        validation: "_ValidationResult"
    },
    NewsletterFormLocaleDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterFormLocale"
    },
    NewsletterFormLocaleUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterFormLocale",
        validation: "_ValidationResult"
    },
    NewsletterFormLocaleUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterFormLocale",
        validation: "_ValidationResult"
    },
    NewsletterSubscriptionCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterSubscription",
        validation: "_ValidationResult"
    },
    NewsletterSubscriptionDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterSubscription"
    },
    NewsletterSubscriptionUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterSubscription",
        validation: "_ValidationResult"
    },
    NewsletterSubscriptionUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "NewsletterSubscription",
        validation: "_ValidationResult"
    },
    ChartCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Chart",
        validation: "_ValidationResult"
    },
    ChartDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Chart"
    },
    ChartUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Chart",
        validation: "_ValidationResult"
    },
    ChartUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Chart",
        validation: "_ValidationResult"
    },
    ChartDataCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ChartData",
        validation: "_ValidationResult"
    },
    ChartDataDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ChartData"
    },
    ChartDataUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ChartData",
        validation: "_ValidationResult"
    },
    ChartDataUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ChartData",
        validation: "_ValidationResult"
    },
    EmployeeCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Employee",
        validation: "_ValidationResult"
    },
    EmployeeDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Employee"
    },
    EmployeeUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Employee",
        validation: "_ValidationResult"
    },
    EmployeeUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Employee",
        validation: "_ValidationResult"
    },
    EmployeeItemCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EmployeeItem",
        validation: "_ValidationResult"
    },
    EmployeeItemDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EmployeeItem"
    },
    EmployeeItemUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EmployeeItem",
        validation: "_ValidationResult"
    },
    EmployeeItemUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EmployeeItem",
        validation: "_ValidationResult"
    },
    EmployeeListCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EmployeeList",
        validation: "_ValidationResult"
    },
    EmployeeListDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EmployeeList"
    },
    EmployeeListUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EmployeeList",
        validation: "_ValidationResult"
    },
    EmployeeListUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EmployeeList",
        validation: "_ValidationResult"
    },
    EmployeeLocaleCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EmployeeLocale",
        validation: "_ValidationResult"
    },
    EmployeeLocaleDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EmployeeLocale"
    },
    EmployeeLocaleUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EmployeeLocale",
        validation: "_ValidationResult"
    },
    EmployeeLocaleUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "EmployeeLocale",
        validation: "_ValidationResult"
    },
    PhotographerCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Photographer",
        validation: "_ValidationResult"
    },
    PhotographerDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Photographer"
    },
    PhotographerUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Photographer",
        validation: "_ValidationResult"
    },
    PhotographerUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Photographer",
        validation: "_ValidationResult"
    },
    DefinitionItemCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DefinitionItem",
        validation: "_ValidationResult"
    },
    DefinitionItemDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DefinitionItem"
    },
    DefinitionItemUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DefinitionItem",
        validation: "_ValidationResult"
    },
    DefinitionItemUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DefinitionItem",
        validation: "_ValidationResult"
    },
    DefinitionListCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DefinitionList",
        validation: "_ValidationResult"
    },
    DefinitionListDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DefinitionList"
    },
    DefinitionListUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DefinitionList",
        validation: "_ValidationResult"
    },
    DefinitionListUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "DefinitionList",
        validation: "_ValidationResult"
    },
    LogoItemCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "LogoItem",
        validation: "_ValidationResult"
    },
    LogoItemDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "LogoItem"
    },
    LogoItemUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "LogoItem",
        validation: "_ValidationResult"
    },
    LogoItemUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "LogoItem",
        validation: "_ValidationResult"
    },
    LogoListCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "LogoList",
        validation: "_ValidationResult"
    },
    LogoListDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "LogoList"
    },
    LogoListUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "LogoList",
        validation: "_ValidationResult"
    },
    LogoListUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "LogoList",
        validation: "_ValidationResult"
    },
    StrategySchemaCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "StrategySchema",
        validation: "_ValidationResult"
    },
    StrategySchemaDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "StrategySchema"
    },
    StrategySchemaUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "StrategySchema",
        validation: "_ValidationResult"
    },
    StrategySchemaUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "StrategySchema",
        validation: "_ValidationResult"
    },
    StrategySchemaGroupCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "StrategySchemaGroup",
        validation: "_ValidationResult"
    },
    StrategySchemaGroupDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "StrategySchemaGroup"
    },
    StrategySchemaGroupUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "StrategySchemaGroup",
        validation: "_ValidationResult"
    },
    StrategySchemaGroupUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "StrategySchemaGroup",
        validation: "_ValidationResult"
    },
    StrategySchemaGroupItemCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "StrategySchemaGroupItem",
        validation: "_ValidationResult"
    },
    StrategySchemaGroupItemDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "StrategySchemaGroupItem"
    },
    StrategySchemaGroupItemUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "StrategySchemaGroupItem",
        validation: "_ValidationResult"
    },
    StrategySchemaGroupItemUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "StrategySchemaGroupItem",
        validation: "_ValidationResult"
    },
    RedirectCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Redirect",
        validation: "_ValidationResult"
    },
    RedirectDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Redirect"
    },
    RedirectUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Redirect",
        validation: "_ValidationResult"
    },
    RedirectUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Redirect",
        validation: "_ValidationResult"
    },
    GalleryCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Gallery",
        validation: "_ValidationResult"
    },
    GalleryDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Gallery"
    },
    GalleryUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Gallery",
        validation: "_ValidationResult"
    },
    GalleryUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "Gallery",
        validation: "_ValidationResult"
    },
    GalleryItemCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "GalleryItem",
        validation: "_ValidationResult"
    },
    GalleryItemDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "GalleryItem"
    },
    GalleryItemUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "GalleryItem",
        validation: "_ValidationResult"
    },
    GalleryItemUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "GalleryItem",
        validation: "_ValidationResult"
    },
    ContactFormCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactForm",
        validation: "_ValidationResult"
    },
    ContactFormDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactForm"
    },
    ContactFormUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactForm",
        validation: "_ValidationResult"
    },
    ContactFormUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactForm",
        validation: "_ValidationResult"
    },
    ContactFormLocaleCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactFormLocale",
        validation: "_ValidationResult"
    },
    ContactFormLocaleDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactFormLocale"
    },
    ContactFormLocaleUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactFormLocale",
        validation: "_ValidationResult"
    },
    ContactFormLocaleUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactFormLocale",
        validation: "_ValidationResult"
    },
    ContactSubscriptionCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactSubscription",
        validation: "_ValidationResult"
    },
    ContactSubscriptionDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactSubscription"
    },
    ContactSubscriptionUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactSubscription",
        validation: "_ValidationResult"
    },
    ContactSubscriptionUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactSubscription",
        validation: "_ValidationResult"
    },
    ContactTypeItemCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactTypeItem",
        validation: "_ValidationResult"
    },
    ContactTypeItemDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactTypeItem"
    },
    ContactTypeItemUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactTypeItem",
        validation: "_ValidationResult"
    },
    ContactTypeItemUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "ContactTypeItem",
        validation: "_ValidationResult"
    },
    FileCreateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "File",
        validation: "_ValidationResult"
    },
    FileDeleteResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "File"
    },
    FileUpdateResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "File",
        validation: "_ValidationResult"
    },
    FileUpsertResult: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        node: "File",
        validation: "_ValidationResult"
    },
    MutationTransaction: {
        ok: "Boolean",
        errorMessage: "String",
        errors: "_MutationError",
        validation: "_ValidationResult",
        createContactPage: "ContactPageCreateResult",
        deleteContactPage: "ContactPageDeleteResult",
        updateContactPage: "ContactPageUpdateResult",
        upsertContactPage: "ContactPageUpsertResult",
        createContactPageLocale: "ContactPageLocaleCreateResult",
        deleteContactPageLocale: "ContactPageLocaleDeleteResult",
        updateContactPageLocale: "ContactPageLocaleUpdateResult",
        upsertContactPageLocale: "ContactPageLocaleUpsertResult",
        createContent: "ContentCreateResult",
        deleteContent: "ContentDeleteResult",
        updateContent: "ContentUpdateResult",
        upsertContent: "ContentUpsertResult",
        createContentBlock: "ContentBlockCreateResult",
        deleteContentBlock: "ContentBlockDeleteResult",
        updateContentBlock: "ContentBlockUpdateResult",
        upsertContentBlock: "ContentBlockUpsertResult",
        createContentReference: "ContentReferenceCreateResult",
        deleteContentReference: "ContentReferenceDeleteResult",
        updateContentReference: "ContentReferenceUpdateResult",
        upsertContentReference: "ContentReferenceUpsertResult",
        createFooter: "FooterCreateResult",
        deleteFooter: "FooterDeleteResult",
        updateFooter: "FooterUpdateResult",
        upsertFooter: "FooterUpsertResult",
        createFooterLocale: "FooterLocaleCreateResult",
        deleteFooterLocale: "FooterLocaleDeleteResult",
        updateFooterLocale: "FooterLocaleUpdateResult",
        upsertFooterLocale: "FooterLocaleUpsertResult",
        createHeader: "HeaderCreateResult",
        deleteHeader: "HeaderDeleteResult",
        updateHeader: "HeaderUpdateResult",
        upsertHeader: "HeaderUpsertResult",
        createHeaderLink: "HeaderLinkCreateResult",
        deleteHeaderLink: "HeaderLinkDeleteResult",
        updateHeaderLink: "HeaderLinkUpdateResult",
        upsertHeaderLink: "HeaderLinkUpsertResult",
        createHeaderLocale: "HeaderLocaleCreateResult",
        deleteHeaderLocale: "HeaderLocaleDeleteResult",
        updateHeaderLocale: "HeaderLocaleUpdateResult",
        upsertHeaderLocale: "HeaderLocaleUpsertResult",
        createHomePage: "HomePageCreateResult",
        deleteHomePage: "HomePageDeleteResult",
        updateHomePage: "HomePageUpdateResult",
        upsertHomePage: "HomePageUpsertResult",
        createHomePageLocale: "HomePageLocaleCreateResult",
        deleteHomePageLocale: "HomePageLocaleDeleteResult",
        updateHomePageLocale: "HomePageLocaleUpdateResult",
        upsertHomePageLocale: "HomePageLocaleUpsertResult",
        createLink: "LinkCreateResult",
        deleteLink: "LinkDeleteResult",
        updateLink: "LinkUpdateResult",
        upsertLink: "LinkUpsertResult",
        createLinkable: "LinkableCreateResult",
        deleteLinkable: "LinkableDeleteResult",
        updateLinkable: "LinkableUpdateResult",
        upsertLinkable: "LinkableUpsertResult",
        createLocale: "LocaleCreateResult",
        deleteLocale: "LocaleDeleteResult",
        updateLocale: "LocaleUpdateResult",
        upsertLocale: "LocaleUpsertResult",
        createMedium: "MediumCreateResult",
        deleteMedium: "MediumDeleteResult",
        updateMedium: "MediumUpdateResult",
        upsertMedium: "MediumUpsertResult",
        createMediumItem: "MediumItemCreateResult",
        deleteMediumItem: "MediumItemDeleteResult",
        updateMediumItem: "MediumItemUpdateResult",
        upsertMediumItem: "MediumItemUpsertResult",
        createMediumList: "MediumListCreateResult",
        deleteMediumList: "MediumListDeleteResult",
        updateMediumList: "MediumListUpdateResult",
        upsertMediumList: "MediumListUpsertResult",
        createPage: "PageCreateResult",
        deletePage: "PageDeleteResult",
        updatePage: "PageUpdateResult",
        upsertPage: "PageUpsertResult",
        createPageLocale: "PageLocaleCreateResult",
        deletePageLocale: "PageLocaleDeleteResult",
        updatePageLocale: "PageLocaleUpdateResult",
        upsertPageLocale: "PageLocaleUpsertResult",
        createSeoDefault: "SeoDefaultCreateResult",
        deleteSeoDefault: "SeoDefaultDeleteResult",
        updateSeoDefault: "SeoDefaultUpdateResult",
        upsertSeoDefault: "SeoDefaultUpsertResult",
        createSeoDefaultLocale: "SeoDefaultLocaleCreateResult",
        deleteSeoDefaultLocale: "SeoDefaultLocaleDeleteResult",
        updateSeoDefaultLocale: "SeoDefaultLocaleUpdateResult",
        upsertSeoDefaultLocale: "SeoDefaultLocaleUpsertResult",
        createVideo: "VideoCreateResult",
        deleteVideo: "VideoDeleteResult",
        updateVideo: "VideoUpdateResult",
        upsertVideo: "VideoUpsertResult",
        createImage: "ImageCreateResult",
        deleteImage: "ImageDeleteResult",
        updateImage: "ImageUpdateResult",
        upsertImage: "ImageUpsertResult",
        createSeo: "SeoCreateResult",
        deleteSeo: "SeoDeleteResult",
        updateSeo: "SeoUpdateResult",
        upsertSeo: "SeoUpsertResult",
        createTranslationDomain: "TranslationDomainCreateResult",
        deleteTranslationDomain: "TranslationDomainDeleteResult",
        updateTranslationDomain: "TranslationDomainUpdateResult",
        upsertTranslationDomain: "TranslationDomainUpsertResult",
        createTranslationCatalogue: "TranslationCatalogueCreateResult",
        deleteTranslationCatalogue: "TranslationCatalogueDeleteResult",
        updateTranslationCatalogue: "TranslationCatalogueUpdateResult",
        upsertTranslationCatalogue: "TranslationCatalogueUpsertResult",
        createTranslationCataloguesIdentifier: "TranslationCataloguesIdentifierCreateResult",
        deleteTranslationCataloguesIdentifier: "TranslationCataloguesIdentifierDeleteResult",
        updateTranslationCataloguesIdentifier: "TranslationCataloguesIdentifierUpdateResult",
        upsertTranslationCataloguesIdentifier: "TranslationCataloguesIdentifierUpsertResult",
        createTranslationKey: "TranslationKeyCreateResult",
        deleteTranslationKey: "TranslationKeyDeleteResult",
        updateTranslationKey: "TranslationKeyUpdateResult",
        upsertTranslationKey: "TranslationKeyUpsertResult",
        createTranslationValue: "TranslationValueCreateResult",
        deleteTranslationValue: "TranslationValueDeleteResult",
        updateTranslationValue: "TranslationValueUpdateResult",
        upsertTranslationValue: "TranslationValueUpsertResult",
        createBranches: "BranchesCreateResult",
        deleteBranches: "BranchesDeleteResult",
        updateBranches: "BranchesUpdateResult",
        upsertBranches: "BranchesUpsertResult",
        createGraphicDesigner: "GraphicDesignerCreateResult",
        deleteGraphicDesigner: "GraphicDesignerDeleteResult",
        updateGraphicDesigner: "GraphicDesignerUpdateResult",
        upsertGraphicDesigner: "GraphicDesignerUpsertResult",
        createEvent: "EventCreateResult",
        deleteEvent: "EventDeleteResult",
        updateEvent: "EventUpdateResult",
        upsertEvent: "EventUpsertResult",
        createEventLocale: "EventLocaleCreateResult",
        deleteEventLocale: "EventLocaleDeleteResult",
        updateEventLocale: "EventLocaleUpdateResult",
        upsertEventLocale: "EventLocaleUpsertResult",
        createArtwork: "ArtworkCreateResult",
        deleteArtwork: "ArtworkDeleteResult",
        updateArtwork: "ArtworkUpdateResult",
        upsertArtwork: "ArtworkUpsertResult",
        createArtworkLocale: "ArtworkLocaleCreateResult",
        deleteArtworkLocale: "ArtworkLocaleDeleteResult",
        updateArtworkLocale: "ArtworkLocaleUpdateResult",
        upsertArtworkLocale: "ArtworkLocaleUpsertResult",
        createDropDownItem: "DropDownItemCreateResult",
        deleteDropDownItem: "DropDownItemDeleteResult",
        updateDropDownItem: "DropDownItemUpdateResult",
        upsertDropDownItem: "DropDownItemUpsertResult",
        createDropDownList: "DropDownListCreateResult",
        deleteDropDownList: "DropDownListDeleteResult",
        updateDropDownList: "DropDownListUpdateResult",
        upsertDropDownList: "DropDownListUpsertResult",
        createArtworkItem: "ArtworkItemCreateResult",
        deleteArtworkItem: "ArtworkItemDeleteResult",
        updateArtworkItem: "ArtworkItemUpdateResult",
        upsertArtworkItem: "ArtworkItemUpsertResult",
        createArtworkList: "ArtworkListCreateResult",
        deleteArtworkList: "ArtworkListDeleteResult",
        updateArtworkList: "ArtworkListUpdateResult",
        upsertArtworkList: "ArtworkListUpsertResult",
        createArtworkSelection: "ArtworkSelectionCreateResult",
        deleteArtworkSelection: "ArtworkSelectionDeleteResult",
        updateArtworkSelection: "ArtworkSelectionUpdateResult",
        upsertArtworkSelection: "ArtworkSelectionUpsertResult",
        createArtworkSelectionItem: "ArtworkSelectionItemCreateResult",
        deleteArtworkSelectionItem: "ArtworkSelectionItemDeleteResult",
        updateArtworkSelectionItem: "ArtworkSelectionItemUpdateResult",
        upsertArtworkSelectionItem: "ArtworkSelectionItemUpsertResult",
        createArtworkSelectionList: "ArtworkSelectionListCreateResult",
        deleteArtworkSelectionList: "ArtworkSelectionListDeleteResult",
        updateArtworkSelectionList: "ArtworkSelectionListUpdateResult",
        upsertArtworkSelectionList: "ArtworkSelectionListUpsertResult",
        createArtworkSelectionLocale: "ArtworkSelectionLocaleCreateResult",
        deleteArtworkSelectionLocale: "ArtworkSelectionLocaleDeleteResult",
        updateArtworkSelectionLocale: "ArtworkSelectionLocaleUpdateResult",
        upsertArtworkSelectionLocale: "ArtworkSelectionLocaleUpsertResult",
        createEventItem: "EventItemCreateResult",
        deleteEventItem: "EventItemDeleteResult",
        updateEventItem: "EventItemUpdateResult",
        upsertEventItem: "EventItemUpsertResult",
        createEventList: "EventListCreateResult",
        deleteEventList: "EventListDeleteResult",
        updateEventList: "EventListUpdateResult",
        upsertEventList: "EventListUpsertResult",
        createBoxItem: "BoxItemCreateResult",
        deleteBoxItem: "BoxItemDeleteResult",
        updateBoxItem: "BoxItemUpdateResult",
        upsertBoxItem: "BoxItemUpsertResult",
        createBoxList: "BoxListCreateResult",
        deleteBoxList: "BoxListDeleteResult",
        updateBoxList: "BoxListUpdateResult",
        upsertBoxList: "BoxListUpsertResult",
        createNewsletterForm: "NewsletterFormCreateResult",
        deleteNewsletterForm: "NewsletterFormDeleteResult",
        updateNewsletterForm: "NewsletterFormUpdateResult",
        upsertNewsletterForm: "NewsletterFormUpsertResult",
        createNewsletterTypeItem: "NewsletterTypeItemCreateResult",
        deleteNewsletterTypeItem: "NewsletterTypeItemDeleteResult",
        updateNewsletterTypeItem: "NewsletterTypeItemUpdateResult",
        upsertNewsletterTypeItem: "NewsletterTypeItemUpsertResult",
        createNewsletterFormLocale: "NewsletterFormLocaleCreateResult",
        deleteNewsletterFormLocale: "NewsletterFormLocaleDeleteResult",
        updateNewsletterFormLocale: "NewsletterFormLocaleUpdateResult",
        upsertNewsletterFormLocale: "NewsletterFormLocaleUpsertResult",
        createNewsletterSubscription: "NewsletterSubscriptionCreateResult",
        deleteNewsletterSubscription: "NewsletterSubscriptionDeleteResult",
        updateNewsletterSubscription: "NewsletterSubscriptionUpdateResult",
        upsertNewsletterSubscription: "NewsletterSubscriptionUpsertResult",
        createChart: "ChartCreateResult",
        deleteChart: "ChartDeleteResult",
        updateChart: "ChartUpdateResult",
        upsertChart: "ChartUpsertResult",
        createChartData: "ChartDataCreateResult",
        deleteChartData: "ChartDataDeleteResult",
        updateChartData: "ChartDataUpdateResult",
        upsertChartData: "ChartDataUpsertResult",
        createEmployee: "EmployeeCreateResult",
        deleteEmployee: "EmployeeDeleteResult",
        updateEmployee: "EmployeeUpdateResult",
        upsertEmployee: "EmployeeUpsertResult",
        createEmployeeItem: "EmployeeItemCreateResult",
        deleteEmployeeItem: "EmployeeItemDeleteResult",
        updateEmployeeItem: "EmployeeItemUpdateResult",
        upsertEmployeeItem: "EmployeeItemUpsertResult",
        createEmployeeList: "EmployeeListCreateResult",
        deleteEmployeeList: "EmployeeListDeleteResult",
        updateEmployeeList: "EmployeeListUpdateResult",
        upsertEmployeeList: "EmployeeListUpsertResult",
        createEmployeeLocale: "EmployeeLocaleCreateResult",
        deleteEmployeeLocale: "EmployeeLocaleDeleteResult",
        updateEmployeeLocale: "EmployeeLocaleUpdateResult",
        upsertEmployeeLocale: "EmployeeLocaleUpsertResult",
        createPhotographer: "PhotographerCreateResult",
        deletePhotographer: "PhotographerDeleteResult",
        updatePhotographer: "PhotographerUpdateResult",
        upsertPhotographer: "PhotographerUpsertResult",
        createDefinitionItem: "DefinitionItemCreateResult",
        deleteDefinitionItem: "DefinitionItemDeleteResult",
        updateDefinitionItem: "DefinitionItemUpdateResult",
        upsertDefinitionItem: "DefinitionItemUpsertResult",
        createDefinitionList: "DefinitionListCreateResult",
        deleteDefinitionList: "DefinitionListDeleteResult",
        updateDefinitionList: "DefinitionListUpdateResult",
        upsertDefinitionList: "DefinitionListUpsertResult",
        createLogoItem: "LogoItemCreateResult",
        deleteLogoItem: "LogoItemDeleteResult",
        updateLogoItem: "LogoItemUpdateResult",
        upsertLogoItem: "LogoItemUpsertResult",
        createLogoList: "LogoListCreateResult",
        deleteLogoList: "LogoListDeleteResult",
        updateLogoList: "LogoListUpdateResult",
        upsertLogoList: "LogoListUpsertResult",
        createStrategySchema: "StrategySchemaCreateResult",
        deleteStrategySchema: "StrategySchemaDeleteResult",
        updateStrategySchema: "StrategySchemaUpdateResult",
        upsertStrategySchema: "StrategySchemaUpsertResult",
        createStrategySchemaGroup: "StrategySchemaGroupCreateResult",
        deleteStrategySchemaGroup: "StrategySchemaGroupDeleteResult",
        updateStrategySchemaGroup: "StrategySchemaGroupUpdateResult",
        upsertStrategySchemaGroup: "StrategySchemaGroupUpsertResult",
        createStrategySchemaGroupItem: "StrategySchemaGroupItemCreateResult",
        deleteStrategySchemaGroupItem: "StrategySchemaGroupItemDeleteResult",
        updateStrategySchemaGroupItem: "StrategySchemaGroupItemUpdateResult",
        upsertStrategySchemaGroupItem: "StrategySchemaGroupItemUpsertResult",
        createRedirect: "RedirectCreateResult",
        deleteRedirect: "RedirectDeleteResult",
        updateRedirect: "RedirectUpdateResult",
        upsertRedirect: "RedirectUpsertResult",
        createGallery: "GalleryCreateResult",
        deleteGallery: "GalleryDeleteResult",
        updateGallery: "GalleryUpdateResult",
        upsertGallery: "GalleryUpsertResult",
        createGalleryItem: "GalleryItemCreateResult",
        deleteGalleryItem: "GalleryItemDeleteResult",
        updateGalleryItem: "GalleryItemUpdateResult",
        upsertGalleryItem: "GalleryItemUpsertResult",
        createContactForm: "ContactFormCreateResult",
        deleteContactForm: "ContactFormDeleteResult",
        updateContactForm: "ContactFormUpdateResult",
        upsertContactForm: "ContactFormUpsertResult",
        createContactFormLocale: "ContactFormLocaleCreateResult",
        deleteContactFormLocale: "ContactFormLocaleDeleteResult",
        updateContactFormLocale: "ContactFormLocaleUpdateResult",
        upsertContactFormLocale: "ContactFormLocaleUpsertResult",
        createContactSubscription: "ContactSubscriptionCreateResult",
        deleteContactSubscription: "ContactSubscriptionDeleteResult",
        updateContactSubscription: "ContactSubscriptionUpdateResult",
        upsertContactSubscription: "ContactSubscriptionUpsertResult",
        createContactTypeItem: "ContactTypeItemCreateResult",
        deleteContactTypeItem: "ContactTypeItemDeleteResult",
        updateContactTypeItem: "ContactTypeItemUpdateResult",
        upsertContactTypeItem: "ContactTypeItemUpsertResult",
        createFile: "FileCreateResult",
        deleteFile: "FileDeleteResult",
        updateFile: "FileUpdateResult",
        upsertFile: "FileUpsertResult",
        query: "Query"
    },
    _Schema: {
        enums: "_Enum",
        entities: "_Entity"
    },
    _Entity: {
        name: "String",
        customPrimaryAllowed: "Boolean",
        fields: "_Field",
        unique: "_UniqueConstraint"
    },
    _UniqueConstraint: {
        fields: "String"
    },
    _Field: {
        "...on _Column": "_Column",
        "...on _Relation": "_Relation",
        name: "String",
        type: "String",
        nullable: "Boolean",
        rules: "_Rule",
        validators: "_Validator"
    },
    _Column: {
        name: "String",
        type: "String",
        enumName: "String",
        defaultValue: "Json",
        nullable: "Boolean",
        rules: "_Rule",
        validators: "_Validator"
    },
    _OrderBy: {
        path: "String",
        direction: "_OrderByDirection"
    },
    _Relation: {
        name: "String",
        type: "String",
        side: "_RelationSide",
        targetEntity: "String",
        ownedBy: "String",
        inversedBy: "String",
        nullable: "Boolean",
        onDelete: "_OnDeleteBehaviour",
        orphanRemoval: "Boolean",
        orderBy: "_OrderBy",
        rules: "_Rule",
        validators: "_Validator"
    },
    _Rule: {
        message: "_RuleMessage",
        validator: "Int"
    },
    _Validator: {
        operation: "String",
        arguments: "_Argument"
    },
    _Argument: {
        "...on _ValidatorArgument": "_ValidatorArgument",
        "...on _PathArgument": "_PathArgument",
        "...on _LiteralArgument": "_LiteralArgument"
    },
    _ValidatorArgument: {
        validator: "Int"
    },
    _PathArgument: {
        path: "String"
    },
    _LiteralArgument: {
        value: "Json"
    },
    _RuleMessage: {
        text: "String"
    },
    _Enum: {
        name: "String",
        values: "String"
    },
    S3SignedUpload: {
        url: "String",
        headers: "S3Header",
        method: "String",
        objectKey: "String",
        bucket: "String",
        publicUrl: "String"
    },
    S3Header: {
        key: "String",
        value: "String"
    },
    S3SignedRead: {
        url: "String",
        headers: "S3Header",
        method: "String",
        objectKey: "String",
        bucket: "String"
    }
};
var One;
(function(One) {
    One["One"] = "One";
})(One || (One = {}));
var LinkType;
(function(LinkType) {
    LinkType["internal"] = "internal";
    LinkType["external"] = "external";
    LinkType["anchor"] = "anchor";
})(LinkType || (LinkType = {}));
var MediumType;
(function(MediumType) {
    MediumType["image"] = "image";
    MediumType["video"] = "video";
})(MediumType || (MediumType = {}));
var ContentReferenceType;
(function(ContentReferenceType) {
    ContentReferenceType["gallery"] = "gallery";
    ContentReferenceType["image"] = "image";
    ContentReferenceType["dropDown"] = "dropDown";
    ContentReferenceType["carouselWithArtworks"] = "carouselWithArtworks";
    ContentReferenceType["button"] = "button";
    ContentReferenceType["events"] = "events";
    ContentReferenceType["boxes"] = "boxes";
    ContentReferenceType["newsletter"] = "newsletter";
    ContentReferenceType["contactForm"] = "contactForm";
    ContentReferenceType["chart"] = "chart";
    ContentReferenceType["link"] = "link";
    ContentReferenceType["definitionList"] = "definitionList";
    ContentReferenceType["sponsors"] = "sponsors";
    ContentReferenceType["strategySchema"] = "strategySchema";
    ContentReferenceType["vennDiagram"] = "vennDiagram";
    ContentReferenceType["personCarousel"] = "personCarousel";
    ContentReferenceType["galleryInfo"] = "galleryInfo";
})(ContentReferenceType || (ContentReferenceType = {}));
var DropDownType;
(function(DropDownType) {
    DropDownType["link"] = "link";
    DropDownType["person"] = "person";
})(DropDownType || (DropDownType = {}));
var ChartType;
(function(ChartType) {
    ChartType["pie"] = "pie";
    ChartType["column"] = "column";
})(ChartType || (ChartType = {}));
var OrderDirection;
(function(OrderDirection) {
    OrderDirection["asc"] = "asc";
    OrderDirection["desc"] = "desc";
    OrderDirection["ascNullsFirst"] = "ascNullsFirst";
    OrderDirection["descNullsLast"] = "descNullsLast";
})(OrderDirection || (OrderDirection = {}));
var TranslationContentType;
(function(TranslationContentType) {
    TranslationContentType["textPlain"] = "textPlain";
    TranslationContentType["textHtml"] = "textHtml";
})(TranslationContentType || (TranslationContentType = {}));
var _MutationErrorType;
(function(_MutationErrorType) {
    _MutationErrorType["NotNullConstraintViolation"] = "NotNullConstraintViolation";
    _MutationErrorType["UniqueConstraintViolation"] = "UniqueConstraintViolation";
    _MutationErrorType["ForeignKeyConstraintViolation"] = "ForeignKeyConstraintViolation";
    _MutationErrorType["NotFoundOrDenied"] = "NotFoundOrDenied";
    _MutationErrorType["NonUniqueWhereInput"] = "NonUniqueWhereInput";
    _MutationErrorType["InvalidDataInput"] = "InvalidDataInput";
    _MutationErrorType["SqlError"] = "SqlError";
})(_MutationErrorType || (_MutationErrorType = {}));
var _OnDeleteBehaviour;
(function(_OnDeleteBehaviour) {
    _OnDeleteBehaviour["restrict"] = "restrict";
    _OnDeleteBehaviour["cascade"] = "cascade";
    _OnDeleteBehaviour["setNull"] = "setNull";
})(_OnDeleteBehaviour || (_OnDeleteBehaviour = {}));
var _RelationSide;
(function(_RelationSide) {
    _RelationSide["owning"] = "owning";
    _RelationSide["inverse"] = "inverse";
})(_RelationSide || (_RelationSide = {}));
var _OrderByDirection;
(function(_OrderByDirection) {
    _OrderByDirection["asc"] = "asc";
    _OrderByDirection["desc"] = "desc";
})(_OrderByDirection || (_OrderByDirection = {}));
class GraphQLError extends Error {
    toString() {
        return "GraphQL Response Error";
    }
    constructor(response){
        super("");
        _define_property(this, "response", void 0);
        this.response = response;
        console.error(response);
    }
}
const ZeusSelect = ()=>(t)=>t;
const ScalarResolver = (scalar, value)=>{
    switch(scalar){
        case "String":
            return "".concat(JSON.stringify(value));
        case "Int":
            return "".concat(value);
        case "Float":
            return "".concat(value);
        case "Boolean":
            return "".concat(value);
        case "ID":
            return '"'.concat(value, '"');
        case "enum":
            return "".concat(value);
        case "scalar":
            return "".concat(value);
        default:
            return false;
    }
};
const TypesPropsResolver = (param)=>{
    let { value , type , name , key , blockArrays  } = param;
    if (value === null) {
        return "null";
    }
    let resolvedValue = AllTypesProps[type][name];
    if (key) {
        resolvedValue = resolvedValue[key];
    }
    if (!resolvedValue) {
        throw new Error("Cannot resolve ".concat(type, " ").concat(name).concat(key ? " ".concat(key) : ""));
    }
    const typeResolved = resolvedValue.type;
    const isArray = resolvedValue.array;
    const isArrayRequired = resolvedValue.arrayRequired;
    if (typeof value === "string" && value.startsWith("ZEUS_VAR$")) {
        const isRequired = resolvedValue.required ? "!" : "";
        let t = "".concat(typeResolved);
        if (isArray) {
            if (isRequired) {
                t = "".concat(t, "!");
            }
            t = "[".concat(t, "]");
            if (isArrayRequired) {
                t = "".concat(t, "!");
            }
        } else {
            if (isRequired) {
                t = "".concat(t, "!");
            }
        }
        return "$".concat(value.split("ZEUS_VAR$")[1], "__ZEUS_VAR__").concat(t);
    }
    if (isArray && !blockArrays) {
        return "[".concat(value.map((v)=>TypesPropsResolver({
                value: v,
                type,
                name,
                key,
                blockArrays: true
            })).join(","), "]");
    }
    const reslovedScalar = ScalarResolver(typeResolved, value);
    if (!reslovedScalar) {
        const resolvedType = AllTypesProps[typeResolved];
        if (typeof resolvedType === "object") {
            const argsKeys = Object.keys(resolvedType);
            return "{".concat(argsKeys.filter((ak)=>value[ak] !== undefined).map((ak)=>"".concat(ak, ":").concat(TypesPropsResolver({
                    value: value[ak],
                    type: typeResolved,
                    name: ak
                }))), "}");
        }
        return ScalarResolver(AllTypesProps[typeResolved], value);
    }
    return reslovedScalar;
};
const isArrayFunction = (parent, a)=>{
    const [values, r] = a;
    const [mainKey, key, ...keys] = parent;
    const keyValues = Object.keys(values).filter((k)=>typeof values[k] !== "undefined");
    if (!keys.length) {
        return keyValues.length > 0 ? "(".concat(keyValues.map((v)=>"".concat(v, ":").concat(TypesPropsResolver({
                value: values[v],
                type: mainKey,
                name: key,
                key: v
            }))).join(","), ")").concat(r ? traverseToSeekArrays(parent, r) : "") : traverseToSeekArrays(parent, r);
    }
    const [typeResolverKey] = keys.splice(keys.length - 1, 1);
    let valueToResolve = ReturnTypes[mainKey][key];
    for (const k of keys){
        valueToResolve = ReturnTypes[valueToResolve][k];
    }
    const argumentString = keyValues.length > 0 ? "(".concat(keyValues.map((v)=>"".concat(v, ":").concat(TypesPropsResolver({
            value: values[v],
            type: valueToResolve,
            name: typeResolverKey,
            key: v
        }))).join(","), ")").concat(r ? traverseToSeekArrays(parent, r) : "") : traverseToSeekArrays(parent, r);
    return argumentString;
};
const resolveKV = (k, v)=>typeof v === "boolean" ? k : typeof v === "object" ? "".concat(k, "{").concat(objectToTree(v), "}") : "".concat(k).concat(v);
const objectToTree = (o)=>"{".concat(Object.keys(o).map((k)=>"".concat(resolveKV(k, o[k]))).join(" "), "}");
const traverseToSeekArrays = (parent, a)=>{
    if (!a) return "";
    if (Object.keys(a).length === 0) {
        return "";
    }
    let b = {};
    if (Array.isArray(a)) {
        return isArrayFunction([
            ...parent
        ], a);
    } else {
        if (typeof a === "object") {
            Object.keys(a).filter((k)=>typeof a[k] !== "undefined").forEach((k)=>{
                if (k === "__alias") {
                    Object.keys(a[k]).forEach((aliasKey)=>{
                        const aliasOperations = a[k][aliasKey];
                        const aliasOperationName = Object.keys(aliasOperations)[0];
                        const aliasOperation = aliasOperations[aliasOperationName];
                        b["".concat(aliasOperationName, "__alias__").concat(aliasKey, ": ").concat(aliasOperationName)] = traverseToSeekArrays([
                            ...parent,
                            aliasOperationName
                        ], aliasOperation);
                    });
                } else {
                    b[k] = traverseToSeekArrays([
                        ...parent,
                        k
                    ], a[k]);
                }
            });
        } else {
            return "";
        }
    }
    return objectToTree(b);
};
const buildQuery = (type, a)=>traverseToSeekArrays([
        type
    ], a);
const inspectVariables = (query)=>{
    const regex = /\$\b\w*__ZEUS_VAR__\[?[^!^\]^\s^,^\)^\}]*[!]?[\]]?[!]?/g;
    let result;
    const AllVariables = [];
    while(result = regex.exec(query)){
        if (AllVariables.includes(result[0])) {
            continue;
        }
        AllVariables.push(result[0]);
    }
    if (!AllVariables.length) {
        return query;
    }
    let filteredQuery = query;
    AllVariables.forEach((variable)=>{
        while(filteredQuery.includes(variable)){
            filteredQuery = filteredQuery.replace(variable, variable.split("__ZEUS_VAR__")[0]);
        }
    });
    return "(".concat(AllVariables.map((a)=>a.split("__ZEUS_VAR__")).map((param)=>{
        let [variableName, variableType] = param;
        return "".concat(variableName, ":").concat(variableType);
    }).join(", "), ")").concat(filteredQuery);
};
const queryConstruct = (t, tName, operationName)=>(o)=>"".concat(t.toLowerCase()).concat(operationName ? " " + operationName : "").concat(inspectVariables(buildQuery(tName, o)));
const fullChainConstruct = (fn)=>{
    return (t, tName)=>{
        return (o, options)=>{
            return fn(queryConstruct(t, tName, options === null || options === void 0 ? void 0 : options.operationName)(o), options === null || options === void 0 ? void 0 : options.variables).then((r)=>{
                seekForAliases(r);
                return r;
            });
        };
    };
};
const fullChainConstructor = (fn, operation, key)=>(o, options)=>fullChainConstruct(fn)(operation, key)(o, options);
const fullSubscriptionConstruct = (fn)=>{
    return (t, tName)=>{
        return (o, options)=>{
            return fn(queryConstruct(t, tName, options === null || options === void 0 ? void 0 : options.operationName)(o));
        };
    };
};
const fullSubscriptionConstructor = (fn, operation, key)=>(o, options)=>fullSubscriptionConstruct(fn)(operation, key)(o, options);
const seekForAliases = (response)=>{
    const traverseAlias = (value)=>{
        if (Array.isArray(value)) {
            value.forEach(seekForAliases);
        } else {
            if (typeof value === "object") {
                seekForAliases(value);
            }
        }
    };
    if (typeof response === "object" && response) {
        const keys = Object.keys(response);
        if (keys.length < 1) {
            return;
        }
        keys.forEach((k)=>{
            const value = response[k];
            if (k.indexOf("__alias__") !== -1) {
                const [operation, alias] = k.split("__alias__");
                response[alias] = {
                    [operation]: value
                };
                delete response[k];
            }
            traverseAlias(value);
        });
    }
};
const $ = (t)=>"ZEUS_VAR$".concat(t.join(""));
const resolverFor = (type, field, fn)=>fn;
const handleFetchResponse = (response)=>{
    if (!response.ok) {
        return new Promise((_, reject)=>{
            response.text().then((text)=>{
                try {
                    reject(JSON.parse(text));
                } catch (err) {
                    reject(text);
                }
            }).catch(reject);
        });
    }
    return response.json();
};
const apiFetch = (options)=>function(query) {
        let variables = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        let fetchFunction = fetch;
        let queryString = query;
        let fetchOptions = options[1] || {};
        if (fetchOptions.method && fetchOptions.method === "GET") {
            queryString = encodeURIComponent(query);
            return fetchFunction("".concat(options[0], "?query=").concat(queryString), fetchOptions).then(handleFetchResponse).then((response)=>{
                if (response.errors) {
                    throw new GraphQLError(response);
                }
                return response.data;
            });
        }
        return fetchFunction("".concat(options[0]), {
            body: JSON.stringify({
                query: queryString,
                variables
            }),
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            ...fetchOptions
        }).then(handleFetchResponse).then((response)=>{
            if (response.errors) {
                throw new GraphQLError(response);
            }
            return response.data;
        });
    };
const apiSubscription = (options)=>{
    return (query)=>{
        try {
            var ref, ref1, ref2;
            const queryString = options[0] + "?query=" + encodeURIComponent(query);
            const wsString = queryString.replace("http", "ws");
            const host = options.length > 1 && ((ref = options[1]) === null || ref === void 0 ? void 0 : (ref1 = ref.websocket) === null || ref1 === void 0 ? void 0 : ref1[0]) || wsString;
            const webSocketOptions = ((ref2 = options[1]) === null || ref2 === void 0 ? void 0 : ref2.websocket) || [
                host
            ];
            const ws = new WebSocket(...webSocketOptions);
            return {
                ws,
                on: (e)=>{
                    ws.onmessage = (event)=>{
                        if (event.data) {
                            const parsed = JSON.parse(event.data);
                            const data = parsed.data;
                            if (data) {
                                seekForAliases(data);
                            }
                            return e(data);
                        }
                    };
                },
                off: (e)=>{
                    ws.onclose = e;
                },
                error: (e)=>{
                    ws.onerror = e;
                },
                open: (e)=>{
                    ws.onopen = e;
                }
            };
        } catch (e) {
            throw new Error("No websockets implemented");
        }
    };
};
const Thunder = (fn, subscriptionFn)=>({
        query: fullChainConstructor(fn, "query", "Query"),
        mutation: fullChainConstructor(fn, "mutation", "Mutation")
    });
const Chain = function() {
    for(var _len = arguments.length, options = new Array(_len), _key = 0; _key < _len; _key++){
        options[_key] = arguments[_key];
    }
    return {
        query: fullChainConstructor(apiFetch(options), "query", "Query"),
        mutation: fullChainConstructor(apiFetch(options), "mutation", "Mutation")
    };
};
const Zeus = {
    query: (o, operationName)=>queryConstruct("query", "Query", operationName)(o),
    mutation: (o, operationName)=>queryConstruct("mutation", "Mutation", operationName)(o)
};
const Selectors = {
    query: ZeusSelect(),
    mutation: ZeusSelect()
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./app/contexts/ActiveUrlContext.ts

function useActivePage() {
    //@TODO reconstruct from querry param
    return (0,router.useRouter)().asPath;
}

;// CONCATENATED MODULE: ./app/components/Link.tsx






function Link(props) {
    var ref, ref1, ref2;
    const activeUrl = useActivePage();
    if ("href" in props) {
        const isActive = activeUrl === props.href;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: props.href,
            className: (0,clsx_m/* default */.Z)(props.className, isActive && props.activeClassName),
            onClick: props.onClick,
            children: props.children
        });
    }
    if (((ref = props.link) === null || ref === void 0 ? void 0 : ref.externalLink) || ((ref1 = props.link) === null || ref1 === void 0 ? void 0 : ref1.internalLink) || ((ref2 = props.link) === null || ref2 === void 0 ? void 0 : ref2.anchorLink)) {
        var ref3;
        const url = props.link.type === LinkType.internal && ((ref3 = props.link.internalLink) === null || ref3 === void 0 ? void 0 : ref3.url) ? props.link.internalLink.url : props.link.type === LinkType.external ? props.link.externalLink : props.link.anchorLink;
        const isActive1 = activeUrl === url;
        var _children;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: url,
            className: (0,clsx_m/* default */.Z)(props.className, isActive1 && props.activeClassName),
            onClick: props.onClick,
            children: (_children = props.children) !== null && _children !== void 0 ? _children : props.link.title
        });
    } else {
        return null;
    }
}

;// CONCATENATED MODULE: ./app/components/BoxTile.tsx



const BoxTile = (param)=>{
    let { link , date , type , title , text  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link, {
        href: link,
        className: (BoxTile_module_default()).BoxTile,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BoxTile_module_default()).BoxInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (BoxTile_module_default()).Date,
                        children: date
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (BoxTile_module_default()).Type,
                        children: type
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (BoxTile_module_default()).Title,
                children: title
            }),
            text && text.length > 300 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (BoxTile_module_default()).LeadParagraph,
                children: [
                    text.substring(0, 250),
                    "..."
                ]
            }) || /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (BoxTile_module_default()).LeadParagraph,
                children: text
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/components/BoxList.tsx




const BoxList = (param)=>{
    let { boxes  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (BoxList_module_default()).BoxList,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            size: "normal",
            children: boxes.items.map((item)=>item.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxTile, {
                    link: item.link,
                    date: item.date,
                    type: item.type,
                    title: item.title,
                    text: item.text
                }, item.id))
        })
    });
};

// EXTERNAL MODULE: ./app/components/Button.module.sass
var Button_module = __webpack_require__(5450);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
// EXTERNAL MODULE: ./node_modules/svg-baker-runtime/browser-symbol.js
var browser_symbol = __webpack_require__(7854);
var browser_symbol_default = /*#__PURE__*/__webpack_require__.n(browser_symbol);
// EXTERNAL MODULE: ./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js
var browser_sprite_build = __webpack_require__(5348);
var browser_sprite_build_default = /*#__PURE__*/__webpack_require__.n(browser_sprite_build);
;// CONCATENATED MODULE: ./app/icons/arrowBig.svg


var symbol = new (browser_symbol_default())({
  "id": "arrowBig",
  "use": "arrowBig-usage",
  "viewBox": "0 0 345 64",
  "content": "<symbol viewBox=\"0 0 345 64\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrowBig\">\n<g clip-path=\"url(#arrowBig_clip0_1624_4543)\">\n<path d=\"M332.343 59.7703V44.6109C332.343 34.8995 328.46 25.5857 321.547 18.7187C314.634 11.8517 305.258 7.99402 295.482 7.99402H-0.240234\" stroke=\"#231F20\" stroke-linecap=\"round\" />\n<path d=\"M342.43 49.719L332.275 60.6138L322.255 49.719\" stroke=\"#231F20\" stroke-linecap=\"round\" />\n</g>\n<defs>\n<clipPath id=\"arrowBig_clip0_1624_4543\">\n<rect width=\"344\" height=\"63\" fill=\"white\" transform=\"translate(0.0712891 0.334351)\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = browser_sprite_build_default().add(symbol);
/* harmony default export */ var arrowBig = (symbol);
;// CONCATENATED MODULE: ./app/icons/arrowDown.svg


var arrowDown_symbol = new (browser_symbol_default())({
  "id": "arrowDown",
  "use": "arrowDown-usage",
  "viewBox": "0 0 22 28",
  "content": "<symbol viewBox=\"0 0 22 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrowDown\">\n<path d=\"M0.93949 16.0241C0.744228 15.8289 0.427646 15.8289 0.232384 16.0241C0.0371215 16.2194 0.0371215 16.536 0.232384 16.7312L0.93949 16.0241ZM10.5859 26.3777L10.2324 26.7312L10.5859 27.0848L10.9395 26.7312L10.5859 26.3777ZM20.9395 16.7312C21.1348 16.536 21.1348 16.2194 20.9395 16.0241C20.7442 15.8289 20.4276 15.8289 20.2324 16.0241L20.9395 16.7312ZM11.0859 1.37769C11.0859 1.10154 10.8621 0.877687 10.5859 0.877687C10.3098 0.877687 10.0859 1.10154 10.0859 1.37769L11.0859 1.37769ZM0.232384 16.7312L10.2324 26.7312L10.9395 26.0241L0.93949 16.0241L0.232384 16.7312ZM10.9395 26.7312L20.9395 16.7312L20.2324 16.0241L10.2324 26.0241L10.9395 26.7312ZM11.0859 26.3777L11.0859 1.37769L10.0859 1.37769L10.0859 26.3777L11.0859 26.3777Z\" fill=\"black\" />\n</symbol>"
});
var arrowDown_result = browser_sprite_build_default().add(arrowDown_symbol);
/* harmony default export */ var arrowDown = (arrowDown_symbol);
;// CONCATENATED MODULE: ./app/icons/arte.svg


var arte_symbol = new (browser_symbol_default())({
  "id": "arte",
  "use": "arte-usage",
  "viewBox": "0 0 742 328",
  "content": "<symbol viewBox=\"0 0 742 328\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arte\">\n<path d=\"M145.999 0.366761H54.1787C53.9195 0.370324 53.67 0.466073 53.4747 0.636971C53.2793 0.807868 53.1509 1.04281 53.112 1.29993L0.213121 326.157C0.190219 326.316 0.200327 326.479 0.24267 326.635C0.285013 326.791 0.358762 326.936 0.459363 327.062C0.56506 327.184 0.695383 327.281 0.841663 327.347C0.987943 327.413 1.14676 327.447 1.30727 327.447H68.1282C68.3946 327.443 68.651 327.344 68.8514 327.168C69.0519 326.992 69.1833 326.75 69.2223 326.486L77.2638 262.947H121.492L130.026 326.486C130.065 326.75 130.196 326.992 130.397 327.168C130.597 327.344 130.854 327.443 131.12 327.447H199.5C199.656 327.443 199.809 327.407 199.951 327.341C200.092 327.275 200.218 327.18 200.321 327.062C200.427 326.94 200.505 326.795 200.548 326.638C200.591 326.481 200.597 326.316 200.567 326.157L147.094 1.19012C147.031 0.948571 146.889 0.735374 146.691 0.58571C146.492 0.436046 146.248 0.358872 145.999 0.366761ZM114.463 209.783H84.3754L99.036 85.643L114.463 209.783Z\" fill=\"black\" />\n<path d=\"M567.275 0.366699H398.568C398.278 0.366699 398 0.482365 397.794 0.688254C397.589 0.894143 397.474 1.17337 397.474 1.46454V65.4972C397.474 65.7884 397.589 66.0676 397.794 66.2735C398 66.4794 398.278 66.595 398.568 66.595H446.981V326.349C446.977 326.494 447.003 326.638 447.057 326.773C447.11 326.908 447.191 327.031 447.293 327.133C447.395 327.236 447.518 327.317 447.652 327.371C447.786 327.424 447.93 327.45 448.075 327.447H517.768C518.058 327.447 518.337 327.331 518.542 327.125C518.747 326.919 518.862 326.64 518.862 326.349V66.595H567.275C567.565 66.595 567.844 66.4794 568.049 66.2735C568.254 66.0676 568.369 65.7884 568.369 65.4972V1.46454C568.369 1.17337 568.254 0.894143 568.049 0.688254C567.844 0.482365 567.565 0.366699 567.275 0.366699Z\" fill=\"black\" />\n<path d=\"M740.742 261.685H651.465V191.367H722.58C722.87 191.367 723.149 191.251 723.354 191.045C723.559 190.839 723.674 190.56 723.674 190.269V129.063C723.674 128.772 723.559 128.493 723.354 128.287C723.149 128.081 722.87 127.965 722.58 127.965H651.465V66.1285H740.277C740.419 66.1285 740.56 66.1 740.692 66.0445C740.823 65.989 740.942 65.9077 741.041 65.8053C741.14 65.703 741.218 65.5817 741.27 65.4487C741.322 65.3156 741.347 65.1735 741.344 65.0306V1.46454C741.347 1.32168 741.322 1.17955 741.27 1.0465C741.218 0.913443 741.14 0.792168 741.041 0.689846C740.942 0.587523 740.823 0.506212 740.692 0.450711C740.56 0.395209 740.419 0.366652 740.277 0.366699H582.1C581.81 0.366699 581.532 0.482365 581.327 0.688254C581.121 0.894143 581.006 1.17337 581.006 1.46454V326.349C581.006 326.64 581.121 326.919 581.327 327.125C581.532 327.331 581.81 327.447 582.1 327.447H740.742C741.032 327.447 741.31 327.331 741.515 327.125C741.721 326.919 741.836 326.64 741.836 326.349V262.783C741.836 262.491 741.721 262.212 741.515 262.006C741.31 261.8 741.032 261.685 740.742 261.685Z\" fill=\"black\" />\n<path d=\"M390.362 293.907L385.877 215.52C384.728 189.418 375.483 171.605 358.525 161.944C366.148 156.78 372.775 150.27 378.081 142.732C387.162 129.64 391.566 113.117 391.566 92.2301C391.755 79.27 389.681 66.3768 385.439 54.1343C381.596 43.1702 375.298 33.2362 367.031 25.0959C350.155 8.62798 325.483 0.256836 293.7 0.256836H215.528C215.238 0.256836 214.96 0.372502 214.755 0.578391C214.549 0.784279 214.434 1.06351 214.434 1.35468V326.349C214.434 326.64 214.549 326.919 214.755 327.125C214.96 327.331 215.238 327.446 215.528 327.446H283.908C284.198 327.446 284.477 327.331 284.682 327.125C284.887 326.919 285.002 326.64 285.002 326.349V197.954H287.409C299.089 197.954 307.54 201.44 312.573 208.329C316.375 213.571 318.344 220.844 318.591 230.533L320.505 290.476C320.916 306.477 323.569 316.687 329.996 326.925C330.094 327.084 330.231 327.216 330.394 327.307C330.557 327.398 330.74 327.446 330.926 327.446H398.978C399.181 327.442 399.379 327.384 399.552 327.278C399.724 327.172 399.866 327.022 399.963 326.843C400.056 326.67 400.105 326.477 400.105 326.28C400.105 326.084 400.056 325.89 399.963 325.717C393.637 316.329 390.29 305.24 390.362 293.907ZM285.002 58.3336H290.883C300.429 58.3336 307.869 61.49 312.983 67.6929C318.755 74.6643 321.681 85.5879 321.681 100.135C321.681 115.807 318.208 127.197 311.397 133.949C308.668 136.521 305.441 138.503 301.917 139.773C298.393 141.043 294.647 141.574 290.91 141.332H285.002V58.3336Z\" fill=\"black\" />\n</symbol>"
});
var arte_result = browser_sprite_build_default().add(arte_symbol);
/* harmony default export */ var arte = (arte_symbol);
;// CONCATENATED MODULE: ./app/icons/cross.svg


var cross_symbol = new (browser_symbol_default())({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 166 78",
  "content": "<symbol viewBox=\"0 0 166 78\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"cross\">\n<path d=\"M1.33594 75.209L165.336 1.20899\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M1.33594 1.20898L165.336 77.2231\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var cross_result = browser_sprite_build_default().add(cross_symbol);
/* harmony default export */ var cross = (cross_symbol);
;// CONCATENATED MODULE: ./app/icons/go.svg


var go_symbol = new (browser_symbol_default())({
  "id": "go",
  "use": "go-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" xmlns=\"http://www.w3.org/2000/svg\" id=\"go\">\n\t<g stroke=\"currentColor\" stroke-width=\"10\" fill=\"none\" fill-rule=\"evenodd\">\n\t\t<path d=\"M486.519 256c0-26.316 13.158-53.947 5.263-77.632-7.895-25-34.21-39.473-50-59.21-14.474-21.053-21.053-51.316-40.79-65.79-19.736-14.473-50-10.526-75-18.42C303.625 27.052 281.257 6 256.257 6c-26.316 0-48.684 21.053-71.053 28.947-23.684 7.895-53.947 3.948-75 18.421-19.737 14.474-26.316 44.737-40.79 65.79-14.473 19.737-42.105 35.526-50 59.21-7.894 23.685 5.264 51.316 5.264 77.632 0 26.316-13.158 53.947-5.263 77.632 7.894 23.684 34.21 39.473 50 59.21 14.473 21.053 21.052 51.316 40.79 65.79 19.736 14.473 50 10.526 75 18.42 23.681 7.896 46.05 28.948 71.05 28.948 26.316 0 48.684-21.053 71.052-28.947 23.685-7.895 53.948-3.948 75-18.421 19.737-14.474 26.316-44.737 40.79-65.79 14.474-19.737 42.105-35.526 50-59.21 6.579-23.685-6.58-51.316-6.58-77.632\" />\n\t\t<path d=\"M220.73 166.526c0-11.842-3.948-22.368-10.527-30.263a43.421 43.421 0 0 0-32.895-15.79c-24.918.713-44.747 21.124-44.736 46.053v185.527c0 25 19.736 46.052 44.736 46.052 25 0 44.737-21.052 44.737-46.052V274.42s1.316-9.21-6.579-18.421c-6.579-6.579-17.105-7.895-17.105-7.895h-31.579\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n\t\t<path d=\"M290.466 212.579c0-25 19.737-46.053 44.737-46.053 25 0 44.737 21.053 44.737 46.053v139.474c0 25-19.737 46.052-44.737 46.052-24.919-.712-44.747-21.123-44.737-46.052V212.579h0z\" stroke-linecap=\"square\" stroke-linejoin=\"round\" />\n\t</g>\n</symbol>"
});
var go_result = browser_sprite_build_default().add(go_symbol);
/* harmony default export */ var go = (go_symbol);
;// CONCATENATED MODULE: ./app/icons/hamburger.svg


var hamburger_symbol = new (browser_symbol_default())({
  "id": "hamburger",
  "use": "hamburger-usage",
  "viewBox": "0 0 166 20",
  "content": "<symbol viewBox=\"0 0 166 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"hamburger\">\n<path d=\"M1.0061 9.98291L165.006 9.9829\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M1.0061 19.2847L165.006 19.2847\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M1.0061 0.681641L165.006 0.681633\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var hamburger_result = browser_sprite_build_default().add(hamburger_symbol);
/* harmony default export */ var hamburger = (hamburger_symbol);
;// CONCATENATED MODULE: ./app/icons/hamburgerMobile.svg


var hamburgerMobile_symbol = new (browser_symbol_default())({
  "id": "hamburgerMobile",
  "use": "hamburgerMobile-usage",
  "viewBox": "0 0 64 37",
  "content": "<symbol viewBox=\"0 0 64 37\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"hamburgerMobile\">\n<path d=\"M1 18.5L63 18.5\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M1 35.6978L63 35.6978\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M1 1L63 0.999997\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var hamburgerMobile_result = browser_sprite_build_default().add(hamburgerMobile_symbol);
/* harmony default export */ var hamburgerMobile = (hamburgerMobile_symbol);
;// CONCATENATED MODULE: ./app/icons/play.svg


var play_symbol = new (browser_symbol_default())({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 43 44",
  "content": "<symbol viewBox=\"0 0 43 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"play\">\n<path d=\"M41.2111 21.1057L3.06999 2.03508C2.27211 1.63614 1.33333 2.21633 1.33333 3.10839V40.8918C1.33333 41.7838 2.27211 42.364 3.06999 41.9651L41.2111 22.8945C41.9482 22.526 41.9482 21.4742 41.2111 21.1057Z\" fill=\"white\" />\n<path d=\"M3.06999 2.03508L3.5172 1.14065V1.14065L3.06999 2.03508ZM41.2111 21.1057L41.6584 20.2112H41.6584L41.2111 21.1057ZM41.2111 22.8945L41.6584 23.7889H41.6584L41.2111 22.8945ZM3.06999 41.9651L2.62278 41.0707L3.06999 41.9651ZM3.5172 1.14065L41.6584 20.2112L40.7639 22.0001L2.62278 2.9295L3.5172 1.14065ZM41.6584 23.7889L3.5172 42.8595L2.62278 41.0707L40.7639 22.0001L41.6584 23.7889ZM2.33333 3.10839V40.8918H0.333328V3.10839H2.33333ZM3.5172 42.8595C2.05442 43.5909 0.333328 42.5272 0.333328 40.8918H2.33333C2.33333 41.0405 2.48979 41.1371 2.62278 41.0707L3.5172 42.8595ZM41.6584 20.2112C43.1325 20.9483 43.1325 23.0519 41.6584 23.7889L40.7639 22.0001L40.7639 22.0001L41.6584 20.2112ZM2.62278 2.9295C2.48979 2.86301 2.33333 2.95972 2.33333 3.10839H0.333328C0.333328 1.47295 2.05442 0.409259 3.5172 1.14065L2.62278 2.9295Z\" fill=\"white\" />\n</symbol>"
});
var play_result = browser_sprite_build_default().add(play_symbol);
/* harmony default export */ var play = (play_symbol);
;// CONCATENATED MODULE: ./app/icons/plus.svg


var plus_symbol = new (browser_symbol_default())({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 33 33",
  "content": "<symbol viewBox=\"0 0 33 33\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus\">\n<line x1=\"16.9004\" y1=\"1.30664\" x2=\"16.9004\" y2=\"32.3066\" stroke=\"black\" stroke-linecap=\"round\" />\n<line x1=\"0.800781\" y1=\"16.4058\" x2=\"31.8008\" y2=\"16.4058\" stroke=\"black\" stroke-linecap=\"round\" />\n</symbol>"
});
var plus_result = browser_sprite_build_default().add(plus_symbol);
/* harmony default export */ var plus = (plus_symbol);
;// CONCATENATED MODULE: ./app/icons/pro.svg


var pro_symbol = new (browser_symbol_default())({
  "id": "pro",
  "use": "pro-usage",
  "viewBox": "0 0 578 338",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 578 338\" id=\"pro\"><path d=\"M383.62 168.7C383.62 57.5 424.9 1 480.32 1 535.13 1 577 57.5 577 168.7c0 111.21-42.45 168.3-96.69 168.3-55.42 0-96.69-57.09-96.69-168.3Z\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M561.67 168.7c0 102.88-35.37 156.4-81.95 156.4-47.16 0-81.36-53.52-81.36-156.4 0-103.47 34.2-155.8 81.36-155.8 47.17 0 81.95 52.33 81.95 155.8Z\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M546.93 168.7c0 94.56-28.3 143.92-67.2 143.92-39.5 0-66.63-49.36-66.63-143.92 0-95.15 27.12-143.32 66.62-143.32 38.91-.6 67.21 48.17 67.21 143.32Z\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M532.2 168.7c0 86.23-21.23 132.02-52.48 132.02-31.24 0-51.29-45.79-51.29-132.02 0-86.82 20.05-131.42 51.3-131.42 31.24 0 52.46 44.6 52.46 131.42Z\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M517.45 168.7c0 77.9-14.15 119.54-37.73 119.54s-36.55-41.63-36.55-119.54c0-78.5 12.97-119.53 36.55-119.53s37.73 41.03 37.73 119.53Z\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M502.71 168.7c0-70.17-7.07-107.64-22.4-107.64-15.92 0-21.81 36.87-21.81 107.64 0 69.58 5.9 107.64 21.81 107.64 15.33 0 22.4-37.46 22.4-107.64ZM1 5.16v327.68M14.56 5.16v327.68M28.7 5.16v327.68M42.27 5.16v327.68M55.83 5.16v327.68M69.39 5.16v327.68M69.39 5.16h17.1c56 0 90.2 39.25 90.2 99.91 0 61.85-35.38 98.72-94.92 98.72H68.8\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M69.39 193.09h11.79c50.7 0 81.95-32.12 81.95-87.42 0-55.31-30.07-88.61-78.41-88.61H69.39\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M69.39 182.38H80c43.04 0 69.57-26.76 69.57-76.71 0-49.36-25.94-77.31-67.21-77.31H69.39\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M69.39 171.68h9.43c34.79 0 56.6-22 56.6-65.42 0-43.41-21.22-66.01-55.42-66.01H68.8\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M69.39 160.38h7.66c27.12 0 44.22-16.65 44.22-54.71 0-37.47-17.1-55.31-43.63-55.31H68.8\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M69.39 149.08h7.07c18.87 0 31.84-11.9 31.84-44 0-32.12-12.97-44.02-31.84-44.02H69.4M261 202.6h3.53c83.72 0 104.36-58.87 104.36-96.93 0-61.85-34.2-100.5-90.2-100.5h-17.7\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M261 17.06h15.32c48.35 0 78.42 33.3 78.42 89.2 0 36.28-18.87 86.23-89.62 86.23H261\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M261 28.36h13.56c40.68 0 66.62 27.95 66.62 77.9 0 35.09-17.7 75.53-74.88 75.53h-4.72\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M261 39.65h11.2c33.6 0 55.42 22.6 55.42 66.61 0 33.9-15.92 64.82-60.73 64.82H261\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M261 50.36h8.84c25.94 0 43.63 17.25 43.63 55.3 0 32.71-14.74 54.12-45.99 54.12H261\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M261 61.66h7.07c18.28 0 31.84 11.9 31.84 44 0 31.52-12.97 43.42-31.84 43.42H261M261 332.84V5.16M247.44 332.84V5.16M233.88 332.84V5.16M219.73 332.84V5.16M206.17 332.84V5.16M192.6 332.84V5.16M375.37 333.43c-6.48-8.92-9.43-19.03-9.43-32.7l-2.95-75.53c-.59-20.82-10.61-38.06-23.58-46.98\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /><path d=\"M329.38 185.35c12.39 7.74 19.46 23.8 20.05 42.82l2.95 71.96c.59 13.68 3.54 23.79 9.43 33.3M318.77 191.9c11.8 7.73 17.1 22.6 17.69 39.84l2.36 68.39c.59 14.27 3.54 24.38 9.43 33.9M306.4 196.65c11.78 7.73 15.91 21.41 16.5 38.06l2.36 64.23c.59 14.27 2.94 24.38 9.43 34.5M291.65 200.22c13.56 6.54 17.69 21.41 18.28 36.87l1.77 60.66c.59 14.87 2.95 24.98 9.43 35.68M263.94 202.6c27.12 0 32.43 19.03 32.43 38.06l1.77 57.1c.59 15.45 2.95 25.56 9.43 35.67\" stroke=\"#000\" stroke-width=\"1.51\" stroke-miterlimit=\"10\" /></symbol>"
});
var pro_result = browser_sprite_build_default().add(pro_symbol);
/* harmony default export */ var pro = (pro_symbol);
;// CONCATENATED MODULE: ./app/icons/index.ts
// Reexport all svg icons











// EXTERNAL MODULE: ./app/components/Icon.module.sass
var Icon_module = __webpack_require__(5352);
var Icon_module_default = /*#__PURE__*/__webpack_require__.n(Icon_module);
;// CONCATENATED MODULE: ./app/components/Icon.tsx




const iconNames = Object.keys(icons_namespaceObject);
const Icon = (param)=>{
    let { name  } = param;
    const icon = icons_namespaceObject[name];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: icon.viewBox,
        className: (0,clsx_m/* default */.Z)((Icon_module_default()).wrapper, (Icon_module_default())["icon-".concat(name)]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
            xlinkHref: "#".concat(icon.id)
        })
    });
};

;// CONCATENATED MODULE: ./app/components/Button.tsx





const Button = (param)=>{
    let { link  } = param;
    var ref;
    const titleWords = (ref = link.title) === null || ref === void 0 ? void 0 : ref.split(" ");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Button_module_default()).Button,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
            link: link,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Button_module_default()).Link,
                children: titleWords === null || titleWords === void 0 ? void 0 : titleWords.map((word, wordIndex)=>{
                    if (wordIndex === titleWords.length - 1) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (Button_module_default()).TitleLastWord,
                            children: [
                                word,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (Button_module_default()).Arrow,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (Button_module_default()).ArrowIn,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                            name: "arrowDown"
                                        })
                                    })
                                })
                            ]
                        }, link.title);
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            word,
                            " "
                        ]
                    }, wordIndex);
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./app/components/CarouselWithArtworks.module.sass
var CarouselWithArtworks_module = __webpack_require__(2923);
var CarouselWithArtworks_module_default = /*#__PURE__*/__webpack_require__.n(CarouselWithArtworks_module);
;// CONCATENATED MODULE: ./app/components/CarouselWithArtworks.tsx








const CarouselWithArtworks = (param)=>{
    let { carousel , isTitleVisible , link  } = param;
    var ref, ref1;
    const cardElement = (0,react.useRef)(null);
    const cardsElement = (0,react.useRef)(null);
    const scroll = (direction)=>{
        if (cardsElement.current === null || cardElement.current === null) {
            return;
        }
        const cardWidth = parseInt(getComputedStyle(cardElement.current).width.replace("px", ""));
        const scrollSlideOffset = direction * cardWidth;
        cardsElement.current.scrollBy({
            left: scrollSlideOffset,
            behavior: "smooth"
        });
    };
    const [showPreviousButton, setShowPreviousButton] = (0,react.useState)(false);
    const [showNextButton, setShowNextButton] = (0,react.useState)(false);
    const onSlideChange = ()=>{
        if (cardsElement.current === null) {
            return;
        }
        setShowPreviousButton(true);
        setShowNextButton(true);
        if (cardsElement.current.scrollLeft === 0) {
            setShowPreviousButton(false);
        }
        var _scrollWidth, _clientWidth;
        if (cardsElement.current.scrollLeft === ((_scrollWidth = cardsElement.current.scrollWidth) !== null && _scrollWidth !== void 0 ? _scrollWidth : 0) - ((_clientWidth = cardsElement.current.clientWidth) !== null && _clientWidth !== void 0 ? _clientWidth : 0)) {
            setShowNextButton(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (cardsElement.current === null) {
            return;
        }
        onSlideChange();
        window.addEventListener("resize", onSlideChange);
        return ()=>{
            window.removeEventListener("resize", onSlideChange);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CarouselWithArtworks_module_default()).CarouselWithArtworks,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            size: "fullWidth",
            disableGutters: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                    size: "fullWidth",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CarouselWithArtworks_module_default()).TitleWrapper,
                        children: [
                            isTitleVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (CarouselWithArtworks_module_default()).Title,
                                children: (ref = carousel.localesByLocale) === null || ref === void 0 ? void 0 : ref.title
                            }),
                            link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                link: link,
                                className: (CarouselWithArtworks_module_default()).ButtonDesktop,
                                children: link.title
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (CarouselWithArtworks_module_default()).CarouselArtworksWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (CarouselWithArtworks_module_default()).CarouselArtworks,
                            ref: cardsElement,
                            onScroll: ()=>onSlideChange(),
                            children: [
                                (ref1 = carousel.artworks) === null || ref1 === void 0 ? void 0 : ref1.items.map((item)=>{
                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        className: (CarouselWithArtworks_module_default()).ArtworkTile,
                                        ref: cardElement,
                                        children: ((ref = item.artwork) === null || ref === void 0 ? void 0 : (ref1 = ref.localesByLocale) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.link) === null || ref2 === void 0 ? void 0 : ref2.url) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link, {
                                            href: (ref3 = item.artwork) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.localesByLocale) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.link) === null || ref5 === void 0 ? void 0 : ref5.url,
                                            children: [
                                                ((ref6 = item.artwork) === null || ref6 === void 0 ? void 0 : ref6.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                                                    image: (ref7 = item.artwork) === null || ref7 === void 0 ? void 0 : ref7.image
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (CarouselWithArtworks_module_default()).ArtworkTitle,
                                                    children: [
                                                        ((ref8 = item.artwork) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.localesByLocale) === null || ref9 === void 0 ? void 0 : ref9.artist) && item.artwork.localesByLocale.artist + ", ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: (ref10 = item.artwork) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.localesByLocale) === null || ref11 === void 0 ? void 0 : ref11.title
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, item.id);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CarouselWithArtworks_module_default()).LastArtworkTile,
                                    ref: cardElement
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                            size: "fullWidth",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CarouselWithArtworks_module_default()).Arrows,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: ()=>scroll(-1),
                                        className: (0,clsx_m/* default */.Z)((CarouselWithArtworks_module_default()).ArrowBackward, showPreviousButton && (CarouselWithArtworks_module_default()).isVisible),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                            name: "arrowDown"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: ()=>scroll(1),
                                        className: (0,clsx_m/* default */.Z)((CarouselWithArtworks_module_default()).ArrowForward, showNextButton && (CarouselWithArtworks_module_default()).isVisible),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                            name: "arrowDown"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                            size: "fullWidth",
                            children: link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                link: link,
                                className: (CarouselWithArtworks_module_default()).ButtonMobile,
                                children: link === null || link === void 0 ? void 0 : link.title
                            })
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./app/components/Chart.module.sass
var Chart_module = __webpack_require__(5862);
var Chart_module_default = /*#__PURE__*/__webpack_require__.n(Chart_module);
;// CONCATENATED MODULE: ./app/components/Chart.tsx








const Chart = (param)=>{
    let { charts , chartLabel  } = param;
    const columnHighiestValue = Math.max(...charts.items.map((item)=>item.number).filter(filterNonEmpty));
    var _number;
    const total = charts.items.reduce((partialSum, a)=>partialSum + ((_number = a.number) !== null && _number !== void 0 ? _number : 0), 0);
    let currentOffset = 0;
    const cardElement = (0,react.useRef)(null);
    const cardsElement = (0,react.useRef)(null);
    const scroll = (direction)=>{
        if (cardsElement.current === null || cardElement.current === null) {
            return;
        }
        const cardWidth = parseInt(getComputedStyle(cardElement.current).width.replace("px", ""));
        const scrollSlideOffset = direction * cardWidth;
        cardsElement.current.scrollBy({
            left: scrollSlideOffset,
            behavior: "smooth"
        });
    };
    const [showPreviousButton, setShowPreviousButton] = (0,react.useState)(false);
    const [showNextButton, setShowNextButton] = (0,react.useState)(false);
    const onSlideChange = ()=>{
        if (cardsElement.current === null) {
            return;
        }
        setShowPreviousButton(true);
        setShowNextButton(true);
        if (cardsElement.current.scrollLeft === 0) {
            setShowPreviousButton(false);
        }
        var _scrollWidth, _clientWidth;
        if (cardsElement.current.scrollLeft === ((_scrollWidth = cardsElement.current.scrollWidth) !== null && _scrollWidth !== void 0 ? _scrollWidth : 0) - ((_clientWidth = cardsElement.current.clientWidth) !== null && _clientWidth !== void 0 ? _clientWidth : 0)) {
            setShowNextButton(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (cardsElement.current === null) {
            return;
        }
        onSlideChange();
        window.addEventListener("resize", onSlideChange);
        return ()=>{
            window.removeEventListener("resize", onSlideChange);
        };
    }, []);
    var _number1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Chart_module_default()).Chart,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            size: "normal",
            disableGutters: true,
            children: [
                charts.type === "pie" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Chart_module_default()).PieGraph,
                            children: charts.items.map((item)=>{
                                const fraction = ((item === null || item === void 0 ? void 0 : item.number) || 0) / total;
                                const rotationDegrees = currentOffset / total * 360;
                                const textRotationDegrees = (currentOffset + ((item === null || item === void 0 ? void 0 : item.number) || 0) / 2) / total * 360;
                                currentOffset += (item === null || item === void 0 ? void 0 : item.number) || 0;
                                var _text, _number;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)((Chart_module_default()).PieGraphFragment, angleToPositionClassName(textRotationDegrees)),
                                        style: {
                                            "--PieGraph-rotationDegrees": rotationDegrees,
                                            "--PieGraph-textRotationDegrees": textRotationDegrees
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartSvg, {
                                            fraction: fraction,
                                            title: (_text = item.text) !== null && _text !== void 0 ? _text : "",
                                            number: (_number = item.number) !== null && _number !== void 0 ? _number : 0,
                                            image: item.image
                                        })
                                    })
                                }, item.id);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                            size: "normal",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Chart_module_default()).MobileTextsWrapper,
                                children: charts.items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Chart_module_default()).MobileTexts,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (Chart_module_default()).MobileText,
                                                children: item.text
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (Chart_module_default()).MobileNumber,
                                                children: [
                                                    item.number,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }, item.id))
                            })
                        })
                    ]
                }),
                charts.type === "column" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Chart_module_default()).ChartColumnWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Chart_module_default()).ChartColumn,
                            ref: cardsElement,
                            onScroll: ()=>onSlideChange(),
                            children: charts.items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Chart_module_default()).ChartColumnLine,
                                    ref: cardElement,
                                    style: {
                                        "--ChartColumn-heightFraction": ((_number1 = item.number) !== null && _number1 !== void 0 ? _number1 : 0) / columnHighiestValue
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: (Chart_module_default()).ColumnInfoText,
                                            children: [
                                                item.number,
                                                " Kč"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Chart_module_default()).Lines
                                        }),
                                        item.date && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (Chart_module_default()).Date,
                                            children: new Intl.DateTimeFormat("cs", {
                                                month: "numeric",
                                                year: "numeric"
                                            }).format(new Date(item.date))
                                        })
                                    ]
                                }, item.id))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                            size: "normal",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Chart_module_default()).ChartNote,
                                children: chartLabel
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                            size: "normal",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Chart_module_default()).Arrows,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: ()=>scroll(-1),
                                        className: (0,clsx_m/* default */.Z)((Chart_module_default()).ArrowBackward, showPreviousButton && (Chart_module_default()).isVisible),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                            name: "arrowDown"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: ()=>scroll(1),
                                        className: (0,clsx_m/* default */.Z)((Chart_module_default()).ArrowForward, showNextButton && (Chart_module_default()).isVisible),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                            name: "arrowDown"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const angleToPositionClassName = (angle)=>{
    if (angle < 90) {
        return (Chart_module_default()).isPositionRightBottom;
    }
    if (angle < 180) {
        return (Chart_module_default()).isPositionLeftBottom;
    }
    if (angle < 270) {
        return (Chart_module_default()).isPositionLeftTop;
    }
    return (Chart_module_default()).isPositionRightTop;
};
const ChartSvg = (param)=>{
    let { fraction , title , number , image  } = param;
    const fractionWithGap = fraction - 5 / 360 // might break with really small fraction numbers
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Chart_module_default()).CirclesWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Chart_module_default()).CirclesText,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Chart_module_default()).CirclesTextIn,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (Chart_module_default()).CircleTitle,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                number,
                                " %"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Chart_module_default()).CircleHover,
                            children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                                image: image
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                height: "600",
                width: "600",
                viewBox: "0 0 600 600",
                fill: "transparent",
                className: (Chart_module_default()).Circles,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        stroke: "currentColor",
                        r: "299",
                        cx: "300",
                        cy: "300",
                        // stroke="#231F20"
                        strokeWidth: "1",
                        strokeDasharray: 1877.913330078125,
                        strokeDashoffset: 1877.913330078125 * (1 - fractionWithGap)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        stroke: "currentColor",
                        r: "289",
                        cx: "300",
                        cy: "300",
                        // stroke="#231F20"
                        strokeWidth: "1",
                        strokeDasharray: 1815.1068115234375,
                        strokeDashoffset: 1815.1068115234375 * (1 - fractionWithGap)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        stroke: "currentColor",
                        r: "279",
                        cx: "300",
                        cy: "300",
                        // stroke="#231F20"
                        strokeWidth: "1",
                        strokeDasharray: 1752.3004150390625,
                        strokeDashoffset: 1752.3004150390625 * (1 - fractionWithGap)
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/isomorphic-fetch/fetch-npm-browserify.js
var fetch_npm_browserify = __webpack_require__(4301);
var fetch_npm_browserify_default = /*#__PURE__*/__webpack_require__.n(fetch_npm_browserify);
;// CONCATENATED MODULE: ./libs/next/api/jsonApiHandler.ts



class ApiAction {
    constructor(validate, run){
        _define_property(this, "validate", void 0);
        _define_property(this, "run", void 0);
        this.run = run;
        if ("parse" in validate) {
            this.validate = (data)=>validate.parse(data);
        } else {
            this.validate = (data)=>validate(data);
        }
    }
}
async function handleApiAction(action, input, req, res) {
    const validInput = action.validate(input);
    return action.run(validInput, req, res);
}
function zodErrorInfo(e) {
    return {
        flat: e.flatten(),
        issues: e.issues,
        errors: e.errors
    };
}
function validationInputFromRequest(req) {
    var _body;
    return {
        ...(_body = req.body) !== null && _body !== void 0 ? _body : {},
        _req: req
    };
}
class NextCloseResponse {
}
function createJsonApiHandler(repository) {
    return async function handler(req, res) {
        const handler = req.query.handler;
        const apiAction = repository[handler];
        if (apiAction) {
            try {
                const result = await handleApiAction(apiAction, validationInputFromRequest(req), req, res);
                res.status(200).json(result);
                return;
            } catch (e) {
                if (e instanceof ZodError) {
                    res.status(400).json({
                        status: "error",
                        validationErrors: zodErrorInfo(e)
                    });
                    return;
                } else if (e instanceof NextCloseResponse) {
                    return;
                } else {
                    throw e;
                }
            }
        }
        throw new Error("Invalid API action handler '".concat(handler.toString(), "'."));
    };
}
class ValidationError extends Error {
    getDeveloperMessage() {
        const prefix = this.source ? "[".concat(this.source, "] ") : "";
        if ("message" in this.original) {
            return prefix + this.original.message;
        }
        if ("validationErrors" in this.original) {
            return prefix + this.original.validationErrors.issues.map((e)=>"[".concat(e.path.join("."), "] ").concat(e.message, " (").concat(e.code, ").")).join("\n");
        }
        return prefix + "ValidationError";
    }
    getUserMessage() {
        return this.getDeveloperMessage();
    }
    getFormErrors() {
        if ("validationErrors" in this.original) {
            return {
                ...this.original.validationErrors.flat,
                source: this.source
            };
        }
        return {
            source: this.source,
            formErrors: [
                this.getUserMessage()
            ],
            fieldErrors: {}
        };
    }
    constructor(original, source){
        super();
        (0,src_define_property/* default */.Z)(this, "original", void 0);
        (0,src_define_property/* default */.Z)(this, "source", void 0);
        this.original = original;
        this.source = source;
        this.message = this.getDeveloperMessage();
    }
}
function createFetcher(url) {
    return async function fetcher(key, input) {
        const actionUrl = url.replace("[handler]", String(key));
        let searchQuery = "";
        const { _req , ...body } = input;
        const req = _req !== null && _req !== void 0 ? _req : {};
        if (req.query) {
            const s = new URLSearchParams();
            Object.entries(req.query).forEach((entry)=>{
                let list = entry[1];
                if (!Array.isArray(list)) {
                    list = list ? [
                        list
                    ] : [];
                }
                list.forEach((value)=>{
                    s.append(entry[0], value);
                });
            });
            searchQuery = s.toString();
            searchQuery = searchQuery ? "?".concat(searchQuery) : "";
        }
        var _method;
        const request = await fetch_npm_browserify_default()(actionUrl + searchQuery, {
            method: ((_method = req.method) !== null && _method !== void 0 ? _method : body) ? "POST" : "GET",
            body: body ? JSON.stringify(body) : undefined,
            headers: {
                "Content-Type": "application/json;charset=utf-8",
                Accept: "application/json;charset=utf-8"
            }
        });
        const result = await request.json();
        if (result && "status" in result && result.status === "error") {
            throw new ValidationError(result, "server");
        }
        const validResult = result;
        return validResult;
    };
}

;// CONCATENATED MODULE: ./app/forms/ContactSubscription/ContactInput.ts


const ContactFormInput = ()=>lib/* object */.Ry({
        name: (0,lib/* string */.Z_)(),
        phone: (0,lib/* string */.Z_)(),
        message: (0,lib/* string */.Z_)(),
        email: (0,lib/* string */.Z_)().email(),
        fileType: (0,lib/* string */.Z_)().nullable().optional(),
        size: (0,lib/* number */.Rx)().nullable().optional()
    });

;// CONCATENATED MODULE: ./app/validators/utils/validateZod.ts


function validateZod(data, validator, options) {
    const input = data instanceof FormData ? Object.fromEntries(data.entries()) : data;
    try {
        return validator.parse(input, {
            ...options !== null && options !== void 0 ? options : {}
        });
    } catch (e) {
        if (e instanceof lib/* ZodError */.jm) {
            throw new ValidationError({
                status: "error",
                validationErrors: zodErrorInfo(e)
            },  true ? "browser" : 0);
        } else {
            throw e;
        }
    }
}

// EXTERNAL MODULE: ./app/components/ContactForm.module.sass
var ContactForm_module = __webpack_require__(7683);
var ContactForm_module_default = /*#__PURE__*/__webpack_require__.n(ContactForm_module);
// EXTERNAL MODULE: ./app/components/FlashMessage.module.sass
var FlashMessage_module = __webpack_require__(5081);
var FlashMessage_module_default = /*#__PURE__*/__webpack_require__.n(FlashMessage_module);
;// CONCATENATED MODULE: ./app/components/FlashMessage.tsx


const FlashMessage = (props)=>{
    const { onDissmiss  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (FlashMessage_module_default()).FlashMessage,
        onAnimationEnd: onDissmiss,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: props.succesMessage
        })
    });
};

;// CONCATENATED MODULE: ./app/components/ContactForm.tsx













const api = createFetcher("/api/v1/[handler]");
function ContactForm(props) {
    const [imagePreviewUrl, setImagePreviewUrl] = (0,react.useState)(null);
    const mutation = (0,es.useMutation)(async (formData)=>{
        const file = lib.z["instanceof"](File).parse(formData.get("file"));
        const data = {
            name: formData.get("name"),
            phone: formData.get("phone"),
            email: formData.get("email"),
            message: formData.get("message"),
            fileType: file === null || file === void 0 ? void 0 : file.type,
            size: file === null || file === void 0 ? void 0 : file.size
        };
        const validatedData = validateZod(data, ContactFormInput());
        const result = await api("contactForm", validatedData);
        if (!result.ok) {
            throw new Error("Something went wrong");
        }
        if (result.upload) {
            const { url , headers , method  } = result.upload;
            const response = fetch(url, {
                method,
                headers: Object.fromEntries(headers.map((header)=>[
                        header.key,
                        header.value
                    ])),
                body: formData.get("file")
            });
            if (!(await response).ok) {
                throw new Error("Failed to upload file.");
            }
        }
        return result;
    });
    const [showFlashMessage, setShowFlashMessage] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setShowFlashMessage(mutation.isSuccess);
    }, [
        mutation.isSuccess
    ]);
    // const validationError = mutation.error instanceof ValidationError ? mutation.error : null
    // const contactTypesError = !!validationError?.getFormErrors().fieldErrors.contactTypes?.length
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ContactForm_module_default()).ContactForm,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            size: "normal",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: (e)=>{
                        e.preventDefault();
                        mutation.mutate(new FormData(e.currentTarget));
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: (ContactForm_module_default()).InputLabel,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (ContactForm_module_default()).InputLabelText,
                                    children: props.contactForm.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    name: "name",
                                    className: (ContactForm_module_default()).Input,
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: (ContactForm_module_default()).InputLabel,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (ContactForm_module_default()).InputLabelText,
                                    children: props.contactForm.phone
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "tel",
                                    name: "phone",
                                    className: (ContactForm_module_default()).Input,
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: (ContactForm_module_default()).InputLabel,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (ContactForm_module_default()).InputLabelText,
                                    children: props.contactForm.email
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "email",
                                    name: "email",
                                    className: (ContactForm_module_default()).Input,
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: (ContactForm_module_default()).InputLabel,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (ContactForm_module_default()).InputLabelText,
                                    children: props.contactForm.message
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                    rows: 7,
                                    name: "message",
                                    className: (ContactForm_module_default()).Input,
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: (ContactForm_module_default()).InputLabel,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (ContactForm_module_default()).InputLabelText,
                                    children: props.contactForm.file
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)((ContactForm_module_default()).Input, (ContactForm_module_default()).InputFileWrapper),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "file",
                                            name: "file",
                                            className: (ContactForm_module_default()).InputFile,
                                            onChange: (e)=>{
                                                var ref;
                                                const file = (ref = e.target.files) === null || ref === void 0 ? void 0 : ref.item(0);
                                                if (file) {
                                                    setImagePreviewUrl(URL.createObjectURL(file));
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ContactForm_module_default()).Plus,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                name: "plus"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ContactForm_module_default()).Image,
                                            children: imagePreviewUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: imagePreviewUrl,
                                                alt: "Soubor k uploadu",
                                                width: "150",
                                                height: "150",
                                                objectFit: "contain"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (ContactForm_module_default()).Button,
                            type: "submit",
                            children: props.contactForm.submit
                        })
                    ]
                }),
                showFlashMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlashMessage, {
                    succesMessage: props.contactForm.successMessage,
                    onDissmiss: ()=>setShowFlashMessage(false)
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./app/components/ContentRenderer.module.sass
var ContentRenderer_module = __webpack_require__(1289);
var ContentRenderer_module_default = /*#__PURE__*/__webpack_require__.n(ContentRenderer_module);
// EXTERNAL MODULE: ./app/components/DefinitionList.module.sass
var DefinitionList_module = __webpack_require__(6219);
var DefinitionList_module_default = /*#__PURE__*/__webpack_require__.n(DefinitionList_module);
;// CONCATENATED MODULE: ./app/components/DefinitionList.tsx




const DefinitionList = (param)=>{
    let { definitions  } = param;
    return(// <div className={s.DefinitionList}>
    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        size: "normal",
        children: definitions.items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (DefinitionList_module_default()).Definition,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (DefinitionList_module_default()).Key,
                        children: item.key
                    }),
                    item.value && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (DefinitionList_module_default()).Value,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                            source: item.value
                        })
                    })
                ]
            }, item.id))
    }));
};

// EXTERNAL MODULE: ./node_modules/collapsible-react-component/dist/index.modern.js
var index_modern = __webpack_require__(721);
// EXTERNAL MODULE: ./node_modules/collapsible-react-component/dist/index.css
var collapsible_react_component_dist = __webpack_require__(4822);
// EXTERNAL MODULE: ./app/components/DropDown.module.sass
var DropDown_module = __webpack_require__(1438);
var DropDown_module_default = /*#__PURE__*/__webpack_require__.n(DropDown_module);
;// CONCATENATED MODULE: ./app/components/DropDown.tsx











const Dropdown = (param)=>{
    let { dropDownList  } = param;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        size: "normal",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (DropDown_module_default()).DropDown,
            children: [
                dropDownList.dropDownType === "link" && dropDownList.items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLinkItem, {
                            ...item
                        })
                    }, item.id)),
                dropDownList.dropDownType === "person" && ((ref = dropDownList.employees) === null || ref === void 0 ? void 0 : ref.items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownPersonItem, {
                            ...item
                        })
                    }, item.id)))
            ]
        })
    });
};
const DropdownLinkItem = (param)=>{
    let { ...item } = param;
    const [open, setOpen] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((DropDown_module_default()).DropDownItem, open && (DropDown_module_default()).isOpen),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: ()=>setOpen((old)=>!old),
                className: (DropDown_module_default()).Title,
                children: [
                    item.title,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (DropDown_module_default()).Arrow,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            name: "arrowDown"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Collapsible */.z, {
                open: open,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (DropDown_module_default()).DropDownContent,
                    children: [
                        item.text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (DropDown_module_default()).Text,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                                source: item.text
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (DropDown_module_default()).ButtonWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                link: item.link,
                                className: (DropDown_module_default()).Button
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const DropdownPersonItem = (param)=>{
    let { ...item } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
    const [open, setOpen] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((DropDown_module_default()).DropDownItem, open && (DropDown_module_default()).isOpen),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: ()=>setOpen((old)=>!old),
                className: (DropDown_module_default()).Title,
                children: [
                    (ref = item.employee) === null || ref === void 0 ? void 0 : ref.name,
                    " ",
                    "–",
                    " ",
                    (ref1 = item.employee) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.localesByLocale) === null || ref2 === void 0 ? void 0 : ref2.position,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (DropDown_module_default()).Arrow,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            name: "arrowDown"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Collapsible */.z, {
                open: open,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (DropDown_module_default()).DropDownContent,
                    children: [
                        ((ref3 = item.employee) === null || ref3 === void 0 ? void 0 : ref3.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (DropDown_module_default()).Image,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                                image: (ref4 = item.employee) === null || ref4 === void 0 ? void 0 : ref4.image
                            })
                        }),
                        ((ref5 = item.employee) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.localesByLocale) === null || ref6 === void 0 ? void 0 : ref6.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (DropDown_module_default()).Text,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                                source: (ref7 = item.employee) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.localesByLocale) === null || ref8 === void 0 ? void 0 : ref8.text
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (DropDown_module_default()).ButtonWrapper,
                            children: [
                                ((ref9 = item.employee) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.localesByLocale) === null || ref10 === void 0 ? void 0 : ref10.email) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    className: (DropDown_module_default()).Button,
                                    href: "mailto:".concat((ref11 = item.employee) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.localesByLocale) === null || ref12 === void 0 ? void 0 : ref12.email),
                                    children: (ref13 = item.employee) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.localesByLocale) === null || ref14 === void 0 ? void 0 : ref14.email
                                }),
                                ((ref15 = item.employee) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.localesByLocale) === null || ref16 === void 0 ? void 0 : ref16.phone) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    className: (DropDown_module_default()).ButtonSecond,
                                    href: "tel:to".concat((ref17 = item.employee) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.localesByLocale) === null || ref18 === void 0 ? void 0 : ref18.phone),
                                    children: (ref19 = item.employee) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.localesByLocale) === null || ref20 === void 0 ? void 0 : ref20.phone
                                })
                            ]
                        })
                    ]
                }, item.id)
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/EventList.module.sass
var EventList_module = __webpack_require__(3646);
var EventList_module_default = /*#__PURE__*/__webpack_require__.n(EventList_module);
;// CONCATENATED MODULE: ./app/components/EventList.tsx




const EventList = (param)=>{
    let { events , eventType  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (EventList_module_default()).EvetList,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            size: "normal",
            children: events.items.map((item)=>{
                var ref, ref1;
                return ((ref = item.event) === null || ref === void 0 ? void 0 : (ref1 = ref.localesByLocale) === null || ref1 === void 0 ? void 0 : ref1.link) && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxTile, {
                    link: item.event.localesByLocale.link.url,
                    date: item.event.localesByLocale.date,
                    type: eventType,
                    title: item.event.localesByLocale.title,
                    text: item.event.localesByLocale.leadParagraph
                }, item.id);
            })
        })
    });
};

// EXTERNAL MODULE: ./app/components/Gallery.module.sass
var Gallery_module = __webpack_require__(9578);
var Gallery_module_default = /*#__PURE__*/__webpack_require__.n(Gallery_module);
;// CONCATENATED MODULE: ./app/components/Gallery.tsx









const Gallery = (param)=>{
    let { mediumList  } = param;
    const cardElement = (0,react.useRef)(null);
    const cardsElement = (0,react.useRef)(null);
    const items = mediumList.items.map((item)=>{
        if (item.medium) {
            var ref, ref1;
            var ref2;
            const source = (ref2 = (ref = item.medium.video) === null || ref === void 0 ? void 0 : ref.src) !== null && ref2 !== void 0 ? ref2 : (ref1 = item.medium.image) === null || ref1 === void 0 ? void 0 : ref1.url;
            if (source) {
                const result = {
                    source,
                    type: item.medium.video ? "video" : "image"
                };
                return result;
            }
        }
    }).filter(filterNonEmpty);
    const lightbox = (0,dist/* useLightbox */.e)(items, {
        onSlideActivate: (current, previous)=>{
            const getSlideVideo = (slideIndex)=>{
                const video = document.querySelector(".fslightbox-absoluted.fslightbox-full-dimension.fslightbox-flex-centered:nth-child(".concat(slideIndex + 1, ") video"));
                if (video instanceof HTMLVideoElement) {
                    return video;
                }
            };
            requestAnimationFrame(()=>{
                var ref;
                if (previous !== null) {
                    var ref1;
                    (ref1 = getSlideVideo(previous.slideIndex)) === null || ref1 === void 0 ? void 0 : ref1.pause();
                }
                (ref = getSlideVideo(current.slideIndex)) === null || ref === void 0 ? void 0 : ref.play();
            });
        }
    });
    const scroll = (direction)=>{
        if (cardsElement.current === null || cardElement.current === null) {
            return;
        }
        const cardWidth = parseInt(getComputedStyle(cardElement.current).width.replace("px", ""));
        const scrollSlideOffset = direction * cardWidth;
        cardsElement.current.scrollBy({
            left: scrollSlideOffset,
            behavior: "smooth"
        });
    };
    const [showPreviousButton, setShowPreviousButton] = (0,react.useState)(false);
    const [showNextButton, setShowNextButton] = (0,react.useState)(false);
    const onSlideChange = ()=>{
        if (cardsElement.current === null) {
            return;
        }
        setShowPreviousButton(true);
        setShowNextButton(true);
        if (cardsElement.current.scrollLeft === 0) {
            setShowPreviousButton(false);
        }
        var _scrollWidth, _clientWidth;
        if (cardsElement.current.scrollLeft === ((_scrollWidth = cardsElement.current.scrollWidth) !== null && _scrollWidth !== void 0 ? _scrollWidth : 0) - ((_clientWidth = cardsElement.current.clientWidth) !== null && _clientWidth !== void 0 ? _clientWidth : 0)) {
            setShowNextButton(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (cardsElement.current === null) {
            return;
        }
        onSlideChange();
        window.addEventListener("resize", onSlideChange);
        return ()=>{
            window.removeEventListener("resize", onSlideChange);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                size: "fullWidth",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Gallery_module_default()).Arrows,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>scroll(-1),
                            className: (0,clsx_m/* default */.Z)((Gallery_module_default()).ArrowBackward, showPreviousButton && (Gallery_module_default()).isVisible),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                name: "arrowDown"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>scroll(1),
                            className: (0,clsx_m/* default */.Z)((Gallery_module_default()).ArrowForward, showNextButton && (Gallery_module_default()).isVisible),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                name: "arrowDown"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                size: "fullWidth",
                disableGutters: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Gallery_module_default()).GalleryWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Gallery_module_default()).Gallery,
                        ref: cardsElement,
                        onScroll: ()=>onSlideChange(),
                        children: [
                            mediumList === null || mediumList === void 0 ? void 0 : mediumList.items.map((item, i)=>{
                                var ref, ref1, ref2;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)((Gallery_module_default()).ItemWrapper, ((ref = item.medium) === null || ref === void 0 ? void 0 : ref.youtubeEmbed) && (Gallery_module_default()).YoutubeEmbed),
                                    ref: cardElement,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Gallery_module_default()).Item,
                                        children: [
                                            ((ref1 = item.medium) === null || ref1 === void 0 ? void 0 : ref1.type) === "image" && item.medium.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Gallery_module_default()).CarouselWrapper,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Gallery_module_default()).Image,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: (Gallery_module_default()).Button,
                                                        onClick: ()=>{
                                                            return lightbox === null || lightbox === void 0 ? void 0 : lightbox.open(i);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                                                            image: item.medium.image,
                                                            layout: "intrinsic"
                                                        })
                                                    })
                                                })
                                            }),
                                            ((ref2 = item.medium) === null || ref2 === void 0 ? void 0 : ref2.type) === "video" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Gallery_module_default()).CarouselWrapper,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Gallery_module_default()).Video,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                        className: (0,clsx_m/* default */.Z)((Gallery_module_default()).Button, (Gallery_module_default()).VideoIframe),
                                                        title: "video",
                                                        width: "640",
                                                        height: "auto",
                                                        src: "https://www.youtube.com/embed/".concat(item.medium.youtubeEmbed),
                                                        frameBorder: "0"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }, item.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Gallery_module_default()).LastTile
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (Gallery_module_default()).LastPlaceholder
                            })
                        ]
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/GalleryInfo.module.sass
var GalleryInfo_module = __webpack_require__(6023);
var GalleryInfo_module_default = /*#__PURE__*/__webpack_require__.n(GalleryInfo_module);
;// CONCATENATED MODULE: ./app/components/GalleryInfo.tsx






const GalleryInfo = (param)=>{
    let { primaryText , secondaryText , image , imageSecond , link  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        size: "normal",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (GalleryInfo_module_default()).GalleryInfo,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (GalleryInfo_module_default()).Images,
                    children: [
                        image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (GalleryInfo_module_default()).ImageWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (GalleryInfo_module_default()).Image,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                                    image: image,
                                    layout: "intrinsic"
                                })
                            })
                        }),
                        imageSecond && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (GalleryInfo_module_default()).ImageWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (GalleryInfo_module_default()).Image,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                                    image: imageSecond,
                                    layout: "intrinsic"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (GalleryInfo_module_default()).Texts,
                    children: [
                        primaryText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (GalleryInfo_module_default()).TextFirst,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                                source: primaryText
                            })
                        }),
                        secondaryText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (GalleryInfo_module_default()).TextSecond,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                                source: secondaryText
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                    className: (GalleryInfo_module_default()).Link,
                    link: link
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./app/components/Image.module.sass
var Image_module = __webpack_require__(6053);
var Image_module_default = /*#__PURE__*/__webpack_require__.n(Image_module);
;// CONCATENATED MODULE: ./app/components/Image.tsx




function Image(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        size: "normal",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Image_module_default()).Image,
            style: {
                "--Image-maxWidth": props.maxWidth ? "".concat(props.maxWidth, "px") : ""
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                image: props.image,
                layout: "intrinsic"
            })
        })
    });
}

// EXTERNAL MODULE: ./app/components/LogoList.module.sass
var LogoList_module = __webpack_require__(8421);
var LogoList_module_default = /*#__PURE__*/__webpack_require__.n(LogoList_module);
;// CONCATENATED MODULE: ./app/components/LogoList.tsx




const LogoList = (param)=>{
    let { logoList  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        size: "normal",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (LogoList_module_default()).LogoList,
            children: logoList.items.map((item)=>item.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (LogoList_module_default()).ImageWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (LogoList_module_default()).Image,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                            image: item.image,
                            layout: "fill",
                            objectFit: "contain"
                        })
                    }, item.id)
                }, item.id))
        })
    });
};

;// CONCATENATED MODULE: ./app/forms/NewsletterSubscription/NewsletterInput.ts


const NewsletterFormInput = ()=>lib/* object */.Ry({
        email: (0,lib/* string */.Z_)().email(),
        newsletterTypes: (0,lib/* array */.IX)((0,lib/* string */.Z_)().uuid()).min(1)
    });

// EXTERNAL MODULE: ./app/components/NewsletterForm.module.sass
var NewsletterForm_module = __webpack_require__(5380);
var NewsletterForm_module_default = /*#__PURE__*/__webpack_require__.n(NewsletterForm_module);
;// CONCATENATED MODULE: ./app/components/NewsletterForm.tsx









const NewsletterForm_api = createFetcher("/api/v1/[handler]");
function NewsletterForm(props) {
    var ref;
    const mutation = (0,es.useMutation)(async (formData)=>{
        const data = {
            email: formData.get("email"),
            newsletterTypes: formData.getAll("newsletterType")
        };
        const validatedData = validateZod(data, NewsletterFormInput());
        const result = await NewsletterForm_api("newsletterForm", validatedData);
        if (!result.ok) {
            throw new Error("Something went wrong");
        }
        return result;
    });
    const [showFlashMessage, setShowFlashMessage] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setShowFlashMessage(mutation.isSuccess);
    }, [
        mutation.isSuccess
    ]);
    const validationError = mutation.error instanceof ValidationError ? mutation.error : null;
    const newsletterTypesError = !!((ref = validationError === null || validationError === void 0 ? void 0 : validationError.getFormErrors().fieldErrors.newsletterTypes) === null || ref === void 0 ? void 0 : ref.length);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (NewsletterForm_module_default()).NewsletterForm,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            size: "normal",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: (e)=>{
                        e.preventDefault();
                        mutation.mutate(new FormData(e.currentTarget));
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (NewsletterForm_module_default()).NewsletterTypeNote,
                            children: props.newsletterForm.newsletterTypeNote
                        }),
                        props.newsletterForm.items && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (NewsletterForm_module_default()).CheckboxWrapper,
                            children: [
                                props.newsletterForm.items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: (NewsletterForm_module_default()).CheckboxLabel,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "checkbox",
                                                name: "newsletterType",
                                                defaultChecked: true,
                                                value: item.id,
                                                className: (NewsletterForm_module_default()).Checkbox
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (NewsletterForm_module_default()).CheckboxText,
                                                children: item.title
                                            })
                                        ]
                                    }, item.id)),
                                newsletterTypesError && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: (NewsletterForm_module_default()).ErrorMessage,
                                    children: [
                                        "* ",
                                        props.newsletterForm.newsletterTypeErrorMessage
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: (NewsletterForm_module_default()).EmailLabel,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (NewsletterForm_module_default()).EmailLabelText,
                                    children: props.newsletterForm.email
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "email",
                                    name: "email",
                                    className: (NewsletterForm_module_default()).Email,
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (NewsletterForm_module_default()).EmailNote,
                            children: props.newsletterForm.emailNote
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (NewsletterForm_module_default()).Button,
                            type: "submit",
                            children: props.newsletterForm.submit
                        })
                    ]
                }),
                !!(mutation.error && !newsletterTypesError) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: (NewsletterForm_module_default()).ErrorMessage,
                    children: [
                        "* ",
                        props.newsletterForm.genericErrorMessage
                    ]
                }),
                showFlashMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlashMessage, {
                    succesMessage: props.newsletterForm.successMessage,
                    onDissmiss: ()=>setShowFlashMessage(false)
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./app/components/PersonCarousel.module.sass
var PersonCarousel_module = __webpack_require__(3247);
var PersonCarousel_module_default = /*#__PURE__*/__webpack_require__.n(PersonCarousel_module);
;// CONCATENATED MODULE: ./app/components/PersonCarousel.tsx








const PersonCarousel = (param)=>{
    let { employees , link  } = param;
    const cardElement = (0,react.useRef)(null);
    const cardsElement = (0,react.useRef)(null);
    const scroll = (direction)=>{
        if (cardsElement.current === null || cardElement.current === null) {
            return;
        }
        const cardWidth = parseInt(getComputedStyle(cardElement.current).width.replace("px", ""));
        const scrollSlideOffset = direction * cardWidth;
        cardsElement.current.scrollBy({
            left: scrollSlideOffset,
            behavior: "smooth"
        });
    };
    const [showPreviousButton, setShowPreviousButton] = (0,react.useState)(false);
    const [showNextButton, setShowNextButton] = (0,react.useState)(false);
    const onSlideChange = ()=>{
        if (cardsElement.current === null) {
            return;
        }
        setShowPreviousButton(true);
        setShowNextButton(true);
        if (cardsElement.current.scrollLeft === 0) {
            setShowPreviousButton(false);
        }
        var _scrollWidth, _clientWidth;
        if (cardsElement.current.scrollLeft === ((_scrollWidth = cardsElement.current.scrollWidth) !== null && _scrollWidth !== void 0 ? _scrollWidth : 0) - ((_clientWidth = cardsElement.current.clientWidth) !== null && _clientWidth !== void 0 ? _clientWidth : 0)) {
            setShowNextButton(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (cardsElement.current === null) {
            return;
        }
        onSlideChange();
        window.addEventListener("resize", onSlideChange);
        return ()=>{
            window.removeEventListener("resize", onSlideChange);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PersonCarousel_module_default()).PersonCarousel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                size: "fullWidth",
                children: link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                    link: link,
                    className: (PersonCarousel_module_default()).ButtonDesktop,
                    children: link.title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                size: "fullWidth",
                disableGutters: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (PersonCarousel_module_default()).PersonWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (PersonCarousel_module_default()).CarouselPeople,
                            ref: cardsElement,
                            onScroll: ()=>onSlideChange(),
                            children: [
                                employees.map((item)=>{
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        className: (PersonCarousel_module_default()).PersonTile,
                                        ref: cardElement,
                                        children: [
                                            item.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (PersonCarousel_module_default()).ImageWrapper,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (PersonCarousel_module_default()).Image,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                                                        image: item.image,
                                                        layout: "intrinsic",
                                                        objectFit: "contain"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (PersonCarousel_module_default()).PersonNameWrapper,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (PersonCarousel_module_default()).PersonName,
                                                        children: item.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (PersonCarousel_module_default()).PersonName,
                                                        children: (ref = item.localesByLocale) === null || ref === void 0 ? void 0 : ref.position
                                                    })
                                                ]
                                            })
                                        ]
                                    }, item.id);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (PersonCarousel_module_default()).LastPersonTile
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                            size: "fullWidth",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (PersonCarousel_module_default()).Arrows,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: ()=>scroll(-1),
                                        className: (0,clsx_m/* default */.Z)((PersonCarousel_module_default()).ArrowBackward, showPreviousButton && (PersonCarousel_module_default()).isVisible),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                            name: "arrowDown"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: ()=>scroll(1),
                                        className: (0,clsx_m/* default */.Z)((PersonCarousel_module_default()).ArrowForward, showNextButton && (PersonCarousel_module_default()).isVisible),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                            name: "arrowDown"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                            size: "fullWidth",
                            children: link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                link: link,
                                className: (PersonCarousel_module_default()).ButtonMobile,
                                children: link === null || link === void 0 ? void 0 : link.title
                            })
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/StrategySchema.module.sass
var StrategySchema_module = __webpack_require__(1156);
var StrategySchema_module_default = /*#__PURE__*/__webpack_require__.n(StrategySchema_module);
;// CONCATENATED MODULE: ./app/components/StrategySchema.tsx





const StrategySchema = (param)=>{
    let { strategySchema  } = param;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (StrategySchema_module_default()).StrategySchema,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            size: "normal",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (StrategySchema_module_default()).Section,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (StrategySchema_module_default()).Input,
                            children: strategySchema.inputFirst
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (StrategySchema_module_default()).Input,
                            children: strategySchema.inputSecond
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (StrategySchema_module_default()).Input,
                            children: strategySchema.inputThird
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (StrategySchema_module_default()).Arrows,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (StrategySchema_module_default()).ArrowLeft,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                name: "arrowBig"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (StrategySchema_module_default()).ArrowRight,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                name: "arrowBig"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (StrategySchema_module_default()).Section,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (StrategySchema_module_default()).ItemsFirst,
                            children: (ref = strategySchema.itemsFirst) === null || ref === void 0 ? void 0 : ref.items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (StrategySchema_module_default()).Text,
                                        children: item.text
                                    })
                                }, item.id))
                        }),
                        strategySchema.logo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (StrategySchema_module_default()).Image,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                                image: strategySchema.logo
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (StrategySchema_module_default()).ItemsSecond,
                            children: (ref1 = strategySchema.itemsSecond) === null || ref1 === void 0 ? void 0 : ref1.items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (StrategySchema_module_default()).Text,
                                        children: item.text
                                    })
                                }, item.id))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (StrategySchema_module_default()).Arrows,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (StrategySchema_module_default()).ArrowLeft,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                name: "arrowBig"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (StrategySchema_module_default()).ArrowRight,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                name: "arrowBig"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (StrategySchema_module_default()).Section,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (StrategySchema_module_default()).Output,
                            children: strategySchema.outputFirst
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (StrategySchema_module_default()).Output,
                            children: strategySchema.outputSecond
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (StrategySchema_module_default()).Output,
                            children: strategySchema.outputThird
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./app/components/VennDiagram.module.sass
var VennDiagram_module = __webpack_require__(5476);
var VennDiagram_module_default = /*#__PURE__*/__webpack_require__.n(VennDiagram_module);
;// CONCATENATED MODULE: ./app/components/VennDiagram.tsx




const VennDiagram = (param)=>{
    let { primaryText , image , secondaryText  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        size: "normal",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (VennDiagram_module_default()).VennDiagram,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (VennDiagram_module_default()).Text,
                    children: primaryText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (VennDiagram_module_default()).Logo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                        image: image,
                        layout: "intrinsic"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (VennDiagram_module_default()).Text,
                    children: secondaryText
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./app/components/Wysiwyg.module.sass
var Wysiwyg_module = __webpack_require__(5137);
var Wysiwyg_module_default = /*#__PURE__*/__webpack_require__.n(Wysiwyg_module);
;// CONCATENATED MODULE: ./app/components/Wysiwyg.tsx



const Wysiwyg = (param)=>{
    let { source , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Wysiwyg_module_default()).wrapper,
        children: source ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
            source: source
        }) : children
    });
};

;// CONCATENATED MODULE: ./app/components/ContentRenderer.tsx


























const standaloneTypes = [
    "reference"
];
const nestedTypes = [
    "listItem",
    "anchor",
    "scrollTarget"
];
const referenceRenderers = {
    gallery (param) {
        let { reference  } = param;
        return reference.media && /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery, {
            mediumList: reference.media
        });
    },
    image (param) {
        let { reference  } = param;
        return reference.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
            image: reference.image,
            alt: "",
            maxWidth: reference.primaryText
        });
    },
    dropDown (param) {
        let { reference  } = param;
        return reference.dropDownList && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown, {
            dropDownList: reference.dropDownList
        });
    },
    carouselWithArtworks (param) {
        let { reference  } = param;
        return reference.artworkSelection && /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselWithArtworks, {
            carousel: reference.artworkSelection,
            isTitleVisible: reference.isVisible,
            link: reference.link
        });
    },
    button (param) {
        let { reference  } = param;
        return reference.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
            link: reference.link
        });
    },
    events (param) {
        let { reference  } = param;
        return reference.eventList && reference.primaryText && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventList, {
            events: reference.eventList,
            eventType: reference.primaryText
        });
    },
    boxes (param) {
        let { reference  } = param;
        return reference.boxList && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxList, {
            boxes: reference.boxList
        });
    },
    newsletter (param) {
        let { reference  } = param;
        var ref;
        return ((ref = reference.newsletterForm) === null || ref === void 0 ? void 0 : ref.localesByLocale) && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterForm, {
            newsletterForm: reference.newsletterForm.localesByLocale
        });
    },
    contactForm (param) {
        let { reference  } = param;
        var ref;
        return ((ref = reference.contactForm) === null || ref === void 0 ? void 0 : ref.localesByLocale) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm, {
            contactForm: reference.contactForm.localesByLocale
        });
    },
    chart (param) {
        let { reference  } = param;
        return reference.chart && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart, {
            charts: reference.chart,
            chartLabel: reference.primaryText
        });
    },
    definitionList (param) {
        let { reference  } = param;
        return reference.definitionList && /*#__PURE__*/ (0,jsx_runtime.jsx)(DefinitionList, {
            definitions: reference.definitionList
        });
    },
    sponsors (param) {
        let { reference  } = param;
        return reference.logoList && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoList, {
            logoList: reference.logoList
        });
    },
    strategySchema (param) {
        let { reference  } = param;
        return reference.strategySchema && /*#__PURE__*/ (0,jsx_runtime.jsx)(StrategySchema, {
            strategySchema: reference.strategySchema
        });
    },
    vennDiagram (param) {
        let { reference  } = param;
        return reference.primaryText && reference.image && reference.secondaryText && /*#__PURE__*/ (0,jsx_runtime.jsx)(VennDiagram, {
            primaryText: reference.primaryText,
            secondaryText: reference.secondaryText,
            image: reference.image
        });
    },
    personCarousel (param) {
        let { reference  } = param;
        const { employeeList  } = reference;
        return employeeList && /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonCarousel, {
            employees: employeeList.items.map((item)=>item.employee).filter(filterNonEmpty),
            link: reference.link
        });
    },
    galleryInfo (param) {
        let { reference  } = param;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryInfo, {
            primaryText: reference.primaryText,
            secondaryText: reference.secondaryText,
            image: reference.image,
            imageSecond: reference.imageSecond,
            link: reference.link
        });
    }
};
const ContentRenderer = (param)=>{
    let { content , containerDisableGutters =false  } = param;
    const blocks = useContentRendererCopyPasteBugWorkaround(content.blocks);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ContentRenderer_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
            blocks: blocks,
            sourceField: "json",
            referenceRenderers: referenceRenderers,
            renderElement: (0,react.useCallback)((element)=>{
                const { type  } = element.element;
                if (type === "internalAnchor") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                        link: element.reference.link,
                        children: element.children
                    });
                }
                console.log({
                    type
                });
                if (nestedTypes.includes(type)) {
                    return element.fallback;
                }
                if (standaloneTypes.includes(type)) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)((ContentRenderer_module_default()).section, element.referenceType && (ContentRenderer_module_default())["is_reference_".concat(element.referenceType)]),
                        children: type !== "reference" || !element.referenceType || element.referenceType in referenceRenderers ? element.fallback : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ContentRenderer_module_default()).notImplemented,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ContentRenderer_module_default()).notImplemented_name,
                                    children: element.referenceType
                                }),
                                "is not yet implemented"
                            ]
                        })
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                    disableGutters: containerDisableGutters,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wysiwyg, {
                        children: element.fallback
                    })
                });
            }, [
                containerDisableGutters
            ])
        })
    });
};

;// CONCATENATED MODULE: ./app/components/Artwork.tsx











function Artwork(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    const cardElement = (0,react.useRef)(null);
    const cardsElement = (0,react.useRef)(null);
    var ref6;
    const galleryImages = ((ref = props.artwork.root) === null || ref === void 0 ? void 0 : (ref1 = ref.gallery) === null || ref1 === void 0 ? void 0 : ref1.items.map((item)=>{
        var ref;
        return {
            source: (ref6 = (ref = item.image) === null || ref === void 0 ? void 0 : ref.url) !== null && ref6 !== void 0 ? ref6 : "",
            type: "image"
        };
    }).filter(filterNonEmpty)) || [];
    const count = galleryImages.length;
    const lightbox = (0,dist/* useLightbox */.e)(galleryImages);
    const scroll = (direction)=>{
        if (cardsElement.current === null || cardElement.current === null) {
            return;
        }
        const cardWidth = parseInt(getComputedStyle(cardElement.current).width.replace("px", ""));
        const scrollSlideOffset = direction * cardWidth;
        cardsElement.current.scrollBy({
            left: scrollSlideOffset,
            behavior: "smooth"
        });
    };
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    const [showPreviousButton, setShowPreviousButton] = (0,react.useState)(false);
    const [showNextButton, setShowNextButton] = (0,react.useState)(false);
    const onSlideChange = ()=>{
        if (cardsElement.current === null) {
            return;
        }
        const percent = cardsElement.current.scrollLeft / (cardsElement.current.scrollWidth - cardsElement.current.clientWidth);
        const active = (count - 1) * percent;
        setActiveIndex(Math.round(active));
        setShowPreviousButton(true);
        setShowNextButton(true);
        if (cardsElement.current.scrollLeft === 0) {
            setShowPreviousButton(false);
        }
        var _scrollWidth, _clientWidth;
        if (cardsElement.current.scrollLeft === ((_scrollWidth = cardsElement.current.scrollWidth) !== null && _scrollWidth !== void 0 ? _scrollWidth : 0) - ((_clientWidth = cardsElement.current.clientWidth) !== null && _clientWidth !== void 0 ? _clientWidth : 0)) {
            setShowNextButton(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (cardsElement.current === null) {
            return;
        }
        onSlideChange();
        window.addEventListener("resize", onSlideChange);
        return ()=>{
            window.removeEventListener("resize", onSlideChange);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Artwork_module_default()).Artwork,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                size: "fullWidth",
                disableGutters: true,
                children: ((ref2 = props.artwork.root) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.gallery) === null || ref3 === void 0 ? void 0 : ref3.items.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Artwork_module_default()).GalleryWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Artwork_module_default()).Gallery,
                        ref: cardsElement,
                        onScroll: ()=>onSlideChange(),
                        children: [
                            (ref4 = props.artwork.root.gallery) === null || ref4 === void 0 ? void 0 : ref4.items.map((item, index)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    ref: cardElement,
                                    className: (Artwork_module_default()).GalleryItem,
                                    children: item.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: ()=>{
                                            return lightbox === null || lightbox === void 0 ? void 0 : lightbox.open(index);
                                        },
                                        className: (Artwork_module_default()).GalleryButton,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Artwork_module_default()).GalleryImage,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                                                image: item.image,
                                                objectFit: "contain"
                                            })
                                        })
                                    })
                                }, item.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Artwork_module_default()).LastGalleryItem,
                                ref: cardElement
                            })
                        ]
                    })
                }) : ((ref5 = props.artwork.root) === null || ref5 === void 0 ? void 0 : ref5.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Artwork_module_default()).ImageWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Artwork_module_default()).Image,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                            image: props.artwork.root.image,
                            layout: "fill",
                            objectFit: "contain"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                size: "fullWidth",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Artwork_module_default()).ArrowWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Artwork_module_default()).ArrowSection
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (0,clsx_m/* default */.Z)((Artwork_module_default()).FullScreenButton, (Artwork_module_default()).ArrowSection),
                            onClick: ()=>{
                                return lightbox === null || lightbox === void 0 ? void 0 : lightbox.open(activeIndex);
                            },
                            children: "Prozkoumat d\xedlo"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)((Artwork_module_default()).Arrows, (Artwork_module_default()).ArrowSection),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: ()=>scroll(-1),
                                    className: (0,clsx_m/* default */.Z)((Artwork_module_default()).ArrowBackward, showPreviousButton && (Artwork_module_default()).isVisible),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        name: "arrowDown"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: ()=>scroll(1),
                                    className: (0,clsx_m/* default */.Z)((Artwork_module_default()).ArrowForward, showNextButton && (Artwork_module_default()).isVisible),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        name: "arrowDown"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                size: "normal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: (Artwork_module_default()).Title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: props.artwork.artist
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: props.artwork.title
                            })
                        ]
                    }),
                    props.artwork.label && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Artwork_module_default()).Label,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                            source: props.artwork.label
                        })
                    }),
                    props.artwork.leadParagraph && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Artwork_module_default()).LeadParagraph,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                            source: props.artwork.leadParagraph
                        })
                    })
                ]
            }),
            props.artwork.content && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentRenderer, {
                content: props.artwork.content
            })
        ]
    });
}

// EXTERNAL MODULE: ./app/components/ArtworkSelection.module.sass
var ArtworkSelection_module = __webpack_require__(1217);
var ArtworkSelection_module_default = /*#__PURE__*/__webpack_require__.n(ArtworkSelection_module);
;// CONCATENATED MODULE: ./app/components/ArtworkSelection.tsx




function ArtworkSelection(props) {
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ArtworkSelection_module_default()).ArtworkSelection,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            size: "normal",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: (ArtworkSelection_module_default()).Title,
                    children: (ref = props.artworkSelection.localesByLocale) === null || ref === void 0 ? void 0 : ref.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ArtworkSelection_module_default()).Artworks,
                    children: (ref1 = props.artworkSelection.artworks) === null || ref1 === void 0 ? void 0 : ref1.items.map((item)=>{
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: (ArtworkSelection_module_default()).Artwork,
                            children: [
                                ((ref = item.artwork) === null || ref === void 0 ? void 0 : ref.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                                    image: item.artwork.image
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: (ArtworkSelection_module_default()).ArtworkTitle,
                                    children: [
                                        ((ref1 = item.artwork) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.localesByLocale) === null || ref2 === void 0 ? void 0 : ref2.artist) && ((ref3 = item.artwork) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.localesByLocale) === null || ref4 === void 0 ? void 0 : ref4.artist) + ", ",
                                        (ref5 = item.artwork) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.localesByLocale) === null || ref6 === void 0 ? void 0 : ref6.title
                                    ]
                                })
                            ]
                        }, item.id);
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./app/components/ContactPage.module.sass
var ContactPage_module = __webpack_require__(4623);
var ContactPage_module_default = /*#__PURE__*/__webpack_require__.n(ContactPage_module);
;// CONCATENATED MODULE: ./app/components/ContactPage.tsx






function ContactPage(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ContactPage_module_default()).ContactPage,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            size: "normal",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: (ContactPage_module_default()).Title,
                    children: props.contactPage.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ContactPage_module_default()).ContactSection,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                props.contactPage.address && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ContactPage_module_default()).Address,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                                        source: props.contactPage.address
                                    })
                                }),
                                props.contactPage.openingHours && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ContactPage_module_default()).OpeningHours,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                                        source: props.contactPage.openingHours
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                            link: props.contactPage.addressLink,
                            className: (ContactPage_module_default()).AddressLink
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ContactPage_module_default()).ContactSection,
                    children: [
                        props.contactPage.phoneLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ContactPage_module_default()).PhoneLabel,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                                source: props.contactPage.phoneLabel
                            })
                        }),
                        props.contactPage.phone && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                            href: "tel:".concat(props.contactPage.phone),
                            className: (ContactPage_module_default()).Phone,
                            children: props.contactPage.phone
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ContactPage_module_default()).ContactSection,
                    children: [
                        props.contactPage.emailLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ContactPage_module_default()).EmailLabel,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                                source: props.contactPage.emailLabel
                            })
                        }),
                        props.contactPage.email && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                            href: "mailto:".concat(props.contactPage.email),
                            className: (ContactPage_module_default()).Email,
                            children: props.contactPage.email
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)((ContactPage_module_default()).ContactSection, (ContactPage_module_default()).MobileTopLine),
                    children: [
                        props.contactPage.identificationsLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ContactPage_module_default()).EmailLabel,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                                source: props.contactPage.identificationsLabel
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ContactPage_module_default()).IcoDicWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (ContactPage_module_default()).Ico,
                                    children: props.contactPage.ico
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (ContactPage_module_default()).Dic,
                                    children: props.contactPage.dic
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ContactPage_module_default()).ContactSection,
                    children: [
                        props.contactPage.databox && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ContactPage_module_default()).DataBoxLabel,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                                source: props.contactPage.databox
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: props.contactPage.databoxNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (ContactPage_module_default()).DataBoxNumber,
                                children: props.contactPage.databoxNumber
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ContactPage_module_default()).ContactSection,
                    children: [
                        props.contactPage.securities && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ContactPage_module_default()).SecuritiesLabel,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                                source: props.contactPage.securities
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: props.contactPage.securitiesNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (ContactPage_module_default()).SecuritiesNumber,
                                children: props.contactPage.securitiesNumber
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ContactPage_module_default()).ContactSection,
                    children: [
                        props.contactPage.socialsLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ContactPage_module_default()).EmailLabel,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                                source: props.contactPage.socialsLabel
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ContactPage_module_default()).Socials,
                            children: [
                                props.contactPage.instagram && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    href: props.contactPage.instagram,
                                    className: (ContactPage_module_default()).Instagram,
                                    children: "Instagram"
                                }),
                                props.contactPage.youtube && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    href: props.contactPage.youtube,
                                    className: (ContactPage_module_default()).Youtube,
                                    children: "Youtube"
                                }),
                                props.contactPage.facebook && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    href: props.contactPage.facebook,
                                    className: (ContactPage_module_default()).Facebook,
                                    children: "Facebook"
                                }),
                                props.contactPage.linkedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    href: props.contactPage.linkedIn,
                                    className: (ContactPage_module_default()).LinkedIn,
                                    children: "LinkedIn"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./app/components/Event.module.sass
var Event_module = __webpack_require__(6881);
var Event_module_default = /*#__PURE__*/__webpack_require__.n(Event_module);
;// CONCATENATED MODULE: ./app/components/Event.tsx







function Event(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((Event_module_default()).Event, props.event.isDark && (Event_module_default()).isDark),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Event_module_default()).ImageTextWrapper,
                children: [
                    props.event.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Event_module_default()).Image,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                            image: props.event.image,
                            layout: "fill",
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Event_module_default()).Lines,
                        children: new Array(10).fill(null).map((_, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Event_module_default()).Line
                            }, i))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (Event_module_default()).Title,
                        children: props.event.title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                size: "normal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (Event_module_default()).Date,
                    children: props.event.date
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Event_module_default()).Border
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                size: "normal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Event_module_default()).VenueWrapper,
                    children: [
                        props.event.venue && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Event_module_default()).Venue,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                                source: props.event.venue
                            })
                        }),
                        props.event.venueNote && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Event_module_default()).VenueNote,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                                source: props.event.venueNote
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Event_module_default()).Border
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                size: "normal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (Event_module_default()).LeadParagraph,
                    children: props.event.leadParagraph
                })
            }),
            props.event.content && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentRenderer, {
                content: props.event.content
            })
        ]
    });
}

// EXTERNAL MODULE: ./app/components/Footer.module.sass
var Footer_module = __webpack_require__(6679);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ./app/components/Footer.tsx







function Footer(props) {
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        size: "fullWidth",
        disableInView: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)((Footer_module_default()).Footer, props.isContactPage && (Footer_module_default()).isContactPage),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Footer_module_default()).Info,
                    children: [
                        props.footer.address && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Footer_module_default()).Address,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* RichTextRenderer */.i, {
                                source: props.footer.address
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Footer_module_default()).Contacts,
                            children: [
                                props.footer.phone && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    href: "tel:to".concat(props.footer.phone),
                                    children: props.footer.phone
                                }),
                                props.footer.email && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    href: "mailto:".concat(props.footer.email),
                                    children: props.footer.email
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Footer_module_default()).Socials,
                            children: [
                                props.footer.youtube && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    className: (Footer_module_default()).Social,
                                    href: props.footer.youtube,
                                    children: "Youtube"
                                }),
                                props.footer.instagram && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    className: (Footer_module_default()).Social,
                                    href: props.footer.instagram,
                                    children: "Instagram"
                                }),
                                props.footer.facebook && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    className: (Footer_module_default()).Social,
                                    href: props.footer.facebook,
                                    children: "Facebook"
                                }),
                                props.footer.linkedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    className: (Footer_module_default()).Social,
                                    href: props.footer.linkedIn,
                                    children: "LinkedIn"
                                })
                            ]
                        })
                    ]
                }),
                ((ref = props.footer.root) === null || ref === void 0 ? void 0 : ref.logo) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Footer_module_default()).Logo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                        image: (ref1 = props.footer.root) === null || ref1 === void 0 ? void 0 : ref1.logo
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Footer_module_default()).MadeBy,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Footer_module_default()).GraphicDesigners,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (Footer_module_default()).Note,
                                    children: props.footer.graphicDesign
                                }),
                                props.footer.graphicDesigners.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Footer_module_default()).GraphicDesigner,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (Footer_module_default()).Ampersand,
                                                children: "&"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                link: item.link,
                                                className: (Footer_module_default()).Link
                                            })
                                        ]
                                    }, item.id))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Footer_module_default()).Dot
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Footer_module_default()).Photographers,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (Footer_module_default()).Note,
                                    children: props.footer.photography
                                }),
                                props.footer.photographers.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Footer_module_default()).Photographer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (Footer_module_default()).Ampersand,
                                                children: "&"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                link: item.link,
                                                className: (Footer_module_default()).Link
                                            })
                                        ]
                                    }, item.id))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Footer_module_default()).Dot
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Footer_module_default()).Development,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (Footer_module_default()).Note,
                                    children: props.footer.development
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    link: props.footer.developerLink,
                                    className: (Footer_module_default()).Link
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./i18n.js
var i18n = __webpack_require__(23);
var i18n_default = /*#__PURE__*/__webpack_require__.n(i18n);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(880);
;// CONCATENATED MODULE: ./app/utils/usePageLoadingState.ts


function usePageLoadingState() {
    const { asPath , events  } = (0,client_router.useRouter)();
    const [loading, setLoading] = react.useState(false);
    const [duration, setDuration] = react.useState(0);
    react.useEffect(()=>{
        const handleStart = ()=>{
            setLoading(true);
        };
        const handleComplete = ()=>{
            setLoading(false);
        };
        events.on("routeChangeStart", handleStart);
        events.on("routeChangeComplete", handleComplete);
        events.on("routeChangeError", handleComplete);
        return ()=>{
            events.off("routeChangeStart", handleStart);
            events.off("routeChangeComplete", handleComplete);
            events.off("routeChangeError", handleComplete);
        };
    }, [
        asPath,
        events
    ]);
    react.useEffect(()=>{
        if (loading) {
            const start = new Date().getTime();
            const interval = setInterval(()=>{
                setDuration(new Date().getTime() - start);
            }, 100);
            return ()=>clearInterval(interval);
        } else {
            setDuration(0);
        }
    }, [
        loading
    ]);
    return [
        loading,
        duration
    ];
}

// EXTERNAL MODULE: ./app/components/Breadcrumbs.module.sass
var Breadcrumbs_module = __webpack_require__(2561);
var Breadcrumbs_module_default = /*#__PURE__*/__webpack_require__.n(Breadcrumbs_module);
;// CONCATENATED MODULE: ./app/components/Breadcrumbs.tsx




function Breadcrumbs(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.breadcrumbs.map((breadcrumb, i)=>{
            if (breadcrumb.url && i !== props.breadcrumbs.length - 1) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (Breadcrumbs_module_default()).BreadcrumbTitle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                href: breadcrumb.url,
                                children: breadcrumb.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Breadcrumbs_module_default()).Dot
                        })
                    ]
                }, i);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Breadcrumbs_module_default()).BreadcrumbTitle,
                children: breadcrumb.title
            }, i);
        })
    });
}

// EXTERNAL MODULE: ./app/components/Header.module.sass
var Header_module = __webpack_require__(4866);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
;// CONCATENATED MODULE: ./app/components/Header.tsx












function Header(props) {
    var ref, ref1, ref2;
    const [open, setOpen] = (0,react.useState)(false);
    const [loading] = usePageLoadingState();
    react.useEffect(()=>{
        setOpen(false);
    }, [
        loading
    ]);
    const translations = props.translations.filter((tr)=>{
        var ref, ref1;
        return ((ref = tr.locale) === null || ref === void 0 ? void 0 : ref.code) !== ((ref1 = props.header.locale) === null || ref1 === void 0 ? void 0 : ref1.code);
    });
    const existingLocales = props.translations.map((tr)=>{
        var ref;
        return (ref = tr.locale) === null || ref === void 0 ? void 0 : ref.code;
    }).filter(filterNonEmpty);
    const missingLocales = i18n_default().locales.filter((locale)=>{
        var ref;
        return !existingLocales.includes(locale) && locale !== ((ref = props.header.locale) === null || ref === void 0 ? void 0 : ref.code);
    });
    const [scrollPosition, setScrollPosition] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        const calculatePosition = ()=>{
            setScrollPosition(window.scrollY);
        };
        window.addEventListener("scroll", calculatePosition, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("scroll", calculatePosition);
        };
    }, []);
    var _homePageLink, _homePageLink1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((Header_module_default()).HeaderSticky, open && (Header_module_default()).isHeaderOpen, props.isHomePage && (Header_module_default()).isHomePageBorder, scrollPosition > 600 && (Header_module_default()).isHomePageBorderVisible),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            size: "fullWidth",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)((Header_module_default()).Header, props.isHomePage && (Header_module_default()).isHomePage),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Header_module_default()).Breadcrumbs,
                        children: props.breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs, {
                            breadcrumbs: props.breadcrumbs
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Header_module_default()).Logo,
                        children: ((ref = props.header.root) === null || ref === void 0 ? void 0 : ref.logo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                            href: (_homePageLink = props.homePageLink) !== null && _homePageLink !== void 0 ? _homePageLink : "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                                image: props.header.root.logo,
                                layout: "intrinsic"
                            })
                        })
                    }),
                    props.isHomePage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link, {
                        href: (_homePageLink1 = props.homePageLink) !== null && _homePageLink1 !== void 0 ? _homePageLink1 : "/",
                        className: (Header_module_default()).HomePageLogo,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: props.logoProTargetRef,
                                className: (Header_module_default()).Pro
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: props.logoArteTargetRef,
                                className: (Header_module_default()).Arte
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (Header_module_default()).IconHamburger,
                        onClick: ()=>setOpen((old)=>!old),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            name: "hamburger"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Header_module_default()).IconHamburgerMobileWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (Header_module_default()).IconHamburgerMobile,
                            onClick: ()=>setOpen((old)=>!old),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                name: "hamburgerMobile"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)((Header_module_default()).HeaderOpen, open && (Header_module_default()).isActive),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                            size: "fullWidth",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Header_module_default()).Header,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Header_module_default()).Locales,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Header_module_default()).LocaleWrapper,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,clsx_m/* default */.Z)((Header_module_default()).Locale, (Header_module_default()).isActiveLocale),
                                                        children: (ref1 = props.header.locale) === null || ref1 === void 0 ? void 0 : ref1.code
                                                    })
                                                }),
                                                translations.map((item)=>{
                                                    var ref, ref1;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                        className: (Header_module_default()).LocaleWrapper,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (Header_module_default()).Dot
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: (ref = item.link) === null || ref === void 0 ? void 0 : ref.url,
                                                                onClick: ()=>{
                                                                    var ref;
                                                                    document.cookie = "NEXT_LOCALE=".concat((ref = item.locale) === null || ref === void 0 ? void 0 : ref.code, "; path=/");
                                                                },
                                                                className: (Header_module_default()).Locale,
                                                                children: (ref1 = item.locale) === null || ref1 === void 0 ? void 0 : ref1.code
                                                            })
                                                        ]
                                                    }, item.id);
                                                }),
                                                missingLocales.map((locale, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (Header_module_default()).MissingLocale,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: (Header_module_default()).Locale,
                                                            onClick: ()=>{
                                                                document.cookie = "NEXT_LOCALE=".concat(locale, "; path=/");
                                                            },
                                                            href: locale === (i18n_default()).defaultLocale ? "/" : "/".concat(locale),
                                                            children: locale
                                                        })
                                                    }, i))
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Header_module_default()).Logo,
                                            children: ((ref2 = props.header.root) === null || ref2 === void 0 ? void 0 : ref2.logo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                href: "/",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                                                    image: props.header.root.logo,
                                                    layout: "intrinsic"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: (0,clsx_m/* default */.Z)((Header_module_default()).IconHamburger, (Header_module_default()).Close, open && (Header_module_default()).isActive),
                                            onClick: ()=>setOpen((old)=>!old),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                name: "cross"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)((Header_module_default()).Links, (Header_module_default()).MobileLinks, open && (Header_module_default()).isActive),
                                    children: props.header.links.map((item)=>{
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Link, {
                                            link: item.link,
                                            className: (Header_module_default()).Link,
                                            activeClassName: (Header_module_default()).isActiveLink,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (Header_module_default()).LinkTitle,
                                                    children: (ref = item.link) === null || ref === void 0 ? void 0 : ref.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Header_module_default()).Arrow,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                        name: "arrowDown"
                                                    })
                                                })
                                            ]
                                        }, item.id);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: (0,clsx_m/* default */.Z)((Header_module_default()).IconHamburger, (Header_module_default()).CloseMobile, open && (Header_module_default()).isActive),
                                    onClick: ()=>setOpen((old)=>!old),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        name: "cross"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./app/components/HomePage.module.sass
var HomePage_module = __webpack_require__(1959);
var HomePage_module_default = /*#__PURE__*/__webpack_require__.n(HomePage_module);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useWindowScroll.js + 4 modules
var useWindowScroll = __webpack_require__(8621);
// EXTERNAL MODULE: ./app/components/HomePageAnimation.module.sass
var HomePageAnimation_module = __webpack_require__(653);
var HomePageAnimation_module_default = /*#__PURE__*/__webpack_require__.n(HomePageAnimation_module);
// EXTERNAL MODULE: ./app/components/LogoArte.module.sass
var LogoArte_module = __webpack_require__(4014);
var LogoArte_module_default = /*#__PURE__*/__webpack_require__.n(LogoArte_module);
;// CONCATENATED MODULE: ./app/components/LogoArte.tsx




const LogoArte = (param)=>{
    let { targetRef  } = param;
    const originRef = (0,react.useRef)(null);
    const [transform, setTransform] = (0,react.useState)({
        x: 0,
        y: 0,
        scale: 1
    });
    (0,react.useEffect)(()=>{
        const recalculatePosition = ()=>{
            const origin = originRef.current;
            const target = targetRef.current;
            if (!target || !origin) {
                return;
            }
            const originRect = origin.getBoundingClientRect();
            const targetRect = target.getBoundingClientRect();
            const progress = 1 - Math.pow(Math.max(0, (targetRect.top - window.scrollY / 40) / (targetRect.top + window.scrollY / 40)), 2);
            setTransform({
                x: progress * (targetRect.left + targetRect.width / 2 - (originRect.left + originRect.width / 2)),
                y: progress * (targetRect.top + targetRect.height / 2 - (originRect.top + originRect.height / 2)),
                scale: 1 + progress * (Math.min(targetRect.width / originRect.width, targetRect.height / originRect.height) - 1)
            });
        };
        window.addEventListener("scroll", recalculatePosition, {
            passive: true
        });
        window.addEventListener("resize", recalculatePosition, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("scroll", recalculatePosition);
            window.removeEventListener("resize", recalculatePosition);
        };
    }, [
        targetRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (LogoArte_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: originRef,
            className: (LogoArte_module_default()).image,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LogoArte_module_default()).image_in,
                style: {
                    ["--LogoArte-x"]: "".concat(transform.x, "px"),
                    ["--LogoArte-y"]: "".concat(transform.y, "px"),
                    ["--LogoArte-scale"]: "".concat(transform.scale)
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    name: "arte"
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./app/components/LogoPro.module.sass
var LogoPro_module = __webpack_require__(5703);
var LogoPro_module_default = /*#__PURE__*/__webpack_require__.n(LogoPro_module);
;// CONCATENATED MODULE: ./app/components/LogoPro.tsx




const LogoPro = (param)=>{
    let { targetRef  } = param;
    const originRef = (0,react.useRef)(null);
    const [transform, setTransform] = (0,react.useState)({
        x: 0,
        y: 0,
        scale: 1
    });
    (0,react.useEffect)(()=>{
        const recalculatePosition = ()=>{
            const origin = originRef.current;
            const target = targetRef.current;
            if (!target || !origin) {
                return;
            }
            const originRect = origin.getBoundingClientRect();
            const targetRect = target.getBoundingClientRect();
            const progress = 1 - Math.pow(Math.max(0, (targetRect.top - window.scrollY / 40) / (targetRect.top + window.scrollY / 40)), 2);
            setTransform({
                x: progress * (targetRect.left + targetRect.width / 2 - (originRect.left + originRect.width / 2)),
                y: progress * (targetRect.top + targetRect.height / 2 - (originRect.top + originRect.height / 2)),
                scale: 1 + progress * (Math.min(targetRect.width / originRect.width, targetRect.height / originRect.height) - 1)
            });
        };
        window.addEventListener("scroll", recalculatePosition, {
            passive: true
        });
        window.addEventListener("resize", recalculatePosition, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("scroll", recalculatePosition);
            window.removeEventListener("resize", recalculatePosition);
        };
    }, [
        targetRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (LogoPro_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: originRef,
            className: (LogoPro_module_default()).image,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LogoPro_module_default()).image_in,
                style: {
                    ["--LogoPro-x"]: "".concat(transform.x, "px"),
                    ["--LogoPro-y"]: "".concat(transform.y, "px"),
                    ["--LogoPro-scale"]: "".concat(transform.scale)
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    name: "pro"
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./app/components/HomePageAnimation.tsx








function HomePageAnimation(props) {
    var ref, ref1;
    const items = ((ref = props.homePage.root) === null || ref === void 0 ? void 0 : (ref1 = ref.media) === null || ref1 === void 0 ? void 0 : ref1.items) || [];
    const [activeImageIndex, setActiveImageIndex] = (0,react.useState)(0);
    const { y: scrollPosition  } = (0,useWindowScroll/* default */.Z)();
    (0,react.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setActiveImageIndex((activeImageIndex + 1) % items.length);
        }, 5000);
        return ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        activeImageIndex,
        items.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HomePageAnimation_module_default()).Animation,
                style: {
                    "--HomePage-animation": "".concat(scrollPosition)
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (HomePageAnimation_module_default()).LeadParagraphWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HomePageAnimation_module_default()).Pro,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoPro, {
                                    targetRef: props.logoProTargetRef
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (HomePageAnimation_module_default()).LeadParagraphDesktop,
                                children: props.homePage.leadParagraph
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomePageAnimation_module_default()).Arte,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoArte, {
                            targetRef: props.logoArteTargetRef
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (HomePageAnimation_module_default()).LeadParagraphMobile,
                        children: props.homePage.leadParagraph
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HomePageAnimation_module_default()).ImageWrapper,
                children: items.map((item, itemIndex)=>{
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                        children: ((ref = item.medium) === null || ref === void 0 ? void 0 : ref.type) === "image" && item.medium.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)((HomePageAnimation_module_default()).Image, activeImageIndex === itemIndex && (HomePageAnimation_module_default()).isActive),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberImage, {
                                image: item.medium.image,
                                layout: "fill",
                                objectFit: "cover",
                                sizes: "calc((100vh - 94px) / ".concat(aspectRatio(item.medium.image), ")")
                            })
                        })
                    }, item.id);
                })
            })
        ]
    });
}
function aspectRatio(image) {
    if (image.width && image.height) {
        return image.height / image.width;
    }
    return 1;
}

;// CONCATENATED MODULE: ./app/components/HomePage.tsx








function HomePage(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (HomePage_module_default()).HomePage,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageAnimation, {
                homePage: props.homePage,
                logoProTargetRef: props.logoProTargetRef,
                logoArteTargetRef: props.logoArteTargetRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                size: "wide",
                children: props.homePage.branches && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (HomePage_module_default()).Branches,
                    children: props.homePage.branches.map((item)=>{
                        var ref, ref1;
                        const titleWords = (ref = item.link) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.split(" ");
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HomePage_module_default()).Branch,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link, {
                                link: item.link,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (HomePage_module_default()).BranchTitle,
                                        children: titleWords === null || titleWords === void 0 ? void 0 : titleWords.map((word, wordIndex)=>{
                                            if (wordIndex === titleWords.length - 1) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (HomePage_module_default()).BranchTitleLastWord,
                                                    children: [
                                                        word,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (HomePage_module_default()).Arrow,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (HomePage_module_default()).ArrowIn,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                                    name: "arrowDown"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }, item.id);
                                            }
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    word,
                                                    " "
                                                ]
                                            }, wordIndex);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (HomePage_module_default()).BranchLeadParagraph,
                                        children: item.leadParagraph
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (HomePage_module_default()).BranchMore,
                                        children: item.more
                                    })
                                ]
                            })
                        }, item.id);
                    })
                })
            }),
            props.homePage.content && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentRenderer, {
                content: props.homePage.content
            })
        ]
    });
}

// EXTERNAL MODULE: ./app/components/Page.module.sass
var Page_module = __webpack_require__(6687);
var Page_module_default = /*#__PURE__*/__webpack_require__.n(Page_module);
;// CONCATENATED MODULE: ./app/components/Page.tsx




function Page(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Page_module_default()).Page,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                size: "wide",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: (Page_module_default()).Title,
                    children: props.page.title
                })
            }),
            props.page.content && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentRenderer, {
                content: props.page.content
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/[[...page]].tsx












var __N_SSP = true;
function CommonPage(props) {
    var ref, ref1, ref2;
    const header = props.dataFromContember.getHeaderLocale;
    var _getLinkable;
    const { artwork , artworkSelection , contactPage , event , homePage , page  } = (_getLinkable = props.dataFromContember.getLinkable) !== null && _getLinkable !== void 0 ? _getLinkable : {};
    const footer = props.dataFromContember.getFooterLocale;
    const pageLocales = [
        homePage,
        event,
        artwork,
        artworkSelection,
        contactPage,
        page
    ].filter(filterNonEmpty)[0];
    const logoProTargetRef = (0,react.useRef)(null);
    const logoArteTargetRef = (0,react.useRef)(null);
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Pro arte, investičn\xed fond"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/apple-touch-icon.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: "/favicon-32x32.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: "/favicon-16x16.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "/site.webmanifest"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "mask-icon",
                        href: "/safari-pinned-tab.svg",
                        color: "#000000"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: "#ffffff"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: "#ffffff"
                    })
                ]
            }),
            header && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                header: header,
                translations: (ref3 = (ref = pageLocales.root) === null || ref === void 0 ? void 0 : ref.locales) !== null && ref3 !== void 0 ? ref3 : [],
                isHomePage: Boolean(homePage),
                logoProTargetRef: logoProTargetRef,
                logoArteTargetRef: logoArteTargetRef,
                homePageLink: (ref1 = props.dataFromContember.getHomePageLocale) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.link) === null || ref2 === void 0 ? void 0 : ref2.url,
                breadcrumbs: props.breadcrumbs
            }),
            homePage && /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage, {
                homePage: homePage,
                logoProTargetRef: logoProTargetRef,
                logoArteTargetRef: logoArteTargetRef
            }),
            artwork && /*#__PURE__*/ (0,jsx_runtime.jsx)(Artwork, {
                artwork: artwork
            }),
            (artworkSelection === null || artworkSelection === void 0 ? void 0 : artworkSelection.root) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtworkSelection, {
                artworkSelection: artworkSelection.root
            }),
            event && /*#__PURE__*/ (0,jsx_runtime.jsx)(Event, {
                event: event
            }),
            contactPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactPage, {
                contactPage: contactPage
            }),
            page && /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
                page: page
            }),
            footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                footer: footer,
                isContactPage: Boolean(contactPage)
            })
        ]
    });
}


/***/ }),

/***/ 5579:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Anchor_wrapper__gHBiy"};

/***/ }),

/***/ 7172:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"GalleryWrapper":"Artwork_GalleryWrapper__2Ci5A","ImageWrapper":"Artwork_ImageWrapper__jClaz","Gallery":"Artwork_Gallery__zM5eX","GalleryItem":"Artwork_GalleryItem__nt8z_","LastGalleryItem":"Artwork_LastGalleryItem__9oZjo","Image":"Artwork_Image__8W5Qd","GalleryImage":"Artwork_GalleryImage__8awD5","GalleryButton":"Artwork_GalleryButton__MHtHm","Title":"Artwork_Title__hYuN0","Label":"Artwork_Label__hXmOY","LeadParagraph":"Artwork_LeadParagraph__2fSLo","ArrowWrapper":"Artwork_ArrowWrapper__9Mc0_","ArrowSection":"Artwork_ArrowSection__sryYu","FullScreenButton":"Artwork_FullScreenButton__SgTR6","Arrows":"Artwork_Arrows__ob6Rk","ArrowBackward":"Artwork_ArrowBackward__H6zFB","ArrowForward":"Artwork_ArrowForward__0OQe_","isVisible":"Artwork_isVisible__gwOj5"};

/***/ }),

/***/ 1217:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Artworks":"ArtworkSelection_Artworks__6ugbZ","Title":"ArtworkSelection_Title__69xO_","Artwork":"ArtworkSelection_Artwork__v4A__","ArtworkTitle":"ArtworkSelection_ArtworkTitle__zM_AV"};

/***/ }),

/***/ 3857:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BoxTile":"BoxTile_BoxTile__M1Hfw","BoxInfo":"BoxTile_BoxInfo__Rv0oz","Title":"BoxTile_Title__XY8su","Date":"BoxTile_Date__GYfpQ","Type":"BoxTile_Type__JP35j","LeadParagraph":"BoxTile_LeadParagraph__KXe4A"};

/***/ }),

/***/ 2561:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BreadcrumbTitle":"Breadcrumbs_BreadcrumbTitle__ZGpAK","Dot":"Breadcrumbs_Dot__gHN_I"};

/***/ }),

/***/ 5450:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__UzamG","Arrow":"Button_Arrow____xn6","Link":"Button_Link__5PGOY","TitleLastWord":"Button_TitleLastWord__cO5h7"};

/***/ }),

/***/ 2923:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CarouselWithArtworks":"CarouselWithArtworks_CarouselWithArtworks__oluEZ","TitleWrapper":"CarouselWithArtworks_TitleWrapper__xm96i","Title":"CarouselWithArtworks_Title__wGjbA","CarouselArtworksWrapper":"CarouselWithArtworks_CarouselArtworksWrapper__E50Ck","CarouselArtworks":"CarouselWithArtworks_CarouselArtworks__dVU31","ArtworkTile":"CarouselWithArtworks_ArtworkTile__rRmLg","LastArtworkTile":"CarouselWithArtworks_LastArtworkTile__DwrOj","ArtworkTitle":"CarouselWithArtworks_ArtworkTitle__K_XYA","Arrows":"CarouselWithArtworks_Arrows__GASH0","ArrowBackward":"CarouselWithArtworks_ArrowBackward__R5xr9","ArrowForward":"CarouselWithArtworks_ArrowForward__UEuyX","isVisible":"CarouselWithArtworks_isVisible__WeI__","ButtonDesktop":"CarouselWithArtworks_ButtonDesktop___JCK_","ButtonMobile":"CarouselWithArtworks_ButtonMobile__2nfn5"};

/***/ }),

/***/ 5862:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ChartColumnWrapper":"Chart_ChartColumnWrapper___SkJw","ChartColumn":"Chart_ChartColumn__SI4d4","ChartColumnLine":"Chart_ChartColumnLine__f0Uz4","Lines":"Chart_Lines__8YffJ","ColumnInfoText":"Chart_ColumnInfoText__KFwD_","Date":"Chart_Date__314_L","PieGraph":"Chart_PieGraph__tRxzx","MobileTextsWrapper":"Chart_MobileTextsWrapper__kMm8H","MobileTexts":"Chart_MobileTexts__Ga9Us","MobileText":"Chart_MobileText__V7oLp","MobileNumber":"Chart_MobileNumber__l_8vt","CirclesWrapper":"Chart_CirclesWrapper__pUE2j","Circles":"Chart_Circles__97h9k","CirclesText":"Chart_CirclesText__gyCDP","CirclesTextIn":"Chart_CirclesTextIn__eZMPq","isPositionRightBottom":"Chart_isPositionRightBottom__y1TdH","isPositionLeftBottom":"Chart_isPositionLeftBottom__3v_Pc","isPositionLeftTop":"Chart_isPositionLeftTop__FieSw","isPositionRightTop":"Chart_isPositionRightTop__lgYEX","CircleHover":"Chart_CircleHover__V2aMn","CircleTitle":"Chart_CircleTitle__j_Xjz","Arrows":"Chart_Arrows__AopgS","ArrowBackward":"Chart_ArrowBackward__czmNw","ArrowForward":"Chart_ArrowForward__NTL5Q","isVisible":"Chart_isVisible__Gzl7I"};

/***/ }),

/***/ 7683:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ContactTypeNote":"ContactForm_ContactTypeNote__hisIz","CheckboxWrapper":"ContactForm_CheckboxWrapper__RrAhA","CheckboxLabel":"ContactForm_CheckboxLabel__A8ISx","Checkbox":"ContactForm_Checkbox__uHwcv","CheckboxText":"ContactForm_CheckboxText__TnUEi","InputLabel":"ContactForm_InputLabel__AiHy1","InputLabelText":"ContactForm_InputLabelText__TQ77N","Input":"ContactForm_Input__iqOND","InputFileWrapper":"ContactForm_InputFileWrapper__oJjsf","InputFile":"ContactForm_InputFile__byh8e","Plus":"ContactForm_Plus__Z5IzN","Image":"ContactForm_Image__jOIHP","EmailNote":"ContactForm_EmailNote__m4cBb","Button":"ContactForm_Button__yi3cq","ErrorMessage":"ContactForm_ErrorMessage__Ph1bD"};

/***/ }),

/***/ 4623:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ContactPage":"ContactPage_ContactPage__gnUu2","Title":"ContactPage_Title__1A665","ContactSection":"ContactPage_ContactSection__tgBRU","MobileTopLine":"ContactPage_MobileTopLine__R26M_","Address":"ContactPage_Address__kxfBL","IcoDicWrapper":"ContactPage_IcoDicWrapper__2pTY4","Ico":"ContactPage_Ico__FDDs2","Dic":"ContactPage_Dic__Lesxz","Socials":"ContactPage_Socials__tbNeO","DataBoxNumber":"ContactPage_DataBoxNumber__BVdid","SecuritiesNumber":"ContactPage_SecuritiesNumber__tB61o","AddressLink":"ContactPage_AddressLink__Ws8xt","Phone":"ContactPage_Phone__sSGmj","Email":"ContactPage_Email__5V_S3","Instagram":"ContactPage_Instagram__mjbwO","Youtube":"ContactPage_Youtube__61ht6","Facebook":"ContactPage_Facebook__B0gki","LinkedIn":"ContactPage_LinkedIn__eyyx2"};

/***/ }),

/***/ 8539:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Container_wrapper__IWY85","view_size_normal":"Container_view_size_normal__uAURE","view_size_wide":"Container_view_size_wide__AGczS","view_size_fullWidth":"Container_view_size_fullWidth__oMLkM","view_disableGutters":"Container_view_disableGutters__H1XJy","isInView":"Container_isInView__bX0NH","Anchor":"Container_Anchor__tvoGZ"};

/***/ }),

/***/ 1289:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentRenderer_wrapper__thhBW","section":"ContentRenderer_section__XuAYX","is_reference_appTiles":"ContentRenderer_is_reference_appTiles__t4h9W","is_reference_carouselWithArtworks":"ContentRenderer_is_reference_carouselWithArtworks__VAzxq","is_reference_personCarousel":"ContentRenderer_is_reference_personCarousel__JV93N","is_reference_boxes":"ContentRenderer_is_reference_boxes__sCqP0","is_reference_events":"ContentRenderer_is_reference_events__JxwoN","is_reference_newsletter":"ContentRenderer_is_reference_newsletter__NZIca","is_reference_contactForm":"ContentRenderer_is_reference_contactForm__p9exK","is_reference_definitionList":"ContentRenderer_is_reference_definitionList__4K4dw","is_reference_sponsors":"ContentRenderer_is_reference_sponsors__3_hNy","is_reference_image":"ContentRenderer_is_reference_image__evH8r","is_reference_dropDown":"ContentRenderer_is_reference_dropDown__GOERz","is_reference_chart":"ContentRenderer_is_reference_chart__4dN49","is_reference_button":"ContentRenderer_is_reference_button__VjxLa","notImplemented":"ContentRenderer_notImplemented__t_woz","notImplemented_name":"ContentRenderer_notImplemented_name__3MSnj"};

/***/ }),

/***/ 6219:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Definition":"DefinitionList_Definition___KT58","Key":"DefinitionList_Key__6M7hf","Value":"DefinitionList_Value___iVcZ"};

/***/ }),

/***/ 1438:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"DropDownItem":"DropDown_DropDownItem__zYI7s","isOpen":"DropDown_isOpen__owCEl","Arrow":"DropDown_Arrow__SgkVy","DropDownContent":"DropDown_DropDownContent__wto5I","Title":"DropDown_Title___fK2G","Image":"DropDown_Image__2H828","Text":"DropDown_Text__ba7iX","ButtonWrapper":"DropDown_ButtonWrapper__bLPz9","Button":"DropDown_Button__kAxXA","ButtonSecond":"DropDown_ButtonSecond__QDQu_"};

/***/ }),

/***/ 6881:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ImageTextWrapper":"Event_ImageTextWrapper__Hj4p7","Image":"Event_Image__STzIX","Lines":"Event_Lines__OCtnZ","Line":"Event_Line__96Djt","Title":"Event_Title__qWXYL","VenueWrapper":"Event_VenueWrapper__FkvJF","Venue":"Event_Venue__IYOki","Date":"Event_Date__BrfA2","VenueNote":"Event_VenueNote__hcDv8","Border":"Event_Border__lZmgq","LeadParagraph":"Event_LeadParagraph__zL2dO","isDark":"Event_isDark__InObq"};

/***/ }),

/***/ 3646:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Event":"EventList_Event__PTi5Y","EventInfo":"EventList_EventInfo__XG1f8","Title":"EventList_Title__OlWUG","Date":"EventList_Date__G3sg5","Type":"EventList_Type__kf6oJ","LeadParagraph":"EventList_LeadParagraph__Cv7ph"};

/***/ }),

/***/ 5081:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"FlashMessage":"FlashMessage_FlashMessage__78DwX","fadeOut":"FlashMessage_fadeOut__L8bjj"};

/***/ }),

/***/ 6679:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__qdKyw","Contacts":"Footer_Contacts__XalR2","Info":"Footer_Info__gqI5W","Socials":"Footer_Socials__Mp8N9","Social":"Footer_Social___HNfb","MadeBy":"Footer_MadeBy__Qi9oc","Note":"Footer_Note__3mAVn","Link":"Footer_Link__0mvO5","GraphicDesigners":"Footer_GraphicDesigners__B2_LV","Photographers":"Footer_Photographers__fwX5W","Development":"Footer_Development__p7e_s","GraphicDesigner":"Footer_GraphicDesigner__Q8YwS","Photographer":"Footer_Photographer__uIMbW","Ampersand":"Footer_Ampersand__1OkH8","Dot":"Footer_Dot__Li2NG","isContactPage":"Footer_isContactPage___2eC8"};

/***/ }),

/***/ 9578:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"GalleryWrapper":"Gallery_GalleryWrapper__eu0bJ","Gallery":"Gallery_Gallery__3P_gG","ItemWrapper":"Gallery_ItemWrapper__cgySX","YoutubeEmbed":"Gallery_YoutubeEmbed__QmRQc","Item":"Gallery_Item__5EfzF","Button":"Gallery_Button__TL2py","ImageWrapper":"Gallery_ImageWrapper__QZpxe","CarouselWrapper":"Gallery_CarouselWrapper__Negai","Play":"Gallery_Play__JmNQ2","Image":"Gallery_Image__0tyFt","Video":"Gallery_Video__40TRN","VideoIframe":"Gallery_VideoIframe__PEU2c","Arrow":"Gallery_Arrow__5veyM","Back":"Gallery_Back__6ac3K","isVisible":"Gallery_isVisible__K5oOZ","Arrows":"Gallery_Arrows__9yU3m","ArrowBackward":"Gallery_ArrowBackward__dKpCg","ArrowForward":"Gallery_ArrowForward__M3gqP","LastTile":"Gallery_LastTile__yVYuF"};

/***/ }),

/***/ 6023:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Images":"GalleryInfo_Images__0yQr3","ImageWrapper":"GalleryInfo_ImageWrapper__OCM1F","Image":"GalleryInfo_Image__7i5Qy","Texts":"GalleryInfo_Texts__dDHLQ","TextFirst":"GalleryInfo_TextFirst__q0csx","TextSecond":"GalleryInfo_TextSecond__yKu0P","Link":"GalleryInfo_Link__Ep_G_"};

/***/ }),

/***/ 4866:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HeaderSticky":"Header_HeaderSticky__snYhw","isHeaderOpen":"Header_isHeaderOpen__GPiLS","isHomePageBorder":"Header_isHomePageBorder__jEgqW","isHomePageBorderVisible":"Header_isHomePageBorderVisible__fim4J","Header":"Header_Header__i9MNa","isHomePage":"Header_isHomePage__k_jVu","Breadcrumbs":"Header_Breadcrumbs__MWT5z","IconHamburger":"Header_IconHamburger__kiDM3","Logo":"Header_Logo__GAp1X","Locales":"Header_Locales__QlEBt","IconHamburgerMobileWrapper":"Header_IconHamburgerMobileWrapper__2scQW","HomePageLogo":"Header_HomePageLogo__75BF_","Pro":"Header_Pro__G4IIt","Arte":"Header_Arte__pc0CD","Links":"Header_Links__ac7nf","Link":"Header_Link__UR7t6","Arrow":"Header_Arrow__4dclB","LinkTitle":"Header_LinkTitle__Cq2fL","isActiveLink":"Header_isActiveLink__DLhYp","IconHamburgerMobile":"Header_IconHamburgerMobile__LJcyP","Close":"Header_Close__aW9u_","HeaderOpen":"Header_HeaderOpen__WuaAV","LocaleWrapper":"Header_LocaleWrapper__DC7J9","MissingLocale":"Header_MissingLocale__BHeQm","Locale":"Header_Locale__35y43","Dot":"Header_Dot__fuJuB","isActiveLocale":"Header_isActiveLocale__246Om","isActive":"Header_isActive__Xa6vZ","CloseMobile":"Header_CloseMobile__N53mn"};

/***/ }),

/***/ 1959:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Branches":"HomePage_Branches__41Jd4","Branch":"HomePage_Branch__fd8Wc","BranchMore":"HomePage_BranchMore__YAJDA","BranchTitle":"HomePage_BranchTitle__rWcZ8","Arrow":"HomePage_Arrow__74uAf","BranchTitleLastWord":"HomePage_BranchTitleLastWord__1YmqT","ArrowIn":"HomePage_ArrowIn__V3hEW","BranchLeadParagraph":"HomePage_BranchLeadParagraph__bOkJm"};

/***/ }),

/***/ 653:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Animation":"HomePageAnimation_Animation__Y7ci2","LeadParagraphWrapper":"HomePageAnimation_LeadParagraphWrapper__WWivp","Pro":"HomePageAnimation_Pro__FRUBp","LeadParagraphDesktop":"HomePageAnimation_LeadParagraphDesktop__38Yle","Arte":"HomePageAnimation_Arte__Is7Yz","LeadParagraphMobile":"HomePageAnimation_LeadParagraphMobile__Ejtwe","ImageWrapper":"HomePageAnimation_ImageWrapper__vANDD","Image":"HomePageAnimation_Image__F3_Zq","isActive":"HomePageAnimation_isActive__fPxPx","scaleUp":"HomePageAnimation_scaleUp__jfWIR"};

/***/ }),

/***/ 5352:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon-arrowBig":"Icon_icon-arrowBig___cutq","icon-arrowDown":"Icon_icon-arrowDown__b8gat","icon-arte":"Icon_icon-arte__TCT9k","icon-cross":"Icon_icon-cross__EupyO","icon-go":"Icon_icon-go__tPeYn","icon-hamburger":"Icon_icon-hamburger__DjhsL","icon-hamburgerMobile":"Icon_icon-hamburgerMobile__nHjFo","icon-play":"Icon_icon-play__eTpV3","icon-plus":"Icon_icon-plus__AD1z6","icon-pro":"Icon_icon-pro__qX7Mm"};

/***/ }),

/***/ 6053:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Image":"Image_Image__a8Qn5"};

/***/ }),

/***/ 4014:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"LogoArte_image__GNYPF","image_in":"LogoArte_image_in__Vl4cv"};

/***/ }),

/***/ 8421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"LogoList":"LogoList_LogoList__0Mdfw","ImageWrapper":"LogoList_ImageWrapper__xAXBf","Image":"LogoList_Image__Qhrkx"};

/***/ }),

/***/ 5703:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"LogoPro_image__liAFJ","image_in":"LogoPro_image_in__u9jDo"};

/***/ }),

/***/ 5380:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"NewsletterTypeNote":"NewsletterForm_NewsletterTypeNote__Yl_6o","CheckboxWrapper":"NewsletterForm_CheckboxWrapper___1Jxa","CheckboxLabel":"NewsletterForm_CheckboxLabel__5IAmO","Checkbox":"NewsletterForm_Checkbox__neNXw","CheckboxText":"NewsletterForm_CheckboxText__aqFoA","EmailLabel":"NewsletterForm_EmailLabel__HpvXF","EmailLabelText":"NewsletterForm_EmailLabelText__lKJNN","Email":"NewsletterForm_Email__7izei","EmailNote":"NewsletterForm_EmailNote__mm_uU","Button":"NewsletterForm_Button__HOf7z","ErrorMessage":"NewsletterForm_ErrorMessage__qi6yk"};

/***/ }),

/***/ 6687:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Title":"Page_Title__F_QfA"};

/***/ }),

/***/ 3247:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PersonCarousel":"PersonCarousel_PersonCarousel__eVJeE","Title":"PersonCarousel_Title__xNK1_","PersonWrapper":"PersonCarousel_PersonWrapper__MrFPy","CarouselPeople":"PersonCarousel_CarouselPeople__FvYdw","PersonTile":"PersonCarousel_PersonTile__4Q124","ImageWrapper":"PersonCarousel_ImageWrapper__e5nNR","Image":"PersonCarousel_Image__zvsz9","LastPersonTile":"PersonCarousel_LastPersonTile__k5NHo","PersonNameWrapper":"PersonCarousel_PersonNameWrapper__7636g","PersonName":"PersonCarousel_PersonName__YndbN","Arrows":"PersonCarousel_Arrows__8gX1_","ArrowBackward":"PersonCarousel_ArrowBackward__k53rX","ArrowForward":"PersonCarousel_ArrowForward__vvSEp","isVisible":"PersonCarousel_isVisible__2dPF1","ButtonDesktop":"PersonCarousel_ButtonDesktop___MEsL","ButtonMobile":"PersonCarousel_ButtonMobile__JfIGu"};

/***/ }),

/***/ 1156:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Input":"StrategySchema_Input__0GUfl","Output":"StrategySchema_Output__2qP7n","Text":"StrategySchema_Text__bG7dx","Image":"StrategySchema_Image___zAH0","Section":"StrategySchema_Section__DrvvX","Arrows":"StrategySchema_Arrows__hb2Na","ArrowLeft":"StrategySchema_ArrowLeft__t5EYE","ArrowRight":"StrategySchema_ArrowRight__4Dmr8","ItemsFirst":"StrategySchema_ItemsFirst__nRMSB","ItemsSecond":"StrategySchema_ItemsSecond__c7MQD"};

/***/ }),

/***/ 5476:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"VennDiagram":"VennDiagram_VennDiagram__g_pS0","Logo":"VennDiagram_Logo__Qc2Dx","Image":"VennDiagram_Image__v9hqT","Text":"VennDiagram_Text__aulFd"};

/***/ }),

/***/ 5137:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wysiwyg_wrapper__J6VX6"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [268,774,888,179], function() { return __webpack_exec__(4046); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);